/* v2.6.5 — 2026-05-05 skip swatch when no storefront-visible colour child found (archived) */
/**
 * Builder Roller 2.0 — Roller/Solar Shade Module
 * 5-step config: Color → Mount & Size → Control Style → Roll Direction → Valance
 * Depends on window.BuilderCore (loaded first via defer order).
 */
(function() {
  'use strict';

  // Guard: only run on v2 builder pages
  if (!window.BuilderCore) {
    console.error('[BuilderRoller] BuilderCore not loaded');
    return;
  }

  var Core = window.BuilderCore;
  var dom = Core.dom;
  var events = Core.events;
  var fractions = Core.fractions;

  /* ============================================================
     PARSE DATA BRIDGES
     ============================================================ */
  var pricingData = Core.parseJSON('builder-pricing-data');
  var componentsData = Core.parseJSON('builder-components-data');
  var parentData = Core.parseJSON('builder-parent-data');
  var surchargeVariants = Core.parseJSON('builder-surcharge-variants');
  // Builder 1.0 parity option icons (Warwick review 2026-06-13). Title->image
  // maps for mount / valancePosition / valanceStyle. Cosmetic only.
  var optionIcons = Core.parseJSON('builder-v2-option-icons') || {};

  if (!componentsData || !parentData) {
    console.error('[BuilderRoller] Missing data bridges');
    var stepsEl = document.querySelector('[data-builder-steps]');
    if (stepsEl) stepsEl.innerHTML = '<div class="builder-v2__error builder-v2__error--visible">Builder configuration missing. Ensure builder blocks are configured in the theme customizer.</div>';
    return;
  }

  if (!pricingData) {
    console.warn('[BuilderRoller] No pricing data found in metafield. Builder will use variant prices as fallback.');
  } else if (!pricingData.color_groups || !pricingData.price_tiers) {
    // Partial metafield (e.g. just motion_spec/cordless_spec without
    // color_groups + price_tiers). Engine falls back to variant pricing
    // for size/color but new gate config still applies. Loud warning so
    // a half-migrated parent does not silently ship to a customer.
    console.warn('[BuilderRoller] builder_pricing metafield is missing color_groups or price_tiers. ' +
                 'Builder will use variant fallback for pricing but will still apply motion_spec / cordless_spec / length_constraints if present. ' +
                 'Do NOT publish this configuration to a customer-facing PDP until the full pricing JSON is populated.');
  }

  /* ============================================================
     COMPARE AT MSRP MULTIPLIER
     parent_product.price and compare_at_price are both in cents in
     the JSON bridge. If compare_at > price, ratio is applied to the
     calculated builder total so the strikethrough MSRP scales with
     size and options. Zero = no compare at, hide MSRP.
     ============================================================ */
  // Spend & Save shows no MSRP and sends the cart no compare saving.
  var ssMode = !!document.querySelector('[data-ss-price-card]');
  var msrpMultiplier = (function() {
    if (!parentData || ssMode) return 0;
    var p = parseFloat(parentData.price) || 0;
    var c = parseFloat(parentData.compare_at_price) || 0;
    return (c > p && p > 0) ? c / p : 0;
  })();

  function renderMsrp(pos, baseAmount) {
    var el = document.querySelector('[data-msrp][data-msrp-pos="' + pos + '"]');
    if (!el) return;
    if (msrpMultiplier <= 0) {
      el.style.display = 'none';
      return;
    }
    if (baseAmount > 0) {
      var msrp = Math.round(baseAmount * msrpMultiplier * 100) / 100;
      var v = el.querySelector('[data-msrp-value]');
      if (v) v.textContent = Core.formatMoney(msrp);
    }
    el.style.display = '';
  }

  // The card's Affirm line is not data-affirm-live, so it follows the top price instead of the bar total.
  var ssAffirmTimer = null;
  function syncSsAffirm(amount) {
    var el = document.querySelector('[data-ss-price-card] [data-affirm-context="pdp-top"]');
    if (!el || !(amount > 0)) return;
    var cents = String(Math.round(amount * 100));
    if (el.getAttribute('data-amount') === cents) return;
    el.setAttribute('data-amount', cents);
    if (ssAffirmTimer) clearTimeout(ssAffirmTimer);
    ssAffirmTimer = setTimeout(function() {
      if (window.affirm && window.affirm.ui && window.affirm.ui.refresh) window.affirm.ui.refresh();
    }, 150);
  }


  /* ============================================================
     FREE SAMPLE ATC
     Per-swatch ORDER SAMPLE button. Lazy-fetches the configured
     sample collection JSON, matches builder color SKU to sample
     variant ID, AJAX adds to cart with vendor=FDB Sample, toggles
     button state. Pre-flight checks the global isValidCart guard
     for mixed-cart and 10-sample cap. Out-of-stock samples render
     greyed and disabled.
     ============================================================ */
  var SampleATC = (function() {
    var configEl = document.getElementById('builder-sample-config');
    var config = configEl ? JSON.parse(configEl.textContent) : {};
    var collectionHandle = (config && config.sampleCollection) || '';
    var samplesBySku = null;
    var samplesByVariantId = null;
    var samplesByNum = null;
    var fetchPromise = null;
    var enabled = !!collectionHandle;
    var SAMPLE_CAP = 10;

    function fetchSamples() {
      if (!enabled) return Promise.resolve(null);
      if (samplesBySku) return Promise.resolve(samplesBySku);
      if (fetchPromise) return fetchPromise;
      fetchPromise = fetch('/collections/' + collectionHandle + '/products.json?limit=250', { headers: { 'Accept': 'application/json' } })
        .then(function(r) { return r.json(); })
        .then(function(json) {
          samplesBySku = {};
          samplesByVariantId = {};
          samplesByNum = {};
          (json.products || []).forEach(function(p) {
            var v = p.variants && p.variants[0];
            if (!v) return;
            var sample = {
              id: v.id,
              name: p.title,
              handle: p.handle,
              image: (p.images && p.images[0] && p.images[0].src) || '',
              available: v.available !== false,
              sku: v.sku || ''
            };
            if (sample.sku) {
              samplesBySku[String(sample.sku).trim().toLowerCase()] = sample;
              // Some families use a bare numeric colour SKU ("544") while the
              // sample variant SKU carries a prefix / zero-padding ("N6COIL 544").
              // Index by the trailing number so findBySku can fall back to it.
              var numMatch = String(sample.sku).match(/(\d+)\s*$/);
              if (numMatch) {
                var numKey = String(parseInt(numMatch[1], 10));
                (samplesByNum[numKey] = samplesByNum[numKey] || []).push(sample);
              }
            }
            if (sample.id) samplesByVariantId[sample.id] = sample;
          });
          return samplesBySku;
        })
        .catch(function(e) {
          console.warn('[SampleATC] fetch failed', e);
          samplesBySku = {};
          return samplesBySku;
        });
      return fetchPromise;
    }

    function findBySku(sku) {
      if (!sku || !samplesBySku) return null;
      var key = String(sku).trim().toLowerCase();
      if (samplesBySku[key]) return samplesBySku[key];
      // Fallback for families whose colour component SKU is the bare number
      // (e.g. Mini "544") but whose sample SKU is prefixed / zero-padded
      // (e.g. "N6COIL 544"). Match on the trailing number only when it is
      // unambiguous (exactly one sample) so colour lines never cross-match.
      var m = key.match(/(\d+)\s*$/);
      if (m && samplesByNum) {
        var hits = samplesByNum[String(parseInt(m[1], 10))];
        if (hits && hits.length === 1) return hits[0];
      }
      return null;
    }

    function showToast(msg, isError) {
      if (typeof Flash === 'function') {
        try { (new Flash(msg, { isError: !!isError })).show(); return; } catch(e) {}
      }
      // R7 Warwick review 2026-05-23: theme-level Flash is not loaded on
      // the builder PDP, so the previous fallback (console only) meant the
      // mixed-cart message and other Sample ATC errors were silent for the
      // customer. Inline toast guarantees the message renders. Auto
      // dismisses after 5 seconds; fades in and out via CSS classes so
      // there is no JS animation loop. Multiple invocations stack
      // vertically because each toast is a separate fixed element.
      console[isError ? 'warn' : 'log']('[SampleATC]', msg);
      var toast = document.createElement('div');
      toast.className = 'builder-v2__inline-toast' + (isError ? ' builder-v2__inline-toast--error' : '');
      toast.setAttribute('role', isError ? 'alert' : 'status');
      toast.setAttribute('aria-live', isError ? 'assertive' : 'polite');
      toast.textContent = msg;
      document.body.appendChild(toast);
      requestAnimationFrame(function() {
        toast.classList.add('builder-v2__inline-toast--visible');
      });
      setTimeout(function() {
        toast.classList.remove('builder-v2__inline-toast--visible');
        setTimeout(function() {
          if (toast.parentNode) toast.parentNode.removeChild(toast);
        }, 350);
      }, 5000);
    }

    var cartCache = null;
    var cartPromise = null;

    function isSampleItem(item) {
      return item && /FDB Sample/i.test(item.vendor || '');
    }

    function sampleQtyInCart(cart) {
      if (!cart || !cart.items) return 0;
      return cart.items.filter(isSampleItem).reduce(function(s, i) { return s + (i.quantity || 0); }, 0);
    }

    function getCart() {
      if (cartCache) return Promise.resolve(cartCache);
      if (cartPromise) return cartPromise;
      cartPromise = fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          cartCache = cart;
          cartPromise = null;
          updateCapState(cart);
          return cart;
        })
        .catch(function(e) {
          cartPromise = null;
          throw e;
        });
      return cartPromise;
    }

    // Header bubble has a theme bug: buildCart adds .hide on empty but never
    // removes it on the 0->1 transition. Toggle it explicitly here.
    function updateNavCart(itemCount) {
      document.querySelectorAll('[data-cart-count]').forEach(function(el) { el.textContent = itemCount; });
      document.querySelectorAll('[data-cart-count-bubble]').forEach(function(el) {
        if (itemCount > 0) el.classList.remove('hide');
        else el.classList.add('hide');
      });
    }

    // Drawer rebuild via the theme's existing ajaxCart loader so an open
    // drawer reflects sample add/remove instead of staying stale.
    function rebuildDrawer() {
      try {
        if (window.ajaxCart && typeof window.ajaxCart.load === 'function') window.ajaxCart.load();
      } catch (e) { console.warn('[SampleATC] drawer rebuild failed', e); }
    }

    function updateCapState(cart) {
      var atCap = sampleQtyInCart(cart) >= SAMPLE_CAP;
      document.querySelectorAll('.builder-v2__sample-btn').forEach(function(btn) {
        if (btn.classList.contains('builder-v2__sample-btn--in-cart')) return;
        if (btn.classList.contains('builder-v2__sample-btn--out-of-stock')) return;
        if (btn.classList.contains('builder-v2__sample-btn--loading')) return;
        if (atCap) {
          btn.classList.add('builder-v2__sample-btn--cap-reached');
          btn.textContent = 'Cart full (10/10)';
        } else if (btn.classList.contains('builder-v2__sample-btn--cap-reached')) {
          btn.classList.remove('builder-v2__sample-btn--cap-reached');
          btn.textContent = 'Free Sample';
        }
      });
    }

    function applyCartResponse(cart) {
      cartCache = cart;
      updateNavCart(cart.item_count || 0);
      updateCapState(cart);
      rebuildDrawer();
    }

    document.addEventListener('cart:updated', function(e) {
      if (e && e.detail && e.detail.source === 'sample-atc') return;
      cartCache = null;
    });

    function setButtonState(btn, state, sample) {
      btn.classList.remove('builder-v2__sample-btn--in-cart', 'builder-v2__sample-btn--out-of-stock', 'builder-v2__sample-btn--loading', 'builder-v2__sample-btn--cap-reached');
      btn.removeAttribute('aria-disabled');
      var wrapper = btn.closest('.builder-v2__swatch-wrapper');
      if (state === 'in-cart') {
        btn.classList.add('builder-v2__sample-btn--in-cart');
        btn.innerHTML = 'Added <span class="builder-v2__sample-check" aria-hidden="true">&#10003;</span>';
        btn.setAttribute('aria-pressed', 'true');
        btn.setAttribute('aria-label', 'Remove ' + (sample && sample.name ? sample.name : 'sample') + ' from cart');
        btn.setAttribute('title', 'Click to remove');
        if (wrapper) wrapper.classList.add('builder-v2__swatch-wrapper--sample-in-cart');
      } else if (state === 'out-of-stock') {
        btn.classList.add('builder-v2__sample-btn--out-of-stock');
        btn.setAttribute('aria-disabled', 'true');
        btn.textContent = 'Free Sample';
        btn.setAttribute('aria-label', 'Free sample of ' + (sample && sample.name ? sample.name : 'this color') + ' (out of stock)');
        btn.setAttribute('aria-pressed', 'false');
        btn.removeAttribute('title');
        if (wrapper) wrapper.classList.remove('builder-v2__swatch-wrapper--sample-in-cart');
      } else if (state === 'loading') {
        btn.classList.add('builder-v2__sample-btn--loading');
        btn.textContent = '';
        btn.removeAttribute('title');
      } else {
        btn.textContent = 'Free Sample';
        btn.setAttribute('aria-pressed', 'false');
        btn.setAttribute('aria-label', 'Free sample of ' + (sample && sample.name ? sample.name : 'this color'));
        btn.removeAttribute('title');
        if (wrapper) wrapper.classList.remove('builder-v2__swatch-wrapper--sample-in-cart');
      }
    }

    function syncButtonsForVariant(variantId, state, sample) {
      var btns = document.querySelectorAll('[data-sample-variant="' + variantId + '"]');
      btns.forEach(function(btn) { setButtonState(btn, state, sample); });
    }

    function attachButton(wrapper, sku, colorName) {
      if (!enabled) return;
      var existing = wrapper.querySelector('.builder-v2__sample-btn');
      if (existing) existing.remove();

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'builder-v2__sample-btn';
      btn.textContent = 'Free Sample';
      btn.setAttribute('aria-pressed', 'false');
      // Reserve grid slot before knowing if a sample exists. visibility (not
      // display) keeps row height consistent — no flicker, no layout shift.
      btn.style.visibility = 'hidden';
      btn.style.pointerEvents = 'none';
      wrapper.appendChild(btn);

      fetchSamples().then(function() {
        var sample = findBySku(sku);
        if (!sample) {
          // No matching sample variant in the configured sample collection.
          // R5 Warwick review 2026-05-23: render the slot in the greyed
          // out-of-stock state instead of leaving it invisible so the
          // customer sees consistent UI across every colour swatch.
          btn.setAttribute('aria-label', 'Sample not available for ' + (colorName || 'this color'));
          btn.style.visibility = '';
          btn.style.pointerEvents = '';
          setButtonState(btn, 'out-of-stock', null);
          return;
        }
        btn.setAttribute('data-sample-variant', sample.id);
        btn.setAttribute('aria-label', 'Order ' + (sample.name || colorName || 'sample'));
        btn.style.visibility = '';
        btn.style.pointerEvents = '';

        if (sample.available === false) {
          setButtonState(btn, 'out-of-stock', sample);
          return;
        }

        getCart().then(function(cart) {
          var inCart = (cart.items || []).some(function(i) { return i.variant_id === sample.id; });
          setButtonState(btn, inCart ? 'in-cart' : 'default', sample);
          if (!inCart && sampleQtyInCart(cart) >= SAMPLE_CAP) {
            btn.classList.add('builder-v2__sample-btn--cap-reached');
            btn.textContent = 'Cart full (10/10)';
          }
        }).catch(function() {
          setButtonState(btn, 'default', sample);
        });
      });

      btn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        if (btn.classList.contains('builder-v2__sample-btn--out-of-stock')) return;
        if (btn.classList.contains('builder-v2__sample-btn--loading')) return;
        if (btn.classList.contains('builder-v2__sample-btn--cap-reached')) {
          showToast('Maximum 10 free samples per order.', true);
          return;
        }
        var variantId = parseInt(btn.getAttribute('data-sample-variant'), 10);
        if (!variantId) return;
        var sample = (samplesByVariantId && samplesByVariantId[variantId]) || null;

        if (btn.classList.contains('builder-v2__sample-btn--in-cart')) {
          // REMOVE: /cart/update.js with quantity=0 returns the full cart
          // (unlike change.js). One round-trip, authoritative response.
          setButtonState(btn, 'loading', sample);
          var updates = {};
          updates[variantId] = 0;
          fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ updates: updates })
          }).then(function(r) {
            if (!r.ok) throw new Error('Remove failed: ' + r.status);
            return r.json();
          }).then(function(cart) {
            syncButtonsForVariant(variantId, 'default', sample);
            applyCartResponse(cart);
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: { source: 'sample-atc' } }));
          }).catch(function() {
            syncButtonsForVariant(variantId, 'in-cart', sample);
            showToast('Could not remove sample. Please try again.', true);
          });
          return;
        }

        // ADD: pre-flight against shared cart cache.
        setButtonState(btn, 'loading', sample);
        getCart().then(function(cart) {
          var items = cart.items || [];
          var hasNonSample = items.some(function(i) { return !isSampleItem(i); });
          var sampleQty = sampleQtyInCart(cart);

          if (hasNonSample) {
            setButtonState(btn, 'default', sample);
            showToast('Free samples must be ordered separately. Please complete your current order first.', true);
            return null;
          }
          if (sampleQty >= SAMPLE_CAP) {
            setButtonState(btn, 'default', sample);
            updateCapState(cart);
            showToast('Maximum 10 free samples per order.', true);
            return null;
          }

          // /cart/add.js returns only the new line item. R6 Warwick review
          // 2026-05-23: instead of chaining a /cart.js GET to refresh the
          // authoritative item_count, mutate the cached cart locally and
          // skip the extra round-trip (~150-300 ms saved per click).
          // cartCache is already populated by the preflight getCart() above.
          // Fallback to /cart.js only when the cache was invalidated
          // between preflight and add (rare cross-tab race).
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
          }).then(function(r) {
            if (!r.ok) return r.json().then(function(err) { throw new Error(err.description || err.message || 'Add failed'); });
            return r.json();
          }).then(function(addResp) {
            // /cart/add.js returns either the single line item or
            // { items: [...] } depending on how the body was built.
            // Normalise to the line item we just added.
            var addedItem = (addResp && addResp.items && addResp.items.length)
              ? addResp.items[0]
              : addResp;
            syncButtonsForVariant(variantId, 'in-cart', sample);
            if (cartCache) {
              cartCache.items = (cartCache.items || []).concat([addedItem]);
              cartCache.item_count = (cartCache.item_count || 0) + 1;
              applyCartResponse(cartCache);
              document.dispatchEvent(new CustomEvent('cart:updated', { detail: { source: 'sample-atc' } }));
            } else {
              fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
                .then(function(r) { return r.json(); })
                .then(function(freshCart) {
                  applyCartResponse(freshCart);
                  document.dispatchEvent(new CustomEvent('cart:updated', { detail: { source: 'sample-atc' } }));
                });
            }
          });
        }).catch(function(e) {
          setButtonState(btn, 'default', sample);
          showToast((e && e.message) || 'Could not add sample. Please try again.', true);
        });
      });
    }

    // Pre-warm both fetches at module init so the first user click doesn't
    // pay for cold caches. fetchSamples and getCart kick off in parallel.
    if (enabled) {
      fetchSamples();
      getCart();
    }

    return {
      enabled: enabled,
      attachButton: attachButton,
      fetchSamples: fetchSamples
    };
  })();


  /* ============================================================
     STATE STORE
     ============================================================ */
  var store = Core.createStore({
    colorGroup: null,
    colorName: null,
    colorSku: null,
    colorImage: null,
    colorProductId: null,
    colorVariantId: null,
    mount: null,
    widthInt: null,
    widthFrac: 0,
    heightInt: null,
    heightFrac: 0,
    control: null,
    controlLabel: null,
    controlSurcharge: 0,
    remoteVariant: null,
    remoteLabel: null,
    remoteSurcharge: 0,
    rollDirection: null,
    roomName: '',
    measuresafe: false,
    shippingUpgrade: false,
    valanceType: null,
    valanceLabel: null,
    valancePrice: 0,
    linerValue: null,
    linerLabel: null,
    linerSurcharge: 0,
    linerColorValue: '',
    linerColorLabel: '',
    edgeBandValue: null,
    edgeBandLabel: null,
    edgeBandSurcharge: 0,
    edgeBandColorValue: '',
    edgeBandColorLabel: '',
    valanceSelValue: null,
    valanceSelLabel: null,
    valanceSelSurcharge: 0,
    foldStyle: null,
    foldCode: null,
    foldLabel: null,
    foldPct: 0,
    foldSurcharge: 0,
    lining: null,
    liningCode: null,
    liningLabel: null,
    liningPct: 0,
    liningSurcharge: 0,
    oversizeSurcharge: 0,
    quantity: 1,
    basePrice: 0,
    totalPrice: 0,
    sizeVariantId: null,
    blind1WidthInt: null,
    blind1WidthFrac: 0,
    blind2WidthInt: null,
    blind2WidthFrac: 0,
    blind1Tilt: 'Left',
    blind2Tilt: 'Right',
    // Mariak vertical steps
    stackValue: null, stackLabel: null, stackSurcharge: 0,
    verticalValanceValue: null, verticalValanceLabel: null, verticalValanceSurcharge: 0,
    extraVaneValue: null, extraVaneLabel: null, extraVaneSurcharge: 0,
    channelPanelOption: null, channelPanelCode: null, channelPanelLabel: null,
    channelPanelPct: 0, channelPanelSurcharge: 0
  });

  /* ============================================================
     PRICING ENGINE INIT
     ============================================================ */
  var pricing = pricingData ? new Core.PricingEngine(pricingData) : null;

  // Read flat add-on price (cents) from pricingData.addon_prices, falling
  // back to the legacy hardcoded value when the metafield is missing.
  // Returning null short-circuits the feature: callers should treat null
  // as "hide the entire row" (e.g. 2-Day Air on Phase II parents).
  function getAddonCents(key, defaultCents) {
    if (!pricing || !pricing.data || !pricing.data.addon_prices) return defaultCents;
    var v = pricing.data.addon_prices[key];
    if (v === null) return null;
    return (typeof v === 'number') ? v : defaultCents;
  }

  // MeasureSafe bills through a fixed-price item, so a parent priced away from $9.99 names its own item here.
  function measureSafeVariantId() {
    var ap = pricing && pricing.data && pricing.data.addon_prices;
    return (ap && ap.measuresafe_variant_id) ? String(ap.measuresafe_variant_id) : '55217671340200';
  }

  /* ============================================================
     FIND COMPONENT BLOCKS BY TYPE
     ============================================================ */
  function findBlock(type) {
    if (!componentsData || !componentsData.blocks) return null;
    for (var i = 0; i < componentsData.blocks.length; i++) {
      if (componentsData.blocks[i].type === type) return componentsData.blocks[i];
    }
    return null;
  }

  function findSizeBlock() {
    return findBlock('size');
  }

  function findColorBlock() {
    return findBlock('color');
  }

  /**
   * Get the line item property key name from a block's config.
   * Searches by block type first, then by builder_type.
   * Falls back to provided default if not found.
   * This ensures EDI keys match whatever the merchant configured in the theme customizer.
   */
  function getBlockPropertyKey(blockType, fallback) {
    // Search by block type (e.g. 'color', 'size')
    var block = findBlock(blockType);
    if (block && block.property) return block.property;
    // Search by builder_type (e.g. 'Mount', 'Lift Cord')
    if (componentsData && componentsData.blocks) {
      for (var i = 0; i < componentsData.blocks.length; i++) {
        if (componentsData.blocks[i].builder_type === blockType) {
          return componentsData.blocks[i].property || fallback;
        }
      }
    }
    return fallback;
  }

  /* ============================================================
     SIZE VARIANT HELPERS
     Parse "WIDTHxHEIGHT" variant titles from the -1 product.
     Cached after first parse to avoid re-processing on every size change.
     ============================================================ */
  var _sizeVariantsCache = null;
  var _sizeVariantsCacheKey = null;
  /* A colour group may pin its own size-holder product, so a parent that sells
     several price grids charges the grid the shopper actually picked. Cordless
     Woven Wood is the first: Classic, Signature and Luxe are three different
     grids and one shared holder was charging every fabric the Signature price
     (Warwick, 17 Aug 2026). Returns null for every parent that does not set
     size_product_id, which keeps the merge-all behaviour below unchanged. */
  function activeSizeProductId() {
    if (!pricing || !pricing.getActiveGroup) return null;
    var group = pricing.getActiveGroup();
    return (group && group.size_product_id) || null;
  }

  function parseSizeVariants() {
    /* Cache is keyed on the pinned product, so switching fabric drops the
       previous group's WxH map instead of charging its price. */
    var pinnedId = activeSizeProductId();
    if (_sizeVariantsCache !== null && _sizeVariantsCacheKey === pinnedId) {
      return _sizeVariantsCache;
    }
    _sizeVariantsCacheKey = pinnedId;
    var sizeBlock = findSizeBlock();
    if (!sizeBlock || !sizeBlock.products || sizeBlock.products.length === 0) {
      _sizeVariantsCache = [];
      return _sizeVariantsCache;
    }
    // Merge variants across ALL size products, not just products[0]. Shopify
    // caps a product at 100 variants, so a large size grid (e.g. the Mini
    // grids run ~200 cells) is split across multiple component products of the
    // same type. Reading only the first would expose half the grid and
    // mis-price the rest under the variant-pricing fallback. Dedupe by WxH
    // (first wins). Products with a single size product are unaffected.
    var variants = [];
    var seenSize = {};
    for (var p = 0; p < sizeBlock.products.length; p++) {
      var product = sizeBlock.products[p];
      if (!product || !product.variants) continue;
      /* When the active fabric pins a holder, read ONLY that product. Without
         this the loop below merges every holder and dedupes by WxH first-wins,
         so whichever product the collection returns first prices all fabrics. */
      if (pinnedId && String(product.id) !== String(pinnedId)) continue;
      for (var i = 0; i < product.variants.length; i++) {
        var v = product.variants[i];
        var normalized = v.title.replace(/\s/g, '').toLowerCase();
        var parts = normalized.split('x');
        if (parts.length === 2 && !isNaN(parseInt(parts[0], 10)) && !isNaN(parseInt(parts[1], 10))) {
          var sizeKey = parseInt(parts[0], 10) + 'x' + parseInt(parts[1], 10);
          if (seenSize[sizeKey]) continue;
          seenSize[sizeKey] = true;
          variants.push({
            id: v.id,
            width: parseInt(parts[0], 10),
            height: parseInt(parts[1], 10),
            price: v.price / 100,
            title: sizeKey
          });
        }
      }
    }
    _sizeVariantsCache = variants;
    return variants;
  }

  /**
   * Resolve a Shopify variant ID to anchor the cart line for a given
   * tier width x tier height. The variant is just an anchor - real price
   * and dimensions ride on line item properties (_BundleSubtotal, Width,
   * Height, etc.) for LogicBroker EDI. So we never want this to return
   * null while the user has a valid configuration.
   *
   * Resolution order:
   *   1. Exact "WxH" match in the size block product (if its variants
   *      are titled in WxH format).
   *   2. First parsed size variant (for size products that have anchor
   *      variants but not titled in WxH format).
   *   3. Parent product's first available variant from parentData.
   *
   * @param {number} tierWidth
   * @param {number} tierHeight
   * @returns {number|null}
   */
  function findSizeVariantId(tierWidth, tierHeight) {
    var variants = parseSizeVariants();

    // 1. Exact tier match
    var target = tierWidth + 'x' + tierHeight;
    for (var i = 0; i < variants.length; i++) {
      if (variants[i].title === target) return variants[i].id;
    }

    // 2. Closest variant >= tier dimensions (round-up match).
    //    Pricing tiers may use 6" increments but size variants use 12",
    //    so exact match can miss. Pick the smallest variant that covers
    //    the tier dimensions so checkout charges the correct amount.
    if (variants.length > 0 && tierWidth > 0 && tierHeight > 0) {
      var bestVariant = null;
      var bestDiff = Infinity;
      for (var vi = 0; vi < variants.length; vi++) {
        if (variants[vi].width >= tierWidth && variants[vi].height >= tierHeight) {
          var diff = (variants[vi].width - tierWidth) + (variants[vi].height - tierHeight);
          if (diff < bestDiff) {
            bestDiff = diff;
            bestVariant = variants[vi];
          }
        }
      }
      if (bestVariant) return bestVariant.id;
    }

    // 3. First parsed size variant fallback
    if (variants.length > 0) return variants[0].id;

    // 3. Raw first variant of the size block product (not WxH titled)
    var sizeBlock = findSizeBlock();
    if (sizeBlock && sizeBlock.products && sizeBlock.products.length > 0) {
      var sp = sizeBlock.products[0];
      if (sp.variants && sp.variants.length > 0) return sp.variants[0].id;
    }

    // 4. Parent product variant as ultimate anchor
    if (parentData && parentData.variant_id) return parentData.variant_id;

    return null;
  }

  /* ============================================================
     GENERATE SEQUENTIAL RANGE
     ============================================================ */
  function range(min, max) {
    var arr = [];
    for (var i = min; i <= max; i++) arr.push(i);
    return arr;
  }


  /* ============================================================
     PER-PRODUCT MOUNT ICONS (Builder 1.0 parity, Warwick review 2026-05-23)
     Inside / Outside mount tile SVGs for Cellular, Faux Wood, Bamboo, and
     Pleated PDPs. Other v2 templates keep the generic icons in ICONS below.
     Activation: window.__BUILDER_V2_MOUNT_TYPE rendered by the section.
     ============================================================ */
  var MOUNT_FRAME = {
    outer: '<rect x="12" y="8" width="96" height="84" rx="2" fill="#f0f0f0" stroke="#bbb" stroke-width="1"/>',
    inner: '<rect x="20" y="15" width="80" height="75" rx="1" fill="#fff" stroke="#13548d" stroke-width="2"/>',
    sill:  '<line x1="16" y1="90" x2="104" y2="90" stroke="#13548d" stroke-width="2.5" stroke-linecap="round"/>'
  };
  function wrapMountSvg(inner) {
    return '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 120 100" fill="none">' +
      MOUNT_FRAME.outer + MOUNT_FRAME.inner + MOUNT_FRAME.sill + inner + '</svg>';
  }
  function cellRows(x, w, yStart, rows) {
    var s = '', h = 5;
    for (var i = 0; i < rows; i++) {
      var y = yStart + i * h;
      s += '<path d="M' + x + ' ' + y + ' l' + (w / 4) + ' ' + (h / 2) +
           ' l' + (w / 4) + ' -' + (h / 2) + ' l' + (w / 4) + ' ' + (h / 2) +
           ' l' + (w / 4) + ' -' + (h / 2) + '" stroke="#13548d" stroke-width="1" fill="none"/>';
    }
    return '<rect x="' + x + '" y="' + yStart + '" width="' + w + '" height="' + (rows * h) +
      '" fill="#e8f0f8" stroke="#13548d" stroke-width="1.2" rx="1"/>' + s;
  }
  function pleatShape(x, w, yStart, yEnd) {
    var s = '<rect x="' + x + '" y="' + yStart + '" width="' + w + '" height="' + (yEnd - yStart) +
      '" fill="#e8f0f8" stroke="#13548d" stroke-width="1.2" rx="1"/>';
    var rows = Math.floor((yEnd - yStart) / 4);
    for (var i = 0; i <= rows; i++) {
      var y = yStart + i * 4;
      s += '<line x1="' + x + '" y1="' + y + '" x2="' + (x + w) + '" y2="' + y +
        '" stroke="#13548d" stroke-width="0.6" opacity="0.5"/>';
    }
    return s;
  }
  function woodSlats(x, w, yStart, yEnd) {
    var s = '<rect x="' + x + '" y="' + yStart + '" width="' + w +
      '" height="4" fill="#d0dde8" stroke="#13548d" stroke-width="1" rx="1"/>';
    var lx1 = x + w * 0.25, lx2 = x + w * 0.75;
    s += '<line x1="' + lx1 + '" y1="' + yStart + '" x2="' + lx1 + '" y2="' + yEnd +
      '" stroke="#13548d" stroke-width="0.5" opacity="0.4"/>';
    s += '<line x1="' + lx2 + '" y1="' + yStart + '" x2="' + lx2 + '" y2="' + yEnd +
      '" stroke="#13548d" stroke-width="0.5" opacity="0.4"/>';
    for (var y = yStart + 6, slatH = 6; y < yEnd; y += slatH) {
      s += '<rect x="' + (x + 1) + '" y="' + y + '" width="' + (w - 2) +
        '" height="3.5" rx="0.5" fill="#e8f0f8" stroke="#13548d" stroke-width="0.8"/>';
    }
    return s;
  }
  function wovenTexture(x, w, yStart, yEnd) {
    var s = '<rect x="' + x + '" y="' + yStart + '" width="' + w + '" height="' + (yEnd - yStart) +
      '" fill="#f0e8d8" stroke="#13548d" stroke-width="1.2" rx="1"/>';
    for (var y = yStart + 3; y < yEnd; y += 4) {
      s += '<line x1="' + x + '" y1="' + y + '" x2="' + (x + w) + '" y2="' + y +
        '" stroke="#c4a87a" stroke-width="1" opacity="0.6"/>';
    }
    for (var vx = x + 6; vx < x + w; vx += 12) {
      s += '<line x1="' + vx + '" y1="' + yStart + '" x2="' + vx + '" y2="' + yEnd +
        '" stroke="#b89860" stroke-width="0.5" opacity="0.3"/>';
    }
    s += '<rect x="' + x + '" y="' + yStart + '" width="' + w +
      '" height="4" fill="#d0bfa0" stroke="#13548d" stroke-width="1" rx="1"/>';
    return s;
  }
  var MOUNT_SVGS = {
    cellular: {
      inside:  wrapMountSvg('<rect x="24" y="17" width="72" height="4" fill="#d0dde8" stroke="#13548d" stroke-width="1"/>' + cellRows(24, 72, 21, 11)),
      outside: wrapMountSvg('<rect x="10" y="8" width="100" height="5" fill="#d0dde8" stroke="#13548d" stroke-width="1"/>' + cellRows(10, 100, 13, 13))
    },
    faux: {
      inside:  wrapMountSvg(woodSlats(24, 72, 17, 76)),
      outside: wrapMountSvg(woodSlats(10, 100, 8, 83))
    },
    woven: {
      inside:  wrapMountSvg(wovenTexture(24, 72, 17, 76)),
      outside: wrapMountSvg(wovenTexture(10, 100, 8, 83))
    },
    pleated: {
      inside:  wrapMountSvg('<rect x="24" y="17" width="72" height="4" fill="#d0dde8" stroke="#13548d" stroke-width="1"/>' + pleatShape(24, 72, 21, 76)),
      outside: wrapMountSvg('<rect x="10" y="8" width="100" height="5" fill="#d0dde8" stroke="#13548d" stroke-width="1"/>' + pleatShape(10, 100, 13, 83))
    }
  };
  function getMountSvgs() {
    var type = (typeof window !== 'undefined') ? window.__BUILDER_V2_MOUNT_TYPE : null;
    return (type && MOUNT_SVGS[type]) ? MOUNT_SVGS[type] : { inside: ICONS.insideMount, outside: ICONS.outsideMount };
  }
  function hasPerTypeMount() {
    var type = (typeof window !== 'undefined') ? window.__BUILDER_V2_MOUNT_TYPE : null;
    return !!(type && MOUNT_SVGS[type]);
  }

  /* ============================================================
     OPTION ICON IMAGES - Builder 1.0 parity (Warwick review 2026-06-13).
     "Use the icons from the current builder." For the Mount and Valance
     tiles we render the same option-product variant image the old builder
     uses (passed in via #builder-v2-option-icons), falling back to the
     inline SVG when no image exists. Purely cosmetic: the cart property
     value emitted for each selection is unchanged, so EDI is unaffected.
     ============================================================ */
  function optionIconUrl(map, exactKey, predicate) {
    if (!map) return '';
    if (exactKey && map[exactKey]) return map[exactKey];
    if (predicate) {
      for (var k in map) {
        if (map.hasOwnProperty(k) && predicate(k)) return map[k];
      }
    }
    return '';
  }
  function iconSlotHtml(imgUrl, svgFallback, alt) {
    if (imgUrl) {
      return '<img class="builder-v2__icon-card-img" src="' + escapeHtml(imgUrl) +
             '" alt="' + escapeHtml(alt || '') + '" loading="lazy" decoding="async">';
    }
    return svgFallback || '';
  }

  /* ============================================================
     INLINE SVG ICONS — High-quality filled illustrations (80x80 viewBox)
     Must be defined before STEPS array since render functions reference ICONS.
     ============================================================ */
  var ICONS = {
    // STEP 2: MOUNT TYPE
    insideMount: '<svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">' +
      '<rect x="10" y="10" width="60" height="60" rx="2" fill="#F5F5F5" stroke="#607D8B" stroke-width="3"/>' +
      '<rect x="14" y="14" width="52" height="52" rx="1" fill="#fff" stroke="#78909C" stroke-width="2.5"/>' +
      '<rect x="20" y="18" width="40" height="6" rx="3" fill="#13548d"/>' +
      '<rect x="20" y="24" width="40" height="36" fill="#E8EDF2" stroke="#13548d" stroke-width="2" stroke-linecap="round"/>' +
      '<path d="M18 40l-4 3v-6l4 3z" fill="#13548d" opacity=".6"/>' +
      '<path d="M62 40l4-3v6l-4-3z" fill="#13548d" opacity=".6"/>' +
      '</svg>',
    outsideMount: '<svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">' +
      '<rect x="16" y="20" width="48" height="50" rx="2" fill="#F5F5F5" stroke="#607D8B" stroke-width="3"/>' +
      '<rect x="20" y="24" width="40" height="42" rx="1" fill="#fff" stroke="#78909C" stroke-width="2.5"/>' +
      '<rect x="8" y="12" width="64" height="6" rx="3" fill="#13548d"/>' +
      '<rect x="8" y="18" width="64" height="40" fill="#E8EDF2" stroke="#13548d" stroke-width="2" stroke-linecap="round"/>' +
      '<path d="M10 38l-6 4v-8l6 4z" fill="#13548d" opacity=".6"/>' +
      '<path d="M70 38l6-4v8l-6-4z" fill="#13548d" opacity=".6"/>' +
      '</svg>',

    // STEP 3: CONTROL STYLE
    chainLeft: '<svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">' +
      '<rect x="14" y="10" width="52" height="7" rx="3.5" fill="#13548d"/>' +
      '<rect x="14" y="17" width="52" height="44" fill="#E8EDF2" stroke="#78909C" stroke-width="2.5"/>' +
      '<rect x="14" y="59" width="52" height="3" rx="1" fill="#78909C"/>' +
      '<line x1="18" y1="17" x2="18" y2="30" stroke="#13548d" stroke-width="2" stroke-linecap="round"/>' +
      '<circle cx="18" cy="33" r="3" fill="#13548d"/><circle cx="18" cy="40" r="3" fill="#13548d"/>' +
      '<circle cx="18" cy="47" r="3" fill="#13548d"/><circle cx="18" cy="54" r="3" fill="#13548d"/>' +
      '<circle cx="18" cy="61" r="3" fill="#13548d"/><circle cx="18" cy="68" r="3" fill="#13548d"/>' +
      '<path d="M15 68q-3 4 0 8t6 0" stroke="#13548d" stroke-width="2" fill="none" stroke-linecap="round"/>' +
      '</svg>',
    chainRight: '<svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">' +
      '<rect x="14" y="10" width="52" height="7" rx="3.5" fill="#13548d"/>' +
      '<rect x="14" y="17" width="52" height="44" fill="#E8EDF2" stroke="#78909C" stroke-width="2.5"/>' +
      '<rect x="14" y="59" width="52" height="3" rx="1" fill="#78909C"/>' +
      '<line x1="62" y1="17" x2="62" y2="30" stroke="#13548d" stroke-width="2" stroke-linecap="round"/>' +
      '<circle cx="62" cy="33" r="3" fill="#13548d"/><circle cx="62" cy="40" r="3" fill="#13548d"/>' +
      '<circle cx="62" cy="47" r="3" fill="#13548d"/><circle cx="62" cy="54" r="3" fill="#13548d"/>' +
      '<circle cx="62" cy="61" r="3" fill="#13548d"/><circle cx="62" cy="68" r="3" fill="#13548d"/>' +
      '<path d="M59 68q-3 4 0 8t6 0" stroke="#13548d" stroke-width="2" fill="none" stroke-linecap="round"/>' +
      '</svg>',
    cordless: '<svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">' +
      '<rect x="14" y="10" width="52" height="7" rx="3.5" fill="#13548d"/>' +
      '<rect x="14" y="17" width="52" height="34" fill="#E8EDF2" stroke="#78909C" stroke-width="2.5"/>' +
      '<rect x="14" y="49" width="52" height="4" rx="2" fill="#78909C" stroke="#607D8B" stroke-width="1"/>' +
      '<path d="M34 62c0-3 2-5 6-5s6 2 6 5" stroke="#455A64" stroke-width="3" stroke-linecap="round" fill="none"/>' +
      '<path d="M37 65l3-4 3 4" fill="#455A64"/>' +
      '<circle cx="40" cy="58" r="2" fill="#455A64"/>' +
      '<path d="M40 68v-4" stroke="#455A64" stroke-width="2" stroke-linecap="round"/>' +
      '<path d="M36 72h8" stroke="#13548d" stroke-width="2" stroke-linecap="round" opacity=".5"/>' +
      '</svg>',
    // Clutch on BOTH sides for the cellular Double Cell TDBU: a honeycomb
    // cellular shade with a beaded continuous-cord loop on the LEFT and RIGHT
    // rails (Kay, 2026-07-09). Approved reference art, downscaled to a transparent
    // WebP and embedded as a data-URI so it drops into the same 100px icon slot.
    clutchBothSides: '<img src="data:image/webp;base64,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" alt="" style="width:100%;height:100%;object-fit:contain;display:block" />',
    motorized: '<svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">' +
      '<rect x="14" y="14" width="52" height="7" rx="3.5" fill="#13548d"/>' +
      '<rect x="8" y="12" width="12" height="11" rx="3" fill="#455A64" stroke="#37474F" stroke-width="2"/>' +
      '<rect x="14" y="21" width="52" height="34" fill="#E8EDF2" stroke="#78909C" stroke-width="2.5"/>' +
      '<rect x="14" y="53" width="52" height="3" rx="1" fill="#78909C"/>' +
      '<rect x="28" y="62" width="24" height="14" rx="4" fill="#fff" stroke="#13548d" stroke-width="2"/>' +
      '<circle cx="36" cy="69" r="2" fill="#13548d"/><circle cx="44" cy="69" r="2" fill="#13548d"/>' +
      '<circle cx="40" cy="65" r="1.5" fill="#13548d" opacity=".4"/>' +
      '<path d="M18 24c-4 2-7 0-9-2" stroke="#13548d" stroke-width="2" stroke-linecap="round" opacity=".4"/>' +
      '<path d="M16 28c-5 3-9 0-12-3" stroke="#13548d" stroke-width="2" stroke-linecap="round" opacity=".25"/>' +
      '</svg>',

    // ROMAN FOLD STYLES (line-drawing style from Elizabeth's Phase II diagrams)
    foldPlain: '<svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">' +
      '<rect x="14" y="10" width="52" height="7" rx="3.5" fill="#13548d"/>' +
      '<rect x="14" y="17" width="52" height="46" fill="#E8EDF2" stroke="#78909C" stroke-width="2.5"/>' +
      '<line x1="14" y1="27" x2="66" y2="27" stroke="#78909C" stroke-width="2"/>' +
      '<line x1="14" y1="36" x2="66" y2="36" stroke="#78909C" stroke-width="2"/>' +
      '<line x1="14" y1="45" x2="66" y2="45" stroke="#78909C" stroke-width="2"/>' +
      '<line x1="14" y1="54" x2="66" y2="54" stroke="#78909C" stroke-width="2"/>' +
      '<rect x="14" y="61" width="52" height="3" rx="1" fill="#78909C"/>' +
      '</svg>',
    foldFlat: '<svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">' +
      '<rect x="14" y="10" width="52" height="7" rx="3.5" fill="#13548d"/>' +
      '<rect x="14" y="17" width="52" height="46" fill="#E8EDF2" stroke="#78909C" stroke-width="2.5"/>' +
      '<line x1="14" y1="50" x2="66" y2="50" stroke="#78909C" stroke-width="2"/>' +
      '<rect x="14" y="54" width="52" height="9" fill="#D7DEE5" stroke="#78909C" stroke-width="2"/>' +
      '<rect x="14" y="61" width="52" height="3" rx="1" fill="#78909C"/>' +
      '</svg>',
    foldSoft: '<svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">' +
      '<rect x="14" y="10" width="52" height="7" rx="3.5" fill="#13548d"/>' +
      '<rect x="14" y="17" width="52" height="46" fill="#E8EDF2" stroke="#78909C" stroke-width="2.5"/>' +
      '<path d="M14 28q26 9 52 0" stroke="#78909C" stroke-width="2" fill="none"/>' +
      '<path d="M14 40q26 9 52 0" stroke="#78909C" stroke-width="2" fill="none"/>' +
      '<path d="M14 52q26 9 52 0" stroke="#78909C" stroke-width="2" fill="none"/>' +
      '<rect x="14" y="61" width="52" height="3" rx="1" fill="#78909C"/>' +
      '</svg>',
    lining: '<svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">' +
      '<rect x="18" y="22" width="44" height="36" rx="3" fill="#D7DEE5" stroke="#78909C" stroke-width="2.5"/>' +
      '<rect x="24" y="16" width="44" height="36" rx="3" fill="#E8EDF2" stroke="#13548d" stroke-width="2.5"/>' +
      '<line x1="30" y1="27" x2="62" y2="27" stroke="#78909C" stroke-width="2"/>' +
      '<line x1="30" y1="35" x2="62" y2="35" stroke="#78909C" stroke-width="2"/>' +
      '<line x1="30" y1="43" x2="62" y2="43" stroke="#78909C" stroke-width="2"/>' +
      '</svg>',

    // Motorwand icons share the chain-icon proportions (head rail + 44-high
    // shade panel + bottom rail at y=59) so the family looks consistent at
    // step 3. The chain on the side is replaced by a straight navy wand
    // (rigid rod) drawn BEFORE the bottom rail so the rail occludes it at
    // the intersection. A small hand grip sits below the bottom rail to
    // convey "press to operate" per the AmericanBlinds reference Warwick
    // linked in the Notion review.
    motorwandLeft: '<svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">' +
      // AmericanBlinds-style composition: window-in-frame backdrop, white
      // shade hanging from a head rail, thin blue motorwand line on the
      // LEFT, and a small circular callout in the upper area showing a
      // line-art hand pinching the wand.
      '<defs>' +
        '<linearGradient id="mwl-sky" x1="0" y1="0" x2="0" y2="1">' +
          '<stop offset="0" stop-color="#DDE9F2"/><stop offset="0.65" stop-color="#F4F7FA"/><stop offset="0.85" stop-color="#E5F0E0"/><stop offset="1" stop-color="#BFD9B8"/>' +
        '</linearGradient>' +
        '<linearGradient id="mwl-shade-grad" x1="0" y1="0" x2="0" y2="1">' +
          '<stop offset="0" stop-color="#FFFFFF"/><stop offset="1" stop-color="#E6EAEE"/>' +
        '</linearGradient>' +
      '</defs>' +
      // Window opening with sky + faint landscape strip at the bottom
      '<rect x="3" y="3" width="74" height="74" rx="2" fill="url(#mwl-sky)" stroke="#B8C2CB" stroke-width="1"/>' +
      // Window mullion (horizontal divider) for a real window feel
      '<line x1="3" y1="46" x2="77" y2="46" stroke="#B8C2CB" stroke-width="0.7"/>' +
      // Head rail (navy, full window width)
      '<rect x="3" y="3" width="74" height="6" rx="1" fill="#13548d"/>' +
      // Roller shade pulled down most of the window
      '<rect x="6" y="9" width="68" height="50" fill="url(#mwl-shade-grad)" stroke="#A8B2BB" stroke-width="0.8"/>' +
      // Shade bottom rail
      '<rect x="6" y="58" width="68" height="2" rx="0.5" fill="#9CA3AB"/>' +
      // Thin blue wand line running down the LEFT side of the shade
      '<line x1="18" y1="9" x2="18" y2="58" stroke="#1976D2" stroke-width="1.6" stroke-linecap="round"/>' +
      // Subtle anchor at the top of the wand where it joins the head rail
      '<circle cx="18" cy="9" r="1.3" fill="#0e3f6d"/>' +
      // Subtle weight/tip at the bottom of the wand
      '<circle cx="18" cy="58" r="1.4" fill="#0e3f6d"/>' +
      // Circular callout positioned in the upper-left of the shade
      '<circle cx="24" cy="26" r="13" fill="#FFFFFF" stroke="#455A64" stroke-width="0.9"/>' +
      // Tabler hand-click icon (MIT licensed, tabler-icons.io). Original
      // 24x24 viewBox; scaled 0.6x and translated so the index finger
      // points up at the wand inside the callout circle.
      '<g transform="translate(13.5 17) scale(0.55)" stroke="#455A64" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" fill="none">' +
        '<path d="M8 13V4.5a1.5 1.5 0 0 1 3 0V12m0-.5v-2a1.5 1.5 0 0 1 3 0V12m0-1.5a1.5 1.5 0 0 1 3 0V12"/>' +
        '<path d="M17 11.5a1.5 1.5 0 0 1 3 0V16a6 6 0 0 1-6 6h-2a6 6 0 0 1-5-2.7L7 19q-.5-.7-3.3-5.7a1.5 1.5 0 0 1 .5-2a1.9 1.9 0 0 1 2.3.3L8 13"/>' +
      '</g>' +
      '</svg>',
    motorwandRight: '<svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">' +
      '<defs>' +
        '<linearGradient id="mwr-sky" x1="0" y1="0" x2="0" y2="1">' +
          '<stop offset="0" stop-color="#DDE9F2"/><stop offset="0.65" stop-color="#F4F7FA"/><stop offset="0.85" stop-color="#E5F0E0"/><stop offset="1" stop-color="#BFD9B8"/>' +
        '</linearGradient>' +
        '<linearGradient id="mwr-shade-grad" x1="0" y1="0" x2="0" y2="1">' +
          '<stop offset="0" stop-color="#FFFFFF"/><stop offset="1" stop-color="#E6EAEE"/>' +
        '</linearGradient>' +
      '</defs>' +
      '<rect x="3" y="3" width="74" height="74" rx="2" fill="url(#mwr-sky)" stroke="#B8C2CB" stroke-width="1"/>' +
      '<line x1="3" y1="46" x2="77" y2="46" stroke="#B8C2CB" stroke-width="0.7"/>' +
      '<rect x="3" y="3" width="74" height="6" rx="1" fill="#13548d"/>' +
      '<rect x="6" y="9" width="68" height="50" fill="url(#mwr-shade-grad)" stroke="#A8B2BB" stroke-width="0.8"/>' +
      '<rect x="6" y="58" width="68" height="2" rx="0.5" fill="#9CA3AB"/>' +
      '<line x1="62" y1="9" x2="62" y2="58" stroke="#1976D2" stroke-width="1.6" stroke-linecap="round"/>' +
      '<circle cx="62" cy="9" r="1.3" fill="#0e3f6d"/>' +
      '<circle cx="62" cy="58" r="1.4" fill="#0e3f6d"/>' +
      '<circle cx="56" cy="26" r="13" fill="#FFFFFF" stroke="#455A64" stroke-width="0.9"/>' +
      // Mirrored Tabler hand-click — same icon flipped horizontally so it
      // visually balances the right-side wand placement.
      '<g transform="translate(66.5 17) scale(-0.55 0.55)" stroke="#455A64" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" fill="none">' +
        '<path d="M8 13V4.5a1.5 1.5 0 0 1 3 0V12m0-.5v-2a1.5 1.5 0 0 1 3 0V12m0-1.5a1.5 1.5 0 0 1 3 0V12"/>' +
        '<path d="M17 11.5a1.5 1.5 0 0 1 3 0V16a6 6 0 0 1-6 6h-2a6 6 0 0 1-5-2.7L7 19q-.5-.7-3.3-5.7a1.5 1.5 0 0 1 .5-2a1.9 1.9 0 0 1 2.3.3L8 13"/>' +
      '</g>' +
      '</svg>',

    // STEP 4: ROLL DIRECTION — premium FRONT-VIEW redesign matching the
    // shopper's mental model (the view they have standing in their room).
    // Both icons render the blind hanging in a window with the TOP of the
    // assembly as the differentiator:
    //   - Standard = clean horizontal tube visible at top, fabric panel
    //     hanging behind it (you see the cylindrical aluminum bar).
    //   - Reverse  = fabric drapes OVER the front of the tube creating
    //     a visible "wave" / curled lip at the top. Tube hidden behind
    //     the fabric drape.
    // Gradients on fabric and tube add material depth; warm cream stroke
    // hints at the window frame for context without dominating; soft
    // floor shadow grounds the assembly.
    standardRoll: '<svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">' +
      '<defs>' +
        // Navy fabric gradient (FDB brand) — top highlight, mid body, deep base
        '<linearGradient id="stdFab" x1="0" y1="0" x2="0" y2="1">' +
          '<stop offset="0%" stop-color="#2378b8"/>' +
          '<stop offset="35%" stop-color="#155995"/>' +
          '<stop offset="100%" stop-color="#0a3a64"/>' +
        '</linearGradient>' +
        // Brushed-aluminum cylinder
        '<linearGradient id="stdTub" x1="0" y1="0" x2="0" y2="1">' +
          '<stop offset="0%" stop-color="#A6B0BD"/>' +
          '<stop offset="30%" stop-color="#FFFFFF"/>' +
          '<stop offset="58%" stop-color="#E5E9EF"/>' +
          '<stop offset="100%" stop-color="#6A7480"/>' +
        '</linearGradient>' +
        // Premium end cap with metallic light catch
        '<radialGradient id="stdCap" cx="0.3" cy="0.3" r="0.85">' +
          '<stop offset="0%" stop-color="#FFFFFF"/>' +
          '<stop offset="55%" stop-color="#C5CDD8"/>' +
          '<stop offset="100%" stop-color="#4F5965"/>' +
        '</radialGradient>' +
        // Inner shadow at top of fabric (where it tucks behind tube)
        '<linearGradient id="stdInner" x1="0" y1="0" x2="0" y2="1">' +
          '<stop offset="0%" stop-color="#000" stop-opacity=".35"/>' +
          '<stop offset="100%" stop-color="#000" stop-opacity="0"/>' +
        '</linearGradient>' +
      '</defs>' +
      // Floor shadow — wider and darker for grounded weight
      '<ellipse cx="40" cy="76" rx="32" ry="1.7" fill="#000" opacity=".18"/>' +
      // FABRIC — fills ~90% of viewBox width for proper presence
      '<rect x="6" y="22" width="62" height="50" fill="url(#stdFab)"/>' +
      // Inner-shadow band at top (depth cue — fabric tucks behind tube)
      '<rect x="6" y="22" width="62" height="7" fill="url(#stdInner)"/>' +
      // Subtle vertical weave — gives it tactile fabric feel, not a flat plane
      '<line x1="18" y1="28" x2="18" y2="71" stroke="#FFFFFF" stroke-width="0.35" opacity=".18"/>' +
      '<line x1="29" y1="28" x2="29" y2="71" stroke="#FFFFFF" stroke-width="0.35" opacity=".18"/>' +
      '<line x1="40" y1="28" x2="40" y2="71" stroke="#FFFFFF" stroke-width="0.35" opacity=".18"/>' +
      '<line x1="51" y1="28" x2="51" y2="71" stroke="#FFFFFF" stroke-width="0.35" opacity=".18"/>' +
      '<line x1="62" y1="28" x2="62" y2="71" stroke="#FFFFFF" stroke-width="0.35" opacity=".18"/>' +
      // Bottom hem — darker accent strip
      '<rect x="4" y="69" width="66" height="4" rx="1.5" fill="#062340"/>' +
      // ALUMINUM TUBE — full-width across top, chunky and dominant
      '<rect x="6" y="11" width="62" height="13" rx="6.5" fill="url(#stdTub)" stroke="#3F4754" stroke-width="0.8"/>' +
      // Tube top sheen — bright cylindrical reflection
      '<rect x="9" y="12.5" width="56" height="1.7" rx="0.85" fill="#FFFFFF" opacity=".85"/>' +
      // RIGHT END CAP — prominent raised disc
      '<ellipse cx="68" cy="17.5" rx="6.5" ry="7" fill="url(#stdCap)" stroke="#3F4754" stroke-width="0.9"/>' +
      // Cap rim shadow for depth
      '<ellipse cx="68" cy="17.5" rx="6.5" ry="7" fill="none" stroke="#000" stroke-width="0.4" opacity=".25"/>' +
      // Clockwise rotation arrow (Standard direction)
      '<path d="M70.7 14.5 A 3.4 3.4 0 1 1 65.4 18" stroke="#1A2028" stroke-width="1.6" fill="none" stroke-linecap="round"/>' +
      '<path d="M65 16.3 L65.4 18.6 L67.6 17.9" stroke="#1A2028" stroke-width="1.6" fill="none" stroke-linecap="round" stroke-linejoin="round"/>' +
      '</svg>',
    // Reverse Roll — matched to SelectBlinds reference. The fabric
    // wraps OVER the tube and cascades down the front ("waterfall").
    // From the customer's viewing angle:
    //   1. Fabric fills the frame (tube hidden behind)
    //   2. Top-right diagonal notch where fabric wraps behind the tube
    //   3. SHORT ALUMINUM TUBE SEGMENT visible at the notch — the
    //      small exposed bar is the cue that says "there IS a tube
    //      behind this fabric, and the fabric went over it"
    //   4. End cap with rotation arrow at the tube's right end
    reverseRoll: '<svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">' +
      '<defs>' +
        '<linearGradient id="revFab" x1="0" y1="0" x2="0" y2="1">' +
          '<stop offset="0%" stop-color="#2378b8"/>' +
          '<stop offset="35%" stop-color="#155995"/>' +
          '<stop offset="100%" stop-color="#0a3a64"/>' +
        '</linearGradient>' +
        // Same aluminum gradient as Standard (reused for tube segment)
        '<linearGradient id="revTub" x1="0" y1="0" x2="0" y2="1">' +
          '<stop offset="0%" stop-color="#A6B0BD"/>' +
          '<stop offset="30%" stop-color="#FFFFFF"/>' +
          '<stop offset="58%" stop-color="#E5E9EF"/>' +
          '<stop offset="100%" stop-color="#6A7480"/>' +
        '</linearGradient>' +
        '<radialGradient id="revCap" cx="0.3" cy="0.3" r="0.85">' +
          '<stop offset="0%" stop-color="#FFFFFF"/>' +
          '<stop offset="55%" stop-color="#C5CDD8"/>' +
          '<stop offset="100%" stop-color="#4F5965"/>' +
        '</radialGradient>' +
      '</defs>' +
      '<ellipse cx="36" cy="76" rx="30" ry="1.7" fill="#000" opacity=".18"/>' +
      // SHORT TUBE SEGMENT visible at top-right — drawn FIRST so
      // the fabric overlaps its left portion. This is the visual cue
      // that distinguishes Reverse from a plain rectangle.
      '<rect x="48" y="10" width="20" height="13" rx="6.5" fill="url(#revTub)" stroke="#3F4754" stroke-width="0.7"/>' +
      // Tube sheen on the exposed segment
      '<rect x="50" y="11.5" width="16" height="1.5" rx="0.75" fill="#FFFFFF" opacity=".7"/>' +
      // FABRIC — full rectangle except the top-right is cut where
      // the fabric wraps behind the tube. The left edge of the cut
      // overlaps the tube segment slightly (fabric in front of tube).
      '<path d="M6 8 L48 8 Q 54 8 56 16 L56 72 L6 72 Z" fill="url(#revFab)"/>' +
      // Light catch on the top fabric edge
      '<line x1="6" y1="8.4" x2="48" y2="8.4" stroke="#FFFFFF" stroke-width="0.5" opacity=".35"/>' +
      // Shadow at the diagonal where fabric wraps behind tube
      '<path d="M48 8 Q 52 10 54 14" stroke="#041c33" stroke-width="0.8" opacity=".45" fill="none"/>' +
      // Vertical weave
      '<line x1="16" y1="12" x2="16" y2="71" stroke="#FFFFFF" stroke-width="0.35" opacity=".18"/>' +
      '<line x1="26" y1="12" x2="26" y2="71" stroke="#FFFFFF" stroke-width="0.35" opacity=".18"/>' +
      '<line x1="36" y1="12" x2="36" y2="71" stroke="#FFFFFF" stroke-width="0.35" opacity=".18"/>' +
      '<line x1="46" y1="12" x2="46" y2="71" stroke="#FFFFFF" stroke-width="0.35" opacity=".18"/>' +
      // Bottom hem
      '<rect x="4" y="69" width="60" height="4" rx="1.5" fill="#062340"/>' +
      // END CAP at the right end of the exposed tube
      '<ellipse cx="68" cy="16.5" rx="6.5" ry="7" fill="url(#revCap)" stroke="#3F4754" stroke-width="0.9"/>' +
      '<ellipse cx="68" cy="16.5" rx="6.5" ry="7" fill="none" stroke="#000" stroke-width="0.4" opacity=".25"/>' +
      // Counter-clockwise rotation arrow
      '<path d="M65.3 13 A 3.4 3.4 0 1 0 70.6 16.7" stroke="#1A2028" stroke-width="1.6" fill="none" stroke-linecap="round"/>' +
      '<path d="M71 14.9 L70.6 17.2 L68.4 16.6" stroke="#1A2028" stroke-width="1.6" fill="none" stroke-linecap="round" stroke-linejoin="round"/>' +
      '</svg>',

    // STEP 5: VALANCE OPTIONS — premium FRONT-VIEW redesign matching the
    // shopper's actual viewing angle. Each icon shows the blind hanging
    // in a window with the TOP element as the differentiator:
    //   - No Valance = visible bare aluminum tube + exposed brackets
    //     (utilitarian look, the mechanism is part of the aesthetic).
    //   - Fascia    = clean rectangular aluminum cover hides the tube
    //     (sharp modern profile).
    //   - Cassette  = curved sleek cover with FABRIC INSERT visible on
    //     the face (the upgrade — premium gradient + woven texture lines
    //     on the insert make it visually earn its surcharge).
    // Shared system: warm cream window-frame stroke, soft floor shadow,
    // gradient on every aluminum surface for material depth, gradient on
    // every fabric for woven feel.
    noValance: '<svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">' +
      '<defs>' +
        '<linearGradient id="nvFab" x1="0" y1="0" x2="0" y2="1">' +
          '<stop offset="0%" stop-color="#2378b8"/>' +
          '<stop offset="100%" stop-color="#13548d"/>' +
        '</linearGradient>' +
        '<linearGradient id="nvTub" x1="0" y1="0" x2="0" y2="1">' +
          '<stop offset="0%" stop-color="#FFFFFF"/>' +
          '<stop offset="100%" stop-color="#C7CFD9"/>' +
        '</linearGradient>' +
      '</defs>' +
      '<path d="M8 12 V8 H72 V12" stroke="#D9C9A8" stroke-width="2" stroke-linecap="round" fill="none" opacity=".75"/>' +
      '<ellipse cx="40" cy="73" rx="22" ry="1.5" fill="#000" opacity=".08"/>' +
      // Exposed mounting brackets (utility look)
      '<rect x="13" y="13" width="3" height="11" rx="0.5" fill="#8B98A8"/>' +
      '<rect x="64" y="13" width="3" height="11" rx="0.5" fill="#8B98A8"/>' +
      // Bare aluminum tube fully visible — the look IS the absence of cover
      '<rect x="16" y="14" width="48" height="8" rx="4" fill="url(#nvTub)" stroke="#13548d" stroke-width="1.4"/>' +
      '<rect x="18" y="15.5" width="44" height="1.2" rx="0.6" fill="#FFFFFF" opacity=".75"/>' +
      '<ellipse cx="16" cy="18" rx="1.6" ry="4" fill="#13548d" opacity=".4"/>' +
      '<ellipse cx="64" cy="18" rx="1.6" ry="4" fill="#13548d" opacity=".4"/>' +
      // Fabric panel below
      '<rect x="22" y="22" width="36" height="46" fill="url(#nvFab)"/>' +
      '<line x1="29" y1="26" x2="29" y2="64" stroke="#FFFFFF" stroke-width="0.3" opacity=".18"/>' +
      '<line x1="40" y1="26" x2="40" y2="64" stroke="#FFFFFF" stroke-width="0.3" opacity=".18"/>' +
      '<line x1="51" y1="26" x2="51" y2="64" stroke="#FFFFFF" stroke-width="0.3" opacity=".18"/>' +
      '<rect x="20" y="65" width="40" height="3.5" rx="1" fill="#0a3357"/>' +
      '</svg>',
    fascia: '<svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">' +
      '<defs>' +
        '<linearGradient id="fasFab" x1="0" y1="0" x2="0" y2="1">' +
          '<stop offset="0%" stop-color="#2378b8"/>' +
          '<stop offset="100%" stop-color="#13548d"/>' +
        '</linearGradient>' +
        '<linearGradient id="fasCov" x1="0" y1="0" x2="0" y2="1">' +
          '<stop offset="0%" stop-color="#FFFFFF"/>' +
          '<stop offset="60%" stop-color="#EFF2F6"/>' +
          '<stop offset="100%" stop-color="#C7CFD9"/>' +
        '</linearGradient>' +
      '</defs>' +
      '<path d="M8 12 V8 H72 V12" stroke="#D9C9A8" stroke-width="2" stroke-linecap="round" fill="none" opacity=".75"/>' +
      '<ellipse cx="40" cy="73" rx="22" ry="1.5" fill="#000" opacity=".09"/>' +
      // Rectangular aluminum fascia — sharp 90° corners, modern profile
      '<rect x="14" y="11" width="52" height="14" rx="1.5" fill="url(#fasCov)" stroke="#13548d" stroke-width="1.5"/>' +
      // Crisp metallic top highlight
      '<rect x="16" y="12.5" width="48" height="1.2" rx="0.6" fill="#FFFFFF" opacity=".85"/>' +
      // End-cap suture lines (read as a 3D extrusion, not flat plane)
      '<line x1="20" y1="13" x2="20" y2="23" stroke="#13548d" stroke-width="0.6" opacity=".4"/>' +
      '<line x1="60" y1="13" x2="60" y2="23" stroke="#13548d" stroke-width="0.6" opacity=".4"/>' +
      // Bottom edge subtle shadow
      '<line x1="14" y1="25" x2="66" y2="25" stroke="#13548d" stroke-width="0.5" opacity=".25"/>' +
      // Fabric below
      '<rect x="22" y="25" width="36" height="43" fill="url(#fasFab)"/>' +
      '<line x1="29" y1="29" x2="29" y2="64" stroke="#FFFFFF" stroke-width="0.3" opacity=".18"/>' +
      '<line x1="40" y1="29" x2="40" y2="64" stroke="#FFFFFF" stroke-width="0.3" opacity=".18"/>' +
      '<line x1="51" y1="29" x2="51" y2="64" stroke="#FFFFFF" stroke-width="0.3" opacity=".18"/>' +
      '<rect x="20" y="65" width="40" height="3.5" rx="1" fill="#0a3357"/>' +
      '</svg>',
    cassette: '<svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">' +
      '<defs>' +
        '<linearGradient id="casFab" x1="0" y1="0" x2="0" y2="1">' +
          '<stop offset="0%" stop-color="#2378b8"/>' +
          '<stop offset="100%" stop-color="#13548d"/>' +
        '</linearGradient>' +
        '<linearGradient id="casShell" x1="0" y1="0" x2="0" y2="1">' +
          '<stop offset="0%" stop-color="#FFFFFF"/>' +
          '<stop offset="55%" stop-color="#EFF2F6"/>' +
          '<stop offset="100%" stop-color="#B8C2CE"/>' +
        '</linearGradient>' +
        '<linearGradient id="casInsert" x1="0" y1="0" x2="0" y2="1">' +
          '<stop offset="0%" stop-color="#2a7cc2"/>' +
          '<stop offset="100%" stop-color="#13548d"/>' +
        '</linearGradient>' +
      '</defs>' +
      '<path d="M8 12 V8 H72 V12" stroke="#D9C9A8" stroke-width="2" stroke-linecap="round" fill="none" opacity=".75"/>' +
      // Slightly darker shadow than fascia — premium products feel grounded
      '<ellipse cx="40" cy="73" rx="22" ry="1.5" fill="#000" opacity=".11"/>' +
      // Outer aluminum shell — flat top, curved bottom (D-profile)
      '<path d="M14 11 H66 V20 Q 66 27 60 27 H20 Q 14 27 14 20 Z" fill="url(#casShell)" stroke="#13548d" stroke-width="1.5" stroke-linejoin="round"/>' +
      // Premium top sheen (brighter than fascia — feels "pearlescent")
      '<rect x="16" y="12.5" width="48" height="1.4" rx="0.7" fill="#FFFFFF" opacity=".9"/>' +
      // FABRIC INSERT recessed into the shell face (the "fabric-covered"
      // feature that makes cassette an upgrade over plain aluminum fascia)
      '<path d="M19 14 H61 V19 Q 61 24 56 24 H24 Q 19 24 19 19 Z" fill="url(#casInsert)"/>' +
      // Woven texture on the fabric insert (premium tactile cue)
      '<line x1="25" y1="16" x2="25" y2="22" stroke="#FFFFFF" stroke-width="0.3" opacity=".35"/>' +
      '<line x1="32" y1="16" x2="32" y2="22" stroke="#FFFFFF" stroke-width="0.3" opacity=".35"/>' +
      '<line x1="40" y1="16" x2="40" y2="22" stroke="#FFFFFF" stroke-width="0.3" opacity=".35"/>' +
      '<line x1="48" y1="16" x2="48" y2="22" stroke="#FFFFFF" stroke-width="0.3" opacity=".35"/>' +
      '<line x1="55" y1="16" x2="55" y2="22" stroke="#FFFFFF" stroke-width="0.3" opacity=".35"/>' +
      // Curved bottom highlight (reflects light off the curve — premium cue)
      '<path d="M18 26 Q 40 28.5 62 26" stroke="#13548d" stroke-width="0.5" opacity=".35" fill="none"/>' +
      // Fabric below cassette (starts lower because cassette extends down)
      '<rect x="22" y="27" width="36" height="41" fill="url(#casFab)"/>' +
      '<line x1="29" y1="30" x2="29" y2="64" stroke="#FFFFFF" stroke-width="0.3" opacity=".18"/>' +
      '<line x1="40" y1="30" x2="40" y2="64" stroke="#FFFFFF" stroke-width="0.3" opacity=".18"/>' +
      '<line x1="51" y1="30" x2="51" y2="64" stroke="#FFFFFF" stroke-width="0.3" opacity=".18"/>' +
      '<rect x="20" y="65" width="40" height="3.5" rx="1" fill="#0a3357"/>' +
      '</svg>',
    cassetteStandard: '<svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">' +
      '<defs>' +
        '<linearGradient id="casStdFab" x1="0" y1="0" x2="0" y2="1">' +
          '<stop offset="0%" stop-color="#2378b8"/>' +
          '<stop offset="100%" stop-color="#13548d"/>' +
        '</linearGradient>' +
        '<linearGradient id="casStdShell" x1="0" y1="0" x2="0" y2="1">' +
          '<stop offset="0%" stop-color="#FFFFFF"/>' +
          '<stop offset="55%" stop-color="#EFF2F6"/>' +
          '<stop offset="100%" stop-color="#B8C2CE"/>' +
        '</linearGradient>' +
      '</defs>' +
      '<path d="M8 12 V8 H72 V12" stroke="#D9C9A8" stroke-width="2" stroke-linecap="round" fill="none" opacity=".75"/>' +
      '<ellipse cx="40" cy="73" rx="22" ry="1.5" fill="#000" opacity=".11"/>' +
      '<path d="M14 11 H66 V20 Q 66 27 60 27 H20 Q 14 27 14 20 Z" fill="url(#casStdShell)" stroke="#13548d" stroke-width="1.5" stroke-linejoin="round"/>' +
      '<rect x="16" y="12.5" width="48" height="1.4" rx="0.7" fill="#FFFFFF" opacity=".9"/>' +
      '<rect x="16" y="17.4" width="48" height="0.6" rx="0.3" fill="#FFFFFF" opacity=".35"/>' +
      '<path d="M18 26 Q 40 28.5 62 26" stroke="#13548d" stroke-width="0.5" opacity=".35" fill="none"/>' +
      '<rect x="22" y="27" width="36" height="41" fill="url(#casStdFab)"/>' +
      '<line x1="29" y1="30" x2="29" y2="64" stroke="#FFFFFF" stroke-width="0.3" opacity=".18"/>' +
      '<line x1="40" y1="30" x2="40" y2="64" stroke="#FFFFFF" stroke-width="0.3" opacity=".18"/>' +
      '<line x1="51" y1="30" x2="51" y2="64" stroke="#FFFFFF" stroke-width="0.3" opacity=".18"/>' +
      '<rect x="20" y="65" width="40" height="3.5" rx="1" fill="#0a3357"/>' +
      '</svg>',
    // Faux Wood valance profiles (front view over the blind slats). Standard =
    // classic crown with a decorative bevelled/curved top; Urban = flat
    // squared-off top. Warwick review 2026-06-05; form per icon-form research.
    valanceStandard: '<svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">' +
      '<ellipse cx="40" cy="74" rx="25" ry="1.4" fill="#000" opacity=".10"/>' +
      '<path d="M11 31 L11 23 Q11 17 17 15 Q26 12 40 12 Q54 12 63 15 Q69 17 69 23 L69 31 Z" fill="#2a6aa8" stroke="#13548d" stroke-width="1.4" stroke-linejoin="round"/>' +
      '<path d="M16 21 Q27 16 40 16 Q53 16 64 21" stroke="#FFFFFF" stroke-width="1" opacity=".45" fill="none"/>' +
      '<rect x="11" y="29" width="58" height="2" fill="#0c3f6e" opacity=".5"/>' +
      '<rect x="19" y="34" width="42" height="3" rx="1" fill="#2378b8"/>' +
      '<rect x="19" y="40" width="42" height="3" rx="1" fill="#2378b8"/>' +
      '<rect x="19" y="46" width="42" height="3" rx="1" fill="#2378b8"/>' +
      '<rect x="19" y="52" width="42" height="3" rx="1" fill="#2378b8"/>' +
      '<rect x="17" y="58" width="46" height="3.5" rx="1" fill="#0a3357"/>' +
      '</svg>',
    valanceUrban: '<svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">' +
      '<ellipse cx="40" cy="74" rx="25" ry="1.4" fill="#000" opacity=".10"/>' +
      '<rect x="12" y="14" width="56" height="16" fill="#2a6aa8" stroke="#13548d" stroke-width="1.4"/>' +
      '<rect x="14" y="15.5" width="52" height="1.4" fill="#FFFFFF" opacity=".45"/>' +
      '<rect x="19" y="34" width="42" height="3" rx="1" fill="#2378b8"/>' +
      '<rect x="19" y="40" width="42" height="3" rx="1" fill="#2378b8"/>' +
      '<rect x="19" y="46" width="42" height="3" rx="1" fill="#2378b8"/>' +
      '<rect x="19" y="52" width="42" height="3" rx="1" fill="#2378b8"/>' +
      '<rect x="17" y="58" width="46" height="3.5" rx="1" fill="#0a3357"/>' +
      '</svg>',
    // Headrail option icons (front view, faux-wood slats). Standard = one rail +
    // one unbroken column of slats. Two-on-One = the SAME continuous rail with
    // two slat panels split by a centre gap + divider (the operative split).
    headrailStandard: '<svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">' +
      '<ellipse cx="40" cy="76" rx="30" ry="1.5" fill="#000" opacity=".10"/>' +
      '<rect x="16" y="8" width="3" height="3" fill="#9aa7b5"/>' +
      '<rect x="61" y="8" width="3" height="3" fill="#9aa7b5"/>' +
      '<rect x="9" y="11" width="62" height="8" rx="2" fill="#C7CFD9" stroke="#5A6573" stroke-width="0.8"/>' +
      '<rect x="11" y="12.5" width="58" height="1.3" rx="0.6" fill="#FFFFFF" opacity=".7"/>' +
      '<rect x="11" y="24" width="58" height="4" rx="1" fill="#2378b8"/>' +
      '<rect x="11" y="30" width="58" height="4" rx="1" fill="#2378b8"/>' +
      '<rect x="11" y="36" width="58" height="4" rx="1" fill="#2378b8"/>' +
      '<rect x="11" y="42" width="58" height="4" rx="1" fill="#2378b8"/>' +
      '<rect x="11" y="48" width="58" height="4" rx="1" fill="#2378b8"/>' +
      '<rect x="11" y="54" width="58" height="4" rx="1" fill="#2378b8"/>' +
      '<rect x="9" y="61" width="62" height="4" rx="1" fill="#0a3357"/>' +
      '<line x1="15" y1="19" x2="15" y2="59" stroke="#8c98a6" stroke-width="1.4" stroke-linecap="round"/>' +
      '</svg>',
    headrailTwoOnOne: '<svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">' +
      '<ellipse cx="40" cy="76" rx="30" ry="1.5" fill="#000" opacity=".10"/>' +
      '<rect x="16" y="8" width="3" height="3" fill="#9aa7b5"/>' +
      '<rect x="61" y="8" width="3" height="3" fill="#9aa7b5"/>' +
      '<rect x="9" y="11" width="62" height="8" rx="2" fill="#C7CFD9" stroke="#5A6573" stroke-width="0.8"/>' +
      '<rect x="11" y="12.5" width="58" height="1.3" rx="0.6" fill="#FFFFFF" opacity=".7"/>' +
      '<rect x="11" y="24" width="25" height="4" rx="1" fill="#2378b8"/>' +
      '<rect x="11" y="30" width="25" height="4" rx="1" fill="#2378b8"/>' +
      '<rect x="11" y="36" width="25" height="4" rx="1" fill="#2378b8"/>' +
      '<rect x="11" y="42" width="25" height="4" rx="1" fill="#2378b8"/>' +
      '<rect x="11" y="48" width="25" height="4" rx="1" fill="#2378b8"/>' +
      '<rect x="11" y="54" width="25" height="4" rx="1" fill="#2378b8"/>' +
      '<rect x="44" y="24" width="25" height="4" rx="1" fill="#2378b8"/>' +
      '<rect x="44" y="30" width="25" height="4" rx="1" fill="#2378b8"/>' +
      '<rect x="44" y="36" width="25" height="4" rx="1" fill="#2378b8"/>' +
      '<rect x="44" y="42" width="25" height="4" rx="1" fill="#2378b8"/>' +
      '<rect x="44" y="48" width="25" height="4" rx="1" fill="#2378b8"/>' +
      '<rect x="44" y="54" width="25" height="4" rx="1" fill="#2378b8"/>' +
      '<rect x="38.5" y="20" width="3" height="42" fill="#5A6573"/>' +
      '<rect x="9" y="61" width="27" height="4" rx="1" fill="#0a3357"/>' +
      '<rect x="44" y="61" width="27" height="4" rx="1" fill="#0a3357"/>' +
      '<line x1="14" y1="19" x2="14" y2="59" stroke="#8c98a6" stroke-width="1.2" stroke-linecap="round"/>' +
      '<line x1="66" y1="19" x2="66" y2="59" stroke="#8c98a6" stroke-width="1.2" stroke-linecap="round"/>' +
      '</svg>',

    // VERTICAL BLINDS (Mariak vertical only): Stack / Extra Vanes / Channel Panel.
    // Refined 2026-06-30: wand marks the control side on splits, free-hang vs framed
    // channel panel, headrail depth + ghosted draw-aside vanes. 80x80 #13548d style.
    stackLeft: '<svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg"> <rect x="10" y="12" width="60" height="6" rx="2" fill="#13548d"/><rect x="10" y="17.2" width="60" height="1.6" rx="0.8" fill="#0f3f6b" opacity=".55"/> <rect x="12" y="20" width="4" height="50" fill="#E8EDF2" stroke="#78909C" stroke-width="1.5"/><rect x="17.5" y="20" width="4" height="50" fill="#E8EDF2" stroke="#78909C" stroke-width="1.5"/><rect x="23" y="20" width="4" height="50" fill="#E8EDF2" stroke="#78909C" stroke-width="1.5"/><rect x="28.5" y="20" width="4" height="50" fill="#E8EDF2" stroke="#78909C" stroke-width="1.5"/> <rect x="37" y="20" width="3" height="50" fill="none" stroke="#c3ced8" stroke-width="1" stroke-dasharray="2 4"/><rect x="46" y="20" width="3" height="50" fill="none" stroke="#c3ced8" stroke-width="1" stroke-dasharray="2 4"/><rect x="55" y="20" width="3" height="50" fill="none" stroke="#c3ced8" stroke-width="1" stroke-dasharray="2 4"/> <path d="M64 45 H47 m4 -4 l-4 4 l4 4" stroke="#13548d" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"/> </svg>',
    stackRight: '<svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg"> <rect x="10" y="12" width="60" height="6" rx="2" fill="#13548d"/><rect x="10" y="17.2" width="60" height="1.6" rx="0.8" fill="#0f3f6b" opacity=".55"/> <rect x="64" y="20" width="4" height="50" fill="#E8EDF2" stroke="#78909C" stroke-width="1.5"/><rect x="58.5" y="20" width="4" height="50" fill="#E8EDF2" stroke="#78909C" stroke-width="1.5"/><rect x="53" y="20" width="4" height="50" fill="#E8EDF2" stroke="#78909C" stroke-width="1.5"/><rect x="47.5" y="20" width="4" height="50" fill="#E8EDF2" stroke="#78909C" stroke-width="1.5"/> <rect x="22" y="20" width="3" height="50" fill="none" stroke="#c3ced8" stroke-width="1" stroke-dasharray="2 4"/><rect x="31" y="20" width="3" height="50" fill="none" stroke="#c3ced8" stroke-width="1" stroke-dasharray="2 4"/><rect x="40" y="20" width="3" height="50" fill="none" stroke="#c3ced8" stroke-width="1" stroke-dasharray="2 4"/> <path d="M16 45 H33 m-4 -4 l4 4 l-4 4" stroke="#13548d" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"/> </svg>',
    stackCenter: '<svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg"> <rect x="10" y="12" width="60" height="6" rx="2" fill="#13548d"/><rect x="10" y="17.2" width="60" height="1.6" rx="0.8" fill="#0f3f6b" opacity=".55"/> <rect x="29.75" y="20" width="4" height="50" fill="#E8EDF2" stroke="#78909C" stroke-width="1.5"/><rect x="35.25" y="20" width="4" height="50" fill="#E8EDF2" stroke="#78909C" stroke-width="1.5"/><rect x="40.75" y="20" width="4" height="50" fill="#E8EDF2" stroke="#78909C" stroke-width="1.5"/><rect x="46.25" y="20" width="4" height="50" fill="#E8EDF2" stroke="#78909C" stroke-width="1.5"/> <rect x="14" y="20" width="3" height="50" fill="none" stroke="#c3ced8" stroke-width="1" stroke-dasharray="2 4"/><rect x="21" y="20" width="3" height="50" fill="none" stroke="#c3ced8" stroke-width="1" stroke-dasharray="2 4"/><rect x="56" y="20" width="3" height="50" fill="none" stroke="#c3ced8" stroke-width="1" stroke-dasharray="2 4"/><rect x="63" y="20" width="3" height="50" fill="none" stroke="#c3ced8" stroke-width="1" stroke-dasharray="2 4"/> <path d="M12 45 H25 m-4 -4 l4 4 l-4 4" stroke="#13548d" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"/><path d="M68 45 H55 m4 -4 l-4 4 l4 4" stroke="#13548d" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"/> </svg>',
    stackSplitLeft: '<svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg"> <rect x="10" y="12" width="60" height="6" rx="2" fill="#13548d"/><rect x="10" y="17.2" width="60" height="1.6" rx="0.8" fill="#0f3f6b" opacity=".55"/> <rect x="16" y="20" width="4" height="50" fill="#E8EDF2" stroke="#78909C" stroke-width="1.5"/><rect x="21.5" y="20" width="4" height="50" fill="#E8EDF2" stroke="#78909C" stroke-width="1.5"/><rect x="27" y="20" width="4" height="50" fill="#E8EDF2" stroke="#78909C" stroke-width="1.5"/> <rect x="35" y="20" width="3" height="50" fill="none" stroke="#c3ced8" stroke-width="1" stroke-dasharray="2 4"/><rect x="42" y="20" width="3" height="50" fill="none" stroke="#c3ced8" stroke-width="1" stroke-dasharray="2 4"/> <rect x="49" y="20" width="4" height="50" fill="#E8EDF2" stroke="#78909C" stroke-width="1.5"/><rect x="54.5" y="20" width="4" height="50" fill="#E8EDF2" stroke="#78909C" stroke-width="1.5"/><rect x="60" y="20" width="4" height="50" fill="#E8EDF2" stroke="#78909C" stroke-width="1.5"/> <line x1="12" y1="19" x2="12" y2="60" stroke="#0f3f6b" stroke-width="2" stroke-linecap="round"/><circle cx="12" cy="64" r="2.6" fill="#0f3f6b"/> </svg>',
    stackSplitRight: '<svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg"> <rect x="10" y="12" width="60" height="6" rx="2" fill="#13548d"/><rect x="10" y="17.2" width="60" height="1.6" rx="0.8" fill="#0f3f6b" opacity=".55"/> <rect x="16" y="20" width="4" height="50" fill="#E8EDF2" stroke="#78909C" stroke-width="1.5"/><rect x="21.5" y="20" width="4" height="50" fill="#E8EDF2" stroke="#78909C" stroke-width="1.5"/><rect x="27" y="20" width="4" height="50" fill="#E8EDF2" stroke="#78909C" stroke-width="1.5"/> <rect x="35" y="20" width="3" height="50" fill="none" stroke="#c3ced8" stroke-width="1" stroke-dasharray="2 4"/><rect x="42" y="20" width="3" height="50" fill="none" stroke="#c3ced8" stroke-width="1" stroke-dasharray="2 4"/> <rect x="49" y="20" width="4" height="50" fill="#E8EDF2" stroke="#78909C" stroke-width="1.5"/><rect x="54.5" y="20" width="4" height="50" fill="#E8EDF2" stroke="#78909C" stroke-width="1.5"/><rect x="60" y="20" width="4" height="50" fill="#E8EDF2" stroke="#78909C" stroke-width="1.5"/> <line x1="68" y1="19" x2="68" y2="60" stroke="#0f3f6b" stroke-width="2" stroke-linecap="round"/><circle cx="68" cy="64" r="2.6" fill="#0f3f6b"/> </svg>',
    vaneNone: '<svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg"> <rect x="10" y="12" width="60" height="6" rx="2" fill="#13548d"/><rect x="10" y="17.2" width="60" height="1.6" rx="0.8" fill="#0f3f6b" opacity=".55"/> <rect x="14" y="20" width="5" height="50" fill="#E8EDF2" stroke="#78909C" stroke-width="1.5"/><rect x="25" y="20" width="5" height="50" fill="#E8EDF2" stroke="#78909C" stroke-width="1.5"/><rect x="36" y="20" width="5" height="50" fill="#E8EDF2" stroke="#78909C" stroke-width="1.5"/><rect x="47" y="20" width="5" height="50" fill="#E8EDF2" stroke="#78909C" stroke-width="1.5"/><rect x="58" y="20" width="5" height="50" fill="#E8EDF2" stroke="#78909C" stroke-width="1.5"/> </svg>',
    vaneExtra: '<svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg"> <rect x="10" y="12" width="60" height="6" rx="2" fill="#13548d"/><rect x="10" y="17.2" width="60" height="1.6" rx="0.8" fill="#0f3f6b" opacity=".55"/> <rect x="13" y="20" width="4" height="50" fill="#E8EDF2" stroke="#78909C" stroke-width="1.5"/><rect x="20" y="20" width="4" height="50" fill="#E8EDF2" stroke="#78909C" stroke-width="1.5"/><rect x="27" y="20" width="4" height="50" fill="#E8EDF2" stroke="#78909C" stroke-width="1.5"/><rect x="34" y="20" width="4" height="50" fill="#E8EDF2" stroke="#78909C" stroke-width="1.5"/><rect x="41" y="20" width="4" height="50" fill="#E8EDF2" stroke="#78909C" stroke-width="1.5"/><rect x="48" y="20" width="4" height="50" fill="#E8EDF2" stroke="#78909C" stroke-width="1.5"/><rect x="55" y="20" width="4" height="50" fill="#E8EDF2" stroke="#78909C" stroke-width="1.5"/><rect x="62" y="20" width="4" height="50" fill="#E8EDF2" stroke="#78909C" stroke-width="1.5"/> <circle cx="62" cy="63" r="9.5" fill="#13548d" stroke="#fff" stroke-width="1.5"/><text x="62" y="66.5" font-size="9.5" font-family="Arial" font-weight="bold" fill="#fff" text-anchor="middle">+3</text> </svg>',
    channelPanelNone: '<svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg"> <rect x="16" y="6" width="13" height="68" fill="none" stroke="#b6c2cc" stroke-width="1.8" stroke-dasharray="4 3"/> <path d="M44 8 L60 8 C60 28, 61 46, 61 56 C61 63, 58 68, 53 66 C48 64, 44 66, 44 56 C44 40, 44 24, 44 8 Z" fill="#E8EDF2" stroke="#78909C" stroke-width="1.6" stroke-linejoin="round"/> <path d="M52 12 C52 32, 53 50, 52 60" stroke="#b6c2cc" stroke-width="1.1" fill="none" opacity=".85"/> <path d="M64 58 q4 3 3 8" stroke="#c3ced8" stroke-width="1.3" fill="none" stroke-linecap="round"/> <path d="M40 60 q-3 4 -1 9" stroke="#c3ced8" stroke-width="1.3" fill="none" stroke-linecap="round"/> </svg>',
    channelPanelWhite: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 4000 4000"><path fill="#e8eef2" d="M1696.7 392.5v1491.6c0 2.9-2.4 5.3-5.3 5.3h-.1c-267.1-5.5-544.5-36.4-794.6-131.2-104.6-39.6-216.7-108.8-272.3-204.8a97 97 0 0 1-13.9-49.2V359.8c0-3.7 2.6-6.8 6.1-7.6l86-18.2q6-1.1 11.4 1.4l129.7 62c7.7 3.7 16.7 3 23.9-1.7l84.5-56.9 2.7-1.8 42.8-27.4a9 9 0 0 1 9.3.1 126 126 0 0 1 30.5 28.1l7.2 7.1 52.9 52.4c3.9 3.9 9.9 5 15 2.7l138.3-62.4c3.3-1.4 7.1-1 9.8 1.3l72.7 58.8a15 15 0 0 0 15.9 1.7l122.9-62.1a9 9 0 0 1 6.8-.4l176.5 62.6a13 13 0 0 0 9.5-.3l24.6-11.2c2.6-1.1 5.7.1 6.8 2.7q.4 1 .4 2.1Z"/><path fill="#e8eef2" d="M640.6 1635.8q.1-1 1.1-1.1.4 0 .7.3a699 699 0 0 0 253.4 159.5c287.6 105.7 604.7 128.7 909.4 128.6q820.5 0 1601.1-.3c1.9 0 3.5 1.6 3.5 3.5l-.1.9-33.6 123.6a23 23 0 0 0 4.1 20.1l53.9 67.4a8.4 8.4 0 0 1-.1 10.5l-38.4 47.4a18 18 0 0 0 0 22.5l39.4 49.3a10 10 0 0 1 1.5 10.1l-69.2 169.4c-2.3 5.6-1.9 12 1.2 17.2l76.4 132.2c.8 1.5.7 3.4-.4 4.8l-56.9 70.3a18 18 0 0 0-2.4 18.9l50.7 112.4c1.3 2.8 0 6.1-2.8 7.3l-1.2.4q-56.2 11.7-78.5 11.5-210.6-1.6-483.3-38.3a15820 15820 0 0 1-702.2-111.4c-269.1-48.6-535.8-125.9-774.6-245.1-327-163.2-622.4-423.4-749.6-774.6a48 48 0 0 1-3-17.4Z"/><path fill="#13548d" d="M3421.9 2691.3a9 9 0 0 1 1.2-8.9l51.8-64c7.4-9 8.4-21.6 2.5-31.7l-73.1-126.7a14 14 0 0 1-.9-12.4l71.1-174.3a13 13 0 0 0-1.8-12.8l-39.8-49.7a7 7 0 0 1 .1-8.8l38.7-47.8c5.3-6.5 5.3-15.9.1-22.6l-58.4-72.9c-2.3-2.8-3-6.5-2.1-10l38.4-140.8q.5-1.8.5-3.7c0-8.1-6.5-14.8-14.6-14.8H1793a4 4 0 0 1-3.9-3.9V338c0-3.1-2.5-5.6-5.6-5.6h-79.7a8 8 0 0 0-7.7 7.7v4.3a10 10 0 0 1-6.4 9.3l-25.7 9.8q-4 1.6-7.9.1l-176.2-62.5a14 14 0 0 0-11.2.7L1350 361.2a9 9 0 0 1-9.9-1.1l-72.1-58.5c-4.1-3.5-10-4.2-15-2L1116.8 361a9 9 0 0 1-10-1.7 2338 2338 0 0 1-79.4-80.4q-18.4-19.4-42.7-2.9-121.7 81.9-127.8 85.8a9 9 0 0 1-8.4.4l-130-61.7a22 22 0 0 0-14.6-1.7l-184.2 39q-1 .3-1.1 1.2v3309.9c0 4 2.8 7.5 6.7 8.4l178.8 40.7q6.5 1.4 12.5-1.2l130.5-58.8c4.6-2.1 10-1.6 14.1 1.2l132.4 88.6a21 21 0 0 0 26.8-2.6l84.8-84.9a8 8 0 0 1 8.6-1.7l141.1 57.6a16 16 0 0 0 15.8-2.3l69.6-55.6a10 10 0 0 1 9.9-1.1l119 59.4c4.7 2.4 10 2.6 14.8.8l163.3-62.1q4.2-1.6 8.7-1a72 72 0 0 1 42.7 18.4c2.6 2.6 6.2 4 9.8 3.9q17.3-.1 42.2 8.4 3 1.2 6.2-.1l28-10.7a7 7 0 0 0 4.2-6.1v-1022l.2-1.6c1-2.9 4-4.6 6.9-3.7q169.7 49.4 344.6 81.5c334.1 61.1 666.1 115.8 1003.5 146.7a1875 1875 0 0 0 203.4 6.6c34.4-.7 96.1-2.9 121-26.4 6.4-6 8.4-15.3 4.8-23.2l-51.7-114.6ZM1730.4 372.5c0-3.5 2.9-6.4 6.4-6.4h12.4c3.6 0 6.4 2.9 6.4 6.4V1884c0 3.6-2.8 6.4-6.4 6.4h-12.4a6.4 6.4 0 0 1-6.4-6.4zM610.5 359.7c0-3.7 2.6-6.8 6.1-7.6l86-18.2q6-1.1 11.4 1.4l129.7 62c7.7 3.7 16.7 3 23.9-1.7l84.5-56.9 2.7-1.8 42.8-27.4a9 9 0 0 1 9.3.1c17.2 11.2 30.3 27.8 44.7 42.1l32.1 31.8 13.8 13.6c3.9 3.9 9.9 5 15 2.7l138.3-62.4c3.3-1.4 7.1-1 9.8 1.3l72.7 58.8a15 15 0 0 0 15.9 1.7l122.9-62.1a9 9 0 0 1 6.8-.4l176.5 62.6a13 13 0 0 0 9.5-.3l24.6-11.2q1-.3 2.1-.4c2.9 0 5.2 2.4 5.2 5.2v1491.7c0 2.9-2.5 5.3-5.4 5.2-267.1-5.5-544.5-36.4-794.6-131.2-104.6-39.6-216.7-108.8-272.3-204.8a97 97 0 0 1-13.9-49.2V359.9Zm-33.6 3256.9a7 7 0 0 1-7 7.1h-11.3a7 7 0 0 1-7-7.1V373.5a7 7 0 0 1 7-7.1h11.3a7 7 0 0 1 7 7.1zm1120-11q0 1-.3 1.7a4.7 4.7 0 0 1-6.2 2.7l-30.2-12.4a12 12 0 0 0-8.7-.1l-167.6 63.8a13 13 0 0 1-10.5-.4l-124.3-62.1c-5-2.4-11-1.8-15.3 1.6l-72.1 57.7c-2 1.5-4.6 2-6.8 1l-143.7-58.7c-5.6-2.3-12.1-1-16.5 3.4l-85.5 85.5a8.6 8.6 0 0 1-11 1.1l-133.8-89.5a15 15 0 0 0-14.5-1.3l-141.1 63.7q-2 1-4.2.4l-87.2-19.8c-4-.9-6.8-4.4-6.8-8.6V1670.1q0-.7.7-1 1-.3 1.4.5c179.2 467.8 616.5 766.5 1076.3 916.4 4.8 1.5 7.9 6 7.9 11zm58.5 9.7c0 4.2-3.5 7.7-7.7 7.7h-9.5a8 8 0 0 1-7.7-7.7V2611.2c0-4.2 3.5-7.7 7.7-7.7h9.5c4.2 0 7.7 3.5 7.7 7.7zm1676.4-804.2q-56.2 11.7-78.5 11.5-210.7-1.7-483.3-38.3a15991 15991 0 0 1-702.2-111.4c-269.1-48.6-535.8-125.9-774.6-245.1-327-163.2-622.4-423.4-749.6-774.6a48 48 0 0 1-3-17.4l.3-.8a1 1 0 0 1 1.5 0 701 701 0 0 0 253.4 159.5c287.6 105.7 604.7 128.7 909.4 128.6l1602-.2c1.8.5 3 2.4 2.5 4.3l-33.6 123.6a23 23 0 0 0 4.1 20.1l53.9 67.4a8.4 8.4 0 0 1-.1 10.5l-38.4 47.4a18 18 0 0 0 0 22.5l39.4 49.3c2.3 2.8 2.8 6.7 1.5 10.1l-69.2 169.4c-2.3 5.6-1.8 12 1.2 17.2l76.4 132.2c.9 1.5.7 3.4-.4 4.8l-56.9 70.3a18 18 0 0 0-2.4 18.9l50.6 112.4.4 1.2a5.6 5.6 0 0 1-4.3 6.5Z"/></svg>',
    vertNoValance: '<svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg"> <rect x="9" y="13" width="62" height="10" rx="2" fill="#ffffff" stroke="#13548d" stroke-width="2.5"/> <rect x="15.5" y="16" width="3" height="4" rx="1" fill="#9fb4c6"/> <rect x="26.5" y="16" width="3" height="4" rx="1" fill="#9fb4c6"/> <rect x="37.5" y="16" width="3" height="4" rx="1" fill="#9fb4c6"/> <rect x="48.5" y="16" width="3" height="4" rx="1" fill="#9fb4c6"/> <rect x="59.5" y="16" width="3" height="4" rx="1" fill="#9fb4c6"/> <rect x="16.2" y="23" width="1.6" height="4" fill="#78909C"/> <rect x="27.2" y="23" width="1.6" height="4" fill="#78909C"/> <rect x="38.2" y="23" width="1.6" height="4" fill="#78909C"/> <rect x="49.2" y="23" width="1.6" height="4" fill="#78909C"/> <rect x="60.2" y="23" width="1.6" height="4" fill="#78909C"/> <rect x="13" y="27" width="8" height="43" fill="#E8EDF2" stroke="#78909C" stroke-width="1.5"/> <rect x="24" y="27" width="8" height="43" fill="#E8EDF2" stroke="#78909C" stroke-width="1.5"/> <rect x="35" y="27" width="8" height="43" fill="#E8EDF2" stroke="#78909C" stroke-width="1.5"/> <rect x="46" y="27" width="8" height="43" fill="#E8EDF2" stroke="#78909C" stroke-width="1.5"/> <rect x="57" y="27" width="8" height="43" fill="#E8EDF2" stroke="#78909C" stroke-width="1.5"/> </svg>',
    vertSquareValance: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 4000 4000"><path fill="#e8eef2" d="M3561.9 1010.2a1 1 0 0 1-.9.5q-9.7.2-17.8 4.2-1 .5-2.3.2l-543.7-147.3a4776 4776 0 0 1-123.2-34q-1.4-.4-2-1a.5.5 0 0 1 0-.8l.4-.2 23.2-2.2q3.8-.4 11.7 1.8 35.4 9.8 70.8 20a43976 43976 0 0 1 232.2 62.4l188.3 51q33.4 9.1 159.9 42.8 1.8.4 3.1 1.3.8.5.4 1.4ZM3532.8 1024.4l-38.9-9.9-16.9-4.6-564.4-153.6-68.3-18.8h-.4q-1.3.2-1.5 1.5v42.6a3 3 0 0 0 2.2 2.9l20.7 5.1 649.2 172.3q1.4.2 2-.9l16.8-35.2v-.2a1 1 0 0 0-.7-1.1Zm-8.2 3-.3-.4zm-1.4-1.2-.3-.2zm.8.6-.3-.3zm-36.1-12.1q-.1 0-.3.2zm-.4.4v.2zm-583.7-159 .1.3zm.2-.4v.2zm620.9 172.1.2.4zm.3 4.4q.3-.5.3-1zm.4-1.4v-.5zm-.3-2.2.1.4zm.2.8v.5zM3709.5 1035.7a204 204 0 0 0-49.2 20.7q-11.1 6-18.9 8.9a254 254 0 0 1-19.7 7c-25.1 5.8-48.7 2-73.3-2.4a34 34 0 0 1-16.7-8.1l14.3-31q1.4-3.1 4.5-4.6 5.2-2.5 13.6-4.7 33.8-8.7 41.6-10.9 4.3-1.2 9 0l26.2 7.2q34.2 9.2 68.5 17.9ZM3765.7 2115.2l-9.1-9.2-.4-.5a157 157 0 0 1-19.5-69.1c-3-62.7-.2-117.2-.3-184.8q-.1-102.3-.1-102.7c.6-61.7-.7-122.5-.5-186.4q.6-168.8-1.8-311.3a2789 2789 0 0 0-2.1-76q-.6-11.8-3.4-24.7c-7.3-32.8-34.8-30.1-61.1-31a80 80 0 0 1-44.7-15.3q-.5-.3-.2-1l.2-.2q6-3.4 11.3-4.6a301 301 0 0 0 69.1-23.4l52.7-17.6q1-.4 1.1-1.4.6-6.6-4.1-6.6-.6-.7 0-2.8l8.6 2a5 5 0 0 1 3.9 4.9zM3606.4 1099.5l-49.3-11.3-32-8.3h-.4q-1.5.1-1.6 1.6v5q.1 2 2 2.5l19.6 4.5q21.1 5.3 41.8 11.4 10.4 3 10.2 13.8-.5 27-.1 59.9.1 1.1 1.1 1.5l8.7 2.3h.2q.9 0 .8-.9V1101q-.1-1.2-1.1-1.4Z"/><path fill="#e8eef2" d="M3685.8 1175.4v-.2q-.3-.6-1-.5a4162 4162 0 0 0-55.4 17.6 75 75 0 0 1-16.1 3.4q-11.4-1.3-24.7-6.4-3.1-1.2-3.1-4.2.1-27.8-.2-55.7 0-1.1-1.2-1.3-1 0-2.2.2l-40.5 12.6-314.1 87.7q-255 70.8-510 141.2l-147.1 40.7c-26.6 7.4-74.3 21.2-118.2 33.3a30437 30437 0 0 0-204.1 57.3c-24.9 7.6-47.8 13.1-73.1 20.7q-24.8 7.4-95 26.7-38.9 10.6-122.6 34.6l-39.4 11.3q-124.2 35.2-243.9 68.5l-54.9 15.3a24026 24026 0 0 0-200.7 57.3l-20.7 4.5q-1 .3-1 1.3v81.2l-.9 37.1c0 2.8-1.9 5.2-4.5 6.1l-102.5 33.7-25.6 7.2a3.4 3.4 0 0 0-2.5 3.3v11.6l.1.6a2 2 0 0 0 2.5 1.4l74.4-22.5 40.8-12.8q150.7-46.5 338.9-103.3l242.1-73c126.7-38.1 450.2-134.9 675.3-201q251.9-74 504.1-148.4 102-30.1 482.2-140.6 49.3-14.3 63.7-18.1 1.1-.4 1.2-1.5zm-2345.3 712.7zm2202.7-746.2v-.3zm-1.1 2.4h-.3zm1.1-1.4zM1536.2 1194.1a494 494 0 0 1-71.3 22.5q-53 11.7-80.8 19.4l-97.3 27.1c-34.9 9.7-109.9 27.1-162.6 42.7-60.5 18-122.4 32.4-178.3 46.7a6367 6367 0 0 0-201.5 57.3c-38.9 11.6-102.8 26-145.5 38.5l-67.9 19.9q-1 .3-2.1 0c-18-5.5-35.2-12-53.1-16.3-2-.5-3.3-2.5-2.8-4.5a4 4 0 0 1 3.1-2.9c13.5-1.9 27.3-7 41.1-9.3 16.8-2.7 38.3-10.6 55.3-13.7q12-2.1 27.3-6.6c22-6.4 42.6-10.4 64.2-16.6q9.9-2.8 25.9-5.7c25.5-4.6 53.9-13.6 77.4-18.3q11.9-2.4 55.4-13.3c29.3-7.4 53.4-12.1 82.7-18.7 26.9-6 53.7-14.6 79.4-20 36.7-7.8 56.3-13.4 94.5-21.9a2108 2108 0 0 0 47.6-11.6q40.9-10.2 85.2-20 6.4-1.4 14.8-3.7a4712 4712 0 0 1 154.5-36.5l20.4-4.7 76.7-17.5c18.9-4.2 40.1-10.6 57.5-13.4q.3 0 .3.3 0 .1-.2.3Z"/><path fill="#d8d8d6" d="M3542.1 1144.2h-.3z"/><path fill="#e8eef2" d="M1100.3 1686.7q.4.4 0 .8l-.4.2h-40.7l-.6-.1-598.1-220a3 3 0 0 1-1.8-2.6v-9.2q.1-1.2 1.3-1.3h.5q88.4 31 110 38.9 87.8 32.4 145.1 52.6l32.7 11.9c87 31.9 151 55.9 217.9 79.5 45.6 16.1 75.7 27.8 131.7 47.9q1.4.5 2.4 1.4M968.9 1697.2l-.7.5-38.6 10.8q-.9.2-1.7 0-8.7-2.7-16.4-5.5c-109.2-40.3-219-80.3-350-128.9q-198.9-73.6-287.6-104.8-.5-.2-.7-.8t.4-1.1h.2l9.1-2 26.8-5.3 14.9-3.5q1.1-.2 2.2.1 65.9 24.9 136.1 50.4c12.3 4.4 26.2 10.3 39.6 15.2q75.5 27.6 118.7 44c32.3 12.4 66.3 24.4 98.9 36.8q63.3 24 84.8 31.6 16.2 5.7 44.9 17.2c19.3 7.7 55.1 20.5 80 30.1q16.7 6.5 36.9 12.5h.1l1.6 1q.8.7.3 1.6Z"/><path fill="#a5a5a3" d="M3675.2 1506.9v93.3z"/><path fill="#e8eef2" d="m3687.2 1666.9-1-411.4q-.1-2.4-2.2-3.6l-6.6-3.2-.6-.1q-1.3 0-1.5 1.5v350.1l.5 73v262.2a5 5 0 0 0 3.7 4.9l5.2 1.4h.7c1.4 0 2.6-1.2 2.6-2.6l-.6-272.3ZM1293.7 1709.7a35 35 0 0 0-14.2-4.2q-45.8-1.2-91.9-2-31.3-.5-35.7-.8c-7.8-.5-16.5.7-23.2.6q-22.8-.2-44.8.8-6.5-.7-9.9.7l-31 4.9q-.1 0-.3.2 0 .3.2.5 12.6 6.8 24.4 11.6c12.1 5 38.4 12.6 57.8 21.3 20 8.9 40 14.4 61.3 7.6q19-6 30.6-8.7c18.9-4.4 31.6-9.1 51.5-14.8 16-4.6 31.6-7.3 47.8-10.7l-22.6-7.2Zm-227.6-1.2h-.2zm-.9.9-.1.3zm-.2.6v.6zm.1.7.2.4zm.3.5.5.4q-.2 0-.5-.4M1402.5 3024.5l-173.6 68.7-1.4.6a2842 2842 0 0 1-71.2 27.5q-4.5 1.6-10.6 1.6l2.3-6.9q.2-.8 1-1.1l5.8-2.5V1827.8l-19.5-2.7 7.8-11.7 11.5.9 9.8-1.8 49.5-13.6L1377 1751s.9 1.7 1.8 4.7l.6 2.5c0 37.9-30.2 59-64.4 69.9-23.7 7.5-47.8 13.7-69.3 24.9-31.6 16.4-40.8 45.9-43.7 79.5a567 567 0 0 0-2.1 56.3q1 103.1 0 173.9-1.2 72.5-.6 121.9c.6 49.5-1.9 110.7-2.2 162.5q-.8 135.5-.2 156.8 2.9 106.3 2.9 124.9v149.8q.3 29.4 2.3 51.1c1.5 16.8 5.2 35.7 16.8 48.7 16.7 18.8 48 17 70 13 21-3.8 43.8-10.5 67.4-14.7 30-5.3 51.5 18.8 46 48.1Z"/><path fill="#d8d8d6" d="M3541.8 1144.4h.3z"/><path fill="#e8eef2" d="M1148.1 3113q-1.7-.3-1.8-2.2l-.3-7.5v-798l.5-482.8q0-1.1.9-1.6 1-.7 2.7-.7a7 7 0 0 1-3.9-1.4l-.5-.7a2.4 2.4 0 0 1 1-3.3q1-.5.4-1.7a18 18 0 0 1-10-.7q-14.8-5.2-29.5-10.8a8769 8769 0 0 0-115.1-42.8l-51.4-19.3q-4.6-2-7-9.2a8 8 0 0 0-4.6-3.2l-2.1-1.4q-3.3 1.2-3.5 4.5-.4 11.3-.1 34.7v74.3q0 1 .8 1.3l131.4 52.6q6.7 1.3 8.2 6.6.3 1.2.3 11c-.3 36.2-1.2 69.7-1.3 107.5-.4 211 .5 448.1 0 653.8q-.4 150.7 1.4 265 .1 6.9-.5 12.1c-.5 4.6-4.4 7.5-8.8 5.5-54-24.8-103.3-49-142.2-66.9h-.3q-.7 0-.7.7v120.1q0 1 .6 1.8a10 10 0 0 0 5.9 3.4l200.6 99.1a76 76 0 0 0 26.7 10.3l2.3-6.9q.2-.8 1-1.1l5.8-2.5q-4.2 1.5-6.8.6Zm-1.4 1.5.3-.2zM3702.4 2038.2l-3.3-1.6q-1-.5-1.1-1.7v-79.3a2 2 0 0 1 1.2-1.8l3.3-1.3c1-.4 2.1.1 2.4 1.1l.1.7v82.1q-.1 1.7-1.9 1.9-.5 0-.8-.2ZM3695.4 2044.1l-79.9 24.4q-1 .2-1.4-.7l-.2-.7q-.1-.5.4-.9 11-4.6 12.7-5.2 33.3-10.7 55.7-18.8 6.8-2.4 12.6-.7 1.1.4.9 1.6-.2.7-.9.9Z"/><path fill="#e8eef2" d="M3712.4 2105.1a3 3 0 0 1-1.8 2.7c-16.7 7.2-29.4 14.5-47 21.1q-8.9 3.3-26.1 10.5l-14.9 5.8c-5.6-24.4-11.5-57.9-2.9-66.3q-2.4 0-4.7.7-1.6.7-1.7 2.4l.2 94.3q0 .7-.8.8h-.3l-12.8-4.6q-.3 0-.4-.6l-.2-99.8q.2-1.7 1.8-1.8.6 0 1.1.4a36 36 0 0 0 20.3 6.7l5.2-1.6 29.9-9.1 54.2-17zM3670 1949.3q-5-1.6-4.9-6.9.6-340.8-.7-695.2 0-6.8.6-8.1.8-1.5 2.4-2.2l16.4-7q1.6-.7 1.6-2.5v-10.5q-.5-1.1-1.7-.9l-92.5 27.6-449.5 131.2q-79.5 23.5-159.1 46.3c-9.6 2.8-20.8 6.7-29.3 9.2a23091 23091 0 0 0-177.2 51.7l-274 80.8c-28.9 8.5-53.5 16.7-81.1 24.3q-13.2 3.7-61 17.8a103700 103700 0 0 0-515.4 154.4 68680 68680 0 0 0-357.9 108.6q-83.9 25.7-134.3 40.4a1736 1736 0 0 0-58.2 17.7l-32 8.6q-1.5.5-1.6 2.1v54.9q.1 1.1 1.3 1.2c6.1-.3 13.7-.4 18.1 4.9q1 13.6 1.1 23.2-.5 258.4-.3 815.2l-.1 7.2a7 7 0 0 1-3.8 5.5 39 39 0 0 1-12.1 3.9q-1.9.5-2 2.3v25.6q.5 1 1.5.7l134.9-51.8 397.1-149.3 268.3-99.8 106.4-39.5 473.1-174.3a42135 42135 0 0 1 535.5-192.9l.4-.1 490.6-175 15-5.3q1.6-.6 1.6-2.3l.2-35.4q-8.4-2.7-17.3-5.9ZM1050.9 2638.1l-.5 229.6q.8 2.4 0 3.5a1 1 0 0 1-1.3.3L809.7 2755l-529.9-258.5a3 3 0 0 1-1.8-2.9l-.6-185.4.3-573.2.4-114.9q.1-1 1-1h.4c24.9 11.1 52.9 20.5 75.1 29.5q14.4 5.8 40.6 15.8 84.2 32 172.1 66.2 123 47.9 251 96.3 52.3 19.8 88.5 33.9 62.2 24.3 88.6 33.8c15.9 5.8 36 15.6 55 21.2q.6.2.6.9v721.6Z"/><path fill="#e8eef2" d="M3685.8 2026.1v-.3q-.6-1.2-1.7-.8-35.8 12.5-69.6 24.8-12 4.4-23.8 9.5c-29.1 10-63 23-86.6 31.4l-554 197.9q-68.2 24.3-294.1 107.1a231218 231218 0 0 0-500.3 184.5c-211.4 78.5-459.6 171.6-690.2 258.9l-79.3 30.6q-.5.2-.7.8-.2 1 .8 1.5c7.6 2.3 24.9 8.3 29 14.9q1.5 2.4 1.6 10.2a3948 3948 0 0 1 .1 84.9q.7 1.4 2.2 1l28.9-11 141.3-54.2 385.3-147.4q384-147.3 769.1-291.9l157.4-59.4q57-21.6 153.1-56.9a143255 143255 0 0 0 334.7-124.3q66.2-24.6 197.9-71.9 1-.4 1.1-1.5l.3-27.3V2072q-1.2-5.3 3.8-11.2l92.9-31.9q1.3-.5 1.2-1.8v-.8ZM1050.9 2893.5q-.2 1.4-1.5 1.5c-1.3.1-.4 0-.7-.1l-40.6-20q-84.7-39-168.1-81.1a2505 2505 0 0 0-50.5-24.8c-22.6-10.6-45.2-22.4-67.3-33.2q-81.7-39.9-118.5-58.1l-240.1-118.6q-82.7-40.8-113.8-56.7-1-.6-.5-1.6.3-.6 1-.7l13.6-1.3q1.1 0 1.9.7 2.3 2.1 3.9 3l91.2 45 530.6 259.2c35 17.1 85.6 41.1 128.1 62.3l28.8 13.6q2.3 1.2 2.4 3.8z"/><path fill="#e8eef2" d="m1385.8 2884.6 7.1 3.7q.7.4.3 1.1-.1.3-.4.4l-49.9 18.7q.4-1.6-.7-2.3 5.3-2.3 20.7-11 6.3-3.6 23-10.6ZM1313.6 2916.2l-50 18.5q-1.6-7.5 2-8.7 15.3-5.2 29.6-12.1 10.1-2.2 18.4 2.4Z"/><g fill="#13548d"><path d="M3753 1049.4q4.7 0 4.1 6.6-.1 1-1.1 1.4l-52.7 17.6-77.7 22q-1.4.4-2.4-.6l-5.6-5.6q-.9-1 0-2l.6-.4zM1147 1812.9a18 18 0 0 1-10-.7q-14.8-5.2-29.5-10.8a8769 8769 0 0 0-115.1-42.8l-51.4-19.3q1.3-4.8 3.4-7.1a2 2 0 0 1 1.9-.7q7 1.3 13.4 3.9c31.5 12.8 73.3 27.1 101.6 38.2q25.9 10.2 84.8 32.2.8.3 1.2.9 2 2.7-.2 6.2ZM1266.3 1783.5l-93.1 26.8q-7.8 2.2-18.5 4a3 3 0 0 1-3.3-2.4v-1.8a4 4 0 0 1 2.8-4.4c36.3-11.3 73.1-21.3 109.4-31.7l93.1-26.8q7.8-2.2 18.5-4a3 3 0 0 1 3.3 2.4v1.8a4 4 0 0 1-2.8 4.4c-36.3 11.3-73.1 21.3-109.4 31.7M1151.3 1820l3.7.9v1291.5q-4.4 1.5-7 .6-1.7-.3-1.8-2.2l-.3-7.5q.2-132 0-263.9v-534.1l.5-482.8q0-1.1.9-1.6 1.6-1 3.9-.7Z"/><path d="M3779.1 2108q-.5-512.4 0-1050.2c0-8.6-1.4-12.8-6.7-18.2q-2.9-3-13.6-5.6-67.8-16.7-139.7-35.3c-9.4-2.5-19.1 0-29.4 2.6q-1 .2-2.1 0l-3.1-.9-252.9-68.1c-143.3-38.9-280.5-75-420.4-113.5q-9-2.4-14.1-2.1-23.4 1.8-48.4 4.1-13 1.3-17.1 10.6-1.6 3.6-1.5 21.2l.2 29.1q0 1.6-1.6 2.1-201 45.3-310.9 69.5-118.1 26-250.6 56.4a151142 151142 0 0 0-1759.8 413.5q-16.8 4.1-38.7 10c-5.8 1.6-10.7 2.5-15.4 6.4q-6.4 5.4-6.5 9.9-.6 18.9-.5 19.2.1 3.3 3.1 5.2 4.2 2.5 7.5 3.7l132.4 48a4851 4851 0 0 1 87.1 32.9c14.2 5.7 31 10.5 48.3 17.4 13.9 5.6 32.9 11.6 51 18.4q117.5 44.2 239 88.6.6.2.7.8.1 1-.8 1.3l-25.2 5.7-1.1-.1q-17.3-7.5-24.8-10c-66.4-23.1-129.7-48.2-196.7-72.9q-29.6-11-67.6-25.8c-26.2-10.3-51.4-18.5-75.5-28-49.7-19.6-106.6-40.2-148.3-55.9-14.9-5.7-31.3-12.9-42.8-17a3939 3939 0 0 1-99.7-36.3q-6-2.3-9.8-1.5l-65.6 14q-12.7 2.9-16.6 13.7-.3.8-.3 1.6l-.3 125.6q0 .7.2 1.3c3.1 8.8 13 10.6 22.2 13.4q2 .8 2.2 3v869.7q0 .7-.8.8-12.1.5-25 2.6c-7.6 1.3-12.7 2.1-16.5 7.5q-1.6 2.2-1.5 13.7v105.3q0 11.7 8.3 15.9 314.5 158 427 214.2 124.5 62.2 224.7 111.4 3.6 1.8 17.2 7.6 1 .5 1 1.6.1 13.5-.4 39.6c-.2 11.3 3.2 14.9 13.4 19.5l16.6 7.6 171.4 85.4c17 8.5 32.3 17.6 49 17.7q6.5 0 20.7-5.4c79.7-30.6 153.2-60.7 238.3-94.8 6.3-2.5 9.1-8.2 9-15.3q0-6.4.2-21.8 0-1.1 1.1-1.6 67.4-25.4 198.8-76c163.4-62.9 351.6-134.4 527.3-202.1q52.4-20.1 524.9-199.1c199.2-75.4 422.6-157.9 640.1-238.9a38070 38070 0 0 1 275.1-100.9q1-.3 2.1 0l19.8 8.4q10.3 4.4 20.5.6c59.7-22.7 96.7-38 139.5-53.3 13.7-4.9 12.4-15.7 12.4-27.9ZM2872.3 831.9l23.2-2.2q3.8-.4 11.7 1.8 35.4 9.8 70.8 20a43976 43976 0 0 1 232.2 62.4l188.3 51q33.4 9.1 159.9 42.8 1.8.4 3.1 1.3.5.3.5.9-.1 1-1 1-9.7.2-17.8 4.2-1 .5-2.3.2L2997.2 868a4776 4776 0 0 1-123.2-34q-1.4-.4-2-1l-.2-.4q0-.5.5-.6Zm-29.9 7v-.4q.4-1.3 1.8-1l68.3 18.8 564.4 153.6 16.9 4.6 38.9 9.9h.2q.6.4.4 1.2l-16.8 35.2q-.7 1.3-2 .9l-649.2-172.3-20.7-5.1a3 3 0 0 1-2.2-2.9zm853.5 334.2q0-1.6 1.5-2.2l4.3-1.7h.4q1.1 0 1.2 1.2v69q.1 1.1-1 1.5c-5.2 1.7-10.5 6.9-16.5 2.9a1 1 0 0 1-.5-.9q0-1.2 1.1-1.3a17 17 0 0 0 8.3-2.5 3 3 0 0 0 1.2-2.3v-63.6ZM1281 2020.5q0-9.5-1.1-23.2c-4.4-5.3-12-5.2-18.1-4.9q-1.1-.1-1.2-1.2v-54.8q0-1.6 1.6-2.1l32-8.6a1736 1736 0 0 1 58.2-17.7q50.4-14.6 134.3-40.4c125.5-38.5 201.4-61.3 357.9-108.6q275.5-83.2 515.4-154.4 47.8-14.2 61-17.8c27.6-7.6 52.2-15.7 81.1-24.3l274-80.8a23091 23091 0 0 1 177.2-51.7c8.5-2.4 19.7-6.4 29.3-9.2q79.6-22.8 159.1-46.3l449.5-131.2 92.5-27.6h.4q1.2.1 1.3 1.4v10.1q0 1.8-1.6 2.5l-16.4 7q-1.6.7-2.4 2.2-.6 1.3-.6 8.1 1.3 354.4.7 695.2 0 5.2 4.9 6.9l17.3 5.9-.2 35.4q0 1.6-1.6 2.3l-15 5.3-490.6 175-.4.1A40643 40643 0 0 0 2644 2366l-473.1 174.3-106.4 39.5-268.3 99.8-397.1 149.3-134.9 51.8h-.4q-1-.1-1.2-1.1v-25.2q.1-1.9 2-2.3 6.9-1 12.1-3.9a7 7 0 0 0 3.8-5.5l.1-7.2q-.2-556.7.3-815.2Zm2394.1-420.3V1250l.1-.6q.6-1.2 2-.7l6.6 3.2q2.1 1 2.2 3.6l1 411.4.6 272.3v.7a2.5 2.5 0 0 1-3.1 1.8l-5.2-1.4a5 5 0 0 1-3.8-4.9v-262.2l-.5-73ZM1265.6 2925.9l23.3-9.2 6.3-2.9 18.1-7.3c22.1-9.2 44.5-17.3 66.9-25.5l11.3 6.6 1.4.7q.3 0 .4.4.2.7-.5 1.1l-49.9 18.7-77.4 29.9a2 2 0 0 1-1.8-.4q-1.5-1.6-.2-3.3-1.6-7.5 2-8.7Zm-3.1-9.8v-.8c0-2.4 1.5-4.5 3.8-5.3l73-26.5 21.3-7.7 9.7-2.8h.3q1.1 0 1.2 1.2v.7c0 1.9-1.3 3.6-3.1 4.2l-27.9 10.9-74.1 29.1-1 .2a3 3 0 0 1-3.1-3.1Zm98.4-48.6-33.2 12.5-62.5 23.6-.7.1q-1.6-.2-1.8-1.8v-6.5q.1-2.1 2-3l22.3-8.8c80.9-31.1 161.9-62.6 242.8-92.8l336.1-125.5 39.8-14.8 666.8-246.5q197.3-73.5 395.4-144.4l23.6-8.4c272.9-96.7 497.5-177 693.3-246.8l.7-.1c1.1 0 1.9.9 1.9 1.9v3.7a4 4 0 0 1-2.7 3.8q-35.1 11.7-62.3 22.1-33.2 12.8-62.1 23.1-130.5 46.8-296.9 105.8-65.7 23.3-123 44l-115.8 41.8-204.2 73.6q-84 30.3-344.6 126.4-228.6 84.3-382.6 141.4a78210 78210 0 0 0-674 253.3q-12.9 5-25.9 9.6l-32.4 12.2Zm2334.4-825.9q.7.2.9.9.2 1.2-.9 1.6l-79.9 24.4a1 1 0 0 1-1.4-.7l-.2-.7q-.1-.5.4-.9 11-4.6 12.7-5.2 33.3-10.7 55.7-18.8 6.8-2.4 12.6-.7Zm-10.7-837.7q-14.4 3.7-63.7 18.1-380.2 110.4-482.2 140.6-252.2 74.4-504.1 148.4c-225 66.1-548.6 162.9-675.3 201l-242.1 73a58090 58090 0 0 0-379.7 116.1l-74.4 22.5h-.6a2 2 0 0 1-2-2.1v-11.6q.1-2.6 2.5-3.3l25.6-7.2 102.5-33.7a6.4 6.4 0 0 0 4.5-6.1l.9-37.1v-81.2q0-1 1-1.3l20.7-4.5q100.2-29.1 200.7-57.3l54.9-15.3q119.5-33.3 243.9-68.5l39.4-11.3q83.7-24 122.6-34.6a4627 4627 0 0 0 95-26.7c25.3-7.6 48.2-13.1 73.1-20.7l29.2-8.5q56.1-15.9 174.9-48.8c43.9-12.2 91.6-25.9 118.2-33.3l147.1-40.7q255-70.5 510-141.2l314.1-87.7 40.5-12.6q1.2-.3 2.2-.2t1.2 1.3q.3 27.8.2 55.7 0 2.9 3.1 4.2a99 99 0 0 0 24.7 6.4q7.8-.7 16.1-3.4 30.1-9.7 55.4-17.6h.2q.7 0 .8.8v26.9q0 1.1-1.1 1.5m-165.7-103.6.3.3q0 .5-.3.6-119.3 34.3-196.7 55.8l-201.3 55.7a212088 212088 0 0 0-883.6 244.4q-365.6 101.7-411.6 114.9-121.8 34.8-488.5 136.9-1.2.3-2.4 0a2554 2554 0 0 1-52.6-18.1 80 80 0 0 0-27.1-4.6q-65-.4-119-.2-1.3 0-2.4-.4l-323.8-117.1q-.6-.2-.9-1-.2-1.2 1-1.7l2324.5-590.4q1.1-.3 2.3 0l371.9 97.9q1.3.4 1.3 1.7.2 6.1-.3 13.2c-.6 9.1 3 8.6 9.3 12.1Zm-2163 614.7q101.4-29 144.9-40.7 9.2-2.4 296.2-83c73.2-20.5 144.1-40.9 208.7-58.6 19.5-5.4 44.8-13 69.3-19.7q91.3-25 196.2-54.4 48.5-13.6 75.7-20.9c34.9-9.3 67.5-19.1 100.8-28.3a23379 23379 0 0 0 193.4-53.8 3430 3430 0 0 1 59.4-16.2c26.2-6.9 53.5-15 79-22l234.6-64.2 44.4-12.2 343.7-95.8A5917 5917 0 0 0 3526 1110l10.6-3.3q1.5-.5 3.1-.1l39.3 8.8q.6.1.8.8.2 1-.7 1.3c-47.9 13.1-95.5 27.9-141.3 40.7l-144.4 40.2q-60.1 16.6-117.5 32.8-57 16.1-117.4 32.8a142531 142531 0 0 0-843.3 235.2l-187.9 53.1q-259.7 73.6-537.8 152.1l-95 26.8q-.8.2-1.5-.3c-9.7-7.3-23.3-10.2-37.2-14.5q-.5 0-.6-.6-.2-.7.6-1Zm2251.6-533.5v.3q-.3.7-1 .6l-8.7-2.3q-1-.4-1.1-1.5-.4-32.9.1-59.9.1-10.8-10.2-13.8a951 951 0 0 0-41.8-11.4l-19.6-4.5q-1.9-.6-2-2.5v-5.4q.5-1.4 2-1.2l32 8.3 49.3 11.3q1 .3 1.1 1.4v80.5ZM473.2 1446.1q138.3-34.5 191.9-47c81.5-19.1 163.7-39.4 241.3-57.2 27.3-6.3 59.7-14.5 84.3-20.3q75.3-17.7 197.1-46.8 141.6-34 414.7-97.1c283.6-65.6 594.1-138.6 828.9-191l177.3-39.6q218.9-49.3 226.7-50.7 1.5-.2 3.1 0 36.7 9 82.6 21.2l187.3 49.8q.8.2 1.4.7l.3.4q.1.7-.6 1L787.2 1559.3h-1.4l-312.6-112.4q-.2 0-.2-.3t.3-.4Zm-12.7 21.5a3 3 0 0 1-1.8-2.6v-9.7q.5-1 1.7-.8 88.4 31 110 38.9 87.8 32.4 145.1 52.6l32.7 11.9c87 31.9 151 55.9 217.9 79.5 45.6 16.1 75.7 27.8 131.7 47.9q1.4.5 2.4 1.4l.2.4q0 .5-.6.6h-40.7l-.6-.1zm-186.6-.2 9.1-2 26.8-5.3 14.9-3.5q1.1-.2 2.2.1 65.9 24.9 136.1 50.4c12.3 4.4 26.2 10.3 39.6 15.2q75.5 27.6 118.7 44c32.3 12.4 66.3 24.4 98.9 36.8q63.3 24 84.8 31.6 16.2 5.7 44.9 17.2c19.3 7.7 55.1 20.5 80 30.1q16.6 6.5 36.9 12.5h.1l1.6 1 .5.7q.2 1-.8 1.4l-38.6 10.8q-.9.2-1.7 0-8.6-2.7-16.4-5.5c-109.2-40.3-219-80.3-350-128.9q-198.9-73.6-287.6-104.8-.5-.2-.7-.8v-.2q0-.7.6-1ZM254 1597.2q-1-.4-1-1.4l.6-98.6v-23.7q.4-1 1.5-.6l11.1 4.5 650.1 238.2.4.2a1 1 0 0 1 0 1.6c-6 6.5-5.5 13.7-5.5 23.9q0 51.5-.3 97.7 0 1 .3 1.9 2.8 8.3 9.4 10.7 39.4 13.8 64.6 24.5c18.9 8 42.6 15.2 61.4 23.6q3.8 1.6 4.7 4.3.1.5 0 .8-.4 1-1.6.7-28.2-10-84.1-33.1-31.1-12.8-84-33.2-261-100.4-511.9-197.7-49.3-19.1-116-44.3Zm796.9 1040.9-.5 229.6q.8 2.4 0 3.5a1 1 0 0 1-1.3.3L809.7 2755l-529.9-258.5a3 3 0 0 1-1.8-2.9l-.6-185.4.3-573.2.4-114.9v-.4q.5-.9 1.4-.5c24.9 11.1 52.9 20.5 75.1 29.5q14.4 5.8 40.6 15.8 84.2 32 172.1 66.2 123 47.9 251 96.3 52.3 19.8 88.5 33.9 62.2 24.3 88.6 33.8c15.9 5.8 36 15.6 55 21.2q.6.2.6.9v721.6Zm-800.6-137.8 13.6-1.3q1.1 0 1.9.7 2.3 2.1 3.9 3l91.2 45 530.6 259.2c35 17.1 85.6 41.1 128.1 62.3l28.8 13.6q2.3 1.2 2.4 3.8v7.1l-.1.7q-.8 1.2-2 .7l-40.6-20q-84.7-39-168.1-81.1a2505 2505 0 0 0-50.5-24.8c-22.6-10.6-45.2-22.4-67.3-33.2q-81.7-39.8-118.5-58.1l-240.1-118.6q-82.7-40.8-113.8-56.7-.6-.3-.7-1 0-1.1 1.1-1.3Zm651.1 376.8a258 258 0 0 0-1.3 47.9l-.2 25.8v.3q-.4.6-1 .3l-25.9-13.7-443.8-221.2-145.4-72.3-49.1-24.4-.7-113.2.1-.5q.5-.7 1.3-.3 3.3 2 7.9 4.3c217.2 108.8 424.7 210.6 682.5 337.4 13.6 6.7 25.2 11.6 36.5 17.2q46.5 22.9 87.4 41.6 1.4.7 1.4 2.2v7.3q-.4.6-1.1.4l-108.3-51.7q-1.2-.6-2.5-.6l-20.2 5.2a54 54 0 0 0-17.2 8Zm149.5 62.1-.1.4q-.4.8-1.3.4L926 2881.1q-.4-.2-.5-.6-.2-.9.7-1.2l13.7-4.2h.7l109.8 52.4q.5.3.6.9v10.7Zm353.2 82.9q0 1.7-1.6 2.4l-161.9 64a3190 3190 0 0 1-84.2 32.8q-4.5 1.6-10.6 1.6a77 77 0 0 1-26.7-10.3l-200.6-99.1q-3.9-1-5.9-3.4a3 3 0 0 1-.6-1.8v-120.4q.4-.6.9-.3c38.9 18 88.2 42.1 142.2 66.9 4.4 2 8.3-.9 8.8-5.5q.6-5.2.5-12.1-1.8-114.4-1.4-265c.6-205.7-.3-442.8 0-653.8 0-37.9.9-71.4 1.3-107.5q0-10-.3-11-1.5-5.1-8.2-6.6l-131.4-52.6q-.8-.4-.9-1.3v-74.3q-.2-23.4.1-34.7 0-3.2 3.5-4.5a10 10 0 0 1 5-3.7l73.6-20.4q1.5-.5 3 0 12.1 2.9 25.1 2.7 19.5-.2 40 .7a20 20 0 0 1 9.9-.7 738 738 0 0 1 44.8-.8c6.7 0 15.4-1.1 23.2-.6q4.3.3 35.7.8 46.2.8 91.9 2 6.1.1 14.2 4.2l22.6 7.2q50.6 17 63.3 21.6 4.5 1.7 4.5 6.9.8 65.7.2 108.7 0 1-1 1.3c-42.5 12.4-94 31.1-126.8 41-8.1 2.4-7.5 9.3-7.5 18.3q-.4 44 0 80.2c0 4-.5 7.9 3.3 9.6 4.5 2 10.3 1 14.9.9q1.2.1 1.3 1.3v830.7c0 .9-.7 1.8-1.6 1.9a28 28 0 0 0-12 5.9 9 9 0 0 0-3.5 7.2v95.2q0 .5.2.8 2.6 4.6 7 3.4 7.6-2 30.4-11.5c37-15.3 78.7-30 106.5-41.1l6.6-2.1h.4q1.2.1 1.3 1.4v123.7ZM3588 2071.9v65.2l-.2 27.3q0 1.1-1.1 1.5-131.6 47.2-197.9 71.9a143255 143255 0 0 1-334.7 124.3q-96.1 35.3-153.1 56.9l-157.4 59.4q-385 144.6-769.1 291.9l-385.3 147.4-141.3 54.2-28.9 11-.6.1q-1.5-.2-1.7-1.7.3-42.9 0-84.3 0-7.8-1.6-10.2c-4.2-6.7-21.4-12.6-29-14.9q-.5-.2-.8-.7-.3-1 .7-1.5l79.3-30.6c230.6-87.3 478.8-180.4 690.2-258.9l68.6-25.4q365.4-134.8 431.7-159.1 226-82.8 294.1-107.1l554-197.9c23.6-8.4 57.5-21.4 86.6-31.4q11.8-5.3 23.8-9.5 33.7-12.2 69.6-24.8h.3q1.2 0 1.5 1.2v.8q.2 1.3-1.1 1.8l-92.9 31.9q-5 6-3.9 11.2Zm177.5 49.1q-.2.8-1 1.2l-140.9 54.1h-.2a1 1 0 0 1-.6-.6V2087a36 36 0 0 0-1-7.8q-3.4-.4-6.6.6-1.6.7-1.7 2.4l.2 94.3v.3q-.3.6-1 .5l-12.8-4.6q-.3 0-.4-.6l-.2-99.8q0-.6.3-1.1c.6-.8 1.7-1 2.5-.4a36 36 0 0 0 20.3 6.7l35.1-10.6 54.2-17q3.1-1.5 3.1-6.1l-.1-97.9c0-11.9-10.2-7.6-16.5-5.2h-.4q-1.1 0-1.2-1.2l-1.3-682.3q.2-2 2.1-2.4 7.2-.8 13.3-3.8a5 5 0 0 0 2.8-4.6l-.2-84.6q0-.7-.3-1.3-2.7-5.4-8.4-3.9-45.1 12.6-85.9 25.4h-.4q-1.2-.1-1.3-1.3v-74.5q-.2-1.3-1.5-1.9l-3.3-1.2-.2-.1c-.6-.3-.7-1.1-.4-1.6q2.6-4 .7-5.7a32 32 0 0 0-12.4-6.6q-30.2-8.2-71.9-18.7-.2 0-.4-.2-.9-.7-.4-1.7l4.4-6.6 14.3-31q1.4-3.1 4.5-4.6 5.2-2.5 13.6-4.7 33.8-8.7 41.6-10.9 4.4-1.2 9 0l26.2 7.2q34.2 9.2 68.5 17.9l43.5 10.9 8.6 2a5 5 0 0 1 3.9 4.9l.3 1061.7q.4 3.2-.2 5.8Zm-67.5-86v-79.3a2 2 0 0 1 1.2-1.8l3.3-1.3.7-.1c1 0 1.9.8 1.9 1.9v82.1q0 .5-.2.8c-.4.9-1.6 1.3-2.5.9l-3.3-1.6q-1-.5-1.1-1.7Z"/></g><path fill="#e8eef2" d="m912.8 1718.3-5.5 4.5-7.4 6a59 59 0 0 1-44.6 9.7c-21-3.4-43.5-11.2-65.6-18.3q-80.2-26.1-163.4-53.6a2837 2837 0 0 0-104.5-32.8q-29-8.4-103.3-27.3c-33.7-8.5-65.1-17.8-94.3-27l-3.3-1q-10.7-3.3-19.8-7a80 80 0 0 1-41-41.8c-8.5-20.4-6.5-38.9-6.5-38.9v-17q.1-1 1.1-1.2c1-.2.3 0 .4 0l11.1 4.5L912 1713.7c1.9.7 2.3 3.2.7 4.5Z"/></svg>',
    // TDBU (Top-Down/Bottom-Up) lift: shade floats between top+bottom rails,
    // down-arrow (top lowers) + up-arrow (bottom raises). HT 7/16 lift upgrade.
    tdbu: '<svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">' + '<rect x="12" y="9" width="56" height="5" rx="2" fill="#13548d"/>' + '<rect x="12" y="66" width="56" height="5" rx="2" fill="#13548d"/>' + '<rect x="14" y="18" width="52" height="4" rx="1.5" fill="#0f3f6b"/>' + '<rect x="16" y="30" width="48" height="20" rx="2" fill="#E8EDF2" stroke="#78909C" stroke-width="1.5"/>' + '<line x1="16" y1="37" x2="64" y2="37" stroke="#b6c2cc" stroke-width="1"/>' + '<line x1="16" y1="43" x2="64" y2="43" stroke="#b6c2cc" stroke-width="1"/>' + '<rect x="14" y="58" width="52" height="4" rx="1.5" fill="#0f3f6b"/>' + '<path d="M40 24 v4 m-2.5 -2.5 l2.5 2.5 l2.5 -2.5" stroke="#13548d" stroke-width="1.8" fill="none" stroke-linecap="round" stroke-linejoin="round"/>' + '<path d="M40 56 v-4 m-2.5 2.5 l2.5 -2.5 l2.5 2.5" stroke="#13548d" stroke-width="1.8" fill="none" stroke-linecap="round" stroke-linejoin="round"/>' + '</svg>'
  };


  /* ============================================================
     STEP RENDERING
     ============================================================ */
  var stepsContainer = dom.qs('[data-builder-steps]');
  if (!stepsContainer) return;

  // Clear loading state
  stepsContainer.innerHTML = '';

  // Steps are metafield-gated. When the parent sets the matching
  // `custom.builder_pricing.show_*` key to false the step is hidden, its
  // value is auto-set so EDI + pricing stay correct, and it is marked
  // complete on init so ATC validation passes without user interaction.
  // Step indices for stepElements references stay stable; only display +
  // auto-complete change, and the visible step digits are renumbered.
  //   show_roll_direction:false  -> Zebra LF/RD + Solar (PDP parity)
  //   show_control:false         -> Cellular (cordless only, Builder 1.0
  //                                 parity: no control choice)
  //   show_valance:false         -> Cellular (no valance on these shades)
  var hideRollDirection = !!(pricingData && pricingData.show_roll_direction === false);
  var hideControl = !!(pricingData && pricingData.show_control === false);
  var hideValance = !!(pricingData && pricingData.show_valance === false);
  // Horizontal-blind families (Faux Wood Premier/Signature, Hardwood, Mini)
  // reuse this v2 engine but with a different step set + EDI emit. Gated by
  // builder_pricing.builder_layout so every existing roller / Phase II /
  // Mariak product (which never sets it) is completely unaffected.
  var isHorizontal = !!(pricingData && pricingData.builder_layout === 'horizontal');
  // Horizontal step gates. Each appended step (indices 5+) is shown only when
  // its builder_pricing flag is explicitly true, so roller / Phase II products
  // (which never set them) keep the appended steps hidden + auto-completed.
  var showWand = !!(pricingData && pricingData.show_wand === true);
  var showValanceStyle = !!(pricingData && pricingData.show_valance_style === true);
  var showValancePosition = !!(pricingData && pricingData.show_valance_position === true);
  var showHeadrail = !!(pricingData && pricingData.show_headrail === true);
  var showPrivacy = !!(pricingData && pricingData.show_privacy === true);
  // 8g: scoping removed the Privacy customer step but Mariak still needs the
  // field, so emit Privacy Options: Standard by default. Gated on its own flag
  // (NOT !showPrivacy) so Hardwood / Faux Wood / Mini 6g never emit a stray one.
  var privacyAutoStandard = !!(pricingData && pricingData.privacy_auto_standard === true);
  var showHardware = !!(pricingData && pricingData.show_hardware === true);
  // Selected hardware option objects, kept so the ATC emit can read each edi_key.
  var currentHardwareOpts = [];
  // Set by the headrail step so Add to Cart can put a corrected split on screen.
  var resplitTwoOnOne = null;
  // Roman fold + lining steps (percent-of-base surcharges). Gated on their own
  // flags so every other family keeps them hidden + auto-completed.
  var showFold = !!(pricingData && pricingData.show_fold === true);
  var showLining = !!(pricingData && pricingData.show_lining === true);
  // Mariak vertical steps (Stack / Valance / Extra Vane / Channel Panel). Each
  // gated on its own flag so every other family keeps them hidden + auto-completed.
  var isVertical = !!(pricingData && pricingData.builder_layout === 'vertical');
  var showStack = !!(pricingData && pricingData.show_stack === true);
  var showVerticalValance = !!(pricingData && pricingData.show_vertical_valance === true);
  var showExtraVane = !!(pricingData && pricingData.show_extra_vane === true);
  var showChannelPanel = !!(pricingData && pricingData.show_channel_panel === true);
  // Liner (SWF Naturals). Two steps: the type drives the size limit and a
  // width-banded surcharge, the colour is display + EDI only. Both stay
  // hidden and auto-completed on every family that does not set show_liner.
  var showLiner = !!(pricingData && pricingData.show_liner === true);
  var showEdgeBand = !!(pricingData && pricingData.show_edge_banding === true);
  var edgeBandOptions = (pricingData && Array.isArray(pricingData.edge_banding_options))
                        ? pricingData.edge_banding_options : [];
  var edgeBandColors = (pricingData && Array.isArray(pricingData.edge_banding_colors))
                       ? pricingData.edge_banding_colors : [];
  var currentEdgeBandOpt = null;
  // Valance selection (SWF Naturals). Separate from the three older valance
  // concepts above so no existing parent changes behaviour.
  var showValanceSel = !!(pricingData && pricingData.show_valance_selection === true);
  var valanceSelOptions = (pricingData && Array.isArray(pricingData.valance_selection_options))
                          ? pricingData.valance_selection_options : [];
  var currentValanceSelOpt = null;
  var linerOptions = (pricingData && Array.isArray(pricingData.liner_options)) ? pricingData.liner_options : [];
  var linerColors = (pricingData && Array.isArray(pricingData.liner_colors)) ? pricingData.liner_colors : [];
  // Optional line under the liner swatches. Config-driven so the wording can
  // change without a deploy; absent key means no element on every other family.
  var linerColorNote = (pricingData && typeof pricingData.liner_color_note === 'string')
                       ? pricingData.liner_color_note : '';
  var linerNote = (pricingData && typeof pricingData.liner_note === 'string') ? pricingData.liner_note : '';
  // A liner also lines the valance when there is one, which the vendor charges as its own width band.
  var valanceLinerBands = (pricingData && pricingData.valance_liner_price_bands) || null;
  // Sky pole (SWF Cellulars). Optional add-on priced per pole, one or two by width.
  var skyPoleCfg = (pricingData && pricingData.sky_pole && typeof pricingData.sky_pole === 'object')
                   ? pricingData.sky_pole : null;
  var showSkyPole = !!skyPoleCfg;
  var skyPoleOptions = (skyPoleCfg && Array.isArray(skyPoleCfg.options)) ? skyPoleCfg.options : [];
  var currentSkyPoleOpt = null;
  // The pick a control change hid, put back when a pole-eligible control returns.
  var hiddenSkyPoleOpt = null;

  var STEPS = [
    { num: 1, title: 'Choose Color', render: renderColorStep, hidden: false },
    { num: 2, title: 'Choose Mount & Size', render: renderMountSizeStep, hidden: false },
    { num: 3, title: 'Choose Control Style', render: renderControlStep, hidden: hideControl },
    { num: 4, title: 'Choose Roll Direction', render: renderRollStep, hidden: hideRollDirection },
    { num: 5, title: 'Choose Valance Options', render: renderValanceStep, hidden: hideValance },
    { num: 6, title: 'Choose Wand Control', render: renderWandStep, hidden: !showWand },
    { num: 7, title: 'Choose Valance Style', render: renderValanceStyleStep, hidden: !showValanceStyle },
    { num: 8, title: 'Choose Valance Options', render: renderValancePositionStep, hidden: !showValancePosition },
    { num: 9, title: 'Choose Headrail Options', render: renderHeadrailStep, hidden: !showHeadrail },
    { num: 10, title: 'Choose Privacy Options', render: renderPrivacyStep, hidden: !showPrivacy },
    { num: 11, title: (pricingData && pricingData.hardware_step_title) || 'Optional Hardware', render: renderHardwareStep, hidden: !showHardware },
    { num: 12, title: 'Choose Fold Style', render: renderFoldStep, hidden: !showFold },
    { num: 13, title: 'Choose Lining', render: renderLiningStep, hidden: !showLining },
    { num: 14, title: 'Choose Stack', render: renderStackStep, hidden: !showStack },
    { num: 15, title: 'Choose Valance', render: renderVerticalValanceStep, hidden: !showVerticalValance },
    { num: 16, title: 'Choose Channel Panel', render: renderChannelPanelStep, hidden: !showChannelPanel },
    { num: 17, title: 'Extra Vanes', render: renderExtraVaneStep, hidden: !showExtraVane },
    // Appended, not inserted. stepElements is indexed by hardcoded number in
    // ~15 places (control 2, roll 3, valance 4, privacy 9, hardware 10, and the
    // _ai>=5 auto-complete loop); inserting at position 1 would shift all of
    // them on all 61 live parents. These are moved into place in the DOM below
    // instead, which is a no-op while show_liner is off.
    { num: 18, title: 'Choose Liner', render: renderLinerStep, hidden: !showLiner },
    { num: 19, title: 'Choose Liner Color', render: renderLinerColorStep, hidden: !showLiner },
    // Appended for the same reason as the liner steps: every hardcoded index
    // into stepElements above would move if these were inserted in flow order.
    { num: 20, title: 'Choose Edge Banding', render: renderEdgeBandStep, hidden: !showEdgeBand },
    { num: 21, title: 'Choose Edge Banding Color', render: renderEdgeBandColorStep, hidden: !showEdgeBand },
    // Appended for the same reason as the liner and edge banding steps.
    { num: 22, title: 'Choose Valance', render: renderValanceSelectionStep, hidden: !showValanceSel }
  ];
  // Pushed only when configured, so every other product builds exactly the DOM it did before.
  if (showSkyPole) STEPS.push({ num: 23, title: 'Choose Sky Pole', render: renderSkyPoleStep, hidden: false });

  var stepElements = [];

  // Build step DOM
  STEPS.forEach(function(step, idx) {
    var stepEl = dom.create('div', 'builder-v2__step' + (idx === 0 ? ' builder-v2__step--active' : ''));
    stepEl.setAttribute('data-step', step.num);
    if (step.hidden) {
      stepEl.style.display = 'none';
      stepEl.classList.add('builder-v2__step--hidden');
    }

    var header = dom.create('div', 'builder-v2__step-header');
    header.setAttribute('role', 'button');
    header.setAttribute('tabindex', '0');
    header.setAttribute('aria-expanded', idx === 0 ? 'true' : 'false');
    header.setAttribute('aria-controls', 'builder-step-body-' + step.num);
    header.innerHTML =
      '<span class="builder-v2__step-num">' +
        '<span class="builder-v2__step-num__digit">' + step.num + '</span>' +
        '<svg class="builder-v2__step-num__check" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
          '<polyline points="20 6 9 17 4 12"/>' +
        '</svg>' +
      '</span>' +
      '<span class="builder-v2__step-title">' + step.title + '</span>' +
      '<span class="builder-v2__step-selection" data-step-selection></span>' +
      '<svg class="builder-v2__step-chevron" viewBox="0 0 20 20" fill="none"><path d="M5 7.5l5 5 5-5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';

    var body = dom.create('div', 'builder-v2__step-body');
    body.id = 'builder-step-body-' + step.num;
    var content = dom.create('div', 'builder-v2__step-content');
    body.appendChild(content);

    stepEl.appendChild(header);
    stepEl.appendChild(body);
    stepsContainer.appendChild(stepEl);

    stepElements.push({
      el: stepEl,
      content: content,
      selectionLabel: header.querySelector('[data-step-selection]')
    });

    // Render step content
    step.render(content);

    // Header click/keyboard → toggle
    dom.on(header, 'click', function() {
      toggleStep(idx);
    });
    dom.on(header, 'keydown', function(e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        toggleStep(idx);
      }
    });
  });

  // Auto-complete each metafield-hidden step so checkBundleReady passes and
  // EDI carries the correct fixed values, then renumber the visible step
  // digits so the customer sees a clean 1..N (e.g. Cellular shows 1, 2 for
  // Color + Mount & Size; Zebra/Solar show 1..4 with Roll Direction hidden).
  if (hideRollDirection && stepElements[3]) {
    store.set('rollDirection', 'standard');
    stepElements[3].el.classList.add('builder-v2__step--complete');
    stepElements[3].selectionLabel.textContent = 'Standard';
  }
  if (hideControl && stepElements[2]) {
    // show_control:false is set only on cordless-only products (Cellular),
    // mirroring how show_roll_direction:false hardcodes 'standard'. control
    // = 'cordless' makes EDI_CONTROL emit Control Style: Cordless with no
    // Lift Side; surcharge 0 because cordless is the base price.
    // Locked-control label is metafield-driven: verticals lock to Wand (Mariak
    // needs Control Style: Wand to resolve CONTROL.POS), every other cordless-only
    // family defaults to Cordless exactly as before.
    var autoCtlVal = (pricingData && pricingData.control_auto_value) || (isVertical ? 'wand' : 'cordless');
    var autoCtlLabel = (pricingData && pricingData.control_auto_label) || (isVertical ? 'Wand' : 'Cordless');
    store.set('control', autoCtlVal);
    store.set('controlLabel', autoCtlLabel);
    store.set('controlSurcharge', 0);
    stepElements[2].el.classList.add('builder-v2__step--complete');
    stepElements[2].selectionLabel.textContent = autoCtlLabel;
  }
  if (hideValance && stepElements[4]) {
    // No valance on these shades. valanceLabel 'None' makes the cart/EDI
    // emit Cassette Valance: None (the accepted Zebra/Solar shape).
    store.set('valanceType', null);
    store.set('valanceLabel', 'None');
    store.set('valancePrice', 0);
    stepElements[4].el.classList.add('builder-v2__step--complete');
    stepElements[4].selectionLabel.textContent = 'None';
  }
  if (privacyAutoStandard && stepElements[9]) {
    // Privacy step suppressed for this family (8g) but the Mariak EDI still
    // requires Privacy Options: Standard. Auto-set + complete, mirroring the
    // hideValance pattern. Only fires when privacy_auto_standard is set, so
    // families with no privacy field never emit a stray value.
    store.set('privacyOption', 'Standard');
    stepElements[9].el.classList.add('builder-v2__step--complete');
    stepElements[9].selectionLabel.textContent = 'Standard';
  }
  // Appended horizontal steps (indices 5+) that are hidden for this family
  // carry no value, so mark them complete to satisfy checkBundleReady. They
  // emit nothing (parent props are gated on their own state being set).
  for (var _ai = 5; _ai < stepElements.length; _ai++) {
    if (STEPS[_ai] && STEPS[_ai].hidden && stepElements[_ai]) {
      stepElements[_ai].el.classList.add('builder-v2__step--complete');
    }
  }
  // Optional Hardware (index 10) is an optional step: zero selections is
  // valid, so mark it complete on show so it never blocks ATC. Toggling a
  // card only updates the emitted Optional Hardware value.
  if (showHardware && stepElements[10]) {
    stepElements[10].el.classList.add('builder-v2__step--complete');
  }
  // The liner steps are built last (see STEPS) but must be answered before
  // size, because the liner is one of the two inputs to the size limit. Move
  // them ahead of Mount & Size in the DOM. Index-based references elsewhere
  // are unaffected: this reorders nodes, not stepElements.
  if (showLiner && stepElements[17] && stepElements[18] && stepElements[1]) {
    stepsContainer.insertBefore(stepElements[17].el, stepElements[1].el);
    stepsContainer.insertBefore(stepElements[18].el, stepElements[1].el);
  }
  // Headrail stays AFTER Mount & Size (Warwick, review 1): the shopper needs a
  // width before the two-on-one choice means anything. Safe because
  // currentPanelCount already assumes the split above the force width, so an
  // over-width shade never dead-ends waiting for a step it cannot reach.

  // Walk the DOM rather than the STEPS array so a repositioned step is
  // numbered where the shopper actually sees it. For every family that does
  // not reorder, DOM order is STEPS order and the hidden class mirrors
  // s.hidden, so this produces the identical numbering it always did.
  // Re-runnable: the liner colour step appears and disappears with the liner
  // choice, which changes how many steps are visible.
  function renumberVisibleSteps() {
    var visibleNum = 1;
    var stepNodes = stepsContainer.children;
    for (var _sn = 0; _sn < stepNodes.length; _sn++) {
      var node = stepNodes[_sn];
      if (!node.classList || !node.classList.contains('builder-v2__step')) continue;
      if (node.classList.contains('builder-v2__step--hidden')) continue;
      var digitEl = node.querySelector('.builder-v2__step-num__digit');
      if (digitEl) digitEl.textContent = visibleNum;
      visibleNum++;
    }
  }

  // renderLinerStep runs inside the build loop above, at which point
  // stepElements[18] does not exist yet, so the colour step has to be settled
  // here once both are built. Before the renumber, so the count is right.
  if (showLiner) syncLinerColorStep();
  if (showEdgeBand) syncEdgeBandColorStep();

  if (hideRollDirection || hideControl || hideValance || isHorizontal || showFold || showLining || isVertical || showLiner || showEdgeBand || showValanceSel || showSkyPole) {
    renumberVisibleSteps();
  }

  // Price bar stays hidden until bundle is ready (controlled by checkBundleReady)


  /* ============================================================
     STEP 1: CHOOSE COLOR
     ============================================================ */
  function renderColorStep(container) {
    var colorBlock = findColorBlock();

    // Free Samples CTA — built first, but appended AFTER the swatches per
    // Warwick PDP review v2: "Please move the Free Sample CTA under the
    // color swatches rather than above, same as existing PDP." Matches the
    // proven placement in builder v1 where the prompt only appears once a
    // shopper has scanned the colors and is still hesitating.
    var sampleCta = dom.create('div', 'builder-v2__sample-cta-box');
    sampleCta.innerHTML =
      '<a href="/pages/free-samples-of-blinds-and-shades" class="builder-v2__sample-cta-link">' +
        '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
          '<path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/>' +
          '<polyline points="3.27 6.96 12 12.01 20.73 6.96"/>' +
          '<line x1="12" y1="22.08" x2="12" y2="12"/>' +
        '</svg>' +
        '<span>Order Free Samples</span>' +
      '</a>';

    // If we have pricing data with color groups, use that for grouping
    if (pricing && pricingData && pricingData.color_groups) {
      pricingData.color_groups.forEach(function(group) {
        var groupDiv = dom.create('div', 'builder-v2__color-group');
        // Optional "$" to "$$$$" marker per group; kept out of group.label because the label also drives colour matching.
        var tierHtml = group.price_tier
          ? ' <span class="builder-v2__color-group-tier">' + escapeHtml(group.price_tier) + '</span>'
          : '';
        groupDiv.innerHTML = '<h4 class="builder-v2__color-group-label">' + escapeHtml(group.label) + tierHtml + '</h4>';

        var swatchesDiv = dom.create('div', 'builder-v2__swatches');

        group.colors.forEach(function(colorName) {
          var btn = dom.create('button', 'builder-v2__swatch');
          btn.setAttribute('type', 'button');
          btn.setAttribute('data-color', colorName);
          btn.setAttribute('data-group', group.id);

          // Find matching component product for image
          var image = '';
          var heroImage = '';
          var sku = (group.color_skus && group.color_skus[colorName]) || '';
          var productId = null;
          var variantId = null;

          if (colorBlock && colorBlock.products) {
            // Match color name to component product title
            // Cascade: exact -> lowercase -> "Color - X (Group)" pattern -> ends-with -> loose substring
            var matchedProduct = null;
            var colorLower = colorName.trim().toLowerCase();
            for (var i = 0; i < colorBlock.products.length; i++) {
              if (colorBlock.products[i].title.trim() === colorName.trim()) {
                matchedProduct = colorBlock.products[i];
                break;
              }
            }
            if (!matchedProduct) {
              for (var i = 0; i < colorBlock.products.length; i++) {
                var titleLower = colorBlock.products[i].title.trim().toLowerCase();
                if (titleLower === colorLower) {
                  matchedProduct = colorBlock.products[i];
                  break;
                }
              }
            }
            // Extract color from canonical "Color - {Name} ({Group})" title and match against
            // both the bare color and the group-prefixed form. Bare match handles Signature
            // products ("Color - Black (7500 Blackout)" -> "Black"). Group-prefixed handles Luxe
            // products ("Color - Genoa Chocolate (Luxe Natural LF)" -> "Genoa Chocolate" matched
            // against group.label "Genoa" + " " + "Chocolate"). This pass replaces the previous
            // loose substring which caused "Black"/"White" to false-match "Almost White (7500
            // Blackout)" via the "Blackout" suffix.
            if (!matchedProduct) {
              var canonicalTargets = [colorLower];
              if (group && group.label) {
                var labelLower = group.label.trim().toLowerCase();
                canonicalTargets.push((labelLower + ' ' + colorLower));
                // First word of label handles multi-word labels where the product prefix is
                // only the brand token, e.g. label "Rosalie Solar 14%" but title "Color -
                // Rosalie Charcoal".
                var firstToken = labelLower.split(/\s+/)[0];
                if (firstToken && firstToken !== labelLower) {
                  canonicalTargets.push(firstToken + ' ' + colorLower);
                }
              }
              for (var i = 0; i < colorBlock.products.length; i++) {
                var canonical = colorBlock.products[i].title.match(/^\s*Color\s*-\s*(.+?)\s*\(/i);
                if (!canonical) continue;
                var extracted = canonical[1].trim().toLowerCase();
                if (canonicalTargets.indexOf(extracted) !== -1) {
                  matchedProduct = colorBlock.products[i];
                  break;
                }
              }
            }
            if (!matchedProduct) {
              // Handle "Group - Color" format: check if title ends with the color name
              for (var i = 0; i < colorBlock.products.length; i++) {
                var parts = colorBlock.products[i].title.split(/[-\/]/);
                var lastPart = parts[parts.length - 1].trim().toLowerCase();
                if (lastPart === colorLower) {
                  matchedProduct = colorBlock.products[i];
                  break;
                }
              }
            }
            if (!matchedProduct) {
              // Phase II / Zebra format: "Color - {Name} {FamilySuffix}" with NO
              // parentheses (e.g. "Color - Beige/White Backing EBV"). Strip the
              // "Color - " prefix, then check whether the remainder starts with
              // the metafield's colour name followed by a space (the family
              // suffix). Falls through cleanly for Mariak titles since
              // "Beige (Signature 7500 Blackout)" does not start with
              // "Beige " (the next char is `(`), so no false-match.
              for (var i = 0; i < colorBlock.products.length; i++) {
                var stripped = colorBlock.products[i].title.replace(/^\s*Color\s*-\s*/i, '').trim().toLowerCase();
                if (stripped === colorLower || stripped.indexOf(colorLower + ' ') === 0) {
                  matchedProduct = colorBlock.products[i];
                  break;
                }
              }
            }
            if (matchedProduct) {
              image = matchedProduct.image || '';
              heroImage = matchedProduct.hero_image || '';
              productId = matchedProduct.id;
              if (matchedProduct.variants && matchedProduct.variants.length > 0) {
                variantId = matchedProduct.variants[0].id;
                if (!sku) sku = matchedProduct.variants[0].sku || '';
              }
            }
          }

          // If the metafield lists a colour that has no storefront-visible
          // component product (typically because the Color child is
          // ARCHIVED or unpublished in Shopify Admin), skip rendering the
          // swatch entirely. Otherwise the customer sees a letter
          // placeholder for an unbuyable colour. Only skips when
          // colorBlock.products has been loaded -- if it is missing or
          // empty the swatch still renders with the placeholder so we
          // don't blank out the whole step on a config issue.
          if (colorBlock && colorBlock.products && colorBlock.products.length > 0 && !matchedProduct) {
            return; // forEach continue
          }

          // Customer-facing display name. The metafield's colors[] entry stays
          // the FULL component title (the matching cascade above needs it);
          // group.color_labels maps it to a short label (Warwick 2026-07-02:
          // drop "PVC Vertical" from vertical colour names). Everything from
          // here down (swatch label, store state, cart Color prop, URL
          // writeback) uses the display name; families without color_labels
          // render byte-identical to before.
          var displayName = (group.color_labels && group.color_labels[colorName]) || colorName;
          btn.setAttribute('data-color', displayName);

          var initial = displayName.charAt(0).toUpperCase();
          var largeImage = image ? image.replace(/width=\d+/, 'width=600') : '';

          // Wrap swatch button + zoom in a container div (avoids nested buttons)
          var wrapper = dom.create('div', 'builder-v2__swatch-wrapper');
          btn.innerHTML =
            (image ? '<img class="builder-v2__swatch-img" src="' + escapeHtml(image) + '" alt="' + escapeHtml(displayName) + '" loading="lazy">' :
              '<span class="builder-v2__swatch-img builder-v2__swatch-img--placeholder">' + escapeHtml(initial) + '</span>') +
            '<span class="builder-v2__swatch-name">' + escapeHtml(displayName) + '</span>';

          wrapper.appendChild(btn);

          if (largeImage) {
            var zoomBtn = document.createElement('button');
            zoomBtn.type = 'button';
            zoomBtn.className = 'builder-v2__swatch-zoom';
            zoomBtn.setAttribute('data-large', largeImage);
            zoomBtn.setAttribute('data-name', displayName);
            zoomBtn.setAttribute('aria-label', 'Zoom ' + displayName);
            zoomBtn.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="7"/><line x1="16.5" y1="16.5" x2="21" y2="21"/></svg>';
            wrapper.appendChild(zoomBtn);
          }

          btn._colorData = {
            groupId: group.id,
            colorName: displayName,
            sku: sku,
            image: image,
            heroImage: heroImage,
            productId: productId,
            variantId: variantId
          };

          if (typeof SampleATC !== 'undefined' && SampleATC.enabled && sku) {
            SampleATC.attachButton(wrapper, sku, displayName);
          }

          swatchesDiv.appendChild(wrapper);
        });

        groupDiv.appendChild(swatchesDiv);
        container.appendChild(groupDiv);
      });

    } else if (colorBlock && colorBlock.products) {
      // Fallback: flat list from component products (no pricing groups)
      var swatchesDiv = dom.create('div', 'builder-v2__swatches');
      colorBlock.products.forEach(function(p) {
        var btn = dom.create('button', 'builder-v2__swatch');
        btn.setAttribute('type', 'button');
        btn.setAttribute('data-color', p.title);

        var variantId = p.variants && p.variants.length > 0 ? p.variants[0].id : null;
        var sku = p.variants && p.variants.length > 0 ? p.variants[0].sku : '';

        var pInitial = p.title.charAt(0).toUpperCase();
        var pLargeImage = p.image ? p.image.replace(/width=\d+/, 'width=600') : '';

        var wrapper = dom.create('div', 'builder-v2__swatch-wrapper');
        btn.innerHTML =
          (p.image ? '<img class="builder-v2__swatch-img" src="' + escapeHtml(p.image) + '" alt="' + escapeHtml(p.title) + '" loading="lazy">' :
            '<span class="builder-v2__swatch-img builder-v2__swatch-img--placeholder">' + escapeHtml(pInitial) + '</span>') +
          '<span class="builder-v2__swatch-name">' + escapeHtml(p.title) + '</span>';

        wrapper.appendChild(btn);

        if (pLargeImage) {
          var zoomBtn = document.createElement('button');
          zoomBtn.type = 'button';
          zoomBtn.className = 'builder-v2__swatch-zoom';
          zoomBtn.setAttribute('data-large', pLargeImage);
          zoomBtn.setAttribute('data-name', p.title);
          zoomBtn.setAttribute('aria-label', 'Zoom ' + p.title);
          zoomBtn.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="7"/><line x1="16.5" y1="16.5" x2="21" y2="21"/></svg>';
          wrapper.appendChild(zoomBtn);
        }

        btn._colorData = {
          groupId: null,
          colorName: p.title,
          sku: sku,
          image: p.image,
          heroImage: p.hero_image || '',
          productId: p.id,
          variantId: variantId
        };

        if (typeof SampleATC !== 'undefined' && SampleATC.enabled && sku) {
          SampleATC.attachButton(wrapper, sku, p.title);
        }

        swatchesDiv.appendChild(wrapper);
      });
      container.appendChild(swatchesDiv);
    }

    // Append Free Samples CTA UNDER the swatches per Warwick PDP review v2
    container.appendChild(sampleCta);

    // Event delegation for swatch clicks
    dom.on(container, 'click', '.builder-v2__swatch', function() {
      var data = this._colorData;
      if (!data) return;

      // Deactivate all swatches
      dom.qsa('.builder-v2__swatch', container).forEach(function(s) {
        s.classList.remove('builder-v2__swatch--active');
      });
      this.classList.add('builder-v2__swatch--active');

      // Update store
      store.set('colorGroup', data.groupId);
      store.set('colorName', data.colorName);
      store.set('colorSku', data.sku);
      store.set('colorImage', data.image);
      store.set('colorProductId', data.productId);
      store.set('colorVariantId', data.variantId);
      // The colour carries the fabric weight, which is half of the size
      // limit, so the allowed drop changes with it.
      applySizeRule();

      // Update pricing engine
      if (pricing && data.groupId) {
        pricing.setActiveGroup(data.groupId);
      }

      // Update step selection label
      stepElements[0].selectionLabel.textContent = data.colorName;

      // Emit for gallery swap
      events.emit('color:change', data);

      // Mobile: scroll the gallery into view so the shopper sees the swapped
      // colour image. On small screens the swatches sit below the gallery, so
      // the swap happens off-screen. Desktop shows the gallery beside the
      // swatches, so no scroll there. Mirrors the engine's 768px breakpoint +
      // reduced-motion handling; does not touch the gallery's own swap logic.
      if (window.innerWidth < 769) {
        var galleryEl = dom.qs('[data-gallery-main]');
        if (galleryEl) {
          var reduceMotionScroll = window.matchMedia &&
            window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          // scrollIntoView({ block: 'start' }) parks the image top at y=0, where the
          // fixed theme header (~96px) clips it, so only the lower part of the swapped
          // image shows. Offset past the header so the whole image lands in view
          // (same headerOffset the Read More / Measurement scrolls use below).
          var headerOffset = 120;
          var galleryTop = galleryEl.getBoundingClientRect().top + window.pageYOffset - headerOffset;
          window.scrollTo({ top: galleryTop, behavior: reduceMotionScroll ? 'auto' : 'smooth' });
        }
      }

      // Update URL with ?color= param for Google Shopping deep-linking.
      // Uses replaceState (not pushState) so back-button returns to
      // the previous page, not the previous color. Matches Blindster's
      // ?c= pattern. Feedoptimize reads these URLs for per-color
      // Shopping listings.
      if (history.replaceState && data.colorName) {
        var _url = new URL(window.location);
        _url.searchParams.set('color', data.colorName);
        history.replaceState(null, '', _url.toString());
      }

      // Mark complete + advance
      completeStep(0);
      recalculatePrice();

      // Rebuild size dropdowns if width range changed
      events.emit('size:rebuild');

      /* Re-resolve the size variant against the new fabric. rebuildSizeDropdowns
         keeps a still-valid width and height without firing a change, so on a
         parent whose groups pin different size holders the cart would keep the
         previous fabric's variant and charge its price. Replaying one change on
         the width select reuses the single size handler rather than duplicating
         its tier and variant logic here. Only fires when a size is already
         chosen, so picking colour first is untouched. */
      if (pricing && data.groupId && activeSizeProductId()) {
        var _wSel = dom.qs('[data-width-select]');
        var _hSel = dom.qs('[data-height-select]');
        if (_wSel && _hSel && _wSel.value && _hSel.value) {
          var _reEvt;
          try { _reEvt = new Event('change', { bubbles: true }); }
          catch (_err) {
            _reEvt = document.createEvent('Event');
            _reEvt.initEvent('change', true, true);
          }
          _wSel.dispatchEvent(_reEvt);
        }
      }
    });

    // Swatch zoom lightbox (desktop only)
    injectSwatchZoomModal();
    dom.on(container, 'click', '.builder-v2__swatch-zoom', function(e) {
      e.preventDefault();
      e.stopPropagation();
      var largeUrl = this.getAttribute('data-large');
      var name = this.getAttribute('data-name');
      if (!largeUrl) return;
      openSwatchZoom(largeUrl, name);
    });
  }


  /* ============================================================
     SIZE DEEP-LINK (?w / ?h)
     ============================================================ */
  // Width/height parsed from the URL on load and applied once the shopper
  // picks a mount (the size <select> options only exist after a mount is
  // chosen, see rebuildSizeDropdowns). General feature for every v2 PDP;
  // powers Google feed landing URLs like /product?color=Red&w=47&h=63.
  // Mirrors the existing ?color deep-link; Mount stays a required on-page
  // choice (never guessed from the URL).
  var deepLinkSize = null;

  function splitDeepLinkDim(val) {
    if (val == null) return null;
    var n = parseFloat(val);
    if (isNaN(n) || n <= 0) return null;
    var intPart = Math.floor(n);
    var frac = Math.round((n - intPart) * 8) / 8; // snap to the eighth grid
    if (frac >= 1) { intPart += 1; frac = 0; }
    return { intPart: intPart, frac: frac };
  }

  function parseSizeParams(params) {
    if (!params) return null;
    var w = splitDeepLinkDim(params.get('w'));
    var h = splitDeepLinkDim(params.get('h'));
    if (!w && !h) return null;
    var out = {};
    if (w) { out.wInt = w.intPart; out.wFrac = w.frac; }
    if (h) { out.hInt = h.intPart; out.hFrac = h.frac; }
    return out;
  }


  /* ============================================================
     STEP 2: CHOOSE MOUNT & SIZE
     ============================================================ */
  /* The widest a Two-on-One headrail can be built. 120in is the factory
     maximum (Kay, 27 Aug 2026, after order fdb63310 went through at 125 1/2in
     and had to be held). A parent can override it in builder_pricing with
     headrail_2on1_max_w, or set that to false to lift the ceiling entirely.
     Module scope on purpose: both the size step and the headrail step read it. */
  function twoOnOneMaxWidth() {
    if (pricingData && pricingData.headrail_2on1_max_w === false) return null;
    if (pricingData && typeof pricingData.headrail_2on1_max_w === 'number') {
      return pricingData.headrail_2on1_max_w;
    }
    return 120;
  }

  // Per-control Two-on-One rules (SWF: loop splits only to 120in, TDBU and
  // motorized never). Neither key set leaves every control on the rules above.
  function twoOnOneByControl() {
    return !!(pricingData && (Array.isArray(pricingData.headrail_2on1_controls) ||
      (pricingData.headrail_2on1_max_w_by_control && typeof pricingData.headrail_2on1_max_w_by_control === 'object')));
  }

  // No control chosen yet counts as allowed, so the headrail step never
  // dead-ends ahead of the control step; the choice re-judges it.
  function twoOnOneAllowedFor(control) {
    var list = pricingData && pricingData.headrail_2on1_controls;
    return !Array.isArray(list) || !control || list.indexOf(control) !== -1;
  }

  function twoOnOneControlMaxWidth(control) {
    var byCtl = pricingData && pricingData.headrail_2on1_max_w_by_control;
    return (control && byCtl && typeof byCtl[control] === 'number') ? byCtl[control] : null;
  }

  // The gap the multi-blind emit takes off between the panels, for the current control.
  function twoOnOneGap() {
    var mb = pricingData && pricingData.edi_multi_blind;
    if (!mb) return 0;
    var gap = (typeof mb.gap1 === 'number') ? mb.gap1 : 0;
    var ctl = store.get('control');
    if (ctl && mb.gap1_by_control && typeof mb.gap1_by_control[ctl] === 'number') gap = mb.gap1_by_control[ctl];
    return gap;
  }

  // SWF's 9 to 120in is on the panel it builds, the blind less half the gap, so
  // the blind limits carry it. Null without the keys: other parents keep 6in.
  function twoOnOnePanelLimits() {
    var pMin = pricingData && pricingData.headrail_2on1_panel_min_w;
    var pMax = pricingData && pricingData.headrail_2on1_panel_max_w;
    if (typeof pMin !== 'number' && typeof pMax !== 'number') return null;
    var halfGap = twoOnOneGap() / 2;
    return { min: typeof pMin === 'number' ? pMin + halfGap : 6, max: typeof pMax === 'number' ? pMax + halfGap : Infinity };
  }

  // Blind 1 widths, on the 1/8in grid, that keep BOTH blinds inside the
  // limits; null when the opening cannot be split that way at all.
  function twoOnOneBlind1Range(overall, lim) {
    if (!(overall > 0) || !lim) return null;
    var lo = Math.ceil(Math.max(lim.min, overall - lim.max) * 8 - 1e-6) / 8;
    var hi = Math.floor(Math.min(lim.max, overall - lim.min) * 8 + 1e-6) / 8;
    return lo <= hi ? { lo: lo, hi: hi } : null;
  }

  function setCardDisabled(card, off) {
    if (!card) return;
    if (off) {
      card.classList.add('builder-v2__icon-card--disabled');
      card.setAttribute('disabled', 'disabled');
      card.setAttribute('aria-disabled', 'true');
    } else {
      card.classList.remove('builder-v2__icon-card--disabled');
      card.removeAttribute('disabled');
      card.removeAttribute('aria-disabled');
    }
  }

  function renderMountSizeStep(container) {
    // Mount options as icon cards. Per-product SVGs and "Most popular"
    // badge apply when the section declared a per-type icon set (Cellular,
    // Faux Wood, Bamboo, Pleated). Other v2 templates fall back to the
    // generic ICONS pair so existing PDPs are unchanged.
    var mountSvgs = getMountSvgs();
    var showPopular = hasPerTypeMount();
    // Current-builder mount images when available (matched by Inside/Outside
    // in the variant title), else the inline SVG.
    var insideIcon  = iconSlotHtml(optionIconUrl(optionIcons.mount, null, function(t){ return /inside/i.test(t); }),  mountSvgs.inside,  'Inside Mount');
    var outsideIcon = iconSlotHtml(optionIconUrl(optionIcons.mount, null, function(t){ return /outside/i.test(t); }), mountSvgs.outside, 'Outside Mount');
    var mountDiv = dom.create('div', 'builder-v2__mount-options');
    mountDiv.innerHTML =
      '<button class="builder-v2__mount-option builder-v2__icon-card" data-mount="inside" type="button">' +
        (showPopular ? '<span class="builder-v2__mount-popular" aria-hidden="true">★ Most popular</span>' : '') +
        '<span class="builder-v2__icon-card-icon">' + insideIcon + '</span>' +
        '<span class="builder-v2__icon-card-label">Inside Mount</span>' +
        '<span class="builder-v2__icon-card-desc">Fits inside the window recess</span>' +
      '</button>' +
      '<button class="builder-v2__mount-option builder-v2__icon-card" data-mount="outside" type="button">' +
        '<span class="builder-v2__icon-card-icon">' + outsideIcon + '</span>' +
        '<span class="builder-v2__icon-card-label">Outside Mount</span>' +
        '<span class="builder-v2__icon-card-desc">Mounts above or outside the frame</span>' +
      '</button>';
    container.appendChild(mountDiv);

    // Mount deduction notice
    var mountNotice = dom.create('div', 'builder-v2__mount-notice');
    mountNotice.style.display = 'none';
    container.appendChild(mountNotice);

    // Size inputs — preceded by a visual divider + "Enter Measurements"
    // heading with a "Help Me Measure" link, matching the SelectBlinds
    // pattern Warwick referenced in his PDP review.
    var sizeDiv = dom.create('div', 'builder-v2__size-area');
    sizeDiv.setAttribute('data-size-area', '');
    sizeDiv.style.display = 'none'; // hidden until mount selected
    // Mini measuring guide cards removed per Warwick PDP review v2:
    // "Remove the icons and short descriptions explaining Width and Height.
    // With the new more detailed Measure and Install section, we can direct
    // the customer to that part of the product page." The Measurement
    // information link below the inputs scrolls + opens that accordion.
    sizeDiv.innerHTML =
      '<div class="builder-v2__size-divider">' +
        '<h3 class="builder-v2__size-divider-title">Enter Measurements</h3>' +
      '</div>' +
      '<div class="builder-v2__size-row">' +
        '<div class="builder-v2__size-field">' +
          '<label class="builder-v2__size-label" for="bv2-width">Width</label>' +
          '<div class="builder-v2__size-inputs">' +
            '<select class="builder-v2__size-select" id="bv2-width" data-width-select aria-label="Width in inches"><option value="">Select width</option></select>' +
            '<select class="builder-v2__size-select builder-v2__size-select--fraction" data-width-frac aria-label="Width fraction"></select>' +
          '</div>' +
        '</div>' +
        '<div class="builder-v2__size-field">' +
          '<label class="builder-v2__size-label" for="bv2-height">Height</label>' +
          '<div class="builder-v2__size-inputs">' +
            '<select class="builder-v2__size-select" id="bv2-height" data-height-select aria-label="Height in inches"><option value="">Select height</option></select>' +
            '<select class="builder-v2__size-select builder-v2__size-select--fraction" data-height-frac aria-label="Height fraction"></select>' +
          '</div>' +
        '</div>' +
      '</div>' +
      // "Please follow our Measuring Guides..." tip — placed UNDER the
      // Width/Height inputs per Warwick PDP review v2: "Move the box
      // underneath the Width and Height inputs. At parity with current
      // product page." Old position (between illustrated cards and the
      // inputs) pushed the inputs too far down the fold.
      '<div class="builder-v2__measure-guide-tip">' +
        '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#13548d" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
          '<rect x="3" y="3" width="18" height="18" rx="3"/>' +
          '<line x1="8" y1="12" x2="16" y2="12"/>' +
          '<line x1="12" y1="8" x2="12" y2="16"/>' +
        '</svg>' +
        '<span>Please review <a href="#builder-v2-measure-install" data-measure-info-link>Measurement information</a> for the best results. If you need a hand with the perfect fit, just reach out!</span>' +
      '</div>' +
      '<div class="builder-v2__room-name">' +
        '<label class="builder-v2__room-name-label" for="bv2-room-name">' +
          'Room Name <span class="builder-v2__room-name-optional">(Optional)</span>' +
        '</label>' +
        '<input type="text" class="builder-v2__room-name-input" id="bv2-room-name" ' +
          'data-room-name placeholder="Ex: West Wall" maxlength="20" autocomplete="off">' +
      '</div>' +
      // MeasureSafe upsell — reuses the existing measuresafe.css classes
      // that are already loaded sitewide on product pages. Exact same
      // markup as snippets/measuresafe-upsell.liquid so the visual is
      // identical to Builder 1.0.
      '<div class="measuresafe" data-measuresafe-upsell>' +
        '<label class="measuresafe__label">' +
          '<input type="checkbox" class="measuresafe__checkbox" id="bv2-measuresafe-checkbox" data-bv2-measuresafe>' +
          '<span class="measuresafe__checkmark"></span>' +
          '<div class="measuresafe__content">' +
            '<svg class="measuresafe__shield" width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
              '<path d="M12 2L4 5V11.09C4 16.14 7.41 20.85 12 22C16.59 20.85 20 16.14 20 11.09V5L12 2ZM10.94 15.54L7.4 12L8.81 10.59L10.93 12.71L15.17 8.47L16.58 9.88L10.94 15.54Z" fill="#13548d"/>' +
            '</svg>' +
            '<span class="measuresafe__title">MEASURESAFE\u2122 GUARANTEE</span>' +
            '<span class="measuresafe__price">+' + Core.formatMoney(getAddonCents('measuresafe_cents', 999) / 100) + '</span>' +
            '<button type="button" class="measuresafe__info-btn" data-bv2-measuresafe-tooltip-trigger aria-label="What is MeasureSafe?">' +
              '<svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">' +
                '<path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 17h-2v-2h2v2zm2.07-7.75l-.9.92C13.45 12.9 13 13.5 13 15h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .88-.36 1.68-.93 2.25z"/>' +
              '</svg>' +
            '</button>' +
          '</div>' +
        '</label>' +
        '<div class="measuresafe__tagline">' +
          'Mismeasure? We\'ll remake it free. You only pay $20 shipping.' +
        '</div>' +
        '<div class="measuresafe__tooltip" data-bv2-measuresafe-tooltip aria-hidden="true">' +
          '<div class="measuresafe__tooltip-content">' +
            '<button type="button" class="measuresafe__tooltip-close" data-bv2-measuresafe-tooltip-close aria-label="Close">\u00d7</button>' +
            '<p class="measuresafe__tooltip-headline"><strong>Mistakes happen. Don\'t pay for them.</strong></p>' +
            '<p>With MeasureSafe\u2122, you\'re fully covered if your new blinds don\'t fit your window.</p>' +
            '<ul class="measuresafe__tooltip-list">' +
              '<li><strong>What we do:</strong> We\'ll remake your blinds at the correct size for free.</li>' +
              '<li><strong>Your cost:</strong> You only pay $20 shipping per remake item, and any price difference if the new blind is larger.</li>' +
            '</ul>' +
            '<a href="/pages/measuresafe-guarantee" class="measuresafe__tooltip-link" target="_blank" rel="noopener">' +
              'Learn more about MeasureSafe\u2122 \u2192' +
            '</a>' +
          '</div>' +
        '</div>' +
      '</div>';
    container.appendChild(sizeDiv);

    // Populate fraction selects
    var widthFrac = dom.qs('[data-width-frac]', sizeDiv);
    var heightFrac = dom.qs('[data-height-frac]', sizeDiv);
    populateFractionSelect(widthFrac);
    populateFractionSelect(heightFrac);

    // Room Name (optional) — store on blur/change so it's captured for cart
    var roomInput = dom.qs('[data-room-name]', sizeDiv);
    if (roomInput) {
      dom.on(roomInput, 'input', function() {
        store.set('roomName', this.value.trim());
      });
    }

    // MeasureSafe tooltip + checkbox
    var msCheckbox = dom.qs('[data-bv2-measuresafe]', sizeDiv);
    var msTrigger = dom.qs('[data-bv2-measuresafe-tooltip-trigger]', sizeDiv);
    var msTooltip = dom.qs('[data-bv2-measuresafe-tooltip]', sizeDiv);
    var msClose = dom.qs('[data-bv2-measuresafe-tooltip-close]', sizeDiv);

    if (msTrigger && msTooltip) {
      // Portal tooltip to <body> on first open so it escapes
      // .page-container's desktop-only `transform: translate3d(0,0,0)`
      // (min-width:768px), which otherwise becomes the containing block
      // for our position:fixed tooltip and makes it render offscreen on
      // desktop. On mobile no transform applies, but moving once is fine.
      dom.on(msTrigger, 'click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        if (msTooltip.parentNode !== document.body) {
          document.body.appendChild(msTooltip);
        }
        msTooltip.classList.toggle('is-visible');
        msTooltip.setAttribute('aria-hidden', !msTooltip.classList.contains('is-visible'));
      });
      if (msClose) {
        dom.on(msClose, 'click', function() {
          msTooltip.classList.remove('is-visible');
          msTooltip.setAttribute('aria-hidden', 'true');
        });
      }
    }
    if (msCheckbox) {
      dom.on(msCheckbox, 'change', function() {
        store.set('measuresafe', this.checked);
        recalculatePrice();
      });
    }

    // 2-Day Air shipping upgrade checkbox
    var shipCheckbox = dom.qs('[data-shipping-upgrade-checkbox]');
    if (shipCheckbox) {
      dom.on(shipCheckbox, 'change', function() {
        store.set('shippingUpgrade', this.checked);
        recalculatePrice();
      });
    }

    // Smart Hub upgrade checkbox (motorized only)
    var smartHubCheckbox = dom.qs('[data-smart-hub-checkbox]');
    if (smartHubCheckbox) {
      dom.on(smartHubCheckbox, 'change', function() {
        store.set('smartHub', this.checked);
        recalculatePrice();
      });
    }

    // Motorwand Charger upgrade checkbox (motorwand L/R only, single quantity)
    var motorwandChargerCheckbox = dom.qs('[data-motorwand-charger-checkbox]');
    if (motorwandChargerCheckbox) {
      dom.on(motorwandChargerCheckbox, 'change', function() {
        store.set('motorwandCharger', this.checked);
        recalculatePrice();
      });
    }

    // Show/hide Smart Hub + Motorwand Charger cards based on control selection.
    // Smart Hub belongs to Motorized (Wi-Fi bridge for the remote-controlled
    // motor). Motorwand Charger belongs to Motorwand L/R (USB-C charger for
    // the in-tube battery that the wand operates), NOT to Motorized. Reset
    // each checkbox when control moves away from its trigger so a stale
    // value cannot carry over into the cart.
    var smartHubCard = dom.qs('[data-smart-hub-upgrade]');
    var motorwandChargerCard = dom.qs('[data-motorwand-charger-upgrade]');
    store.subscribe(function(key) {
      if (key !== 'control') return;
      var current = store.get('control');
      var isMotorized = current === 'motorized';
      var isMotorwand = current === 'motorwand-left' || current === 'motorwand-right';
      // Per-parent addon support gate. If the parent's metafield doesn't define
      // `addon_prices.smart_hub_cents` / `motorwand_charger_cents` (e.g. Mariak
      // parents, which never had these features), the card stays hidden even
      // when the customer picks Motorized / Motorwand. Prevents Phase II
      // addons from bleeding into Mariak PDPs.
      var hubCents = getAddonCents('smart_hub_cents', null);
      var chargerCents = getAddonCents('motorwand_charger_cents', null);
      var hubSupported = hubCents != null && hubCents > 0;
      var chargerSupported = chargerCents != null && chargerCents > 0;

      if (smartHubCard) {
        var showHub = isMotorized && hubSupported;
        smartHubCard.style.display = showHub ? '' : 'none';
        if (!showHub && smartHubCheckbox && smartHubCheckbox.checked) {
          smartHubCheckbox.checked = false;
          store.set('smartHub', false);
        }
      }
      if (motorwandChargerCard) {
        var showCharger = isMotorwand && chargerSupported;
        motorwandChargerCard.style.display = showCharger ? '' : 'none';
        if (!showCharger && motorwandChargerCheckbox && motorwandChargerCheckbox.checked) {
          motorwandChargerCheckbox.checked = false;
          store.set('motorwandCharger', false);
        }
      }
      recalculatePrice();
    });

    // Mount click
    dom.on(mountDiv, 'click', '.builder-v2__mount-option', function() {
      var mount = this.getAttribute('data-mount');

      // A mount was chosen: clear the deep-link "choose a mount" nudge.
      var _dlHint = document.querySelector('[data-deeplink-hint]');
      if (_dlHint && _dlHint.parentNode) _dlHint.parentNode.removeChild(_dlHint);
      dom.qsa('.builder-v2__mount-option', mountDiv).forEach(function(b) {
        b.classList.remove('builder-v2__mount-option--active');
        b.classList.remove('builder-v2__icon-card--active');
      });
      this.classList.add('builder-v2__mount-option--active');
      this.classList.add('builder-v2__icon-card--active');
      store.set('mount', mount);
      // Old Style Roman has a valance inside but none outside, so the valance liner follows the mount.
      if (showLiner) { refreshLinerUi(); recalculatePrice(); }
      sizeDiv.style.display = '';

      // Show mount-specific measurement notice (matches old builder's "Good to know" copy)
      var infoIcon = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" style="flex-shrink:0"><circle cx="12" cy="12" r="11" stroke="#13548d" stroke-width="2" fill="none"/><text x="12" y="17" text-anchor="middle" font-size="14" font-weight="bold" fill="#13548d">i</text></svg>';
      if (mount === 'inside') {
        mountNotice.innerHTML =
          infoIcon +
          '<div><strong>Good to know</strong><br>To ensure a perfect fit, please provide the exact measurements of your window opening. Please do <strong>NOT</strong> deduct from these measurements or use the size of current blinds as a reference.</div>';
        mountNotice.style.display = '';
      } else {
        mountNotice.innerHTML =
          infoIcon +
          '<div><strong>Good to know</strong><br>' +
          (isVertical
            ? 'For Vertical Blinds we recommend adding at least 3" to each side measurement for a total of 6" or more. It is also suggested that outside mount vertical blinds be installed at least 3" above the window opening.'
            : 'Best for blackout and room darkening, outside mount blinds and shades are installed over the window on brackets attached to the wall or window frame. We suggest adding at least 4" to both your width and height measurements to help minimize light gaps around the edges.') +
          '</div>';
        mountNotice.style.display = '';
      }

      rebuildSizeDropdowns();
    });

    // Width/Height change.
    // We update store + price immediately so the user sees live feedback.
    // Step 2 does NOT auto-advance to Step 3. It only marks itself complete
    // (green checkmark + selection summary in header) so the user knows
    // their measurements are locked in. The step stays open so they can
    // notice and fill the optional Room Name field below the dropdowns.
    // The user clicks Step 3's header themselves when ready to proceed.

    // Parity with legacy product-builder.js:797-810. When the maximum
    // nominal width/height is selected, that dimension's fraction is not
    // orderable: a fraction on top of the max nominal exceeds the largest
    // price tier (roundUpToTier returns null, getBasePrice null, the price
    // silently freezes). The product also cannot be made larger than its
    // max. Disable and zero the fraction at max; re-enable below max.
    // Idempotent and direction-safe so it can also run after a color-group
    // size rebuild repopulates the nominal selects.
    function lockFractionAtMax(nominalSel, fracSel) {
      if (!nominalSel || !fracSel) return;
      var opts = nominalSel.options;
      var maxOpt = opts.length ? opts[opts.length - 1].value : '';
      var atMax = nominalSel.value !== '' && nominalSel.value === maxOpt;
      if (atMax) {
        fracSel.value = '0';
        fracSel.disabled = true;
      } else if (fracSel.disabled) {
        fracSel.disabled = false;
      }
    }

    dom.on(sizeDiv, 'change', 'select', function() {
      var widthSel = dom.qs('[data-width-select]', sizeDiv);
      var heightSel = dom.qs('[data-height-select]', sizeDiv);
      var wFrac = dom.qs('[data-width-frac]', sizeDiv);
      var hFrac = dom.qs('[data-height-frac]', sizeDiv);

      lockFractionAtMax(widthSel, wFrac);
      lockFractionAtMax(heightSel, hFrac);

      var wInt = widthSel.value ? parseInt(widthSel.value, 10) : null;
      var hInt = heightSel.value ? parseInt(heightSel.value, 10) : null;
      var wf = parseFloat(wFrac.value) || 0;
      var hf = parseFloat(hFrac.value) || 0;

      // Apply length_constraints (e.g. Modern Fabric Blackout:
      // width > 94 locks height to <= 84). Constraint shape:
      // [{ when_width_gt: 94, max_height: 84 }, ...]
      // When width is cleared (wInt null) the loop below leaves
      // constrainedMax null, which re-enables every height option.
      if (lengthConstraints.length) {
        var constrainedMax = null;
        if (wInt) {
          for (var lci = 0; lci < lengthConstraints.length; lci++) {
            var lc = lengthConstraints[lci];
            if (wInt > lc.when_width_gt) {
              if (constrainedMax === null || lc.max_height < constrainedMax) {
                constrainedMax = lc.max_height;
              }
            }
          }
        }
        var heightOpts = heightSel.options;
        for (var hoi = 0; hoi < heightOpts.length; hoi++) {
          var optVal = parseInt(heightOpts[hoi].value, 10);
          heightOpts[hoi].disabled = (constrainedMax !== null && optVal > constrainedMax);
        }
        if (constrainedMax !== null && hInt && hInt > constrainedMax) {
          heightSel.value = '';
          hInt = null;
          // Reset downstream: invalid height means step 2 is no longer
          // complete, the prior price is stale, and any picked size
          // variant must clear so cart never references a too-tall variant.
          store.set('sizeVariantId', null);
          stepElements[1].el.classList.remove('builder-v2__step--complete');
          stepElements[1].selectionLabel.textContent = '';
          recalculatePrice();
        }
      }

      // Set fractions BEFORE integers: the size gates (motorized/motorwand/
      // cordless) subscribe to widthInt/heightInt, and the cordless gate reads
      // the fraction to test the true size. Setting the frac first guarantees it
      // is fresh (not the previous size's) when the int notification fires.
      store.set('widthFrac', wf);
      store.set('heightFrac', hf);
      store.set('widthInt', wInt);
      store.set('heightInt', hInt);

      // size_rule families: reprice the liner for the new width and re-gate
      // the heights. Both are no-ops when the product carries no size_rule.
      refreshLinerUi();
      applySizeRule();
      // applySizeRule clears the height when the new width makes it
      // unbuildable. Re-read it so the size-variant lookup below cannot
      // anchor the cart to a size the fabric cannot be made in.
      if (store.get('heightInt') === null) hInt = null;

      // Deep-link writeback: reflect the chosen size in the URL (replaceState,
      // mirrors the ?color writeback) so feed and shared links carry the size.
      if (history.replaceState) {
        try {
          var _su = new URL(window.location);
          if (wInt) _su.searchParams.set('w', fractions.combine(wInt, wf));
          else _su.searchParams.delete('w');
          if (hInt) _su.searchParams.set('h', fractions.combine(hInt, hf));
          else _su.searchParams.delete('h');
          history.replaceState(null, '', _su.toString());
        } catch (e) {}
      }

      if (wInt && hInt) {
        // Find matching size variant
        var actualWidth = fractions.combine(wInt, wf);
        var actualHeight = fractions.combine(hInt, hf);

        if (pricing && pricing.getActiveGroup()) {
          // Pricing engine path: round up to tier, find variant.
          // price_tiers can live inside the color group OR at root level
          // (mirrors getBasePrice logic in builder-core.js).
          var tiers = pricing.getActiveGroup().price_tiers || pricing.data.price_tiers;
          if (tiers) {
            var wTier = pricing.roundUpToTier(actualWidth, tiers.widths);
            var hTier = pricing.roundUpToTier(actualHeight, tiers.heights);
            // findSizeVariantId always falls back to a valid anchor
            // (parsed size variant -> raw first size variant -> parent),
            // so even if tier rounding fails the cart still gets an ID.
            var anchorTierW = wTier ? wTier.tier : 0;
            var anchorTierH = hTier ? hTier.tier : 0;
            store.set('sizeVariantId', findSizeVariantId(anchorTierW, anchorTierH));
          }
        } else {
          // Fallback path (no pricing data): find closest variant by rounding up
          var variants = parseSizeVariants();
          var bestVariant = null;
          var bestDiff = Infinity;
          for (var vi = 0; vi < variants.length; vi++) {
            var vw = variants[vi].width;
            var vh = variants[vi].height;
            if (vw >= actualWidth && vh >= actualHeight) {
              var diff = (vw - actualWidth) + (vh - actualHeight);
              if (diff < bestDiff) {
                bestDiff = diff;
                bestVariant = variants[vi];
              }
            }
          }
          // Same fallback chain if no closest variant found
          store.set('sizeVariantId', bestVariant ? bestVariant.id : findSizeVariantId(0, 0));
        }

        var displayW = fractions.formatDisplay(wInt, wf);
        var displayH = fractions.formatDisplay(hInt, hf);
        stepElements[1].selectionLabel.textContent =
          store.get('mount').charAt(0).toUpperCase() + store.get('mount').slice(1) +
          ' - ' + displayW + ' x ' + displayH;

        // Live price feedback every change
        recalculatePrice();

        // Mark Step 2 complete (green check + summary) but do NOT
        // auto-collapse or auto-open Step 3. The step stays open so the
        // user can fill Room Name before proceeding.
        stepElements[1].el.classList.add('builder-v2__step--complete');
        checkBundleReady();
      }
    });

    // Listen for size rebuild (when color group changes max width)
    events.on('size:rebuild', function() {
      if (store.get('mount')) rebuildSizeDropdowns();
    });

    // Apply a pending ?w/?h deep-link once the size selects are populated.
    // Sets whichever dimension is in range, then fires ONE delegated change
    // (the handler reads both selects) so price + size-variant resolve. The
    // pending value is consumed so it never fights a later manual change.
    function applyDeepLinkSize() {
      if (!deepLinkSize) return;
      var widthSel = dom.qs('[data-width-select]', sizeDiv);
      var heightSel = dom.qs('[data-height-select]', sizeDiv);
      if (!widthSel || !heightSel) return;
      var wFrac = dom.qs('[data-width-frac]', sizeDiv);
      var hFrac = dom.qs('[data-height-frac]', sizeDiv);
      function setOpt(sel, num) {
        if (!sel || num == null) return false;
        for (var i = 0; i < sel.options.length; i++) {
          if (sel.options[i].value !== '' && parseFloat(sel.options[i].value) === num) {
            sel.value = sel.options[i].value;
            return true;
          }
        }
        return false; // out of this product's range -> skip gracefully
      }
      var wSet = setOpt(widthSel, deepLinkSize.wInt);
      var hSet = setOpt(heightSel, deepLinkSize.hInt);
      if (wSet) setOpt(wFrac, deepLinkSize.wFrac);
      if (hSet) setOpt(hFrac, deepLinkSize.hFrac);
      var applied = wSet || hSet;
      deepLinkSize = null; // one-shot
      if (applied) {
        var evt;
        try { evt = new Event('change', { bubbles: true }); }
        catch (e) { evt = document.createEvent('Event'); evt.initEvent('change', true, true); }
        widthSel.dispatchEvent(evt);
      }
    }

    function rebuildSizeDropdowns() {
      var widthSel = dom.qs('[data-width-select]', sizeDiv);
      var heightSel = dom.qs('[data-height-select]', sizeDiv);
      if (!widthSel || !heightSel) return;

      var widthRange, heightRange;

      if (pricing && pricing.getActiveGroup()) {
        var r = pricing.getWidthRange();
        widthRange = range(r.minWidth, r.maxWidth);
        heightRange = range(r.minHeight, r.maxHeight);
      } else {
        var variants = parseSizeVariants();
        var widths = [], heights = [];
        variants.forEach(function(v) {
          if (widths.indexOf(v.width) === -1) widths.push(v.width);
          if (heights.indexOf(v.height) === -1) heights.push(v.height);
        });
        widths.sort(function(a,b) { return a - b; });
        heights.sort(function(a,b) { return a - b; });
        if (widths.length >= 2) widthRange = range(widths[0], widths[widths.length - 1]);
        else widthRange = widths;
        if (heights.length >= 2) heightRange = range(heights[0], heights[heights.length - 1]);
        else heightRange = heights;
      }

      /* Two-on-One has a build ceiling. The factory tops out at 120in on a
         2-on-1 headrail (Kay, order fdb63310 went through at 125 1/2in and had
         to be held). Where a parent FORCES 2-on-1 above a threshold, every
         width past that ceiling has no buildable headrail at all, so those
         widths come out of the dropdown rather than letting the customer reach
         the headrail step and find both cards disabled.
         Parents that merely OFFER 2-on-1 keep their full width range; the card
         itself is disabled instead, in renderHeadrailStep. */
      var twoMaxW = twoOnOneMaxWidth();
      var forceW = (pricingData && typeof pricingData.headrail_force_2on1_above_w === 'number')
        ? pricingData.headrail_force_2on1_above_w : null;
      if (twoMaxW !== null && forceW !== null && forceW < twoMaxW && widthRange && widthRange.length) {
        widthRange = widthRange.filter(function(w) { return w <= twoMaxW; });
      }

      // Preserve current selection if still valid
      var currentW = store.get('widthInt');
      var currentH = store.get('heightInt');

      populateSelect(widthSel, widthRange, 'Select width', currentW);
      populateSelect(heightSel, heightRange, 'Select height', currentH);

      // Clear selection if out of range and invalidate step 2 completion
      var invalidated = false;
      if (currentW && widthRange.indexOf(currentW) === -1) {
        store.set('widthInt', null);
        store.set('sizeVariantId', null);
        widthSel.value = '';
        invalidated = true;
      }
      if (currentH && heightRange.indexOf(currentH) === -1) {
        store.set('heightInt', null);
        store.set('sizeVariantId', null);
        heightSel.value = '';
        invalidated = true;
      }
      if (invalidated) {
        // Remove completed state from step 2 and all downstream steps
        for (var si = 1; si < stepElements.length; si++) {
          stepElements[si].el.classList.remove('builder-v2__step--complete');
          stepElements[si].selectionLabel.textContent = '';
        }
        // Reset downstream store values
        store.set('control', null);
        store.set('controlLabel', null);
        store.set('controlSurcharge', 0);
        store.set('rollDirection', null);
        store.set('valanceType', null);
        store.set('valanceLabel', null);
        store.set('valancePrice', 0);
        store.set('foldStyle', null);
        store.set('foldCode', null);
        store.set('foldLabel', null);
        store.set('foldPct', 0);
        store.set('foldSurcharge', 0);
        store.set('lining', null);
        store.set('liningCode', null);
        store.set('liningLabel', null);
        store.set('liningPct', 0);
        store.set('liningSurcharge', 0);
        // Liner (size_rule families). The loop below strips the step's
        // completed state and its active card, so the state has to go with it.
        // Left behind, the surcharge would stay in the total while the UI shows
        // no liner selected.
        currentLinerOpt = null;
        store.set('linerValue', null);
        store.set('linerLabel', null);
        store.set('linerSurcharge', 0);
        store.set('linerColorValue', '');
        store.set('linerColorLabel', '');
        currentEdgeBandOpt = null;
        store.set('edgeBandValue', null);
        store.set('edgeBandLabel', null);
        store.set('edgeBandSurcharge', 0);
        store.set('edgeBandColorValue', '');
        store.set('edgeBandColorLabel', '');
        currentValanceSelOpt = null;
        store.set('valanceSelValue', null);
        store.set('valanceSelLabel', null);
        store.set('valanceSelSurcharge', 0);
        // Deactivate downstream option/icon cards
        for (var si = 2; si < stepElements.length; si++) {
          dom.qsa('.builder-v2__icon-card--active', stepElements[si].content).forEach(function(c) {
            c.classList.remove('builder-v2__icon-card--active');
          });
        }
        // Re-apply every metafield-hidden step's auto-complete state so ATC
        // + EDI stay correct after a size invalidation. The one-shot init
        // block at page load does not re-fire on color-group changes, and
        // a hidden step cannot be re-completed by the user (no visible card).
        if (hideRollDirection && stepElements[3]) {
          store.set('rollDirection', 'standard');
          stepElements[3].el.classList.add('builder-v2__step--complete');
          stepElements[3].selectionLabel.textContent = 'Standard';
        }
        if (hideControl && stepElements[2]) {
          // Mirror the init-block control lock (metafield-driven, verticals
          // default to Wand) so a size-invalidating color change never reverts
          // a Wand-locked vertical to Cordless and drops CONTROL.POS on the EDI.
          var rAutoVal = (pricingData && pricingData.control_auto_value) || (isVertical ? 'wand' : 'cordless');
          var rAutoLabel = (pricingData && pricingData.control_auto_label) || (isVertical ? 'Wand' : 'Cordless');
          store.set('control', rAutoVal);
          store.set('controlLabel', rAutoLabel);
          store.set('controlSurcharge', 0);
          stepElements[2].el.classList.add('builder-v2__step--complete');
          stepElements[2].selectionLabel.textContent = rAutoLabel;
        }
        if (hideValance && stepElements[4]) {
          store.set('valanceType', null);
          store.set('valanceLabel', 'None');
          store.set('valancePrice', 0);
          stepElements[4].el.classList.add('builder-v2__step--complete');
          stepElements[4].selectionLabel.textContent = 'None';
        }
        // Re-complete every metafield-hidden appended step (indices 5+), exactly
        // like the init block, so hidden fold/lining/privacy/vertical steps the
        // user cannot re-click never leave Add to Cart disabled after a size
        // invalidation. Visible steps are intentionally left un-complete so the
        // customer re-picks them.
        for (var _ri = 5; _ri < stepElements.length; _ri++) {
          if (STEPS[_ri] && STEPS[_ri].hidden && stepElements[_ri]) {
            stepElements[_ri].el.classList.add('builder-v2__step--complete');
          }
        }
        // The liner was just cleared, so settle the colour step with it. The
        // loop above only re-completes HIDDEN steps, and the colour step is
        // visible whenever show_liner is on, so without this it stays visible
        // and incomplete with no liner to pick a colour for, and Add to Cart
        // can never be satisfied.
        if (showLiner) syncLinerColorStep();
        if (showEdgeBand) syncEdgeBandColorStep();
        // Re-check bundle readiness (will disable ATC)
        checkBundleReady();
        recalculatePrice();
      }
      // Rebuild repopulates the nominal selects without firing 'change',
      // so re-assert the max-dimension fraction lock here too. Idempotent:
      // keeps the fraction disabled if a max selection survived the rebuild,
      // re-enables it if the selection dropped below max or was invalidated.
      lockFractionAtMax(widthSel, dom.qs('[data-width-frac]', sizeDiv));
      lockFractionAtMax(heightSel, dom.qs('[data-height-frac]', sizeDiv));
      // Same reason, for size_rule families: populateSelect above rebuilt the
      // height options with every one enabled, and no 'change' fires to re-gate
      // them. Without this the fabric and liner limit silently disappears after
      // a colour-group change and a shopper can pick a drop the mill will not
      // make. Both calls no-op on families with no size_rule / liner.
      refreshLinerUi();
      applySizeRule();

      // Options now exist -> apply a pending size deep-link (one-shot).
      applyDeepLinkSize();
    }
  }


  /* ============================================================
     STEP 3: CHOOSE CONTROL STYLE
     ============================================================ */
  // Motorization eligibility comes from a Liquid-rendered flag in the
  // JSON bridge (server-side, no CDN). Add the tag "motorized" to any
  // product in Shopify Admin to enable. Per Warwick: only available on
  // Signature LF, Signature Sheer LF, Luxe Natural LF.
  var motorizedAllowed = !!parentData.motorized_enabled;

  // Per-product motion + cordless dimension specs come from
  // builder_pricing metafield. Defaults preserve Mariak behaviour
  // (motorization disabled above 72 in either dimension; no cordless gate).
  var motionSpec = (pricingData && pricingData.motion_spec) || { min_w: 0, max_w: 72, min_h: 0, max_h: 72 };
  var cordlessSpec = (pricingData && pricingData.cordless_spec) || null;
  // Chain (CCO) dimension caps, same shape as cordless_spec. Added for the
  // Mariak Roller/Solar rule "Plastic Chain / Metal Chain max width 120in"
  // (Warwick, 21 Jul 2026). Parents without a chain_spec leave it null and
  // the gate below is a no-op for them.
  var chainSpec = (pricingData && pricingData.chain_spec) || null;
  // TDBU and Continuous Cord Loop can have their own ranges (SWF). Null keeps
  // TDBU on cordless_spec and leaves the loop cards ungated, as before.
  var tdbuSpec = (pricingData && pricingData.tdbu_spec) || null;
  var contCordLoopSpec = (pricingData && pricingData.cont_cord_loop_spec) || null;
  // Motorised can have a tighter size range than Motorwand (Roman: the motor
  // caps at 72" while motorwand runs to 115"). Falls back to motion_spec, so
  // every existing family that sets only motion_spec is unchanged.
  var motorizedSpec = (pricingData && pricingData.motorized_spec) || motionSpec;
  var lengthConstraints = (pricingData && pricingData.length_constraints) || [];
  // size_rule supersedes length_constraints for families whose maximum drop
  // depends on the fabric and liner rather than on width alone. Absent on every
  // existing family, so they keep length_constraints untouched.
  var sizeRule = (pricingData && pricingData.size_rule) || null;
  var fabricByColor = (sizeRule && sizeRule.fabric_by_color) || {};

  // Build the Step 3 control-style option list from pricingData. The base
  // set covers Plastic Chain L/R, Metal Chain L/R, Cordless, Motorized.
  // Per-parent metafield can append Motorwand variants (L/R), exclude
  // specific options, and reorder. Mariak parents leave `motorwand_variants`,
  // `control_style.exclude`, `control_style.order` undefined so they fall
  // through to the legacy base set in declared order.
  function buildControlOptions(pd) {
    var base = [
      { value: 'plastic-chain-left', label: 'Plastic Chain', desc: 'Left Side', icon: ICONS.chainLeft, surcharge: 0, surchargeKey: null },
      { value: 'plastic-chain-right', label: 'Plastic Chain', desc: 'Right Side', icon: ICONS.chainRight, surcharge: 0, surchargeKey: null },
      { value: 'stainless-chain-left', label: 'Metal Chain', desc: 'Left Side', icon: ICONS.chainLeft, surcharge: 0, surchargeKey: 'stainless_chain' },
      { value: 'stainless-chain-right', label: 'Metal Chain', desc: 'Right Side', icon: ICONS.chainRight, surcharge: 0, surchargeKey: 'stainless_chain' },
      { value: 'cordless', label: 'Cordless', desc: 'Child-safe, no cords', icon: ICONS.cordless, surcharge: 0, surchargeKey: 'cordless' },
      { value: 'motorized', label: 'Motorized', desc: 'Remote control operation', icon: ICONS.cordless, surcharge: 0, surchargeKey: 'motorized' }
    ];

    // Metal beaded chain has no LogicBroker mapping on Zebra (9040/9085) yet, so
    // a metal-chain Zebra order cannot transmit correctly to the factory.
    // Suppress the option on Zebra parents until Phase II adds the 9040 mapping
    // (Warwick request, 2026-06-08). Re-enable by removing this filter once the
    // mapping is confirmed live.
    if (pd && pd.edi_family === 'zebra') {
      base = base.filter(function(o) {
        return o.value !== 'stainless-chain-left' && o.value !== 'stainless-chain-right';
      });
    }

    // Optional Motorwand variants (Left/Right) injected when the parent
    // metafield declares them. Surcharge key is shared so the price comes
    // from `pricing.getSurcharge('motorwand')`; the named cart-line lookup
    // (surchargeVariants.control[opt.value]) keeps the two variants distinct
    // at the same price point.
    var motorwandVariants = (pd && Array.isArray(pd.motorwand_variants)) ? pd.motorwand_variants : [];
    if (motorwandVariants.indexOf('left') !== -1) {
      base.push({ value: 'motorwand-left', label: 'Motorwand', desc: 'Left Side', icon: ICONS.motorwandLeft, surcharge: 0, surchargeKey: 'motorwand' });
    }
    if (motorwandVariants.indexOf('right') !== -1) {
      base.push({ value: 'motorwand-right', label: 'Motorwand', desc: 'Right Side', icon: ICONS.motorwandRight, surcharge: 0, surchargeKey: 'motorwand' });
    }

    // Optional Continuous Cord Loop variants (Left/Right) injected when the
    // parent metafield declares them (Roman). Surcharge key 'continuous_cord_loop'
    // bands by width via builder_pricing.addons; the two cards share the band
    // price and the Left/Right placement rides on the Lift Side EDI emit
    // (Cord_Placement). Mirrors the motorwand injection above.
    var cclVariants = (pd && Array.isArray(pd.cont_cord_loop_variants)) ? pd.cont_cord_loop_variants : [];
    if (cclVariants.indexOf('left') !== -1) {
      base.push({ value: 'cont-cord-loop-left', label: 'Continuous Cord Loop', desc: 'Left Side', icon: ICONS.chainLeft, surcharge: 0, surchargeKey: 'continuous_cord_loop' });
    }
    if (cclVariants.indexOf('right') !== -1) {
      base.push({ value: 'cont-cord-loop-right', label: 'Continuous Cord Loop', desc: 'Right Side', icon: ICONS.chainRight, surcharge: 0, surchargeKey: 'continuous_cord_loop' });
    }

    // Optional Top-Down/Bottom-Up lift variants (HT 7/16 Double Cell). Injected
    // ONLY when the parent metafield declares tdbu_lifts, so no other family is
    // touched. Flat +$80 from surcharges.{cont_cord_loop_tdbu, cordless_tdbu};
    // the cart line resolves by name key (surchargeVariants.control[value]) to
    // the legacy $80 Lift Style variants. HT has no factory feed (no EDI entry).
    var tdbuLifts = (pd && Array.isArray(pd.tdbu_lifts)) ? pd.tdbu_lifts : [];
    if (tdbuLifts.indexOf('cont-cord-loop') !== -1) {
      base.push({ value: 'cont-cord-loop-tdbu', label: 'Clutch', desc: 'Top Down, Bottom Up', icon: ICONS.clutchBothSides, surcharge: 0, surchargeKey: 'cont_cord_loop_tdbu' });
    }
    if (tdbuLifts.indexOf('cordless') !== -1) {
      base.push({ value: 'cordless-tdbu', label: 'Cordless', desc: 'Top Down, Bottom Up', icon: ICONS.tdbu, surcharge: 0, surchargeKey: 'cordless_tdbu' });
    }

    // Per-parent exclusions remove unsupported options without touching
    // the rest. Example: Zebra parents will exclude 'acculift-cordless'
    // once that option is reintroduced.
    var exclude = (pd && pd.control_style && Array.isArray(pd.control_style.exclude))
                  ? pd.control_style.exclude
                  : [];
    var filtered = exclude.length
                   ? base.filter(function(o) { return exclude.indexOf(o.value) === -1; })
                   : base;

    // Sort by declared order array. Unlisted options keep their original
    // index after the listed ones; legacy parents (no `order` array)
    // pass through unchanged.
    var order = (pd && pd.control_style && Array.isArray(pd.control_style.order))
                ? pd.control_style.order
                : null;
    if (order) {
      filtered.sort(function(a, b) {
        var ia = order.indexOf(a.value);
        var ib = order.indexOf(b.value);
        if (ia === -1 && ib === -1) return 0;
        if (ia === -1) return 1;
        if (ib === -1) return -1;
        return ia - ib;
      });
    }

    // Per-parent label overrides. Mariak Roller/Solar parents set
    // control_style.labels.cordless = "Deluxe Cordless" so the historic
    // Mariak branding survives the shared-engine move (Phase II keeps the
    // shorter "Cordless" default). Descriptions can also be overridden if a
    // parent needs different copy.
    var labelMap = (pd && pd.control_style && pd.control_style.labels && typeof pd.control_style.labels === 'object')
                   ? pd.control_style.labels
                   : null;
    var descMap = (pd && pd.control_style && pd.control_style.descs && typeof pd.control_style.descs === 'object')
                  ? pd.control_style.descs
                  : null;
    if (labelMap || descMap) {
      filtered.forEach(function(o) {
        if (labelMap && typeof labelMap[o.value] === 'string' && labelMap[o.value]) o.label = labelMap[o.value];
        if (descMap && typeof descMap[o.value] === 'string' && descMap[o.value]) o.desc = descMap[o.value];
      });
    }

    return filtered;
  }

  function renderControlStep(container) {
    var options = buildControlOptions(pricingData);

    // Size-banded control surcharges (Roman: Continuous Cord Loop / Cordless /
    // Motorwand priced by width band in builder_pricing.addons). Falls back to
    // the flat surcharges[key] for every existing family (no addons table), so
    // roller / Phase II / Mariak parents are completely unaffected.
    function controlSurchargeFor(opt) {
      if (!opt.surchargeKey || !pricing) return 0;
      var bands = pricingData && (pricingData.addons || pricingData.valance_pricing);
      if (bands && bands[opt.surchargeKey]) {
        var w = fractions.combine(store.get('widthInt'), store.get('widthFrac'));
        return pricing.getAddonPrice(opt.surchargeKey, w);
      }
      return pricing.getSurcharge(opt.surchargeKey);
    }

    options.forEach(function(opt) {
      if (opt.surchargeKey && pricing) {
        opt.surcharge = controlSurchargeFor(opt);
      }
    });

    // Switch to a 4-column layout when the control set grows past 6 cards
    // (Motorwand L/R injection lifts the count to 7 or 8). Keeps Mariak's
    // 6-card layout on the original 3-column grid.
    var gridClass = options.length > 6 ? 'builder-v2__icon-grid builder-v2__icon-grid--4' : 'builder-v2__icon-grid';
    var optionsDiv = dom.create('div', gridClass);

    options.forEach(function(opt) {

      var card = dom.create('button', 'builder-v2__icon-card');
      card.setAttribute('type', 'button');
      card.setAttribute('data-control', opt.value);

      var priceBadge = opt.surcharge > 0
        ? '<span class="builder-v2__icon-card-badge">+' + Core.formatMoney(opt.surcharge) + '</span>'
        : '<span class="builder-v2__icon-card-badge builder-v2__icon-card-badge--free">Included</span>';

      card.innerHTML =
        priceBadge +
        '<span class="builder-v2__icon-card-icon">' + opt.icon + '</span>' +
        '<span class="builder-v2__icon-card-label">' + escapeHtml(opt.label) + '</span>' +
        '<span class="builder-v2__icon-card-desc">' + escapeHtml(opt.desc) + '</span>';

      card._controlData = opt;
      optionsDiv.appendChild(card);
    });

    container.appendChild(optionsDiv);

    // The newer size gates can grey out every card, so those parents get a line
    // saying why. Built only when one of their keys is set.
    var blockedNote = null;
    if (pricingData && (pricingData.tdbu_spec || pricingData.cont_cord_loop_spec ||
        hasAreaCap(pricingData.cordless_spec) ||
        hasAreaCap(pricingData.motorized_spec || pricingData.motion_spec))) {
      blockedNote = dom.create('div', 'builder-v2__mount-notice builder-v2__mount-notice--below');
      blockedNote.setAttribute('data-control-blocked-note', '');
      blockedNote.setAttribute('role', 'status');
      blockedNote.style.display = 'none';
      container.appendChild(blockedNote);
    }

    // Motorized visibility is handled by Liquid CSS in the section file
    // (not JS) to avoid Shopify minifier issues. See product-template-builder-v2.liquid.

    // Remote Control sub-step. Parity with Builder 1.0: when the customer
    // picks Motorized, an inline sub-step must appear under Step 3 letting
    // them choose 1 / 6 / 16 channel. Driven by the per-parent metafield
    // pricingData.motorized_remote_options; absent on Mariak so the
    // sub-step never renders for legacy parents.
    var remoteOptions = (pricingData && Array.isArray(pricingData.motorized_remote_options))
                        ? pricingData.motorized_remote_options
                        : [];
    var remoteSubstepDiv = null;
    if (remoteOptions.length > 0) {
      remoteSubstepDiv = dom.create('div', 'builder-v2__remote-substep');
      remoteSubstepDiv.setAttribute('data-remote-substep', '');
      remoteSubstepDiv.style.display = 'none';
      var subHeading = dom.create('div', 'builder-v2__remote-substep-title');
      subHeading.textContent = 'Choose Remote Control Options';
      remoteSubstepDiv.appendChild(subHeading);
      var remoteGrid = dom.create('div', 'builder-v2__icon-grid builder-v2__icon-grid--3 builder-v2__remote-substep-grid');
      remoteOptions.forEach(function(opt) {
        var card = dom.create('button', 'builder-v2__icon-card');
        card.setAttribute('type', 'button');
        card.setAttribute('data-remote', opt.value);
        // Accept either schema in the metafield: `surcharge_cents` (integer
        // cents, e.g. 3599) or `price` (number dollars, e.g. 35.99). The
        // Round 1 metafield write used `price` while earlier scaffolding
        // used `surcharge_cents`; this reads either so the 16-channel
        // +$35.99 badge renders correctly.
        var cents = 0;
        if (typeof opt.surcharge_cents === 'number') {
          cents = opt.surcharge_cents;
        } else if (typeof opt.price === 'number') {
          cents = Math.round(opt.price * 100);
        }
        var dollars = cents / 100;
        var priceBadge = cents > 0
          ? '<span class="builder-v2__icon-card-badge">+' + Core.formatMoney(dollars) + '</span>'
          : '<span class="builder-v2__icon-card-badge builder-v2__icon-card-badge--free">Included</span>';
        // Default-to-empty-string for label/desc so a partial metafield
        // entry (e.g. missing label) never propagates "undefined" into the
        // parent_props EDI payload via state.remoteLabel.
        var labelText = (opt.label && String(opt.label)) || (opt.value || '');
        var descText = (opt.desc && String(opt.desc)) || '';
        // Display label drops the "(Operates X Shade)" suffix so the
        // "Included" badge doesn't crash into the title. Full labelText
        // is preserved in _remoteData.label for EDI parent_props parity.
        var displayLabel = labelText.replace(/\s*\([^)]*\)\s*$/, '');
        card.innerHTML =
          priceBadge +
          '<span class="builder-v2__icon-card-label">' + escapeHtml(displayLabel) + '</span>' +
          '<span class="builder-v2__icon-card-desc">' + escapeHtml(descText) + '</span>';
        card._remoteData = { value: opt.value, label: labelText, desc: descText, surcharge: dollars };
        remoteGrid.appendChild(card);
      });
      remoteSubstepDiv.appendChild(remoteGrid);
      container.appendChild(remoteSubstepDiv);

      dom.on(remoteGrid, 'click', '.builder-v2__icon-card', function() {
        if (this.hasAttribute('disabled')) return;
        var data = this._remoteData;
        if (!data) return;
        dom.qsa('.builder-v2__icon-card', remoteGrid).forEach(function(c) {
          c.classList.remove('builder-v2__icon-card--active');
        });
        this.classList.add('builder-v2__icon-card--active');
        store.set('remoteVariant', data.value);
        store.set('remoteLabel', data.label + (data.desc ? ' - ' + data.desc : ''));
        store.set('remoteSurcharge', data.surcharge);
        recalculatePrice();
      });

      // Show / hide the sub-step based on the active control. When the
      // user moves away from Motorized, clear the remote selection so a
      // stale value cannot leak into the cart payload.
      store.subscribe(function(key) {
        if (key !== 'control') return;
        var isMotorized = store.get('control') === 'motorized';
        remoteSubstepDiv.style.display = isMotorized ? '' : 'none';
        if (!isMotorized) {
          if (store.get('remoteVariant') != null) {
            store.set('remoteVariant', null);
            store.set('remoteLabel', null);
            store.set('remoteSurcharge', 0);
            dom.qsa('.builder-v2__icon-card', remoteGrid).forEach(function(c) {
              c.classList.remove('builder-v2__icon-card--active');
            });
            recalculatePrice();
          }
        } else if (store.get('remoteVariant') == null) {
          // Auto-select the first option (free 1-channel) so the cart
          // payload always carries a remote choice when Motorized is the
          // active control.
          var firstCard = dom.qs('.builder-v2__icon-card', remoteGrid);
          if (firstCard) firstCard.click();
        }
      });
    }

    dom.on(optionsDiv, 'click', '.builder-v2__icon-card', function() {
      // Block clicks on disabled cards (motorization size-locked)
      if (this.hasAttribute('disabled')) return;

      var data = this._controlData;
      if (!data) return;

      dom.qsa('.builder-v2__icon-card', optionsDiv).forEach(function(c) {
        c.classList.remove('builder-v2__icon-card--active');
      });
      this.classList.add('builder-v2__icon-card--active');

      store.set('control', data.value);
      store.set('controlLabel', data.label + (data.desc ? ' - ' + data.desc : ''));
      store.set('controlSurcharge', controlSurchargeFor(data));

      stepElements[2].selectionLabel.textContent = data.label;
      completeStep(2);
      recalculatePrice();

      // Trigger valance lock check (motorized → no valance)
      enforceValanceLock();
    });

    // Optional max_area_sq_in on a control spec. Some fabrics cap the square
    // inches rather than either side, so it is tested on the true size.
    function hasAreaCap(spec) {
      return !!(spec && typeof spec.max_area_sq_in === 'number');
    }
    function overMaxArea(spec, wActual, hActual) {
      return hasAreaCap(spec) && wActual > 0 && hActual > 0 && wActual * hActual > spec.max_area_sq_in;
    }

    // Size restriction: disable motorization outside the parent's
    // motion_spec. Uses integer part only (not fractions) because in the
    // blinds industry "72 inches" includes 72 0/8 through 72 7/8. A
    // customer selecting 72 3/8" is still ordering a "72-inch blind".
    // Always subscribe -- checks for the DOM element directly
    {
      store.subscribe(function(key) {
        // Read here, not at render: motorizedSpec is assigned after the steps render.
        var motorStrict = !!(motorizedSpec && motorizedSpec.strict_fractions === true);
        // Fractions feed only the optional area cap and strict bounds; otherwise the bounds stay whole-inch.
        var motorFracKey = key === 'widthFrac' || key === 'heightFrac';
        if (key !== 'widthInt' && key !== 'heightInt' && !(motorFracKey && (motorStrict || hasAreaCap(motorizedSpec)))) return;
        var motorCard = dom.qs('[data-control="motorized"]', optionsDiv);
        if (!motorCard) return;

        var wInt = store.get('widthInt');
        var hInt = store.get('heightInt');
        // No size picked yet -- do not disable on initial render
        if (!wInt && !hInt) return;
        var wMotor = (wInt && motorStrict) ? fractions.combine(wInt, store.get('widthFrac')) : wInt;
        var hMotor = (hInt && motorStrict) ? fractions.combine(hInt, store.get('heightFrac')) : hInt;
        // Test only the bound that applies on each axis the user has set.
        var oversized = (wInt && (wMotor < motorizedSpec.min_w || wMotor > motorizedSpec.max_w))
                     || (hInt && (hMotor < motorizedSpec.min_h || hMotor > motorizedSpec.max_h));
        if (!oversized && wInt && hInt &&
            overMaxArea(motorizedSpec, fractions.combine(wInt, store.get('widthFrac')), fractions.combine(hInt, store.get('heightFrac')))) {
          oversized = true;
        }

        if (oversized) {
          motorCard.classList.add('builder-v2__icon-card--disabled');
          motorCard.setAttribute('disabled', 'disabled');
          motorCard.setAttribute('aria-disabled', 'true');
          // If motorized was already selected, reset control style
          if (store.get('control') === 'motorized') {
            store.set('control', null);
            store.set('controlLabel', null);
            store.set('controlSurcharge', 0);
            motorCard.classList.remove('builder-v2__icon-card--active');
            stepElements[2].el.classList.remove('builder-v2__step--complete');
            stepElements[2].selectionLabel.textContent = '';
            recalculatePrice();
            enforceValanceLock();
          }
        } else {
          motorCard.classList.remove('builder-v2__icon-card--disabled');
          motorCard.removeAttribute('disabled');
          motorCard.removeAttribute('aria-disabled');
        }
      });
    }

    // Motorwand dimension gate. Motorwand reads motion_spec; Motorised has its
    // own motorized_spec because their ranges can differ (Roman: motor caps at
    // 72" vs motorwand 115" — Warwick 2026-06-25 spec sheet). Disables both
    // motorwand-left and motorwand-right when the size is out of range, and
    // resets the active selection if either was picked.
    {
      store.subscribe(function(key) {
        if (key !== 'widthInt' && key !== 'heightInt') return;
        var motorwandCards = [
          dom.qs('[data-control="motorwand-left"]', optionsDiv),
          dom.qs('[data-control="motorwand-right"]', optionsDiv)
        ].filter(Boolean);
        if (motorwandCards.length === 0) return;

        var wInt = store.get('widthInt');
        var hInt = store.get('heightInt');
        if (!wInt && !hInt) return;
        var oversized = (wInt && (wInt < motionSpec.min_w || wInt > motionSpec.max_w))
                     || (hInt && (hInt < motionSpec.min_h || hInt > motionSpec.max_h));

        motorwandCards.forEach(function(card) {
          if (oversized) {
            card.classList.add('builder-v2__icon-card--disabled');
            card.setAttribute('disabled', 'disabled');
            card.setAttribute('aria-disabled', 'true');
          } else {
            card.classList.remove('builder-v2__icon-card--disabled');
            card.removeAttribute('disabled');
            card.removeAttribute('aria-disabled');
          }
        });

        if (oversized) {
          var active = store.get('control');
          if (active === 'motorwand-left' || active === 'motorwand-right') {
            store.set('control', null);
            store.set('controlLabel', null);
            store.set('controlSurcharge', 0);
            motorwandCards.forEach(function(c) { c.classList.remove('builder-v2__icon-card--active'); });
            stepElements[2].el.classList.remove('builder-v2__step--complete');
            stepElements[2].selectionLabel.textContent = '';
            recalculatePrice();
            enforceValanceLock();
          }
        }
      });
    }

    // Cordless dimension gate. Subscriber registers unconditionally
    // because renderControlStep can run before the cordlessSpec var
    // is assigned (see STEPS forEach above). Inside the callback,
    // cordlessSpec is read by closure — by the time it fires, the
    // var has been assigned. Products without a cordless_spec in
    // builder_pricing leave it null and the gate is a no-op for them.
    // Mariak Roller/Solar parents carry {max_w:96} (no Deluxe Cordless
    // above 96in wide, Warwick 2026-07-02); Phase II parents carry their
    // factory bounds (84in, strict on fractions per Warwick 2026-07-02).
    {
      store.subscribe(function(key) {
        // Also watch the fraction keys: cordless tests the true size, so a
        // fraction change at a fixed whole inch (e.g. 96 -> 96 1/2") must
        // re-evaluate. The motion gates above use whole inches only, so they
        // deliberately do not subscribe to the fraction keys.
        if (key !== 'widthInt' && key !== 'heightInt' && key !== 'widthFrac' && key !== 'heightFrac') return;
        if (!cordlessSpec) return;
        // Gate EVERY cordless mechanism: the plain card and the Top-Down/
        // Bottom-Up variant. A cordless_spec cap that only greyed the plain
        // card would let the customer order the same impossible size via
        // Cordless TDBU (7/16 Double Cell, Warwick 2026-07-03).
        var cordlessCards = [
          dom.qs('[data-control="cordless"]', optionsDiv),
          tdbuSpec ? null : dom.qs('[data-control="cordless-tdbu"]', optionsDiv) // tdbu_spec gates it below
        ].filter(Boolean);
        if (cordlessCards.length === 0) return;

        var wInt = store.get('widthInt');
        var hInt = store.get('heightInt');
        if (!wInt && !hInt) return;
        // Cordless tests the ACTUAL fractional size, unlike the motion gates
        // above which use whole inches on purpose. Warwick's rule is "Deluxe
        // Cordless not selectable above 96 inches", so 96 1/2" must fall out of
        // range while a flat 96" stays available (max_w is an inclusive ceiling).
        var wActual = wInt ? fractions.combine(wInt, store.get('widthFrac')) : 0;
        var hActual = hInt ? fractions.combine(hInt, store.get('heightFrac')) : 0;
        var outOfRange = (wInt && (wActual < cordlessSpec.min_w || wActual > cordlessSpec.max_w))
                      || (hInt && (hActual < cordlessSpec.min_h || hActual > cordlessSpec.max_h));
        if (!outOfRange && overMaxArea(cordlessSpec, wActual, hActual)) outOfRange = true;

        if (outOfRange) {
          cordlessCards.forEach(function(card) {
            card.classList.add('builder-v2__icon-card--disabled');
            card.setAttribute('disabled', 'disabled');
            card.setAttribute('aria-disabled', 'true');
          });
          var activeControl = store.get('control');
          if (activeControl === 'cordless' || (activeControl === 'cordless-tdbu' && !tdbuSpec)) {
            store.set('control', null);
            store.set('controlLabel', null);
            store.set('controlSurcharge', 0);
            cordlessCards.forEach(function(card) { card.classList.remove('builder-v2__icon-card--active'); });
            stepElements[2].el.classList.remove('builder-v2__step--complete');
            stepElements[2].selectionLabel.textContent = '';
            recalculatePrice();
            enforceValanceLock();
          }
        } else {
          cordlessCards.forEach(function(card) {
            card.classList.remove('builder-v2__icon-card--disabled');
            card.removeAttribute('disabled');
            card.removeAttribute('aria-disabled');
          });
        }
      });
    }

    // Chain dimension gate: the mirror of the cordless gate above, for the
    // four chain mechanisms. Mariak keeps changing what their factory can
    // make, so the caps live in data (chain_spec per parent), not in code.
    // Fraction-aware exactly like cordless: max_w is an inclusive ceiling,
    // 120 flat stays selectable, 120 1/8 falls out of range.
    {
      store.subscribe(function(key) {
        if (key !== 'widthInt' && key !== 'heightInt' && key !== 'widthFrac' && key !== 'heightFrac') return;
        if (!chainSpec) return;
        var chainCards = [
          dom.qs('[data-control="plastic-chain-left"]', optionsDiv),
          dom.qs('[data-control="plastic-chain-right"]', optionsDiv),
          dom.qs('[data-control="stainless-chain-left"]', optionsDiv),
          dom.qs('[data-control="stainless-chain-right"]', optionsDiv)
        ].filter(Boolean);
        if (chainCards.length === 0) return;

        var wInt = store.get('widthInt');
        var hInt = store.get('heightInt');
        if (!wInt && !hInt) return;
        var wActual = wInt ? fractions.combine(wInt, store.get('widthFrac')) : 0;
        var hActual = hInt ? fractions.combine(hInt, store.get('heightFrac')) : 0;
        var chainMinW = chainSpec.min_w || 0;
        var chainMaxW = (chainSpec.max_w != null) ? chainSpec.max_w : 999;
        var chainMinH = chainSpec.min_h || 0;
        var chainMaxH = (chainSpec.max_h != null) ? chainSpec.max_h : 999;
        var outOfRange = (wInt && (wActual < chainMinW || wActual > chainMaxW))
                      || (hInt && (hActual < chainMinH || hActual > chainMaxH));
        // Conditional chain rules, e.g. the Phase II solar railroad: chains over
        // 94in wide cannot exceed 84in long, while motorized keeps its own
        // limits (Warwick 21 Jul 2026: railroad is chain-only per the spec
        // sheet). Shape: conditional: [{ when_width_gt: 94, max_height: 84 }].
        if (!outOfRange && chainSpec.conditional && chainSpec.conditional.length) {
          for (var cci = 0; cci < chainSpec.conditional.length; cci++) {
            var cc = chainSpec.conditional[cci];
            if (wInt && hInt && cc.when_width_gt != null && cc.max_height != null &&
                wActual > cc.when_width_gt && hActual > cc.max_height) {
              outOfRange = true;
              break;
            }
          }
        }

        if (outOfRange) {
          chainCards.forEach(function(card) {
            card.classList.add('builder-v2__icon-card--disabled');
            card.setAttribute('disabled', 'disabled');
            card.setAttribute('aria-disabled', 'true');
          });
          var activeChain = store.get('control');
          if (activeChain === 'plastic-chain-left' || activeChain === 'plastic-chain-right' ||
              activeChain === 'stainless-chain-left' || activeChain === 'stainless-chain-right') {
            store.set('control', null);
            store.set('controlLabel', null);
            store.set('controlSurcharge', 0);
            chainCards.forEach(function(card) { card.classList.remove('builder-v2__icon-card--active'); });
            stepElements[2].el.classList.remove('builder-v2__step--complete');
            stepElements[2].selectionLabel.textContent = '';
            recalculatePrice();
            enforceValanceLock();
          }
        } else {
          chainCards.forEach(function(card) {
            card.classList.remove('builder-v2__icon-card--disabled');
            card.removeAttribute('disabled');
            card.removeAttribute('aria-disabled');
          });
        }
      });
    }

    // TDBU dimension gate, the cordless gate for the cordless-tdbu card alone.
    // Only runs when tdbu_spec is set; otherwise cordless_spec covers the card.
    {
      store.subscribe(function(key) {
        if (key !== 'widthInt' && key !== 'heightInt' && key !== 'widthFrac' && key !== 'heightFrac') return;
        if (!tdbuSpec) return;
        var tdbuCard = dom.qs('[data-control="cordless-tdbu"]', optionsDiv);
        if (!tdbuCard) return;

        var wInt = store.get('widthInt');
        var hInt = store.get('heightInt');
        if (!wInt && !hInt) return;
        var wActual = wInt ? fractions.combine(wInt, store.get('widthFrac')) : 0;
        var hActual = hInt ? fractions.combine(hInt, store.get('heightFrac')) : 0;
        var outOfRange = (wInt && (wActual < tdbuSpec.min_w || wActual > tdbuSpec.max_w))
                      || (hInt && (hActual < tdbuSpec.min_h || hActual > tdbuSpec.max_h));
        if (!outOfRange && overMaxArea(tdbuSpec, wActual, hActual)) outOfRange = true;

        setCardDisabled(tdbuCard, outOfRange);
        if (outOfRange && store.get('control') === 'cordless-tdbu') {
          store.set('control', null);
          store.set('controlLabel', null);
          store.set('controlSurcharge', 0);
          tdbuCard.classList.remove('builder-v2__icon-card--active');
          stepElements[2].el.classList.remove('builder-v2__step--complete');
          stepElements[2].selectionLabel.textContent = '';
          recalculatePrice();
          enforceValanceLock();
        }
      });
    }

    // Continuous Cord Loop dimension gate, the chain gate for the two loop
    // cards. Absent cont_cord_loop_spec leaves them ungated.
    {
      store.subscribe(function(key) {
        if (key !== 'widthInt' && key !== 'heightInt' && key !== 'widthFrac' && key !== 'heightFrac') return;
        if (!contCordLoopSpec) return;
        var loopCards = [
          dom.qs('[data-control="cont-cord-loop-left"]', optionsDiv),
          dom.qs('[data-control="cont-cord-loop-right"]', optionsDiv)
        ].filter(Boolean);
        if (loopCards.length === 0) return;

        var wInt = store.get('widthInt');
        var hInt = store.get('heightInt');
        if (!wInt && !hInt) return;
        var wActual = wInt ? fractions.combine(wInt, store.get('widthFrac')) : 0;
        var hActual = hInt ? fractions.combine(hInt, store.get('heightFrac')) : 0;
        var loopMinW = contCordLoopSpec.min_w || 0;
        var loopMaxW = (contCordLoopSpec.max_w != null) ? contCordLoopSpec.max_w : 999;
        var loopMinH = contCordLoopSpec.min_h || 0;
        var loopMaxH = (contCordLoopSpec.max_h != null) ? contCordLoopSpec.max_h : 999;
        var outOfRange = (wInt && (wActual < loopMinW || wActual > loopMaxW))
                      || (hInt && (hActual < loopMinH || hActual > loopMaxH));
        if (!outOfRange && overMaxArea(contCordLoopSpec, wActual, hActual)) outOfRange = true;

        loopCards.forEach(function(card) { setCardDisabled(card, outOfRange); });
        var activeLoop = store.get('control');
        if (outOfRange && (activeLoop === 'cont-cord-loop-left' || activeLoop === 'cont-cord-loop-right')) {
          store.set('control', null);
          store.set('controlLabel', null);
          store.set('controlSurcharge', 0);
          loopCards.forEach(function(card) { card.classList.remove('builder-v2__icon-card--active'); });
          stepElements[2].el.classList.remove('builder-v2__step--complete');
          stepElements[2].selectionLabel.textContent = '';
          recalculatePrice();
          enforceValanceLock();
        }
      });
    }

    // Registered after every size gate so it reads their settled result. CSS
    // hides Motorized on untagged parents, so a hidden card counts as unavailable.
    if (blockedNote) {
      store.subscribe(function(key) {
        if (key !== 'widthInt' && key !== 'heightInt' && key !== 'widthFrac' && key !== 'heightFrac') return;
        var cards = dom.qsa('.builder-v2__icon-card', optionsDiv);
        var blocked = cards.length > 0 && !!(store.get('widthInt') || store.get('heightInt')) &&
          cards.every(function(card) {
            return card.hasAttribute('disabled') || window.getComputedStyle(card).display === 'none';
          });
        if (blocked) {
          blockedNote.style.display = '';
          var msg = 'No control option can be made at this size. Please adjust the width or height.';
          if (blockedNote.textContent !== msg) blockedNote.textContent = msg;
        } else {
          blockedNote.textContent = '';
          blockedNote.style.display = 'none';
        }
      });
    }

    // Width-banded control repricing. When width changes, recompute each
    // control card's band price, refresh its badge, and if a banded control is
    // selected update its surcharge so the total + cart child variant track the
    // band. No-op for families without an addons band table (badge unchanged).
    store.subscribe(function(key) {
      if (key !== 'widthInt' && key !== 'widthFrac') return;
      var changed = false;
      dom.qsa('.builder-v2__icon-card', optionsDiv).forEach(function(card) {
        var opt = card._controlData;
        if (!opt) return;
        var next = controlSurchargeFor(opt);
        if (next === opt.surcharge) return;
        opt.surcharge = next;
        changed = true;
        var badge = card.querySelector('.builder-v2__icon-card-badge');
        if (badge) {
          if (next > 0) {
            badge.className = 'builder-v2__icon-card-badge';
            badge.textContent = '+' + Core.formatMoney(next);
          } else {
            badge.className = 'builder-v2__icon-card-badge builder-v2__icon-card-badge--free';
            badge.textContent = 'Included';
          }
        }
        if (store.get('control') === opt.value) {
          store.set('controlSurcharge', next);
        }
      });
      if (changed && store.get('control')) recalculatePrice();
    });
  }


  /* ============================================================
     STEP 4: CHOOSE ROLL DIRECTION
     ============================================================ */
  function renderRollStep(container) {
    var options = [
      { value: 'standard', label: 'Standard Roll', desc: 'Fabric rolls behind the tube, closer to window', icon: ICONS.standardRoll },
      { value: 'reverse', label: 'Reverse Roll', desc: 'Fabric rolls in front of the tube (waterfall)', icon: ICONS.reverseRoll }
    ];

    var optionsDiv = dom.create('div', 'builder-v2__mount-options');

    options.forEach(function(opt) {
      var card = dom.create('button', 'builder-v2__icon-card');
      card.setAttribute('type', 'button');
      card.setAttribute('data-roll', opt.value);
      card.innerHTML =
        '<span class="builder-v2__icon-card-icon">' + opt.icon + '</span>' +
        '<span class="builder-v2__icon-card-label">' + escapeHtml(opt.label) + '</span>' +
        '<span class="builder-v2__icon-card-desc">' + escapeHtml(opt.desc) + '</span>';

      card._rollData = opt;
      optionsDiv.appendChild(card);
    });

    container.appendChild(optionsDiv);

    dom.on(optionsDiv, 'click', '.builder-v2__icon-card', function() {
      var data = this._rollData;
      if (!data) return;

      dom.qsa('.builder-v2__icon-card', optionsDiv).forEach(function(c) {
        c.classList.remove('builder-v2__icon-card--active');
      });
      this.classList.add('builder-v2__icon-card--active');

      store.set('rollDirection', data.value);
      stepElements[3].selectionLabel.textContent = data.label;
      completeStep(3);

      // Trigger valance lock check (reverse roll → no valance)
      enforceValanceLock();
    });
  }


  /* ============================================================
     HORIZONTAL STEP: WAND CONTROL (Faux Wood Premier/Signature,
     Hardwood). Appended step index 5. Emits `Wand Control` = Left
     or Right, the exact legacy Builder 1.0 label confirmed on live
     orders. Gated by builder_pricing.show_wand. No surcharge.
     ============================================================ */
  function renderWandStep(container) {
    var options = [
      { value: 'Left',  label: 'Left',  desc: 'Wand tilt control on the left',  icon: ICONS.motorwandLeft },
      { value: 'Right', label: 'Right', desc: 'Wand tilt control on the right', icon: ICONS.motorwandRight }
    ];

    var optionsDiv = dom.create('div', 'builder-v2__mount-options');

    options.forEach(function(opt) {
      var card = dom.create('button', 'builder-v2__icon-card');
      card.setAttribute('type', 'button');
      card.setAttribute('data-wand', opt.value);
      card.innerHTML =
        '<span class="builder-v2__icon-card-icon">' + opt.icon + '</span>' +
        '<span class="builder-v2__icon-card-label">' + escapeHtml(opt.label) + '</span>' +
        '<span class="builder-v2__icon-card-desc">' + escapeHtml(opt.desc) + '</span>';
      card._wandData = opt;
      optionsDiv.appendChild(card);
    });

    container.appendChild(optionsDiv);

    dom.on(optionsDiv, 'click', '.builder-v2__icon-card', function() {
      var data = this._wandData;
      if (!data) return;
      dom.qsa('.builder-v2__icon-card', optionsDiv).forEach(function(c) {
        c.classList.remove('builder-v2__icon-card--active');
      });
      this.classList.add('builder-v2__icon-card--active');
      store.set('wandControl', data.value);
      stepElements[5].selectionLabel.textContent = data.label;
      completeStep(5);
    });
  }


  /* ============================================================
     HORIZONTAL STEP: VALANCE STYLE (Faux Wood Premier/Signature).
     Appended step index 6. Emits `Valance Style` = Standard or Urban
     (exact legacy label). Gated by show_valance_style. No surcharge.
     ============================================================ */
  function renderValanceStyleStep(container) {
    var options = [
      { value: 'Standard', label: 'Standard', desc: 'Classic profile with a bevelled edge', icon: ICONS.valanceStandard },
      { value: 'Urban',    label: 'Urban',    desc: 'Squared-off contemporary profile', icon: ICONS.valanceUrban }
    ];

    var optionsDiv = dom.create('div', 'builder-v2__mount-options');

    options.forEach(function(opt) {
      var card = dom.create('button', 'builder-v2__icon-card');
      card.setAttribute('type', 'button');
      card.setAttribute('data-valance-style', opt.value);
      var iconHtml = iconSlotHtml(optionIconUrl(optionIcons.valanceStyle, opt.value, null), opt.icon, opt.label);
      card.innerHTML =
        '<span class="builder-v2__icon-card-icon">' + iconHtml + '</span>' +
        '<span class="builder-v2__icon-card-label">' + escapeHtml(opt.label) + '</span>' +
        '<span class="builder-v2__icon-card-desc">' + escapeHtml(opt.desc) + '</span>';
      card._valanceStyleData = opt;
      optionsDiv.appendChild(card);
    });

    container.appendChild(optionsDiv);

    dom.on(optionsDiv, 'click', '.builder-v2__icon-card', function() {
      var data = this._valanceStyleData;
      if (!data) return;
      dom.qsa('.builder-v2__icon-card', optionsDiv).forEach(function(c) {
        c.classList.remove('builder-v2__icon-card--active');
      });
      this.classList.add('builder-v2__icon-card--active');
      store.set('valanceStyle', data.value);
      stepElements[6].selectionLabel.textContent = data.label;
      completeStep(6);
    });
  }


  /* ============================================================
     HORIZONTAL STEP: VALANCE OPTIONS / POSITION (Faux Wood, Hardwood).
     Appended step index 7. Emits `Valance Options` = the exact legacy
     recess string. Gated by show_valance_position. No surcharge.
     ============================================================ */
  function renderValancePositionStep(container) {
    // Labels are the full option wording from the current builder (Warwick review
    // 2026-06-13: "keep the language the same as what is on the current builder").
    // The old builder shows the full variant titles in its dropdown, so display
    // label = emitted EDI value = icon variant key, all identical.
    var options = [
      { value: 'Inside Mount Fully Recessed',     label: 'Inside Mount Fully Recessed',     desc: 'Valance sits flush inside the frame', icon: ICONS.insideMount },
      { value: 'Inside Mount Partially Recessed', label: 'Inside Mount Partially Recessed', desc: 'Valance partially inside the frame', icon: ICONS.insideMount },
      { value: 'Outside Mount Not Recessed',      label: 'Outside Mount Not Recessed',       desc: 'Valance mounts in front on the wall', icon: ICONS.outsideMount }
    ];

    var optionsDiv = dom.create('div', 'builder-v2__mount-options');

    options.forEach(function(opt) {
      var card = dom.create('button', 'builder-v2__icon-card');
      card.setAttribute('type', 'button');
      card.setAttribute('data-valance-position', opt.value);
      var iconHtml = iconSlotHtml(optionIconUrl(optionIcons.valancePosition, opt.value, null), opt.icon, opt.label);
      card.innerHTML =
        '<span class="builder-v2__icon-card-icon">' + iconHtml + '</span>' +
        '<span class="builder-v2__icon-card-label">' + escapeHtml(opt.label) + '</span>' +
        '<span class="builder-v2__icon-card-desc">' + escapeHtml(opt.desc) + '</span>';
      card._valancePositionData = opt;
      optionsDiv.appendChild(card);
    });

    container.appendChild(optionsDiv);

    dom.on(optionsDiv, 'click', '.builder-v2__icon-card', function() {
      var data = this._valancePositionData;
      if (!data) return;
      dom.qsa('.builder-v2__icon-card', optionsDiv).forEach(function(c) {
        c.classList.remove('builder-v2__icon-card--active');
      });
      this.classList.add('builder-v2__icon-card--active');
      store.set('valancePosition', data.value);
      stepElements[7].selectionLabel.textContent = data.label;
      completeStep(7);
    });
  }


  /* ============================================================
     HORIZONTAL STEP: HEADRAIL OPTIONS (Mini 6g/8g, Hardwood).
     Appended step index 8. Standard vs Two-on-One (+$25.04, the only
     real horizontal surcharge). Emits `Headrail Options` + a byte-exact
     `Headrail Details` string (see buildHeadrailDetails). Customer-facing
     Tilt Location (Left/Right, default Left) on Standard; Two-on-One lets the
     customer choose each section's tilt (Blind 1 / Blind 2, defaults Left /
     Right) for legacy parity. show_headrail.
     ============================================================ */
  function renderHeadrailStep(container) {
    // Two-on-one is free once it becomes mandatory: SWF charge for it only
    // below the width where the factory stops building a single headrail.
    function headrailSurchargeNow() {
      var amt = (pricingData && typeof pricingData.headrail_2on1_surcharge === 'number')
                ? pricingData.headrail_2on1_surcharge : 25.04;
      var freeAbove = (pricingData && typeof pricingData.headrail_2on1_free_above_w === 'number')
                      ? pricingData.headrail_2on1_free_above_w : null;
      if (freeAbove === null) return amt;
      var wNow = fractions.combine(store.get('widthInt') || 0, store.get('widthFrac') || 0);
      return (wNow > freeAbove) ? 0 : amt;
    }
    var surchargeAmt = headrailSurchargeNow();
    var options = [
      { value: 'Standard Headrail',  label: 'Standard Headrail',  desc: 'One headrail across the full width', surcharge: 0, icon: ICONS.headrailStandard },
      { value: 'Two on One Headrail', label: 'Two on One Headrail', desc: 'Two independent blinds on one headrail', surcharge: surchargeAmt, icon: ICONS.headrailTwoOnOne }
    ];

    var optionsDiv = dom.create('div', 'builder-v2__mount-options');
    options.forEach(function(opt) {
      var card = dom.create('button', 'builder-v2__icon-card');
      card.setAttribute('type', 'button');
      card.setAttribute('data-headrail', opt.value);
      var badge = opt.surcharge > 0
        ? '<span class="builder-v2__icon-card-badge">+' + Core.formatMoney(opt.surcharge) + '</span>'
        : '<span class="builder-v2__icon-card-badge builder-v2__icon-card-badge--free">Included</span>';
      card.innerHTML = badge +
        '<span class="builder-v2__icon-card-icon">' + opt.icon + '</span>' +
        '<span class="builder-v2__icon-card-label">' + escapeHtml(opt.label) + '</span>' +
        '<span class="builder-v2__icon-card-desc">' + escapeHtml(opt.desc) + '</span>';
      card._headrailData = opt;
      optionsDiv.appendChild(card);
    });
    container.appendChild(optionsDiv);

    // Standard greys out silently above the force width; this says why.
    // Inert unless builder_pricing sets headrail_force_2on1_note.
    var forceNote = dom.create('div', 'builder-v2__mount-notice builder-v2__mount-notice--below');
    forceNote.setAttribute('data-headrail-force-note', '');
    forceNote.setAttribute('role', 'status');
    forceNote.style.display = 'none';
    container.appendChild(forceNote);

    // formatMaxLength supplies the inch mark, so the merchant string carries a
    // {w} token and the threshold keeps one source of truth.
    function forceNoteMessage(thresholdW) {
      var tpl = (pricingData && typeof pricingData.headrail_force_2on1_note === 'string')
                ? pricingData.headrail_force_2on1_note : '';
      if (!tpl) return '';
      return tpl.split('{w}').join(formatMaxLength(thresholdW));
    }

    // Show before write so a screen reader has the node in the tree, and skip
    // an unchanged write so it does not re-announce on every inch.
    function setForceNote(msg) {
      if (msg) {
        forceNote.style.display = '';
        if (forceNote.textContent !== msg) forceNote.textContent = msg;
      } else {
        forceNote.textContent = '';
        forceNote.style.display = 'none';
      }
    }

    // Tilt Location sub-step (Blind 1; default Left). Shown only for Standard
    // Headrail. Two-on-One fixes Blind 1 Left / Blind 2 Right (legacy parity).
    var tiltWrap = dom.create('div', 'builder-v2__remote-substep');
    tiltWrap.style.display = 'none';
    // Cordless-only families have no left or right side to tilt, so the whole
    // sub-step is suppressed. Default stays 'Left' for the EDI value.
    var hideTilt = !!(pricingData && pricingData.show_headrail_tilt === false);
    var tiltTitle = dom.create('div', 'builder-v2__remote-substep-title');
    tiltTitle.textContent = 'Tilt Location';
    tiltWrap.appendChild(tiltTitle);
    var tiltGrid = dom.create('div', 'builder-v2__icon-grid builder-v2__icon-grid--3 builder-v2__remote-substep-grid');
    ['Left', 'Right'].forEach(function(t) {
      var b = dom.create('button', 'builder-v2__icon-card' + (t === 'Left' ? ' builder-v2__icon-card--active' : ''));
      b.setAttribute('type', 'button');
      b.setAttribute('data-headrail-tilt', t);
      b.innerHTML = '<span class="builder-v2__icon-card-label">' + t + '</span>';
      tiltGrid.appendChild(b);
    });
    tiltWrap.appendChild(tiltGrid);
    if (hideTilt) tiltWrap.setAttribute('data-tilt-hidden', '1');
    container.appendChild(tiltWrap);

    // Two-on-One per-blind width sub-step (Warwick review 2026-06-05). Mariak
    // needs the width of each blind, like the legacy #width-crtl-inch-1/2. The
    // customer sets Blind 1 (left); Blind 2 (right) is the remainder of the
    // opening, so the two always sum to the overall width — no invalid split is
    // possible. Shown only when Two-on-One is chosen.
    var blindWrap = dom.create('div', 'builder-v2__remote-substep');
    blindWrap.style.display = 'none';
    blindWrap.innerHTML =
      '<div class="builder-v2__remote-substep-title">Split the width between the two blinds</div>' +
      '<div class="builder-v2__size-row">' +
        '<div class="builder-v2__size-field">' +
          '<label class="builder-v2__size-label">Blind 1 width (left)</label>' +
          '<div class="builder-v2__size-inputs">' +
            '<select class="builder-v2__size-select" data-blind1-inch aria-label="Blind 1 width in inches"></select>' +
            '<select class="builder-v2__size-select builder-v2__size-select--fraction" data-blind1-frac aria-label="Blind 1 width fraction"></select>' +
          '</div>' +
        '</div>' +
        '<div class="builder-v2__size-field">' +
          '<label class="builder-v2__size-label">Blind 2 width (right)</label>' +
          '<div class="builder-v2__size-inputs">' +
            '<select class="builder-v2__size-select" data-blind2-readout disabled aria-label="Blind 2 width"><option>—</option></select>' +
          '</div>' +
        '</div>' +
      '</div>';
    container.appendChild(blindWrap);

    // Two-on-One per-blind Tilt Location sub-step (Warwick review 2026-06-13).
    // Legacy parity: on the current builder the customer chooses each section's
    // tilt (#tilt-loc-1 / #tilt-loc-2; defaults left / right). Same card UI as
    // the Standard Tilt Location above (the "Hardwood page" style Warwick asked
    // to match). Defaults are Blind 1 Left / Blind 2 Right, identical to the
    // value the emit was previously hardcoding, so an untouched selection yields
    // a byte-identical Headrail Details string. Shown only for Two-on-One.
    function buildTiltRow(titleText, storeKey, defaultVal) {
      var wrap = dom.create('div', 'builder-v2__remote-substep');
      var title = dom.create('div', 'builder-v2__remote-substep-title');
      title.textContent = titleText;
      wrap.appendChild(title);
      var grid = dom.create('div', 'builder-v2__icon-grid builder-v2__icon-grid--3 builder-v2__remote-substep-grid');
      ['Left', 'Right'].forEach(function(t) {
        var b = dom.create('button', 'builder-v2__icon-card' + (t === defaultVal ? ' builder-v2__icon-card--active' : ''));
        b.setAttribute('type', 'button');
        b.setAttribute('data-tilt', t);
        b.innerHTML = '<span class="builder-v2__icon-card-label">' + t + '</span>';
        grid.appendChild(b);
      });
      wrap.appendChild(grid);
      dom.on(grid, 'click', '.builder-v2__icon-card', function() {
        dom.qsa('.builder-v2__icon-card', grid).forEach(function(c) {
          c.classList.remove('builder-v2__icon-card--active');
        });
        this.classList.add('builder-v2__icon-card--active');
        store.set(storeKey, this.getAttribute('data-tilt'));
      });
      return wrap;
    }
    var twoTiltWrap = dom.create('div', 'builder-v2__two-tilt');
    twoTiltWrap.style.display = 'none';
    twoTiltWrap.appendChild(buildTiltRow('Blind 1 tilt location (left blind)', 'blind1Tilt', 'Left'));
    twoTiltWrap.appendChild(buildTiltRow('Blind 2 tilt location (right blind)', 'blind2Tilt', 'Right'));
    container.appendChild(twoTiltWrap);

    var b1Inch = blindWrap.querySelector('[data-blind1-inch]');
    var b1Frac = blindWrap.querySelector('[data-blind1-frac]');
    var b2Readout = blindWrap.querySelector('[data-blind2-readout]');
    populateFractionSelect(b1Frac);

    // Decompose a decimal width into whole inches + nearest eighth fraction.
    function splitInchFrac(value) {
      var inch = Math.floor(value + 0.0001);
      var fr = value - inch;
      var best = fractions.VALUES[0], bd = Math.abs(fractions.VALUES[0] - fr);
      for (var k = 1; k < fractions.VALUES.length; k++) {
        var d = Math.abs(fractions.VALUES[k] - fr);
        if (d < bd) { bd = d; best = fractions.VALUES[k]; }
      }
      return { inch: inch, frac: best };
    }

    // Greys out the eighths that would push a blind past a panel limit and
    // moves a stranded fraction to the nearest allowed one. No-op without limits.
    function limitBlind1Fractions() {
      var lim = twoOnOnePanelLimits();
      if (!lim) return;
      var rng = twoOnOneBlind1Range(fractions.combine(store.get('widthInt'), store.get('widthFrac')), lim);
      var inch = b1Inch.value ? parseInt(b1Inch.value, 10) : null;
      var cur = parseFloat(b1Frac.value) || 0;
      var nearest = null, nearestD = Infinity;
      for (var k = 0; k < b1Frac.options.length; k++) {
        var fv = parseFloat(b1Frac.options[k].value) || 0;
        var ok = inch === null || !rng || (inch + fv >= rng.lo && inch + fv <= rng.hi);
        b1Frac.options[k].disabled = !ok;
        if (ok && Math.abs(fv - cur) < nearestD) { nearestD = Math.abs(fv - cur); nearest = b1Frac.options[k].value; }
      }
      var picked = b1Frac.options[b1Frac.selectedIndex];
      if (nearest !== null && (!picked || picked.disabled)) b1Frac.value = nearest;
    }

    function recomputeBlind2() {
      limitBlind1Fractions();
      var overall = fractions.combine(store.get('widthInt'), store.get('widthFrac'));
      var b1i = b1Inch.value ? parseInt(b1Inch.value, 10) : null;
      var b1f = parseFloat(b1Frac.value) || 0;
      if (b1i === null) { b2Readout.innerHTML = '<option>—</option>'; applySizeRule(); return; }
      store.set('blind1WidthInt', b1i);
      store.set('blind1WidthFrac', b1f);
      var rem = overall - fractions.combine(b1i, b1f);
      if (rem < 0) rem = 0;
      var s = splitInchFrac(rem);
      store.set('blind2WidthInt', s.inch);
      store.set('blind2WidthFrac', s.frac);
      b2Readout.innerHTML = '<option>' + fractions.formatDisplay(s.inch, s.frac) + '</option>';
      // Moving the split changes the widest panel, and the size cap is measured
      // on that panel, so the height range has to be re-judged here.
      applySizeRule();
    }

    // Only Blind 1 widths that keep both blinds inside the limits are offered.
    // b1Target keeps a shopper's split when it still fits, else the even split.
    function seedLimitedBlindWidths(lim, b1Target) {
      var overall = fractions.combine(store.get('widthInt'), store.get('widthFrac'));
      var rng = twoOnOneBlind1Range(overall, lim);
      var vals = [];
      if (rng) {
        for (var i = Math.floor(rng.lo); i <= Math.floor(rng.hi); i++) vals.push(i);
      }
      var def = splitInchFrac(overall / 2);
      if (typeof b1Target === 'number' && rng) {
        var kept = splitInchFrac(b1Target);
        var keptVal = fractions.combine(kept.inch, kept.frac);
        if (keptVal >= rng.lo && keptVal <= rng.hi) def = kept;
      }
      if (rng) {
        var defVal = Math.min(rng.hi, Math.max(rng.lo, fractions.combine(def.inch, def.frac)));
        def = splitInchFrac(defVal);
      }
      populateSelect(b1Inch, vals, 'Select', rng ? def.inch : null);
      b1Frac.value = String(def.frac);
      recomputeBlind2();
    }

    function seedBlindWidths(b1Target) {
      var panelLim = twoOnOnePanelLimits();
      if (panelLim) { seedLimitedBlindWidths(panelLim, b1Target); return; }
      var totalInt = store.get('widthInt') || 0;
      var minB = 6;
      var maxB = Math.max(minB, totalInt - minB);
      var vals = [];
      for (var i = minB; i <= maxB; i++) vals.push(i);
      var def = splitInchFrac(fractions.combine(store.get('widthInt'), store.get('widthFrac')) / 2);
      if (def.inch < minB) def.inch = minB;
      populateSelect(b1Inch, vals, 'Select', def.inch);
      b1Frac.value = String(def.frac);
      recomputeBlind2();
    }

    dom.on(blindWrap, 'change', 'select', recomputeBlind2);
    // Keep the split in sync if the customer goes back and changes the width.
    events.on('size:rebuild', function() {
      if (blindWrap.style.display === 'none') return;
      // A colour change keeps the shopper's Blind 1 where the limits still allow it.
      if (twoOnOnePanelLimits()) seedBlindWidths(fractions.combine(store.get('blind1WidthInt'), store.get('blind1WidthFrac')));
      else seedBlindWidths();
    });

    // Re-split in proportion when the width moves, so the selector, the readout
    // and the emitted panels never fall back to a silent even split.
    function resplitForWidth() {
      if (store.get('headrailOption') !== 'Two on One Headrail') return;
      var lim = twoOnOnePanelLimits();
      var overall = fractions.combine(store.get('widthInt'), store.get('widthFrac'));
      if (!lim || !(overall > 0)) return;
      var b1 = fractions.combine(store.get('blind1WidthInt'), store.get('blind1WidthFrac'));
      var b2 = fractions.combine(store.get('blind2WidthInt'), store.get('blind2WidthFrac'));
      var rng = twoOnOneBlind1Range(overall, lim);
      var fits = rng && b1 >= rng.lo && b1 <= rng.hi && b2 >= lim.min && b2 <= lim.max;
      if (fits && Math.abs((b1 + b2) - overall) < 0.001) return;
      seedBlindWidths((b1 > 0 && b1 + b2 > 0) ? overall * b1 / (b1 + b2) : undefined);
    }
    resplitTwoOnOne = resplitForWidth;
    if (twoOnOnePanelLimits()) {
      // Deferred for the same reason as the width gate below: widthFrac and
      // widthInt arrive as separate sets. The control sets the gap, so it moves the limits.
      var resplitQueued = false;
      store.subscribe(function(key) {
        if (key !== 'widthInt' && key !== 'widthFrac' && key !== 'control') return;
        if (resplitQueued) return;
        resplitQueued = true;
        setTimeout(function() { resplitQueued = false; resplitForWidth(); }, 0);
      });
    }

    dom.on(optionsDiv, 'click', '.builder-v2__icon-card', function() {
      var data = this._headrailData;
      if (!data) return;
      dom.qsa('.builder-v2__icon-card', optionsDiv).forEach(function(c) {
        c.classList.remove('builder-v2__icon-card--active');
      });
      this.classList.add('builder-v2__icon-card--active');
      store.set('headrailOption', data.value);
      // Two on one halves the panel, which is what lifts the size limit.
      applySizeRule();
      store.set('headrailSurcharge', data.surcharge ? headrailSurchargeNow() : 0);
      if (data.value === 'Two on One Headrail') {
        tiltWrap.style.display = 'none';
        blindWrap.style.display = '';
        twoTiltWrap.style.display = hideTilt ? 'none' : '';
        seedBlindWidths();
      } else {
        tiltWrap.style.display = hideTilt ? 'none' : '';
        blindWrap.style.display = 'none';
        twoTiltWrap.style.display = 'none';
      }
      stepElements[8].selectionLabel.textContent = data.label + (data.surcharge > 0 ? ' (+' + Core.formatMoney(data.surcharge) + ')' : '');
      recalculatePrice();
      completeStep(8);
    });

    dom.on(tiltGrid, 'click', '.builder-v2__icon-card', function() {
      var val = this.getAttribute('data-headrail-tilt');
      dom.qsa('.builder-v2__icon-card', tiltGrid).forEach(function(c) {
        c.classList.remove('builder-v2__icon-card--active');
      });
      this.classList.add('builder-v2__icon-card--active');
      store.set('headrailTilt', val);
    });

    // Forced Two-on-One above a width threshold. Mariak cannot build a single
    // headrail past 96in on the Mini families (Warwick 2026-07-03), so when
    // builder_pricing carries headrail_force_2on1_above_w the Standard card is
    // disabled and Two-on-One auto-selects once the ACTUAL width (inches +
    // fraction) exceeds the threshold; 96 flat still allows Standard. Dropping
    // back to or under the threshold re-enables Standard but keeps the
    // customer's current selection. The auto-select goes through the real
    // card click so the surcharge, per-blind width split, per-blind tilt and
    // step completion all follow the normal path.
    {
      var forceAboveW = (pricingData && typeof pricingData.headrail_force_2on1_above_w === 'number')
        ? pricingData.headrail_force_2on1_above_w : null;
      var twoMaxW = twoOnOneMaxWidth();
      /* Run the gate whenever EITHER rule applies. Forced parents have their
         width dropdown capped in renderMountSizeStep so the ceiling is normally
         unreachable there; parents that merely offer 2-on-1 keep their full
         width range and rely on the card being disabled here. */
      var panelLimGate = twoOnOnePanelLimits();
      // The control sets the gap, and the gap moves the panel limits.
      var watchControl = twoOnOneByControl() || !!panelLimGate;
      if (forceAboveW !== null || twoMaxW !== null || watchControl || panelLimGate) {
        // Deferred + coalesced: the size handler and deep-link init write
        // widthFrac and widthInt as separate store.sets, so a synchronous
        // subscriber can observe a fresh fraction against a stale integer.
        // The cordless/motion gates tolerate that (disable/enable settles on
        // the final notification) but this gate CLICKS a card, which commits
        // headrail option, surcharge and step completion - a transient must
        // never trigger it. setTimeout(0) runs after the whole synchronous
        // set batch, so the evaluation only ever sees coherent width state.
        var forceEvalQueued = false;
        var evaluateHeadrailForce = function() {
          forceEvalQueued = false;
          var stdCard = dom.qs('[data-headrail="Standard Headrail"]', optionsDiv);
          var twoCard = dom.qs('[data-headrail="Two on One Headrail"]', optionsDiv);
          if (!stdCard || !twoCard) return;
          var wInt = store.get('widthInt');
          var ctlNow = store.get('control');
          var ctlAllowsTwo = twoOnOneAllowedFor(ctlNow);
          // No width to judge yet: clear the note and the grey-out together, or
          // a colour regrid leaves a dead card with no reason showing.
          if (!wInt) {
            setForceNote('');
            setCardDisabled(stdCard, false);
            setCardDisabled(twoCard, !ctlAllowsTwo);
            if (!ctlAllowsTwo && store.get('headrailOption') === 'Two on One Headrail') stdCard.click();
            return;
          }
          var wActual = fractions.combine(wInt, store.get('widthFrac'));

          /* The two-on-one price depends on the width, so the badge and the
             stored amount have to follow a width change, not just the initial
             render. Free once the width makes it mandatory. */
          var liveAmt = headrailSurchargeNow();
          var twoBadge = twoCard.querySelector('.builder-v2__icon-card-badge');
          if (twoBadge) {
            if (liveAmt > 0) {
              twoBadge.className = 'builder-v2__icon-card-badge';
              twoBadge.textContent = '+' + Core.formatMoney(liveAmt);
            } else {
              twoBadge.className = 'builder-v2__icon-card-badge builder-v2__icon-card-badge--free';
              twoBadge.textContent = 'Included';
            }
          }
          if (store.get('headrailOption') === 'Two on One Headrail' &&
              (store.get('headrailSurcharge') || 0) !== liveAmt) {
            store.set('headrailSurcharge', liveAmt);
            recalculatePrice();
          }

          /* Two-on-One has a hard build ceiling; the force rule is only a
             preference, so the ceiling wins and the force is skipped above it.
             Otherwise a width past both would disable BOTH cards. */
          var ctlMaxW = twoOnOneControlMaxWidth(ctlNow);
          var twoMaxNow = (ctlMaxW !== null) ? ctlMaxW : twoMaxW;
          var overTwoMax = twoMaxNow !== null && wActual > twoMaxNow;
          // A control that cannot split is never forced onto Two-on-One.
          // Nor is a width that cannot be shared inside the per-blind limits.
          var cannotSplit = !!panelLimGate && !twoOnOneBlind1Range(wActual, twoOnOnePanelLimits());
          var disableTwo = overTwoMax || !ctlAllowsTwo || cannotSplit;
          var disableStd = forceAboveW !== null && wActual > forceAboveW && !disableTwo;

          /* Settle both cards' enabled state BEFORE selecting anything.
             click() on a disabled button is a no-op per the HTML spec, so
             choosing first and enabling second would silently drop the
             fallback and leave an unbuildable option selected. */
          setCardDisabled(twoCard, disableTwo);
          setCardDisabled(stdCard, disableStd);
          // disableStd IS "2-on-1 forced by width", so the note tracks it.
          setForceNote(disableStd ? forceNoteMessage(forceAboveW) : '');

          var chosen = store.get('headrailOption');
          if (disableTwo && chosen === 'Two on One Headrail') stdCard.click();
          else if (disableStd && chosen !== 'Two on One Headrail') twoCard.click();
          // Standard is the only answer for this control, so pick it rather than
          // leave the step open. Only while nothing is chosen: the click completes it.
          else if (showHeadrail && pricingData && Array.isArray(pricingData.headrail_2on1_controls) && ctlNow && !ctlAllowsTwo && !disableStd &&
                   !stdCard.classList.contains('builder-v2__icon-card--active') &&
                   !twoCard.classList.contains('builder-v2__icon-card--active')) stdCard.click();
        };
        store.subscribe(function(key) {
          // Control-aware parents re-judge on a control change too, whichever step came first.
          if (key !== 'widthInt' && key !== 'widthFrac' && !(watchControl && key === 'control')) return;
          if (forceEvalQueued) return;
          forceEvalQueued = true;
          setTimeout(evaluateHeadrailForce, 0);
        });
      }
    }
  }

  // Byte-exact legacy Headrail Details. Standard is order-proven (fdb61279);
  // Two-on-One uses the customer's per-blind widths + per-blind tilt choices
  // (defaults Left / Right preserve the previously hardcoded bytes) and is
  // confirmed by the planned Mariak test order. Hardwood prepends the
  // "Tilt Type: Wand" segment via pricingData.headrail_tilt_type.
  function buildHeadrailDetails(state, widthDisplay) {
    var prefix = (pricingData && pricingData.headrail_tilt_type)
      ? ('Tilt Type: ' + pricingData.headrail_tilt_type + ', ') : '';
    if (state.headrailOption === 'Two on One Headrail') {
      // Use the customer's per-blind widths when present and still summing to
      // the opening; else fall back to an even half/half split (e.g. if the
      // width changed after the headrail step). Self-correcting so the emitted
      // widths always add up to the overall width.
      var overall = fractions.combine(state.widthInt, state.widthFrac);
      var b1 = formatHalfWidth(state.widthInt, state.widthFrac);
      var b2 = b1;
      if (state.blind1WidthInt != null && state.blind2WidthInt != null) {
        var sum = fractions.combine(state.blind1WidthInt, state.blind1WidthFrac || 0) +
                  fractions.combine(state.blind2WidthInt, state.blind2WidthFrac || 0);
        if (Math.abs(sum - overall) < 0.0625) {
          b1 = fractions.formatDisplay(state.blind1WidthInt, state.blind1WidthFrac || 0);
          b2 = fractions.formatDisplay(state.blind2WidthInt, state.blind2WidthFrac || 0);
        }
      }
      // Customer-chosen per-blind tilt (Warwick review 2026-06-13). Defaults
      // are Left / Right, identical to what this string previously hardcoded, so
      // an untouched selection produces a byte-identical Headrail Details value.
      var b1tilt = state.blind1Tilt || 'Left';
      var b2tilt = state.blind2Tilt || 'Right';
      return prefix +
        'Blind 1 Width: ' + b1 + ', Blind 1 Tilt Location: ' + b1tilt + ', ' +
        'Blind 2 Width: ' + b2 + ', Blind 2 Tilt Location: ' + b2tilt;
    }
    var tilt = state.headrailTilt || 'Left';
    return prefix +
      'Blind 1 Width: ' + widthDisplay + ', Blind 1 Tilt Location: ' + tilt;
  }

  // Half-width per blind for Two-on-One, mirroring legacy changeHeadrail:
  // floor(total/2) inches + the nearest eighth fraction (both blinds equal).
  function formatHalfWidth(widthInt, widthFrac) {
    var total = fractions.combine(widthInt, widthFrac);
    if (!total) return '';
    var half = total / 2;
    var inch = Math.floor(half);
    var xD = half - inch;
    if (xD < 0.0001) return inch + '"';
    var decArr = [0.125, 0.25, 0.375, 0.5, 0.625, 0.75, 0.875];
    var fracText = ['1/8', '1/4', '3/8', '1/2', '5/8', '3/4', '7/8'];
    var closest = decArr[0], idx = 0;
    for (var i = 1; i < decArr.length; i++) {
      if (Math.abs(decArr[i] - xD) < Math.abs(closest - xD)) { closest = decArr[i]; idx = i; }
    }
    return inch + ' ' + fracText[idx] + '"';
  }


  /* ============================================================
     HORIZONTAL STEP: PRIVACY OPTIONS (Mini 2" 8g only).
     Appended step index 9. Single mandatory value, emits
     `Privacy Options` = "Standard". show_privacy. No surcharge.
     ============================================================ */
  function renderPrivacyStep(container) {
    var opts = (pricingData && Array.isArray(pricingData.privacy_options) && pricingData.privacy_options.length)
               ? pricingData.privacy_options
               : [{ value: 'Standard', label: 'Standard', desc: 'Standard privacy slat routing' }];

    var optionsDiv = dom.create('div', 'builder-v2__mount-options');
    opts.forEach(function(opt) {
      var value = (typeof opt === 'string') ? opt : opt.value;
      var label = (typeof opt === 'string') ? opt : (opt.label || opt.value);
      var desc  = (typeof opt === 'object' && opt.desc) ? opt.desc : '';
      var card = dom.create('button', 'builder-v2__icon-card');
      card.setAttribute('type', 'button');
      card.setAttribute('data-privacy', value);
      card.innerHTML =
        '<span class="builder-v2__icon-card-label">' + escapeHtml(label) + '</span>' +
        (desc ? '<span class="builder-v2__icon-card-desc">' + escapeHtml(desc) + '</span>' : '');
      card._privacyData = { value: value, label: label };
      optionsDiv.appendChild(card);
    });
    container.appendChild(optionsDiv);

    dom.on(optionsDiv, 'click', '.builder-v2__icon-card', function() {
      var data = this._privacyData;
      if (!data) return;
      dom.qsa('.builder-v2__icon-card', optionsDiv).forEach(function(c) {
        c.classList.remove('builder-v2__icon-card--active');
      });
      this.classList.add('builder-v2__icon-card--active');
      store.set('privacyOption', data.value);
      stepElements[9].selectionLabel.textContent = data.label;
      completeStep(9);
    });
  }


  /* ============================================================
     HORIZONTAL STEP: OPTIONAL HARDWARE (Faux Wood, Mini).
     Appended step index 10. Multi-select, OPTIONAL (auto-completed
     on show; zero selections is valid). Emits `Optional Hardware`
     = the selected component titles, comma-joined. show_hardware. $0.
     ============================================================ */
  function renderHardwareStep(container) {
    var opts = (pricingData && Array.isArray(pricingData.hardware_options)) ? pricingData.hardware_options : [];
    if (!opts.length) return;

    var hint = dom.create('div', 'builder-v2__remote-substep-title');
    hint.textContent = 'Optional add-ons. Select any that apply, or skip.';
    container.appendChild(hint);

    var optionsDiv = dom.create('div', 'builder-v2__mount-options');
    opts.forEach(function(opt) {
      var value = (typeof opt === 'string') ? opt : opt.value;
      var label = (typeof opt === 'string') ? opt : (opt.label || opt.value);
      var desc  = (typeof opt === 'object' && opt.desc) ? opt.desc : '';
      var card = dom.create('button', 'builder-v2__icon-card');
      card.setAttribute('type', 'button');
      card.setAttribute('data-hardware', value);
      // Free hardware can carry the same green Included badge as other free picks.
      var included = (typeof opt === 'object' && opt.included)
        ? '<span class="builder-v2__icon-card-badge builder-v2__icon-card-badge--free">Included</span>' : '';
      card.innerHTML =
        included +
        '<span class="builder-v2__icon-card-label">' + escapeHtml(label) + '</span>' +
        (desc ? '<span class="builder-v2__icon-card-desc">' + escapeHtml(desc) + '</span>' : '');
      card._hardwareData = opt;
      optionsDiv.appendChild(card);
      // A long explanation sits in a note beside a normal-size button instead of stretching it.
      if (typeof opt === 'object' && opt.note) {
        optionsDiv.classList.add('builder-v2__hardware-options--noted');
        var note = dom.create('div', 'builder-v2__mount-notice builder-v2__hardware-note');
        note.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" style="flex-shrink:0"><circle cx="12" cy="12" r="11" stroke="#13548d" stroke-width="2" fill="none"/><text x="12" y="17" text-anchor="middle" font-size="14" font-weight="bold" fill="#13548d">i</text></svg>' +
          '<div>' + escapeHtml(opt.note) + '</div>';
        optionsDiv.appendChild(note);
      }
    });
    container.appendChild(optionsDiv);

    function syncHardwareSelection() {
      var selected = [];
      currentHardwareOpts = [];
      dom.qsa('.builder-v2__icon-card--active', optionsDiv).forEach(function(c) {
        selected.push(c.getAttribute('data-hardware'));
        currentHardwareOpts.push(c._hardwareData);
      });
      store.set('optionalHardware', selected.join(', '));
      stepElements[10].selectionLabel.textContent = selected.length ? selected.join(', ') : 'None';
    }

    dom.on(optionsDiv, 'click', '.builder-v2__icon-card', function() {
      // A gated card is greyed out; ignore clicks on it.
      if (this.hasAttribute('disabled')) return;
      this.classList.toggle('builder-v2__icon-card--active');
      syncHardwareSelection();
    });

    // Per-option control gate, mirroring the flat-surcharge width gate. SWF
    // cannot fit hold downs to a motorized shade; options without the key are untouched.
    var hasControlGate = opts.some(function(o) { return o && Array.isArray(o.disable_for_controls); });
    if (hasControlGate) {
      var applyHardwareControlGate = function() {
        var control = store.get('control');
        var clearedActive = false;
        dom.qsa('.builder-v2__icon-card', optionsDiv).forEach(function(card) {
          var o = card._hardwareData;
          var blocked = !!(control && o && Array.isArray(o.disable_for_controls) &&
                           o.disable_for_controls.indexOf(control) !== -1);
          if (blocked) {
            card.classList.add('builder-v2__icon-card--disabled');
            card.setAttribute('disabled', 'disabled');
            card.setAttribute('aria-disabled', 'true');
            if (card.classList.contains('builder-v2__icon-card--active')) {
              card.classList.remove('builder-v2__icon-card--active');
              clearedActive = true;
            }
          } else {
            card.classList.remove('builder-v2__icon-card--disabled');
            card.removeAttribute('disabled');
            card.removeAttribute('aria-disabled');
          }
        });
        // Drop a now-blocked pick so it cannot ride through to the order.
        if (clearedActive) syncHardwareSelection();
      };
      store.subscribe(function(key) {
        if (key !== 'control') return;
        applyHardwareControlGate();
      });
      applyHardwareControlGate();
    }
  }


  /* ============================================================
     VALANCE LOCK. Disables incompatible valance cards based on the
     active roll direction + control style. Called whenever either
     state changes. If the user already picked a now-locked option,
     auto-resets to a valid alternative + recalculates the price.

     Compatibility matrix (Warwick Round 2 review, 2026-05-12):
       Fascia:               locked by Cordless or Reverse Roll.
       Cassette (fabric):    locked by Reverse Roll. Cordless lock
                             only when per-parent compat array
                             excludes "fabric_insert" (Phase II /
                             Zebra).
       Cassette (no fabric): locked by Motorized or Motorwand
                             (Zebra rule: motor controls require
                             fabric insert). Card only exists on
                             Zebra parents.
     ============================================================ */
  function enforceValanceLock() {
    var isReverse = store.get('rollDirection') === 'reverse';
    var control = store.get('control');
    var isMotorized = control === 'motorized';
    var isMotorwand = control === 'motorwand-left' || control === 'motorwand-right';
    var isCordless = control === 'cordless' || control === 'cordless-tdbu';

    // Per-parent compat array. Phase II Roller/Solar + Zebra set this to
    // ["standard"] so fabric_insert cassette locks under Cordless.
    var cordlessCassetteCompat = (pricingData && Array.isArray(pricingData.cordless_cassette_compat))
                                 ? pricingData.cordless_cassette_compat
                                 : ['standard', 'fabric_insert'];
    var cordlessLocksCassette = isCordless && cordlessCassetteCompat.indexOf('fabric_insert') === -1;

    var fasciaLocked = isCordless || isReverse;
    // Fabric insert cassette: no longer locked by Motorized. Per Round 2,
    // motorized + motorwand are the controls that REQUIRE fabric insert on
    // Zebra; on other families fabric insert remains available on motorized.
    var cassetteLocked = isReverse || cordlessLocksCassette;
    // No-fabric-insert cassette (Zebra only): locked by motorized + motorwand
    // (those controls require fabric insert per Warwick Round 2 spec).
    var cassetteStandardLocked = isReverse || isMotorized || isMotorwand;

    var fasciaCard = dom.qs('[data-valance="fascia"]');
    var cassetteCard = dom.qs('[data-valance="cassette"]');
    var cassetteStandardCard = dom.qs('[data-valance="cassette-standard"]');

    function applyLock(card, locked) {
      if (!card) return;
      if (locked) {
        card.classList.add('builder-v2__icon-card--disabled');
        card.setAttribute('disabled', 'disabled');
        card.setAttribute('aria-disabled', 'true');
      } else {
        card.classList.remove('builder-v2__icon-card--disabled');
        card.removeAttribute('disabled');
        card.removeAttribute('aria-disabled');
      }
    }
    applyLock(fasciaCard, fasciaLocked);
    applyLock(cassetteCard, cassetteLocked);
    applyLock(cassetteStandardCard, cassetteStandardLocked);

    // If the currently selected valance is now locked, reset.
    var currentValance = store.get('valanceType');
    var needsReset = (currentValance === 'fascia' && fasciaLocked) ||
                     (currentValance === 'cassette' && cassetteLocked) ||
                     (currentValance === 'cassette-fabric' && cassetteLocked) ||
                     (currentValance === 'cassette-standard' && cassetteStandardLocked);
    if (needsReset) {
      var noValanceAllowed = !(pricingData && pricingData.valance_options && pricingData.valance_options.show_none === false);
      if (noValanceAllowed) {
        store.set('valanceType', null);
        store.set('valanceLabel', 'No Valance');
        store.set('valancePrice', 0);
        dom.qsa('[data-valance]').forEach(function(c) {
          c.classList.remove('builder-v2__icon-card--active');
        });
        var noValCard = dom.qs('[data-valance="none"]');
        if (noValCard) noValCard.classList.add('builder-v2__icon-card--active');
        stepElements[4].selectionLabel.textContent = 'No Valance';
        recalculatePrice();
      } else {
        // Mandatory-cassette parent (Zebra): pick the still-unlocked cassette
        // option. Cordless -> cassette-standard; motorized/motorwand -> cassette.
        var fallbackSelector = cassetteStandardLocked
          ? '[data-valance="cassette"]'
          : '[data-valance="cassette-standard"]';
        var fallbackCard = dom.qs(fallbackSelector);
        if (fallbackCard && !fallbackCard.hasAttribute('disabled')) {
          dom.qsa('[data-valance]').forEach(function(c) {
            c.classList.remove('builder-v2__icon-card--active');
          });
          fallbackCard.click();
        } else {
          // Edge case: both cassette types locked simultaneously (e.g. Zebra
          // + Reverse Roll + Motorized lock cassette-standard via motor and
          // cassette via reverse roll). No valid valance option remains, so
          // clear state and mark step 5 incomplete so ATC cannot proceed
          // with a locked valance in the cart payload.
          store.set('valanceType', null);
          store.set('valanceLabel', '');
          store.set('valancePrice', 0);
          dom.qsa('[data-valance]').forEach(function(c) {
            c.classList.remove('builder-v2__icon-card--active');
          });
          if (stepElements[4]) {
            stepElements[4].el.classList.remove('builder-v2__step--complete');
            stepElements[4].selectionLabel.textContent = '';
          }
          recalculatePrice();
        }
      }
    }
  }


  /* ============================================================
     STEP 5: CHOOSE VALANCE OPTIONS
     ============================================================ */
  function renderValanceStep(container) {
    var optionsDiv = dom.create('div', 'builder-v2__icon-grid builder-v2__icon-grid--3');
    optionsDiv.setAttribute('data-valance-options', '');

    // Per-parent valance option overrides. Drives Zebra's mandatory cassette
    // structure (no "No Valance", no Fascia, two cassette types) without
    // affecting Mariak / Roller / Solar. Defaults preserve legacy behaviour
    // when the metafield key is absent.
    var valanceOpts = (pricingData && pricingData.valance_options) || {};
    var labelOverrides = (valanceOpts.labels && typeof valanceOpts.labels === 'object') ? valanceOpts.labels : {};
    var descOverrides = (valanceOpts.descs && typeof valanceOpts.descs === 'object') ? valanceOpts.descs : {};
    function labelFor(key, defaultText) {
      return (typeof labelOverrides[key] === 'string' && labelOverrides[key]) ? labelOverrides[key] : defaultText;
    }
    function descFor(key, defaultText) {
      return (typeof descOverrides[key] === 'string' && descOverrides[key]) ? descOverrides[key] : defaultText;
    }
    // Boolean defaults: show_none + show_fascia + show_cassette = true,
    // show_cassette_standard = false.
    function showFlag(name, defaultVal) {
      if (typeof valanceOpts[name] === 'boolean') return valanceOpts[name];
      return defaultVal;
    }

    var options = [];
    if (showFlag('show_none', true)) {
      options.push({ value: null, label: labelFor('none', 'No Valance'), desc: descFor('none', 'Standard open roller'), icon: ICONS.noValance, addonType: null });
    }
    if (showFlag('show_fascia', true)) {
      options.push({ value: 'fascia', label: labelFor('fascia', 'Aluminum Fascia (White)'), desc: descFor('fascia', 'Clean rectangular cover'), icon: ICONS.fascia, addonType: 'fascia' });
    }
    if (showFlag('show_cassette_standard', false)) {
      options.push({ value: 'cassette-standard', label: labelFor('cassette-standard', 'Cassette with No Fabric Insert'), desc: descFor('cassette-standard', 'Standard cassette, no fabric'), icon: ICONS.cassetteStandard, addonType: 'cassette_standard' });
    }
    if (showFlag('show_cassette', true)) {
      options.push({ value: 'cassette', label: labelFor('cassette', 'Fabric Insert Cassette'), desc: descFor('cassette', 'Curved cover with fabric insert'), icon: ICONS.cassette, addonType: 'cassette' });
    }

    // Hide a valance card when the parent's metafield explicitly defines an
    // EMPTY price map for that addon type (e.g. Phase II Roller has no fascia
    // SKU; the JSON has `fascia: {}`). Mariak parents leave valance_pricing
    // undefined entirely, so all 3 cards render. Only skips when the key is
    // present but empty — protects against accidental hide on missing config.
    var valancePricing = pricingData && pricingData.valance_pricing;
    options = options.filter(function(opt) {
      if (!opt.addonType || !valancePricing) return true;
      var addon = valancePricing[opt.addonType];
      if (!addon) return true; // key absent -> render
      // Both array-form ({widths,prices}) and object-form ({"60":44,...}).
      // Empty object {} or empty arrays -> hide.
      if (Array.isArray(addon.widths) && addon.widths.length === 0) return false;
      if (Object.keys(addon).length === 0) return false;
      return true;
    });

    options.forEach(function(opt) {
      var card = dom.create('button', 'builder-v2__icon-card');
      card.setAttribute('type', 'button');
      card.setAttribute('data-valance', opt.value || 'none');

      var priceBadge = '';
      if (opt.addonType) {
        priceBadge = '<span class="builder-v2__icon-card-badge" data-valance-price="' + opt.addonType + '">+$0.00</span>';
      } else {
        priceBadge = '<span class="builder-v2__icon-card-badge builder-v2__icon-card-badge--free">Included</span>';
      }

      card.innerHTML =
        priceBadge +
        '<span class="builder-v2__icon-card-icon">' + opt.icon + '</span>' +
        '<span class="builder-v2__icon-card-label">' + escapeHtml(opt.label) + '</span>' +
        '<span class="builder-v2__icon-card-desc">' + escapeHtml(opt.desc) + '</span>';

      card._valanceData = opt;
      optionsDiv.appendChild(card);
    });

    // Switch the grid to a 2-column layout when only two valance cards
    // render (Zebra: two cassette types, no fascia / no "No Valance").
    // Avoids the orphan empty cell a 3-col grid leaves with 2 cards.
    if (options.length === 2) {
      optionsDiv.classList.remove('builder-v2__icon-grid--3');
      optionsDiv.classList.add('builder-v2__icon-grid--2');
    }

    container.appendChild(optionsDiv);

    // When the parent metafield removes the "No Valance" option (Zebra:
    // mandatory cassette per spec), the first non-locked card is auto-
    // selected so the customer always has a valid valance choice. Round 3:
    // wait until the user picks a control style before auto-selecting, so
    // the green tick on step 5 does not appear on first PDP load. Once
    // control is picked, enforceValanceLock has already applied its locks,
    // so the first non-disabled card is the correct compatibility pick.
    if (!showFlag('show_none', true) && options.length > 0) {
      var autoValanceFired = false;
      store.subscribe(function(key) {
        if (key !== 'control' || autoValanceFired) return;
        if (!store.get('control')) return;
        autoValanceFired = true;
        enforceValanceLock();
        var cards = dom.qsa('.builder-v2__icon-card', optionsDiv);
        for (var i = 0; i < cards.length; i++) {
          if (!cards[i].hasAttribute('disabled')) {
            cards[i].click();
            break;
          }
        }
      });
    }

    // Click handler
    dom.on(optionsDiv, 'click', '.builder-v2__icon-card', function() {
      // Block clicks on disabled cards (locked by reverse roll / motorized)
      if (this.hasAttribute('disabled')) return;

      var data = this._valanceData;
      if (!data) return;

      dom.qsa('.builder-v2__icon-card', optionsDiv).forEach(function(c) {
        c.classList.remove('builder-v2__icon-card--active');
      });
      this.classList.add('builder-v2__icon-card--active');

      var price = 0;
      if (data.addonType && pricing) {
        var w = fractions.combine(store.get('widthInt'), store.get('widthFrac'));
        price = pricing.getAddonPrice(data.addonType, w);
      }

      store.set('valanceType', data.value);
      store.set('valanceLabel', data.label);
      store.set('valancePrice', price);

      stepElements[4].selectionLabel.textContent = data.label;
      completeStep(4);
      recalculatePrice();
    });

    // Update valance prices when width changes
    store.subscribe(function(key) {
      if (key === 'widthInt' || key === 'widthFrac') {
        updateValancePrices();
        // Recalc selected valance price
        var currentType = store.get('valanceType');
        if (currentType && pricing) {
          var w = fractions.combine(store.get('widthInt'), store.get('widthFrac'));
          store.set('valancePrice', pricing.getAddonPrice(currentType, w));
        }
      }
    });

    function updateValancePrices() {
      var w = fractions.combine(store.get('widthInt'), store.get('widthFrac'));
      if (!w || !pricing) return;
      dom.qsa('[data-valance-price]', optionsDiv).forEach(function(el) {
        var type = el.getAttribute('data-valance-price');
        var price = pricing.getAddonPrice(type, w);
        el.textContent = '+' + Core.formatMoney(price);
      });
    }
  }


  /* ============================================================
     SIZE RULE GATE (size_rule families)
     The maximum drop depends on the fabric, the liner and the panel
     width, so it has to be recomputed whenever any of those change.
     Families without size_rule return immediately and keep using
     length_constraints exactly as before.
     ============================================================ */

  // Nearest 1/8" below, rendered the way the rest of the builder writes
  // sizes, so the number in the message is one a shopper can actually order.
  function formatMaxLength(v) {
    var eighths = Math.floor(v * 8) / 8;
    var whole = Math.floor(eighths);
    var frac = eighths - whole;
    var names = { 0: '', 0.125: ' 1/8', 0.25: ' 1/4', 0.375: ' 3/8', 0.5: ' 1/2',
                  0.625: ' 5/8', 0.75: ' 3/4', 0.875: ' 7/8' };
    var f = names[frac];
    return whole + (f === undefined ? '' : f) + '"';
  }

  function currentFabricKey() {
    if (!sizeRule) return null;
    var sku = store.get('colorSku');
    var name = store.get('colorName');
    if (sku && fabricByColor[sku]) return fabricByColor[sku];
    if (name && fabricByColor[name]) return fabricByColor[name];
    return sizeRule.default_fabric || null;
  }

  function currentLinerKey() {
    var v = store.get('linerValue');
    if (v) return v;
    return (sizeRule && sizeRule.default_option) || 'none';
  }

  function currentPanelCount() {
    if (store.get('headrailOption') === 'Two on One Headrail') return 2;
    // Above the force threshold the headrail step auto-selects Two-on-One, but
    // that step sits after Mount & Size, so assume the split here. Otherwise the
    // size rule dead-ends a width the shopper is never allowed to build as one.
    var forceW = (pricingData && typeof pricingData.headrail_force_2on1_above_w === 'number')
                 ? pricingData.headrail_force_2on1_above_w : null;
    if (forceW !== null) {
      var wForce = fractions.combine(store.get('widthInt') || 0, store.get('widthFrac') || 0);
      // Mirrors the headrail gate, so the size rule never assumes a split it will refuse.
      var ctlForce = store.get('control');
      var ctlForceMax = twoOnOneControlMaxWidth(ctlForce);
      var limForce = twoOnOnePanelLimits();
      if (wForce > forceW && twoOnOneAllowedFor(ctlForce) && !(ctlForceMax !== null && wForce > ctlForceMax) &&
          !(limForce && !twoOnOneBlind1Range(wForce, limForce))) return 2;
    }
    return 1;
  }

  // The fabric has to cover the WIDER blind, not the average, so an uneven
  // 2-on-1 split is judged on its widest panel.
  function currentWidestPanelWidth() {
    if (currentPanelCount() < 2) return null;
    var b1 = fractions.combine(store.get('blind1WidthInt') || 0, store.get('blind1WidthFrac') || 0);
    var b2 = fractions.combine(store.get('blind2WidthInt') || 0, store.get('blind2WidthFrac') || 0);
    if (!(b1 > 0) || !(b2 > 0)) return null;
    // A width change does not re-run recomputeBlind2, so a split that no longer
    // sums to the overall width is stale. Same sum guard buildHeadrailDetails
    // uses; fall back to the even split rather than size against old numbers.
    var overall = fractions.combine(store.get('widthInt') || 0, store.get('widthFrac') || 0);
    if (!(overall > 0) || Math.abs((b1 + b2) - overall) > 0.001) return null;
    return Math.max(b1, b2);
  }

  // The note under the size fields. Created lazily so families without a
  // size_rule never get the element at all.
  function sizeRuleNote() {
    if (!stepElements[1] || !stepElements[1].content) return null;
    var el = dom.qs('[data-size-rule-note]', stepElements[1].content);
    if (!el) {
      el = dom.create('div', 'builder-v2__mount-notice');
      el.setAttribute('data-size-rule-note', '');
      el.style.display = 'none';
      // Sits directly under the width and height selects. Appended to the step
      // it landed below MeasureSafe, too far from the field it is about.
      var sizeRow = dom.qs('.builder-v2__size-row', stepElements[1].content);
      if (sizeRow && sizeRow.parentNode) {
        sizeRow.parentNode.insertBefore(el, sizeRow.nextSibling);
      } else {
        stepElements[1].content.appendChild(el);
      }
    }
    return el;
  }

  function applySizeRule() {
    if (!sizeRule) return;
    var heightSel = dom.qs('[data-height-select]');
    var note = sizeRuleNote();
    if (!heightSel || !note) return;

    // Drop a height that can no longer be built and reset everything the size
    // step drives, so the cart can never hold a variant the fabric cannot make.
    function clearHeightSelection() {
      heightSel.value = '';
      var hFracSel = dom.qs('[data-height-frac]');
      if (hFracSel) hFracSel.value = '0';
      store.set('heightFrac', 0);
      store.set('heightInt', null);
      store.set('sizeVariantId', null);
      if (stepElements[1]) {
        stepElements[1].el.classList.remove('builder-v2__step--complete');
        stepElements[1].selectionLabel.textContent = '';
      }
      // The size handler only reprices inside `if (wInt && hInt)`, which no
      // longer holds now the height is gone, so the old price would sit stale.
      recalculatePrice();
      checkBundleReady();
    }

    var widthActual = fractions.combine(store.get('widthInt') || 0, store.get('widthFrac') || 0);
    var fabric = currentFabricKey();
    var linerKey = currentLinerKey();

    // Nothing to judge yet: re-enable every height so the shopper is never
    // left with options disabled by a stale calculation.
    if (!widthActual || !fabric) {
      for (var r = 0; r < heightSel.options.length; r++) heightSel.options[r].disabled = false;
      note.style.display = 'none';
      return;
    }

    var res = Core.sizeLimit(sizeRule, {
      width: widthActual,
      fabric: fabric,
      option: linerKey,
      panels: currentPanelCount(),
      panelWidth: currentWidestPanelWidth()
    });

    if (!res.ok) {
      // Nothing is buildable on any of these paths, so disable every height AND
      // drop one already chosen. Returning without clearing left the step
      // complete and Add to Cart live on a size the factory would reject.
      for (var p2 = 0; p2 < heightSel.options.length; p2++) heightSel.options[p2].disabled = true;
      if (store.get('heightInt')) clearHeightSelection();
      if (res.reason === 'panel_too_wide') {
        note.innerHTML = currentPanelCount() > 1
          ? '<div><strong>One of the two blinds is too wide.</strong> Neither can be over ' +
            formatMaxLength(res.panelMaxWidth) + ', so even the split up between them.</div>'
          : '<div><strong>Too wide for a single blind.</strong> Over ' +
            formatMaxLength(res.panelMaxWidth) + ' wide this has to be made as two blinds on one headrail.</div>';
      } else {
        // Every height is greyed out at this point, so say something rather than
        // leaving a dead dropdown with no explanation.
        console.warn('[BuilderRoller] size_rule could not be evaluated:', res.reason,
                     '(fabric=' + fabric + ', liner=' + linerKey + ')');
        note.innerHTML = '<div><strong>We cannot size this combination.</strong> ' +
          'Please pick a different colour or liner, or contact us and we will sort it.</div>';
      }
      note.style.display = '';
      return;
    }

    var maxLen = res.maxLength;

    // Disable every height above the cap. Compared against the option's own
    // numeric value so a 86" option is disabled when the cap is 85.7".
    for (var i = 0; i < heightSel.options.length; i++) {
      var optVal = parseFloat(heightSel.options[i].value);
      heightSel.options[i].disabled = !isNaN(optVal) && optVal > maxLen;
    }

    // If the height already chosen no longer fits, clear it and reset
    // downstream exactly as the length_constraints branch does, so the cart
    // can never hold a size variant the fabric cannot be made in.
    var hActual = fractions.combine(store.get('heightInt') || 0, store.get('heightFrac') || 0);
    if (hActual && hActual > maxLen) clearHeightSelection();

    // Tell the shopper the limit and, when they are at it, how to get past it.
    // A dead-end list of greyed options loses the sale silently; the ways out
    // are a lighter fabric, dropping the liner, or splitting onto two headrails.
    var linerLabel = store.get('linerLabel');
    // Quote the width the cap was actually measured on: for a 2-on-1 that is
    // one blind, not the whole opening.
    var notedWidth = (res.panelWidth && currentPanelCount() > 1) ? res.panelWidth : widthActual;
    // Warwick's wording, review 1. Reads as a sentence about the shade rather
    // than about the rule, and says WHY the cap exists.
    var context = 'at ' + formatMaxLength(notedWidth) + ' per shade with your selected liner type' +
                  ' due to overall shade weight';
    var msg = '<div><strong>Maximum height ' + formatMaxLength(maxLen) + '</strong> ' + context + '.';
    if (res.basis !== 'fabric') {
      msg += ' If you need more height for your shade, try another fabric option.';
    }
    msg += '</div>';
    note.innerHTML = msg;
    note.style.display = '';
  }


  /* ============================================================
     LINER STEPS (SWF Naturals): TYPE then COLOUR
     Type is answered before size because it is one of the two inputs to
     the size limit (see applySizeRule). Colour carries no price and no
     size effect; it exists so EDI can transmit LINER.COLOR.
     Both steps are inert unless show_liner is true.
     ============================================================ */

  // Currently selected liner option object. Held here rather than in the
  // store because the surcharge has to be recomputed from its price bands
  // every time the width changes.
  var currentLinerOpt = null;

  /**
   * Width-banded liner surcharge. Rounds the width UP into the first band
   * that covers it, the same way the price grid resolves a size, so a 61"
   * shade pays the 72" band exactly as it does everywhere else here.
   * Over the widest band it charges the widest price rather than nothing.
   */
  function linerSurchargeFor(opt, widthActual) {
    if (!opt || !opt.price_bands || !(widthActual > 0)) return 0;
    var bands = opt.price_bands;
    if (!Array.isArray(bands.widths) || !Array.isArray(bands.prices)) return 0;
    // Round UP into the first band that covers this width. Deliberately not
    // routed through the PricingEngine's roundUpToTier: that lives on the
    // prototype and needs an instance, and this must work even if pricing is
    // null. Over the widest band, charge the widest price rather than nothing.
    var idx = bands.prices.length - 1;
    for (var b = 0; b < bands.widths.length; b++) {
      if (widthActual <= bands.widths[b]) { idx = b; break; }
    }
    // The vendor sheets author these two ways. A dense row carries a price in
    // every width column. A sparse row carries a price only where it changes
    // (cordless lift is 3 values across 13 columns) and the value holds until
    // the next one. So if the band we landed on is blank, walk back to the last
    // one that was filled in. Without this a sparse row silently charges zero.
    while (idx > 0 && (bands.prices[idx] === null || bands.prices[idx] === undefined || bands.prices[idx] === '')) {
      idx--;
    }
    var amt = parseFloat(bands.prices[idx]);
    return (amt > 0) ? amt : 0;
  }

  // Valance liner rides on a chosen liner whenever the shade has a valance (anything but VALANCE.TYPE N).
  function valanceLinerFor(opt, widthActual) {
    if (!valanceLinerBands || !(linerSurchargeFor(opt, widthActual) > 0) || !currentValanceSelOpt) return 0;
    var f = valanceSelEdiFields(currentValanceSelOpt, store.get('mount'));
    if (!f || f['VALANCE.TYPE'] === 'N') return 0;
    return linerSurchargeFor({ price_bands: valanceLinerBands }, widthActual);
  }

  // Recompute the surcharge and repaint every card badge for the current
  // width. Called on selection and again whenever the size changes, so the
  // badge always shows what the shopper will actually be charged.
  function refreshLinerUi() {
    if (!showLiner) return;
    var w = fractions.combine(store.get('widthInt') || 0, store.get('widthFrac') || 0);
    var cards = dom.qsa('[data-liner]');
    for (var i = 0; i < cards.length; i++) {
      var opt = cards[i]._linerData;
      var badge = cards[i].querySelector('[data-liner-badge]');
      if (!opt || !badge) continue;
      var amt = Math.round((linerSurchargeFor(opt, w) + valanceLinerFor(opt, w)) * 100) / 100;
      if (amt > 0) {
        badge.textContent = '+' + Core.formatMoney(amt);
        badge.className = 'builder-v2__icon-card-badge';
      } else {
        badge.textContent = w > 0 ? 'Included' : '';
        badge.className = 'builder-v2__icon-card-badge builder-v2__icon-card-badge--free';
      }
    }
    store.set('linerSurcharge', currentLinerOpt
      ? Math.round((linerSurchargeFor(currentLinerOpt, w) + valanceLinerFor(currentLinerOpt, w)) * 100) / 100 : 0);
  }

  // The colour step only makes sense once a liner is actually on the shade.
  // With no liner it is hidden and marked complete so it can never block ATC.
  function syncLinerColorStep() {
    if (!showLiner) return;
    var el = stepElements[18];
    if (!el) return;
    var needsColor = !!(currentLinerOpt && currentLinerOpt.takes_color && linerColors.length);
    if (needsColor) {
      el.el.style.display = '';
      el.el.classList.remove('builder-v2__step--hidden');
      // Show only the colours belonging to the chosen liner. A swatch with no
      // data-liner-for is left visible so a family that does not split its
      // colours by liner is unaffected.
      var want = currentLinerOpt.value;
      var cards = el.el.querySelectorAll('[data-liner-color]');
      for (var _lf = 0; _lf < cards.length; _lf++) {
        var belongs = cards[_lf].getAttribute('data-liner-for');
        var hide = !!(belongs && belongs !== want);
        cards[_lf].style.display = hide ? 'none' : '';
        // A colour that no longer applies cannot stay selected.
        if (hide && cards[_lf].classList.contains('builder-v2__swatch--active')) {
          cards[_lf].classList.remove('builder-v2__swatch--active');
          store.set('linerColorValue', '');
          store.set('linerColorLabel', '');
          el.selectionLabel.textContent = '';
        }
      }
      if (!store.get('linerColorValue')) {
        el.el.classList.remove('builder-v2__step--complete');
        el.selectionLabel.textContent = '';
        // The step just went incomplete, so Add to Cart has to be re-gated or
        // it stays live with no liner colour chosen.
        checkBundleReady();
      }
    } else {
      el.el.style.display = 'none';
      el.el.classList.add('builder-v2__step--hidden');
      el.el.classList.add('builder-v2__step--complete');
      el.selectionLabel.textContent = '';
      store.set('linerColorValue', '');
      store.set('linerColorLabel', '');
      // Drop the highlight with the value, or a re-shown step displays a
      // selection it no longer holds.
      var lcOn = el.el.querySelectorAll('.builder-v2__swatch--active');
      for (var _lc = 0; _lc < lcOn.length; _lc++) lcOn[_lc].classList.remove('builder-v2__swatch--active');
      // Mirror of the un-complete branch: the step just changed completion, so
      // Add to Cart has to be re-gated here as well.
      checkBundleReady();
    }
    // The visible step count just changed, so the digits have to follow.
    // Guarded because this also runs from inside the build loop, before
    // renumberVisibleSteps has anything complete to number.
    if (stepElements.length > 18) renumberVisibleSteps();
  }

  function renderLinerStep(container) {
    if (!linerOptions.length) {
      if (showLiner && stepElements[17]) {
        stepElements[17].el.classList.add('builder-v2__step--complete');
        console.warn('[BuilderRoller] show_liner is on but liner_options is empty; step auto-completed so Add to Cart is never blocked. Author the options array.');
      }
      return;
    }

    var optionsDiv = dom.create('div', 'builder-v2__mount-options');
    linerOptions.forEach(function(opt) {
      var card = dom.create('button', 'builder-v2__icon-card');
      card.setAttribute('type', 'button');
      card.setAttribute('data-liner', opt.value);
      card.innerHTML =
        '<span class="builder-v2__icon-card-badge builder-v2__icon-card-badge--free" data-liner-badge></span>' +
        '<span class="builder-v2__icon-card-label">' + escapeHtml(opt.label) + '</span>' +
        (opt.desc ? '<span class="builder-v2__icon-card-desc">' + escapeHtml(opt.desc) + '</span>' : '');
      card._linerData = opt;
      optionsDiv.appendChild(card);
    });
    container.appendChild(optionsDiv);
    if (linerNote) {
      var lNote = dom.create('div', 'builder-v2__mount-notice builder-v2__mount-notice--below');
      lNote.setAttribute('data-liner-note', '');
      lNote.textContent = linerNote;
      container.appendChild(lNote);
    }

    dom.on(optionsDiv, 'click', '.builder-v2__icon-card', function() {
      var data = this._linerData;
      if (!data) return;
      dom.qsa('.builder-v2__icon-card', optionsDiv).forEach(function(c) {
        c.classList.remove('builder-v2__icon-card--active');
      });
      this.classList.add('builder-v2__icon-card--active');

      currentLinerOpt = data;
      store.set('linerValue', data.value);
      store.set('linerLabel', data.label);
      stepElements[17].selectionLabel.textContent = data.label;
      completeStep(17);

      refreshLinerUi();
      syncLinerColorStep();
      // The liner is half of the size limit, so the allowed drop changes the
      // moment it does. Re-gate the heights and reprice against the new cap.
      applySizeRule();
      recalculatePrice();
    });

    refreshLinerUi();
    syncLinerColorStep();
  }

  function renderLinerColorStep(container) {
    if (!linerColors.length) {
      if (showLiner && stepElements[18]) {
        stepElements[18].el.classList.add('builder-v2__step--complete');
      }
      return;
    }

    var optionsDiv = dom.create('div', 'builder-v2__swatches');
    linerColors.forEach(function(col) {
      var card = dom.create('button', 'builder-v2__swatch');
      card.setAttribute('type', 'button');
      card.setAttribute('data-liner-color', col.value);
      // Which liner this colour belongs to, so the step can hide the ones that
      // do not apply. Privacy and Room Darkening are the SAME five colours with
      // different codes, and offering both sends the factory a liner type and a
      // colour code that contradict each other.
      if (col.liner) card.setAttribute('data-liner-for', col.liner);
      card.setAttribute('title', col.label);
      // Same markup as the colour swatches: image (or an initial-letter
      // placeholder) plus the visible name. The name matters here because the
      // liner colours are Seal / Cocoa / Sand rather than anything guessable
      // from the picture.
      card.innerHTML =
        (col.image
          ? '<img class="builder-v2__swatch-img" src="' + escapeHtml(col.image) + '" alt="' + escapeHtml(col.label) + '" loading="lazy">'
          : '<span class="builder-v2__swatch-img builder-v2__swatch-img--placeholder">' + escapeHtml(String(col.label || '?').charAt(0).toUpperCase()) + '</span>') +
        '<span class="builder-v2__swatch-name">' + escapeHtml(col.label) + '</span>';
      card._linerColorData = col;
      optionsDiv.appendChild(card);
    });
    container.appendChild(optionsDiv);

    // textContent, not innerHTML: the string is merchant copy from a metafield
    // and must never be parsed as markup.
    if (linerColorNote) {
      var lcNote = dom.create('div', 'builder-v2__mount-notice builder-v2__mount-notice--below');
      lcNote.setAttribute('data-liner-color-note', '');
      lcNote.textContent = linerColorNote;
      container.appendChild(lcNote);
    }

    dom.on(optionsDiv, 'click', '.builder-v2__swatch', function() {
      var data = this._linerColorData;
      if (!data) return;
      dom.qsa('.builder-v2__swatch', optionsDiv).forEach(function(c) {
        c.classList.remove('builder-v2__swatch--active');
      });
      this.classList.add('builder-v2__swatch--active');
      store.set('linerColorValue', data.value);
      store.set('linerColorLabel', data.label);
      stepElements[18].selectionLabel.textContent = data.label;
      completeStep(18);
    });
  }


  /* ============================================================
     EDGE BANDING STEPS (SWF Naturals): YES/NO then COLOUR
     Flat surcharge, unlike the width-banded liner. Does not feed the size
     rule, so nothing here re-gates the heights.
     ============================================================ */
  // Shown only once Yes is chosen, mirroring the liner colour step.
  function syncEdgeBandColorStep() {
    if (!showEdgeBand) return;
    var idx = stepIndexOf(renderEdgeBandColorStep);
    var el = idx > -1 ? stepElements[idx] : null;
    if (!el) return;
    var needsColor = !!(currentEdgeBandOpt && currentEdgeBandOpt.takes_color && edgeBandColors.length);
    if (needsColor) {
      el.el.style.display = '';
      el.el.classList.remove('builder-v2__step--hidden');
      if (!store.get('edgeBandColorValue')) {
        el.el.classList.remove('builder-v2__step--complete');
        el.selectionLabel.textContent = '';
        checkBundleReady();
      }
    } else {
      el.el.style.display = 'none';
      el.el.classList.add('builder-v2__step--hidden');
      el.el.classList.add('builder-v2__step--complete');
      el.selectionLabel.textContent = '';
      store.set('edgeBandColorValue', '');
      store.set('edgeBandColorLabel', '');
      var ebOn = el.el.querySelectorAll('.builder-v2__swatch--active');
      for (var _eb = 0; _eb < ebOn.length; _eb++) ebOn[_eb].classList.remove('builder-v2__swatch--active');
      checkBundleReady();
    }
    renumberVisibleSteps();
  }

  function renderEdgeBandStep(container) {
    var selfIdx = stepIndexOf(renderEdgeBandStep);
    if (!edgeBandOptions.length) {
      if (showEdgeBand && selfIdx > -1 && stepElements[selfIdx]) {
        stepElements[selfIdx].el.classList.add('builder-v2__step--complete');
        console.warn('[BuilderRoller] show_edge_banding is on but edge_banding_options is empty; step auto-completed so Add to Cart is never blocked. Author the options array.');
      }
      return;
    }

    var optionsDiv = dom.create('div', 'builder-v2__mount-options');
    edgeBandOptions.forEach(function(opt) {
      var amt = parseFloat(opt.price) || 0;
      var card = dom.create('button', 'builder-v2__icon-card');
      card.setAttribute('type', 'button');
      card.setAttribute('data-edge-banding', opt.value);
      card.innerHTML =
        (amt > 0
          ? '<span class="builder-v2__icon-card-badge">+' + Core.formatMoney(amt) + '</span>'
          : '<span class="builder-v2__icon-card-badge builder-v2__icon-card-badge--free">Included</span>') +
        '<span class="builder-v2__icon-card-label">' + escapeHtml(opt.label) + '</span>' +
        (opt.desc ? '<span class="builder-v2__icon-card-desc">' + escapeHtml(opt.desc) + '</span>' : '');
      card._edgeBandData = opt;
      optionsDiv.appendChild(card);
    });
    container.appendChild(optionsDiv);

    dom.on(optionsDiv, 'click', '.builder-v2__icon-card', function() {
      var data = this._edgeBandData;
      if (!data) return;
      dom.qsa('.builder-v2__icon-card', optionsDiv).forEach(function(c) {
        c.classList.remove('builder-v2__icon-card--active');
      });
      this.classList.add('builder-v2__icon-card--active');

      currentEdgeBandOpt = data;
      store.set('edgeBandValue', data.value);
      store.set('edgeBandLabel', data.label);
      store.set('edgeBandSurcharge', parseFloat(data.price) || 0);
      // Settle the colour step first. This step is last in DOM order, so
      // completing it while the colour step is still hidden-and-complete makes
      // checkBundleReady flash the button ready before the sync undoes it.
      syncEdgeBandColorStep();
      if (selfIdx > -1) {
        stepElements[selfIdx].selectionLabel.textContent = data.label;
        completeStep(selfIdx);
      }
      recalculatePrice();
    });

    syncEdgeBandColorStep();
  }

  function renderEdgeBandColorStep(container) {
    var selfIdx = stepIndexOf(renderEdgeBandColorStep);
    if (!edgeBandColors.length) {
      // Complete THIS step, not the Yes/No one above it, or Yes/No shows a
      // tick with nothing selected and Add to Cart opens with no value stored.
      if (showEdgeBand && selfIdx > -1 && stepElements[selfIdx]) {
        stepElements[selfIdx].el.classList.add('builder-v2__step--complete');
      }
      return;
    }

    var optionsDiv = dom.create('div', 'builder-v2__swatches');
    edgeBandColors.forEach(function(col) {
      var card = dom.create('button', 'builder-v2__swatch');
      card.setAttribute('type', 'button');
      card.setAttribute('data-edge-banding-color', col.value);
      card.setAttribute('title', col.label);
      card.innerHTML =
        (col.image
          ? '<img class="builder-v2__swatch-img" src="' + escapeHtml(col.image) + '" alt="' + escapeHtml(col.label) + '" loading="lazy">'
          : '<span class="builder-v2__swatch-img builder-v2__swatch-img--placeholder">' + escapeHtml(String(col.label || '?').charAt(0).toUpperCase()) + '</span>') +
        '<span class="builder-v2__swatch-name">' + escapeHtml(col.label) + '</span>';
      card._edgeBandColorData = col;
      optionsDiv.appendChild(card);
    });
    container.appendChild(optionsDiv);

    dom.on(optionsDiv, 'click', '.builder-v2__swatch', function() {
      var data = this._edgeBandColorData;
      if (!data) return;
      dom.qsa('.builder-v2__swatch', optionsDiv).forEach(function(c) {
        c.classList.remove('builder-v2__swatch--active');
      });
      this.classList.add('builder-v2__swatch--active');
      store.set('edgeBandColorValue', data.value);
      store.set('edgeBandColorLabel', data.label);
      if (selfIdx > -1) {
        stepElements[selfIdx].selectionLabel.textContent = data.label;
        completeStep(selfIdx);
      }
    });
  }


  /* ============================================================
     ROMAN STEPS: FOLD STYLE + LINING (percent-of-base surcharges)
     ============================================================ */
  // Find a step index by its render function. Titles are NOT unique
  // ("Choose Valance Options" appears twice), so match the function.
  /* ============================================================
     VALANCE SELECTION STEP (SWF Naturals): Standard / Old Style Roman.
     ============================================================ */
  // Some valance options map to different factory codes by mount, so the
  // fields are resolved at Add to Cart against the mount actually picked.
  // EDI wants a bare number, so trim float noise without forcing decimals.
  function ediNum(v) {
    return String(Math.round(v * 10000) / 10000);
  }

  function valanceSelEdiFields(opt, mount) {
    if (!opt) return null;
    var byMount = opt.edi_by_mount;
    if (byMount) {
      var key = mount === 'inside' ? 'Inside' : (mount === 'outside' ? 'Outside' : null);
      var hit = key && (byMount[key] || byMount[key.toLowerCase()]);
      if (hit) return hit;
    }
    return opt.edi || null;
  }

  function renderValanceSelectionStep(container) {
    var selfIdx = stepIndexOf(renderValanceSelectionStep);
    if (!valanceSelOptions.length) {
      if (showValanceSel && selfIdx > -1 && stepElements[selfIdx]) {
        stepElements[selfIdx].el.classList.add('builder-v2__step--complete');
        console.warn('[BuilderRoller] show_valance_selection is on but valance_selection_options is empty; step auto-completed so Add to Cart is never blocked. Author the options array.');
      }
      return;
    }

    var optionsDiv = dom.create('div', 'builder-v2__mount-options');
    valanceSelOptions.forEach(function(opt) {
      var amt = parseFloat(opt.price) || 0;
      var card = dom.create('button', 'builder-v2__icon-card');
      card.setAttribute('type', 'button');
      card.setAttribute('data-valance-selection', opt.value);
      // Icon slot mirrors the Valance Style step. The guard matters: the icon
      // box is a fixed 100px square, so an empty span punches a hole.
      var vsIcon = iconSlotHtml(opt.image || optionIconUrl(optionIcons.valanceSelection, opt.value, null),
                                (opt.icon && ICONS[opt.icon]) || '', opt.label);
      card.innerHTML =
        (amt > 0
          ? '<span class="builder-v2__icon-card-badge">+' + Core.formatMoney(amt) + '</span>'
          : '<span class="builder-v2__icon-card-badge builder-v2__icon-card-badge--free">Included</span>') +
        (vsIcon ? '<span class="builder-v2__icon-card-icon">' + vsIcon + '</span>' : '') +
        '<span class="builder-v2__icon-card-label">' + escapeHtml(opt.label) + '</span>' +
        (opt.desc ? '<span class="builder-v2__icon-card-desc">' + escapeHtml(opt.desc) + '</span>' : '');
      card._valanceSelData = opt;
      optionsDiv.appendChild(card);
    });
    container.appendChild(optionsDiv);

    dom.on(optionsDiv, 'click', '.builder-v2__icon-card', function() {
      var data = this._valanceSelData;
      if (!data) return;
      dom.qsa('.builder-v2__icon-card', optionsDiv).forEach(function(c) {
        c.classList.remove('builder-v2__icon-card--active');
      });
      this.classList.add('builder-v2__icon-card--active');

      currentValanceSelOpt = data;
      store.set('valanceSelValue', data.value);
      store.set('valanceSelLabel', data.label);
      store.set('valanceSelSurcharge', parseFloat(data.price) || 0);
      if (selfIdx > -1) {
        stepElements[selfIdx].selectionLabel.textContent = data.label;
        completeStep(selfIdx);
      }
      if (showLiner) refreshLinerUi();
      recalculatePrice();
    });
  }


  function stepIndexOf(renderFn) {
    for (var i = 0; i < STEPS.length; i++) {
      if (STEPS[i].render === renderFn) return i;
    }
    return -1;
  }

  // Shared renderer for a single-select percent option step (Fold / Lining).
  // Each card shows a "+N%" badge (or "Included" at 0%). Selecting it stores
  // the EDI code + percent; recalculatePrice turns the percent into a dollar
  // surcharge off the current base, charged at ATC via a penny child variant.
  // Upcharge badge text for a percent-of-base option (Soft Fold / Thermal /
  // Blackout). Once the base price is known (size chosen) show the calculated
  // dollar amount the shopper actually pays; before that fall back to the
  // percentage. The Fold/Lining steps are only reachable after size, so the
  // shopper sees the dollar figure. Rounded the same way as the charged
  // surcharge (Math.round(base * pct * 100) / 100) so the badge equals the cart.
  function percentBadgeText(pct) {
    var base = store.get('basePrice') || 0;
    if (base > 0) return '+' + Core.formatMoney(Math.round(base * pct * 100) / 100);
    return '+' + (+(pct * 100).toFixed(2)) + '%';
  }

  function renderPercentStep(container, opts) {
    var options = (pricingData && Array.isArray(pricingData[opts.optionsKey])) ? pricingData[opts.optionsKey] : [];
    if (!options.length) {
      // Shown (show_fold/show_lining true) but no options authored. Auto-complete
      // the step so a half-written config never bricks Add to Cart, and warn so
      // it surfaces in testing. Mirrors the Optional Hardware complete-on-show.
      var emptyIdx = stepIndexOf(opts.render);
      if (emptyIdx >= 0 && stepElements[emptyIdx]) {
        stepElements[emptyIdx].el.classList.add('builder-v2__step--complete');
        stepElements[emptyIdx].selectionLabel.textContent = '';
      }
      // Only warn when the step is actually shown but unauthored. A hidden step
      // legitimately has no options, so warning there fires a false alarm on
      // every family that doesn't use this step.
      if (emptyIdx >= 0 && STEPS[emptyIdx] && !STEPS[emptyIdx].hidden) {
        console.warn('[BuilderRoller] ' + opts.optionsKey + ' is empty but its show flag is on; step auto-completed to avoid blocking Add to Cart. Author the options array.');
      }
      return;
    }
    var gridClass = options.length > 3 ? 'builder-v2__icon-grid builder-v2__icon-grid--4' : 'builder-v2__icon-grid';
    var optionsDiv = dom.create('div', gridClass);

    options.forEach(function(opt) {
      var card = dom.create('button', 'builder-v2__icon-card');
      card.setAttribute('type', 'button');
      card.setAttribute(opts.dataAttr, opt.value);
      var pct = (typeof opt.pct === 'number') ? opt.pct : 0;
      var badge = pct > 0
        ? '<span class="builder-v2__icon-card-badge" data-pct-badge="' + pct + '">' + percentBadgeText(pct) + '</span>'
        : '<span class="builder-v2__icon-card-badge builder-v2__icon-card-badge--free">Included</span>';
      var icon = (opt.icon && ICONS[opt.icon]) || ICONS[opts.fallbackIcon] || '';
      card.innerHTML =
        badge +
        '<span class="builder-v2__icon-card-icon">' + icon + '</span>' +
        '<span class="builder-v2__icon-card-label">' + escapeHtml(opt.label || '') + '</span>' +
        '<span class="builder-v2__icon-card-desc">' + escapeHtml(opt.desc || '') + '</span>';
      card._optData = opt;
      optionsDiv.appendChild(card);
    });
    container.appendChild(optionsDiv);

    // Keep the percent badges showing the live dollar amount as the base
    // price (size) changes, mirroring the banded-control badge subscriber.
    store.subscribe(function(key) {
      if (key !== 'basePrice') return;
      dom.qsa('[data-pct-badge]', optionsDiv).forEach(function(b) {
        var p = parseFloat(b.getAttribute('data-pct-badge')) || 0;
        if (p > 0) b.textContent = percentBadgeText(p);
      });
    });

    var stepIdx = stepIndexOf(opts.render);
    dom.on(optionsDiv, 'click', '.builder-v2__icon-card', function() {
      var data = this._optData;
      if (!data) return;
      dom.qsa('.builder-v2__icon-card', optionsDiv).forEach(function(c) {
        c.classList.remove('builder-v2__icon-card--active');
      });
      this.classList.add('builder-v2__icon-card--active');
      store.set(opts.valueKey, data.value);
      store.set(opts.codeKey, data.code || '');
      store.set(opts.labelKey, data.label || '');
      store.set(opts.pctKey, (typeof data.pct === 'number') ? data.pct : 0);
      // A priced option with no EDI code would charge the surcharge but emit no
      // Fold Style / Liner Options to the factory. Warn so the omission is caught.
      if ((typeof data.pct === 'number' && data.pct > 0) && !data.code) {
        console.warn('[BuilderRoller] ' + opts.optionsKey + ' option "' + (data.label || data.value) +
          '" is priced but has no EDI code; the surcharge will be charged but its EDI spec will not emit.');
      }
      if (stepIdx >= 0) {
        stepElements[stepIdx].selectionLabel.textContent = data.label || '';
        completeStep(stepIdx);
      }
      recalculatePrice();
    });
  }

  function renderFoldStep(container) {
    renderPercentStep(container, {
      optionsKey: 'fold_options', dataAttr: 'data-fold', fallbackIcon: 'foldPlain',
      valueKey: 'foldStyle', codeKey: 'foldCode', labelKey: 'foldLabel', pctKey: 'foldPct',
      render: renderFoldStep
    });
  }

  function renderLiningStep(container) {
    renderPercentStep(container, {
      optionsKey: 'lining_options', dataAttr: 'data-lining', fallbackIcon: 'lining',
      valueKey: 'lining', codeKey: 'liningCode', labelKey: 'liningLabel', pctKey: 'liningPct',
      render: renderLiningStep
    });
  }


  /* ============================================================
     MARIAK VERTICAL STEPS: STACK / VALANCE / EXTRA VANE / CHANNEL PANEL
     ============================================================ */
  // Shared renderer for a flat per-shade surcharge step (Stack, vertical Valance,
  // Extra Vane). Mirrors renderPercentStep but the badge shows the flat dollar
  // amount and each option carries `surcharge` (not `pct`). The dollars charge at
  // ATC through the same penny/dollar denomination children as the Roman percent
  // surcharges. Channel Panel is percent-of-base, so it reuses renderPercentStep.
  function renderFlatSurchargeStep(container, opts) {
    var options = (pricingData && Array.isArray(pricingData[opts.optionsKey])) ? pricingData[opts.optionsKey] : [];
    var idx = stepIndexOf(opts.render);
    if (!options.length) {
      if (idx >= 0 && stepElements[idx]) {
        stepElements[idx].el.classList.add('builder-v2__step--complete');
        stepElements[idx].selectionLabel.textContent = '';
      }
      // Only warn when the step is shown but unauthored; hidden steps have no
      // options by design (see renderPercentStep).
      if (idx >= 0 && STEPS[idx] && !STEPS[idx].hidden) {
        console.warn('[BuilderRoller] ' + opts.optionsKey + ' is empty but its show flag is on; step auto-completed to avoid blocking Add to Cart. Author the options array.');
      }
      return;
    }
    var gridClass = options.length > 3 ? 'builder-v2__icon-grid builder-v2__icon-grid--4' : 'builder-v2__icon-grid';
    var optionsDiv = dom.create('div', gridClass);
    options.forEach(function(opt) {
      var card = dom.create('button', 'builder-v2__icon-card');
      card.setAttribute('type', 'button');
      card.setAttribute(opts.dataAttr, opt.value);
      var sc = (typeof opt.surcharge === 'number') ? opt.surcharge : 0;
      var badge = sc > 0
        ? '<span class="builder-v2__icon-card-badge">+' + Core.formatMoney(sc) + '</span>'
        : '<span class="builder-v2__icon-card-badge builder-v2__icon-card-badge--free">Included</span>';
      var icon = (opt.icon && ICONS[opt.icon]) || (opts.fallbackIcon && ICONS[opts.fallbackIcon]) || '';
      card.innerHTML =
        badge +
        '<span class="builder-v2__icon-card-icon">' + icon + '</span>' +
        '<span class="builder-v2__icon-card-label">' + escapeHtml(opt.label || '') + '</span>' +
        '<span class="builder-v2__icon-card-desc">' + escapeHtml(opt.desc || '') + '</span>';
      card._optData = opt;
      optionsDiv.appendChild(card);
    });
    container.appendChild(optionsDiv);
    dom.on(optionsDiv, 'click', '.builder-v2__icon-card', function() {
      // A gated card is greyed out; ignore clicks on it.
      if (this.hasAttribute('disabled')) return;
      var data = this._optData;
      if (!data) return;
      dom.qsa('.builder-v2__icon-card', optionsDiv).forEach(function(c) {
        c.classList.remove('builder-v2__icon-card--active');
      });
      this.classList.add('builder-v2__icon-card--active');
      store.set(opts.valueKey, data.value);
      store.set(opts.labelKey, data.label || '');
      store.set(opts.surchargeKey, (typeof data.surcharge === 'number') ? data.surcharge : 0);
      if (idx >= 0) {
        stepElements[idx].selectionLabel.textContent = data.label || '';
        completeStep(idx);
      }
      recalculatePrice();
    });

    // Per-option width gate. Any option in these flat-surcharge steps can carry
    // max_w (and optionally min_w) and it greys out once the size goes past what
    // the factory can build. Added for the vertical Square Corner Valance, which
    // Mariak only makes up to 120in wide (Warwick, 4 Aug). Options without those
    // keys are untouched, so every other product behaves exactly as before.
    var hasWidthGate = options.some(function(o) { return o && (o.max_w != null || o.min_w != null); });
    if (hasWidthGate) {
      var applyOptionWidthGate = function() {
        var wInt = store.get('widthInt');
        if (!wInt) return;
        // Test the true fractional width, so 120 1/2in falls out of range while a
        // flat 120in stays available (max_w is an inclusive ceiling).
        var wActual = fractions.combine(wInt, store.get('widthFrac'));
        var clearedActive = false;
        dom.qsa('.builder-v2__icon-card', optionsDiv).forEach(function(card) {
          var o = card._optData;
          if (!o) return;
          var outOfRange = (o.max_w != null && wActual > o.max_w) ||
                           (o.min_w != null && wActual < o.min_w);
          if (outOfRange) {
            card.classList.add('builder-v2__icon-card--disabled');
            card.setAttribute('disabled', 'disabled');
            card.setAttribute('aria-disabled', 'true');
            if (card.classList.contains('builder-v2__icon-card--active')) {
              card.classList.remove('builder-v2__icon-card--active');
              clearedActive = true;
            }
          } else {
            card.classList.remove('builder-v2__icon-card--disabled');
            card.removeAttribute('disabled');
            card.removeAttribute('aria-disabled');
          }
        });
        // If the shopper had already chosen the option that just became
        // unavailable, clear it so the step has to be answered again rather than
        // carrying an unbuildable choice through to the order.
        if (clearedActive) {
          store.set(opts.valueKey, null);
          store.set(opts.labelKey, null);
          store.set(opts.surchargeKey, 0);
          if (idx >= 0) {
            stepElements[idx].selectionLabel.textContent = '';
            stepElements[idx].el.classList.remove('builder-v2__step--complete');
          }
          recalculatePrice();
        }
      };
      store.subscribe(function(key) {
        if (key !== 'widthInt' && key !== 'widthFrac') return;
        applyOptionWidthGate();
      });
      applyOptionWidthGate();
    }
  }

  function renderStackStep(container) {
    renderFlatSurchargeStep(container, {
      optionsKey: 'stack_options', dataAttr: 'data-stack',
      valueKey: 'stackValue', labelKey: 'stackLabel', surchargeKey: 'stackSurcharge',
      render: renderStackStep
    });
  }

  function renderVerticalValanceStep(container) {
    renderFlatSurchargeStep(container, {
      optionsKey: 'vertical_valance_options', dataAttr: 'data-vvalance',
      valueKey: 'verticalValanceValue', labelKey: 'verticalValanceLabel', surchargeKey: 'verticalValanceSurcharge',
      render: renderVerticalValanceStep
    });
  }

  function renderExtraVaneStep(container) {
    renderFlatSurchargeStep(container, {
      optionsKey: 'extra_vane_options', dataAttr: 'data-extravane',
      valueKey: 'extraVaneValue', labelKey: 'extraVaneLabel', surchargeKey: 'extraVaneSurcharge',
      render: renderExtraVaneStep
    });
  }

  // Channel Panel = percent-of-base (White +25%); reuses the Roman percent step.
  function renderChannelPanelStep(container) {
    renderPercentStep(container, {
      optionsKey: 'channel_panel_options', dataAttr: 'data-channelpanel',
      valueKey: 'channelPanelOption', codeKey: 'channelPanelCode', labelKey: 'channelPanelLabel', pctKey: 'channelPanelPct',
      render: renderChannelPanelStep
    });
  }

  // SWF sends one pole up to the threshold width and two above it, and bills per pole.
  function skyPoleQty() {
    var above = skyPoleCfg && skyPoleCfg.two_poles_above_w;
    var w = fractions.combine(store.get('widthInt'), store.get('widthFrac'));
    return (typeof above === 'number' && w > above) ? 2 : 1;
  }

  function skyPoleAmount(opt, qty) {
    return opt ? Math.round(qty * (parseFloat(opt.price) || 0) * 100) / 100 : 0;
  }

  function skyPoleAllowed() {
    var ctl = skyPoleCfg && skyPoleCfg.controls;
    return !Array.isArray(ctl) || ctl.indexOf(store.get('control')) !== -1;
  }

  // Re-run on control and width changes: the step only exists for some lifts,
  // and every badge moves when the pole count does.
  function syncSkyPoleStep() {
    var idx = stepIndexOf(renderSkyPoleStep);
    var el = idx > -1 ? stepElements[idx] : null;
    if (!el) return;
    var allowed = skyPoleAllowed();
    if (!allowed && currentSkyPoleOpt) {
      hiddenSkyPoleOpt = currentSkyPoleOpt;
      currentSkyPoleOpt = null;
      store.set('skyPoleValue', null);
      recalculatePrice();
    } else if (allowed && !currentSkyPoleOpt && hiddenSkyPoleOpt) {
      // recalculatePrice re-derives the pole count from the width in force now.
      currentSkyPoleOpt = hiddenSkyPoleOpt;
      hiddenSkyPoleOpt = null;
      store.set('skyPoleValue', currentSkyPoleOpt.value);
      recalculatePrice();
    }
    var qty = skyPoleQty();
    dom.qsa('.builder-v2__icon-card', el.content).forEach(function(card) {
      var opt = card._skyPoleData;
      if (opt === currentSkyPoleOpt) {
        card.classList.add('builder-v2__icon-card--active');
      } else {
        card.classList.remove('builder-v2__icon-card--active');
      }
      if (!opt) return;
      var amt = skyPoleAmount(opt, qty);
      var badge = card.querySelector('.builder-v2__icon-card-badge');
      if (badge) {
        if (amt > 0) {
          badge.className = 'builder-v2__icon-card-badge';
          badge.textContent = '+' + Core.formatMoney(amt);
        } else {
          badge.className = 'builder-v2__icon-card-badge builder-v2__icon-card-badge--free';
          badge.textContent = 'Included';
        }
      }
      var desc = card.querySelector('.builder-v2__icon-card-desc');
      if (desc) desc.textContent = qty > 1 ? qty + ' poles x ' + Core.formatMoney(parseFloat(opt.price) || 0) : '1 pole';
    });
    el.el.style.display = allowed ? '' : 'none';
    if (allowed) {
      el.el.classList.remove('builder-v2__step--hidden');
    } else {
      el.el.classList.add('builder-v2__step--hidden');
    }
    if (!el.el.classList.contains('builder-v2__step--complete')) {
      el.el.classList.add('builder-v2__step--complete');
      checkBundleReady();
    }
    el.selectionLabel.textContent = currentSkyPoleOpt
      ? (currentSkyPoleOpt.label || currentSkyPoleOpt.value) + ' x ' + qty
      : 'No Sky Pole';
    renumberVisibleSteps();
  }

  function renderSkyPoleStep(container) {
    var selfIdx = stepIndexOf(renderSkyPoleStep);
    // Optional with a "none" default, so it is complete from the start and never blocks Add to Cart.
    if (selfIdx > -1 && stepElements[selfIdx]) {
      stepElements[selfIdx].el.classList.add('builder-v2__step--complete');
    }
    if (!skyPoleOptions.length) {
      console.warn('[BuilderRoller] sky_pole is set but sky_pole.options is empty; step auto-completed so Add to Cart is never blocked. Author the options array.');
      return;
    }
    var cards = [null].concat(skyPoleOptions);
    var gridClass = cards.length > 3 ? 'builder-v2__icon-grid builder-v2__icon-grid--4' : 'builder-v2__icon-grid';
    var optionsDiv = dom.create('div', gridClass);
    cards.forEach(function(opt) {
      var card = dom.create('button', 'builder-v2__icon-card');
      card.setAttribute('type', 'button');
      card.setAttribute('data-sky-pole', opt ? opt.value : 'none');
      var icon = (opt && opt.icon && ICONS[opt.icon]) || '';
      card.innerHTML =
        '<span class="builder-v2__icon-card-badge builder-v2__icon-card-badge--free">Included</span>' +
        (icon ? '<span class="builder-v2__icon-card-icon">' + icon + '</span>' : '') +
        '<span class="builder-v2__icon-card-label">' + escapeHtml(opt ? (opt.label || opt.value) : 'No Sky Pole') + '</span>' +
        '<span class="builder-v2__icon-card-desc"></span>';
      card._skyPoleData = opt;
      optionsDiv.appendChild(card);
    });
    container.appendChild(optionsDiv);

    dom.on(optionsDiv, 'click', '.builder-v2__icon-card', function() {
      hiddenSkyPoleOpt = null;
      currentSkyPoleOpt = this._skyPoleData || null;
      store.set('skyPoleValue', currentSkyPoleOpt ? currentSkyPoleOpt.value : null);
      syncSkyPoleStep();
      recalculatePrice();
    });

    store.subscribe(function(key) {
      if (key === 'control' || key === 'widthInt' || key === 'widthFrac') syncSkyPoleStep();
    });
    syncSkyPoleStep();
  }


  /* ============================================================
     STEP NAVIGATION (ACCORDION)
     ============================================================ */
  function toggleStep(idx) {
    var stepEl = stepElements[idx].el;
    var isActive = stepEl.classList.contains('builder-v2__step--active');
    var isComplete = stepEl.classList.contains('builder-v2__step--complete');

    // Block clicking incomplete future steps (only allow completed or active).
    // Walk the DOM, not the STEPS array: a repositioned step (the liner steps
    // move ahead of Mount & Size) sits at a high array index, so array order
    // would demand every later step be finished before it could ever open.
    if (!isActive && !isComplete) {
      var allPrevComplete = true;
      var prevNode = stepEl.previousElementSibling;
      while (prevNode) {
        if (prevNode.classList &&
            prevNode.classList.contains('builder-v2__step') &&
            !prevNode.classList.contains('builder-v2__step--hidden') &&
            !prevNode.classList.contains('builder-v2__step--complete')) {
          allPrevComplete = false;
          break;
        }
        prevNode = prevNode.previousElementSibling;
      }
      if (!allPrevComplete) return;
    }

    // Toggle this step only. Do not auto-collapse other steps and do
    // not auto-scroll. Per Warwick: customers should keep prior steps
    // open so they can review their measurements and earlier choices
    // while picking the next option, without the page jumping. They
    // can close any step manually by clicking its header again.
    var header = stepEl.querySelector('.builder-v2__step-header');
    if (isActive) {
      stepEl.classList.remove('builder-v2__step--active');
      if (header) header.setAttribute('aria-expanded', 'false');
    } else {
      stepEl.classList.add('builder-v2__step--active');
      if (header) header.setAttribute('aria-expanded', 'true');
    }
  }

  function completeStep(idx) {
    stepElements[idx].el.classList.add('builder-v2__step--complete');
    // No auto-advance to next step. User clicks the next step header
    // manually. Per Warwick: auto-jump pushes users down the page
    // before they're ready (especially on mobile) and prevents
    // browsing colors with the gallery image swap.
    checkBundleReady();
  }


  /* ============================================================
     PRICE RECALCULATION
     ============================================================ */
  function recalculatePrice() {
    var w = fractions.combine(store.get('widthInt'), store.get('widthFrac'));
    var h = fractions.combine(store.get('heightInt'), store.get('heightFrac'));

    var base = 0;
    if (w && h) {
      if (pricing && pricing.getActiveGroup()) {
        // Pricing engine: use WxH matrix
        base = pricing.getBasePrice(w, h);
        // A null cell in an otherwise-present grid means this exact size
        // COMBINATION has no price (e.g. railroaded solar: >94" wide caps at
        // 84" tall, so the wide+tall cells are empty on purpose). Without this
        // flag the base silently became 0, the total showed only the option
        // surcharges (a 103x100 shade "cost" $7.69), and checkout would have
        // half-charged the order. Kay/Phase II case, 20 Jul 2026.
        var tiersPresent = !!(pricing.getActiveGroup().price_tiers || pricing.data.price_tiers);
        store.set('priceUnavailable', tiersPresent && base === null);
        if (base === null) base = 0;
      } else {
        // Fallback: use variant price from the matched size variant
        var variantId = store.get('sizeVariantId');
        if (variantId) {
          var variants = parseSizeVariants();
          for (var i = 0; i < variants.length; i++) {
            if (variants[i].id === variantId) {
              base = variants[i].price;
              break;
            }
          }
        }
      }
    }

    if (!(w && h) || !(pricing && pricing.getActiveGroup())) {
      store.set('priceUnavailable', false);
    }

    store.set('basePrice', base);

    // Roman percent-of-base surcharges: Soft Fold / Thermal Sateen / Premium
    // Blackout are each a percent of the base retail price, additive (Warwick:
    // $100 base + 18% + 25% = $143). 0 for every family that never sets a pct.
    // Charged at checkout via a penny child variant; here they feed the total.
    var foldPct = store.get('foldPct') || 0;
    var liningPct = store.get('liningPct') || 0;
    var foldSurcharge = Math.round(base * foldPct * 100) / 100;
    var liningSurcharge = Math.round(base * liningPct * 100) / 100;
    store.set('foldSurcharge', foldSurcharge);
    store.set('liningSurcharge', liningSurcharge);

    // Mariak vertical: flat Stack / Valance / Extra Vane surcharges (from the step
    // store) + Channel Panel as a percent of base. 0 for every non-vertical family.
    var stackSurcharge = store.get('stackSurcharge') || 0;
    var verticalValanceSurcharge = store.get('verticalValanceSurcharge') || 0;
    var extraVaneSurcharge = store.get('extraVaneSurcharge') || 0;
    var channelPanelPct = store.get('channelPanelPct') || 0;
    var channelPanelSurcharge = Math.round(base * channelPanelPct * 100) / 100;
    store.set('channelPanelSurcharge', channelPanelSurcharge);

    var surcharge = store.get('controlSurcharge') || 0;
    var remoteSurcharge = store.get('remoteSurcharge') || 0;
    var valance = store.get('valancePrice') || 0;
    var oversize = (pricing && w) ? pricing.getOversizeSurcharge(w) : 0;
    store.set('oversizeSurcharge', oversize);

    // Remote Channel surcharge (16-channel +$35.99 on Phase II Motorized)
    // is folded into the per-shade total via controlSurcharge so it flows
    // through the existing calculateTotal -> bundle subtotal path with no
    // additional engine work needed.
    var combinedControlSurcharge = surcharge + remoteSurcharge;
    var headrailSurcharge = store.get('headrailSurcharge') || 0;
    var total = pricing
      ? pricing.calculateTotal({ basePrice: base, controlSurcharge: combinedControlSurcharge, valancePrice: valance, oversizeSurcharge: oversize })
      : Math.round((base + combinedControlSurcharge + valance + oversize) * 100) / 100;
    // Two-on-One headrail surcharge (+$25.04) is the only horizontal-family
    // surcharge; folded into the per-shade total after the base calc so it
    // flows into _BundleSubtotal. 0 for every other product (never set).
    if (headrailSurcharge) {
      total = Math.round((total + headrailSurcharge) * 100) / 100;
    }
    // Liner surcharge (width-banded, SWF Naturals). Folded in the same way so
    // it reaches _BundleSubtotal. 0 for every family that has no liner step.
    var linerSurcharge = store.get('linerSurcharge') || 0;
    if (linerSurcharge) {
      total = Math.round((total + linerSurcharge) * 100) / 100;
    }
    // Edge banding is one flat price, not width banded like the liner.
    var edgeBandSurcharge = store.get('edgeBandSurcharge') || 0;
    if (edgeBandSurcharge) {
      total = Math.round((total + edgeBandSurcharge) * 100) / 100;
    }
    // Valance selection, flat price like the edge banding.
    var valanceSelSurcharge = store.get('valanceSelSurcharge') || 0;
    if (valanceSelSurcharge) {
      total = Math.round((total + valanceSelSurcharge) * 100) / 100;
    }
    // Sky pole is derived here, not stored at click, because the pole count follows the width.
    if (showSkyPole) {
      var skyPoleQtyNow = skyPoleQty();
      var skyPoleSurcharge = skyPoleAmount(currentSkyPoleOpt, skyPoleQtyNow);
      store.set('skyPoleQty', skyPoleQtyNow);
      store.set('skyPoleSurcharge', skyPoleSurcharge);
      if (skyPoleSurcharge) {
        total = Math.round((total + skyPoleSurcharge) * 100) / 100;
      }
    }
    // Fold + lining percent surcharges (Roman) fold into the per-shade total
    // after the base calc so they flow into _BundleSubtotal. 0 for every other
    // family (foldSurcharge / liningSurcharge stay 0).
    if (foldSurcharge || liningSurcharge) {
      total = Math.round((total + foldSurcharge + liningSurcharge) * 100) / 100;
    }
    // Mariak vertical surcharges fold into the per-shade total after the base calc
    // so they flow into _BundleSubtotal. 0 for every non-vertical family.
    var verticalAdd = stackSurcharge + verticalValanceSurcharge + extraVaneSurcharge + channelPanelSurcharge;
    if (verticalAdd) {
      total = Math.round((total + verticalAdd) * 100) / 100;
    }

    // MeasureSafe, 2-Day Air, Motorwand Charger are PER-SHADE (multiplied by
    // qty in display + ATC). Smart Hub is ONE-PER-CART (added once after the
    // qty multiplier — ATC pushes Smart Hub child at quantity:1).
    // Prices are read from pricingData.addon_prices metafield with safe
    // defaults matching the legacy literals so Mariak parents are unaffected.
    // A null metafield value forces the feature off entirely (e.g. 2-Day Air
    // is null on Phase II parents because the supplier does not support it).
    var msCents = getAddonCents('measuresafe_cents', 999);
    var shipCents = getAddonCents('two_day_air_cents', 4000);
    var chargerCents = getAddonCents('motorwand_charger_cents', 1499);
    var smartHubCents = getAddonCents('smart_hub_cents', 11200);
    var msPrice = (store.get('measuresafe') && msCents != null) ? msCents / 100 : 0;
    var shipPrice = (store.get('shippingUpgrade') && shipCents != null) ? shipCents / 100 : 0;
    var motorwandChargerPrice = (store.get('motorwandCharger') && chargerCents != null) ? chargerCents / 100 : 0;
    var smartHubPrice = (store.get('smartHub') && smartHubCents != null) ? smartHubCents / 100 : 0;
    var perShadeAddons = msPrice + shipPrice + motorwandChargerPrice;
    var totalWithAddons = Math.round((total + perShadeAddons) * 100) / 100;
    store.set('totalPrice', total); // store raw total WITHOUT add-ons for cart line

    // Update DOM — show per-unit and total with qty multiplier
    var qty = store.get('quantity') || 1;
    var lineTotal = Math.round((totalWithAddons * qty + smartHubPrice) * 100) / 100;

    var priceEl = dom.qs('[data-total-price]');
    if (priceEl) priceEl.textContent = Core.formatMoney(lineTotal);

    var perUnitEl = dom.qs('[data-price-per-unit]');
    if (perUnitEl) {
      perUnitEl.textContent = qty > 1 ? '(' + qty + ' x ' + Core.formatMoney(total) + ' each)' : '';
    }

    var displayEl = dom.qs('[data-price-value]');
    // An unpriced size would otherwise show the surcharges alone as the price.
    if (displayEl && total > 0 && !store.get('priceUnavailable')) {
      // Top "Starting at" mirrors the per-shade total + per-shade addons
      // (MeasureSafe, Motorwand Charger, 2-Day Air upgrade). Matches the
      // bottom Your Price for the common qty=1 case so the two figures
      // visibly agree. Smart Hub is once-per-cart and the quantity
      // multiplier is line-level, so neither is folded in here.
      // The Spend & Save card is the headline price, so it follows the quantity like the bar total.
      var topAmount = ssMode ? lineTotal : totalWithAddons;
      displayEl.textContent = Core.formatMoney(topAmount);
      if (ssMode) syncSsAffirm(topAmount);
    }
    // Once a real size is priced, the top label names that size instead of the starting one.
    var sizeLabelEl = dom.qs('[data-price-size]');
    if (sizeLabelEl && displayEl && total > 0 && base > 0) {
      sizeLabelEl.textContent = 'for ' + (ssMode && qty > 1 ? qty + ' at ' : '') + fractions.formatDisplay(store.get('widthInt'), store.get('widthFrac')) +
        ' x ' + fractions.formatDisplay(store.get('heightInt'), store.get('heightFrac'));
      var fromLabelEl = dom.qs('[data-price-from]');
      if (fromLabelEl) fromLabelEl.hidden = true;
    }

    // Compare At MSRP. Multiplier comes from the parent product's
    // compare_at_price / price ratio. Builder applies that ratio to the
    // calculated total so the strikethrough scales with size and options.
    if (!store.get('priceUnavailable')) renderMsrp('top', total);
    renderMsrp('bottom', lineTotal);

    // Mobile sticky ATC price
    var atcPriceEl = dom.qs('[data-atc-price]');
    if (atcPriceEl) {
      atcPriceEl.textContent = lineTotal > 0 ? Core.formatMoney(lineTotal) : '';
    }

    // Show price bar as soon as we have any calculated price (not waiting for all steps)
    var priceBar = dom.qs('[data-price-bar]');
    if (priceBar) {
      priceBar.style.display = (base > 0) ? '' : 'none';
    }

    // Show 2-Day Air upgrade once price is visible AND the parent metafield
    // declares a 2-day-air price. Phase II parents set two_day_air_cents to
    // null (Warwick spec: the supplier does not support 2-Day Air on Phase II
    // products yet, pending LogicBroker confirmation). When null, the card
    // stays hidden so the customer cannot tick an inert checkbox.
    var shipUpgradeEl = dom.qs('[data-shipping-upgrade]');
    if (shipUpgradeEl) {
      var twoDayCents = getAddonCents('two_day_air_cents', 4000);
      shipUpgradeEl.style.display = (base > 0 && twoDayCents != null) ? '' : 'none';
    }

    events.emit('price:update', { base: base, total: total });
  }


  /* ============================================================
     BUNDLE READINESS CHECK
     ============================================================ */
  var wasReady = false;
  function checkBundleReady() {
    // All 5 steps must be completed
    var allComplete = true;
    for (var i = 0; i < stepElements.length; i++) {
      if (!stepElements[i].el.classList.contains('builder-v2__step--complete')) {
        allComplete = false;
        break;
      }
    }

    // Must also have a valid size variant.
    // Safety net: if every step is complete but no anchor variant has been
    // resolved (edge case where the size block has no usable products and
    // the tier lookup never ran), force-set the parent product variant as
    // the cart anchor. The anchor is just a placeholder - the real price
    // and dimensions ride on line item properties for LogicBroker EDI.
    if (allComplete && !store.get('sizeVariantId') && parentData && parentData.variant_id) {
      console.warn('[BuilderRoller] No size variant resolved - using parent variant as anchor');
      store.set('sizeVariantId', parentData.variant_id);
    }
    var hasVariant = !!store.get('sizeVariantId');
    // Never sell a size the grid cannot price: block the cart and route the
    // customer to a quote instead of half-charging option surcharges.
    var priceUnavailable = !!store.get('priceUnavailable');
    var ready = allComplete && hasVariant && !priceUnavailable;

    var atcBtn = dom.qs('[data-atc-btn]');
    if (atcBtn) {
      atcBtn.disabled = !ready;
      if (priceUnavailable) {
        var atcTextQ = atcBtn.querySelector('[data-atc-text]');
        if (atcTextQ) atcTextQ.textContent = 'This Size Needs a Quote - Call 1-800-355-2546';
      } else if (ready) {
        var atcText = atcBtn.querySelector('[data-atc-text]'); if (atcText) atcText.textContent = 'Add to Cart';
      } else {
        // Find first incomplete step to guide the customer
        // Walk the DOM, matching toggleStep, or the button can name a step
        // the gate refuses to open because another one comes first on screen.
        var nextStep = '';
        var gNodes = stepsContainer.children;
        for (var j = 0; j < gNodes.length; j++) {
          var gNode = gNodes[j];
          if (!gNode.classList || !gNode.classList.contains('builder-v2__step')) continue;
          if (gNode.classList.contains('builder-v2__step--hidden')) continue;
          if (gNode.classList.contains('builder-v2__step--complete')) continue;
          for (var g2 = 0; g2 < stepElements.length; g2++) {
            if (stepElements[g2].el === gNode) { nextStep = STEPS[g2].title; break; }
          }
          break;
        }
        var atcText = atcBtn.querySelector('[data-atc-text]'); if (atcText) atcText.textContent = nextStep ? 'Complete: ' + nextStep : 'Add to Cart';
      }

      // Task 5f: one-time attention pulse on the false→true transition.
      // Triggers only when the user just finished the last step and the
      // button becomes actionable, never on subsequent recalcs.
      if (ready && !wasReady) {
        var reduceMotion = window.matchMedia &&
          window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (!reduceMotion) {
          atcBtn.classList.add('builder-v2__atc-btn--ready');
          setTimeout(function() {
            atcBtn.classList.remove('builder-v2__atc-btn--ready');
          }, 600);
        }
      }
    }
    wasReady = ready;

    if (ready) {
      events.emit('bundle:ready', { valid: true });
    }
  }


  // A Two-on-One split outside the panel limits never reaches the cart. A fixable
  // one is re-split on screen so the shopper sees the widths before a second click.
  function twoOnOneSplitSendable() {
    var lim = twoOnOnePanelLimits();
    if (!lim || store.get('headrailOption') !== 'Two on One Headrail') return true;
    var overall = fractions.combine(store.get('widthInt'), store.get('widthFrac'));
    var rng = twoOnOneBlind1Range(overall, lim);
    var b1 = fractions.combine(store.get('blind1WidthInt'), store.get('blind1WidthFrac'));
    var b2 = fractions.combine(store.get('blind2WidthInt'), store.get('blind2WidthFrac'));
    if (rng && b1 >= rng.lo && b1 <= rng.hi && b2 >= lim.min && b2 <= lim.max &&
        Math.abs((b1 + b2) - overall) < 0.001) return true;
    // Named on the 1/8in grid the selector offers, so 9 3/16 reads as 9 1/4.
    var minText = formatMaxLength(Math.ceil(lim.min * 8 - 1e-6) / 8);
    var limitText = lim.max < Infinity
      ? 'between ' + minText + ' and ' + formatMaxLength(lim.max) + ' wide'
      : 'at least ' + minText + ' wide';
    if (!rng) {
      showError('Each blind on a Two on One Headrail must be ' + limitText +
                ', which this width does not allow. Please choose Standard Headrail or change the width.');
      return false;
    }
    if (resplitTwoOnOne) resplitTwoOnOne();
    showError('Each blind on a Two on One Headrail must be ' + limitText +
              '. We have adjusted the split, so please check the blind widths and add to cart again.');
    return false;
  }


  /* ============================================================
     ADD TO CART
     ============================================================ */
  var atcBtn = dom.qs('[data-atc-btn]');
  if (atcBtn) {
    dom.on(atcBtn, 'click', function() {
      if (atcBtn.disabled) return;
      if (!twoOnOneSplitSendable()) return;

      var state = store.get();
      var timestamp = Core.Cart.generateTimestamp();

      // Find size variant
      var sizeVariantId = state.sizeVariantId;
      if (!sizeVariantId) {
        showError('Could not find matching size variant. Please adjust your dimensions.');
        return;
      }

      // Build display strings
      var widthDisplay = fractions.formatDisplay(state.widthInt, state.widthFrac);
      var heightDisplay = fractions.formatDisplay(state.heightInt, state.heightFrac);

      // Collect child items
      // Each component with a surcharge is added as a child line item with its
      // own Shopify variant at the correct price. This ensures Shopify checkout
      // charges the correct total (sum of variant prices = _BundleSubtotal).
      var childItems = [];
      var childVariantIds = [];
      var childBundleProps = {
        'Bundle': parentData.title,
        '_BundleHandle': parentData.handle,
        '_Timestamp': timestamp
      };

      // Charge an exact surcharge amount as one or more bundle child lines.
      // Prefer the dedicated mapped variant (it is also the EDI marker); when no
      // variant is mapped for this exact amount (e.g. a control/cordless/valance
      // price that is not present in the surcharge island), fall back to the $1 +
      // $0.01 denomination variants so the surcharge shown on the PDP and cart is
      // actually collected at checkout instead of silently dropping. Same
      // mechanism as the fold/lining denomination block below.
      // denomDollar/denomPenny let a caller route its denomination fallback to a
      // type-named product so the checkout line reads e.g. "Valance Options
      // Upgrade" instead of the shared "Control Style Upgrade" (Warwick
      // 2026-07-11). Omit them to use the shared dollar/penny.
      // One child line per non-zero digit ($100 + $70 + $3 + $0.90 + $0.08) so a
      // surcharge is a handful of single items, not hundreds of $1/$0.01 units.
      function splitDigits(cents, map) {
        if (!map || !(cents > 0)) return null;
        var out = [], top = Math.floor(cents / 100000), rest = cents % 100000;
        if (top > 0) {
          if (top <= 9 && map[top * 100000]) out.push([map[top * 100000], 1, top * 100000]);
          else if (map[100000]) out.push([map[100000], top, 100000]);
          else return null;
        }
        var places = [10000, 1000, 100, 10, 1];
        for (var i = 0; i < places.length; i++) {
          var d = Math.floor(rest / places[i]) % 10;
          if (!d) continue;
          if (!map[d * places[i]]) return null;
          out.push([map[d * places[i]], 1, d * places[i]]);
        }
        var sum = 0;
        for (var j = 0; j < out.length; j++) sum += out[j][1] * out[j][2];
        return sum === cents ? out : null;
      }

      function pushSurchargeChild(mappedVariantId, amountDollars, label, denomDollar, denomPenny) {
        if (mappedVariantId) {
          childItems.push({ variantId: mappedVariantId, quantity: state.quantity, properties: childBundleProps });
          childVariantIds.push(mappedVariantId);
          return;
        }
        if (!(amountDollars > 0)) return;
        var cents = Math.round(amountDollars * 100);
        var dollarUnits = Math.floor(cents / 100);
        var centUnits = cents % 100;
        var dVar = denomDollar || (surchargeVariants && surchargeVariants.dollar);
        var pVar = denomPenny || (surchargeVariants && surchargeVariants.penny);
        var digitLines = splitDigits(cents, surchargeVariants && surchargeVariants.digits && surchargeVariants.digits[dVar]);
        if (digitLines) {
          for (var di = 0; di < digitLines.length; di++) {
            childItems.push({ variantId: digitLines[di][0], quantity: digitLines[di][1] * state.quantity, properties: childBundleProps });
            childVariantIds.push(digitLines[di][0]);
          }
          return;
        }
        if (dollarUnits > 0 && dVar) {
          childItems.push({ variantId: dVar, quantity: dollarUnits * state.quantity, properties: childBundleProps });
          childVariantIds.push(dVar);
        }
        if (centUnits > 0 && pVar) {
          childItems.push({ variantId: pVar, quantity: centUnits * state.quantity, properties: childBundleProps });
          childVariantIds.push(pVar);
        }
        if ((dollarUnits > 0 && !dVar) || (centUnits > 0 && !pVar)) {
          console.warn('[BuilderRoller] ' + (label || 'surcharge') + ' $' + amountDollars.toFixed(2) +
            ' has no mapped variant and no $1/$0.01 denomination variant; bundle would undercharge.');
        }
      }

      // Color as child (component product from collection, priced at $0)
      if (state.colorVariantId) {
        childItems.push({
          variantId: state.colorVariantId,
          quantity: state.quantity,
          properties: childBundleProps
        });
        childVariantIds.push(state.colorVariantId);
      }

      // Control style surcharge as child (e.g. cordless $27.92, motorized $129).
      // Named lookup tried first (state.control = "motorwand-left" etc.) so
      // options that share a price (Motorwand Left + Right both at $70.88)
      // can still resolve to distinct variant IDs. Price-keyed fallback keeps
      // legacy Mariak parents working unchanged when surchargeVariants.control
      // only carries price keys ("27.92" -> variantId).
      if (surchargeVariants && state.controlSurcharge > 0 && surchargeVariants.control) {
        var controlNameKey = state.control;
        var controlPriceKey = state.controlSurcharge.toFixed(2);
        // Width-banded control parents (Roman: banded_controls=true) charge by
        // price band; Left/Right share a band so the price-key variant is the
        // correct charge — prefer it over the legacy name-key motorwand variants
        // (fixed-price, used by other families). Every existing parent (no
        // banded_controls flag) keeps name-key-first behaviour unchanged.
        var controlVariantId;
        // A name-key variant bills its own fixed price (cordless-tdbu is $80), so
        // these parents charge the exact amount: price key, else $1/$0.01 units.
        if (pricingData && pricingData.control_charge_by_amount === true) {
          controlVariantId = surchargeVariants.control[controlPriceKey];
        } else if (pricingData && pricingData.banded_controls && surchargeVariants.control[controlPriceKey]) {
          controlVariantId = surchargeVariants.control[controlPriceKey];
        } else {
          controlVariantId = (controlNameKey && surchargeVariants.control[controlNameKey])
                             || surchargeVariants.control[controlPriceKey];
        }
        pushSurchargeChild(controlVariantId, state.controlSurcharge, 'control surcharge (' + controlNameKey + ')',
          surchargeVariants && surchargeVariants.controlDollar, surchargeVariants && surchargeVariants.controlPenny);
      }

      // Roman fold/lining and the Mariak vertical steps have no price-matched
      // variant, so they always charge through the denomination children: whole
      // dollars ($1) + cents ($0.01). The exact amount is billed while per-line
      // quantities stay ~100x smaller and never hit Shopify's 100k-per-line cap
      // at elevated shade quantities. They all fold into _BundleSubtotal; the
      // Fold Style / Liner Options EDI codes ride on the parent props, not these
      // children.
      //
      // These used to be summed into ONE amount charged on the SHARED denomination
      // variants, which live on the master "Control Style Upgrade" product and are
      // titled "Percent Surcharge Dollar"/"Unit". That is what order fdb62133 (a
      // Classic Faux Wood Vertical) showed at checkout: "Control Style Upgrade /
      // Percent Surcharge Dollar" on a product with no control-style upgrade at
      // all. Split so each line reads as the surcharge it actually is (Warwick
      // 2026-07-12).
      //
      // Splitting is safe to the cent: every one of these is already rounded to
      // whole cents at source (Math.round(base * pct * 100) / 100 for the
      // percent ones, config values for the flat ones), so charging them
      // separately sums to exactly the same total as charging them merged. Do NOT
      // fold an unrounded amount into this group or the charge will drift from the
      // displayed price.
      pushSurchargeChild(null, state.verticalValanceSurcharge || 0, 'vertical valance surcharge',
        surchargeVariants && surchargeVariants.valanceDollar, surchargeVariants && surchargeVariants.valancePenny);

      var optionsAmt = (state.foldSurcharge || 0) + (state.liningSurcharge || 0)
        + (state.stackSurcharge || 0) + (state.extraVaneSurcharge || 0)
        + (state.channelPanelSurcharge || 0);
      pushSurchargeChild(null, optionsAmt, 'options surcharge (fold/lining/stack/vane/panel)',
        surchargeVariants && surchargeVariants.optionsDollar, surchargeVariants && surchargeVariants.optionsPenny);

      // Two-on-One headrail surcharge as child (+$25.04). Variant id is
      // per-family (Mini vs Hardwood headrail component), so it reads from
      // pricingData.surcharge_variants.headrail keyed by the headrail option
      // (price-key fallback). Only pushes when Two on One is selected.
      var headrailSV = (pricingData && pricingData.surcharge_variants && pricingData.surcharge_variants.headrail)
                       || (surchargeVariants && surchargeVariants.headrail);
      // Gate on the amount, not the map: headrail has NO key in the shared surcharge
      // island, so a parent missing surcharge_variants.headrail must still fall
      // through to the denomination fallback instead of silently dropping.
      if (state.headrailSurcharge > 0 && state.headrailOption) {
        var headrailVariantId = headrailSV && (headrailSV[state.headrailOption] || headrailSV[state.headrailSurcharge.toFixed(2)]);
        pushSurchargeChild(headrailVariantId, state.headrailSurcharge, 'headrail surcharge',
          surchargeVariants && surchargeVariants.headrailDollar, surchargeVariants && surchargeVariants.headrailPenny);
      }

      // Liner surcharge as child. Price key FIRST, unlike headrail above: this
      // surcharge is width-banded, so a name-keyed variant would collect one
      // fixed amount at every width. Gated on the amount so a parent with no
      // liner map still charges correctly rather than silently dropping.
      var linerSV = (pricingData && pricingData.surcharge_variants && pricingData.surcharge_variants.liner)
                    || (surchargeVariants && surchargeVariants.liner);
      if ((state.linerSurcharge || 0) > 0 && state.linerValue) {
        var linerVariantId = linerSV && (linerSV[state.linerSurcharge.toFixed(2)] || linerSV[state.linerValue]);
        // Falls back to the Options Upgrade denominations, not the bare
        // dollar/penny pair: those belong to "Control Style Upgrade", which
        // reads wrong at checkout on a parent that has no control step.
        pushSurchargeChild(linerVariantId, state.linerSurcharge, 'liner surcharge',
          surchargeVariants && (surchargeVariants.linerDollar || surchargeVariants.optionsDollar),
          surchargeVariants && (surchargeVariants.linerPenny || surchargeVariants.optionsPenny));
      }

      // Edge banding surcharge as child. One flat price, so a name key is safe
      // here in a way it is not for the width-banded liner above.
      var edgeSV = (pricingData && pricingData.surcharge_variants && pricingData.surcharge_variants.edge_banding)
                   || (surchargeVariants && surchargeVariants.edgeBanding);
      if ((state.edgeBandSurcharge || 0) > 0 && state.edgeBandValue) {
        var edgeVariantId = edgeSV && (edgeSV[state.edgeBandValue] || edgeSV[state.edgeBandSurcharge.toFixed(2)]);
        pushSurchargeChild(edgeVariantId, state.edgeBandSurcharge, 'edge banding surcharge',
          surchargeVariants && (surchargeVariants.edgeBandingDollar || surchargeVariants.optionsDollar),
          surchargeVariants && (surchargeVariants.edgeBandingPenny || surchargeVariants.optionsPenny));
      }

      // Valance selection surcharge as child. Flat price, so keying the variant
      // map by option name is safe here the same way it is for edge banding.
      var vsSV = (pricingData && pricingData.surcharge_variants && pricingData.surcharge_variants.valance_selection)
                 || (surchargeVariants && surchargeVariants.valanceSelection);
      if ((state.valanceSelSurcharge || 0) > 0 && state.valanceSelValue) {
        var vsVariantId = vsSV && (vsSV[state.valanceSelValue] || vsSV[state.valanceSelSurcharge.toFixed(2)]);
        pushSurchargeChild(vsVariantId, state.valanceSelSurcharge, 'valance surcharge',
          surchargeVariants && (surchargeVariants.valanceSelectionDollar || surchargeVariants.optionsDollar),
          surchargeVariants && (surchargeVariants.valanceSelectionPenny || surchargeVariants.optionsPenny));
      }

      // Sky pole as child. Price key only: the amount doubles with two poles,
      // so a variant keyed by option name would undercharge.
      if ((state.skyPoleSurcharge || 0) > 0 && state.skyPoleValue) {
        var spSV = (pricingData && pricingData.surcharge_variants && pricingData.surcharge_variants.sky_pole)
                   || (surchargeVariants && surchargeVariants.skyPole);
        pushSurchargeChild(spSV && spSV[state.skyPoleSurcharge.toFixed(2)], state.skyPoleSurcharge, 'sky pole surcharge',
          surchargeVariants && (surchargeVariants.skyPoleDollar || surchargeVariants.optionsDollar),
          surchargeVariants && (surchargeVariants.skyPolePenny || surchargeVariants.optionsPenny));
      }

      // Remote Channel surcharge as child (Motorized parents only — 16-channel
      // option carries +$35.99, 1- and 6-channel options are free and push
      // nothing). Named-key lookup on surchargeVariants.remote keeps the map
      // independent of control surcharge collisions.
      if (surchargeVariants && (state.remoteSurcharge || 0) > 0 && surchargeVariants.remote) {
        var remoteNameKey = state.remoteVariant;
        var remotePriceKey = state.remoteSurcharge.toFixed(2);
        var remoteVariantId = (remoteNameKey && surchargeVariants.remote[remoteNameKey])
                              || surchargeVariants.remote[remotePriceKey];
        pushSurchargeChild(remoteVariantId, state.remoteSurcharge, 'remote channel surcharge',
          surchargeVariants && surchargeVariants.remoteDollar, surchargeVariants && surchargeVariants.remotePenny);
      }

      // Valance surcharge as child (cassette / cassette-standard / fascia,
      // width-based pricing). Each valance type routes to its own
      // surchargeVariants map so Zebra's two cassette types can never
      // resolve to the wrong SKU. When valancePrice is 0 the entire
      // block skips, so a "free" cassette-standard on Zebra never tries
      // to push a child line.
      if (surchargeVariants && state.valancePrice > 0) {
        var valanceMapKey;
        if (state.valanceType === 'cassette' || state.valanceType === 'cassette-fabric') {
          valanceMapKey = 'cassette';
        } else if (state.valanceType === 'cassette-standard') {
          valanceMapKey = 'cassette_standard';
        } else {
          valanceMapKey = 'fascia';
        }
        var valancePriceKey = state.valancePrice.toFixed(2);
        var valanceMap = surchargeVariants[valanceMapKey];
        pushSurchargeChild(valanceMap && valanceMap[valancePriceKey], state.valancePrice, 'valance surcharge (' + valanceMapKey + ')',
          surchargeVariants && surchargeVariants.valanceDollar, surchargeVariants && surchargeVariants.valancePenny);
      }

      // Oversize surcharge as child ($100 flat)
      if (surchargeVariants && state.oversizeSurcharge > 0 && surchargeVariants.oversize) {
        childItems.push({
          variantId: surchargeVariants.oversize,
          quantity: state.quantity,
          properties: childBundleProps
        });
        childVariantIds.push(surchargeVariants.oversize);
      }

      // 2-Day Air shipping upgrade as child. Skip entirely when the parent
      // metafield sets `addon_prices.two_day_air_cents` to null (Phase II
      // products don't support 2-Day Air per Warwick's spec).
      var atcShipPushCents = getAddonCents('two_day_air_cents', 4000);
      if (surchargeVariants && state.shippingUpgrade && surchargeVariants.shipping && atcShipPushCents != null) {
        childItems.push({
          variantId: surchargeVariants.shipping,
          quantity: state.quantity,
          properties: childBundleProps
        });
        childVariantIds.push(surchargeVariants.shipping);
      }

      // Smart Hub ($112, qty:1) is added as a STANDALONE cart line, NOT a
      // bundle child. Reason: cart-template.liquid skips any item with
      // _Timestamp from corrected_subtotal and expects parent _BundleSubtotal
      // (per-unit × qty) to fold the cost in. Encoding $112 as 112/qty per
      // unit hits floating-point rounding when qty doesn't divide 112
      // (qty 3, 6, 7, 9, ...) — cart shows $0.01-0.04 less than checkout
      // charges. Letting Smart Hub stand on its own makes cart-template
      // count its $112 directly. Drops props starting with `_` so cart
      // integrity does not auto-remove or skip it.
      var atcSmartHubPushCents = getAddonCents('smart_hub_cents', 11200);
      if (surchargeVariants && state.smartHub && surchargeVariants.smartHub && atcSmartHubPushCents != null) {
        childItems.push({
          variantId: surchargeVariants.smartHub,
          quantity: 1,
          properties: {
            'Bundle': parentData.title // visual link for the customer; no _Timestamp / _BundleHandle so cart-template counts it
          }
        });
        childVariantIds.push(surchargeVariants.smartHub);
      }
      var atcChargerPushCents = getAddonCents('motorwand_charger_cents', 1499);
      if (surchargeVariants && state.motorwandCharger && surchargeVariants.motorwandCharger && atcChargerPushCents != null) {
        childItems.push({
          variantId: surchargeVariants.motorwandCharger,
          quantity: state.quantity,
          properties: childBundleProps
        });
        childVariantIds.push(surchargeVariants.motorwandCharger);
      }

      // Build parent properties (EDI-compatible keys)
      // Property key names read from block config to match what LogicBroker transforms expect.
      var mountKey = getBlockPropertyKey('Mount', 'Mount Type');
      var bundleIds = Core.Cart.buildBundleIds(sizeVariantId, childVariantIds);
      // Bundle subtotal is per-unit; cart-template multiplies by line qty.
      // Children pushed with `_Timestamp` bundle props are skipped from the
      // cart subtotal — expecting parent _BundleSubtotal to fold them in.
      // Per-shade items add their unit price (cart × qty matches their qty
      // child line). Smart Hub is NOT included here because it is pushed as
      // a standalone cart line without _Timestamp; cart-template counts it
      // directly. This avoids the cents-drift rounding bug at qty 3/6/7/9
      // where 112/qty does not divide cleanly.
      var atcShipCents = getAddonCents('two_day_air_cents', 4000);
      var atcChargerCents = getAddonCents('motorwand_charger_cents', 1499);
      var bundleTotal = state.totalPrice
        + ((state.shippingUpgrade && atcShipCents != null) ? atcShipCents / 100 : 0)
        + ((state.motorwandCharger && atcChargerCents != null) ? atcChargerCents / 100 : 0);

      // EDI emit shape: Phase II shade mappings (9035/9037/9041/9063) read
      // `Control Style` strictly against {Nylon Beaded Chain, Metal Beaded
      // Chain, Motorwand, Cordless, Motorized} and the chain/motorwand
      // location from a separate `Lift Side` property. Mariak's mapping is
      // fuzzy (.includes) so the legacy combined label is fine for Mariak
      // parents. Vendor on parentData drives the branch.
      var EDI_CONTROL = {
        'plastic-chain-left':    { style: 'Nylon Beaded Chain', side: 'Left' },
        'plastic-chain-right':   { style: 'Nylon Beaded Chain', side: 'Right' },
        'stainless-chain-left':  { style: 'Metal Beaded Chain', side: 'Left' },
        'stainless-chain-right': { style: 'Metal Beaded Chain', side: 'Right' },
        'cordless':              { style: 'Cordless',  side: null },
        'motorized':             { style: 'Motorized', side: null },
        'motorwand-left':        { style: 'Motorwand', side: 'Left' },
        'motorwand-right':       { style: 'Motorwand', side: 'Right' },
        'cont-cord-loop-left':   { style: 'Continuous Cord Loop', side: 'Left' },
        'cont-cord-loop-right':  { style: 'Continuous Cord Loop', side: 'Right' }
      };
      var ediEntry = EDI_CONTROL[state.control] || null;
      var isMariakVendor = ((parentData.vendor || '') + '').toLowerCase() === 'mariak';
      // Zebra (sku 9040 / 9085) LogicBroker reads `Lift Cord`, not `Lift Side`,
      // and expects specific value strings — see the Zebra Lift Cord block
      // below. Detection by metafield flag (pricingData.edi_family === 'zebra')
      // keeps the 9040 vs 9085 distinction in data, not a sku-prefix grep.
      var isZebra = !isMariakVendor && !!(pricingData && pricingData.edi_family === 'zebra');
      var controlStyleProp = isMariakVendor || !ediEntry
                             ? (state.controlLabel || '')
                             : ediEntry.style;

      // Cassette Valance EDI value. The valance card label is customer-facing;
      // the EDI feed needs the family-specific answer text (9035 Solar emits
      // YES / NOT SELECTED, 9040 Zebra emits FABRIC WRAPPED / STANDARD). The
      // optional pricingData.valance_options.edi map translates the selected
      // valance type to that answer. When the map is absent the emit falls
      // back to the display label, so Mariak and not-yet-mapped families keep
      // their current behaviour unchanged.
      var valanceKey = state.valanceType ? state.valanceType : 'none';
      var valanceEdiMap = (pricingData && pricingData.valance_options && pricingData.valance_options.edi) || {};
      var cassetteValanceEmit = (typeof valanceEdiMap[valanceKey] === 'string' && valanceEdiMap[valanceKey])
                                ? valanceEdiMap[valanceKey]
                                : (state.valanceLabel || 'None');

      var parentProps = {
        'Bundle': parentData.title,
        '_BundleHandle': parentData.handle,
        '_BundleImg': parentData.featured_image || '',
        '_Timestamp': timestamp,
        '_BundleIds': bundleIds,
        '_BundleSubtotal': bundleTotal.toFixed(2),
        '_BundleCompareSubtotal': (msrpMultiplier > 0 ? Math.round(bundleTotal * msrpMultiplier * 100) / 100 : bundleTotal).toFixed(2),
        '_colorCode': state.colorSku || '',
        'Width': widthDisplay,
        'Height': heightDisplay
      };
      // Control Style + Cassette Valance are roller-family props. Horizontal
      // blinds carry Wand Control / Valance Style / Headrail instead, and their
      // legacy EDI never includes these two. isHorizontal is set only on the
      // horizontal parents, so every existing product keeps both props as-is.
      if (!isHorizontal) {
        parentProps['Control Style'] = controlStyleProp;
        // Verticals carry Valance Style (emitted in the vertical block below),
        // not Cassette Valance, so skip it to keep the cart + EDI clean.
        if (!isVertical) { parentProps['Cassette Valance'] = cassetteValanceEmit; }
      }
      // Roll Direction is only emitted when the roll-direction step is shown
      // (show_roll_direction not false). Families that hide the step (Cellular,
      // Faux Wood, Bamboo / Woven Wood, Pleated, and Zebra) have no roll
      // direction choice, so emitting the hardcoded 'standard' default added an
      // invalid `Roll_Position=S` EDI segment for product codes that have no
      // such field. Phase II (Elizabeth Soper, 2026-05-28) flagged this on
      // Cellular post Builder 2.0 migration. Roller families (Mariak roller,
      // Phase II roller, and Solar roller) leave show_roll_direction absent, so
      // they keep the step visible and still emit here unchanged. Gating on the
      // same flag that hides the step keeps the EDI emit and the UI in lockstep.
      if (!hideRollDirection) {
        parentProps['Roll Direction'] = state.rollDirection === 'standard' ? 'Standard Roll' : 'Reverse Roll';
      }
      parentProps[mountKey] = state.mount === 'inside' ? 'Inside Mount' : 'Outside Mount';
      // Liner (SWF Naturals). Property names follow the human-readable cart
      // convention the LogicBroker mappers already read ('Control Style',
      // 'Cassette Valance'), and both keys are config-driven so the EDI
      // integrator can rename them without a theme deploy. The colour VALUE is
      // whatever liner_colors[].value holds, so the config decides whether the
      // wire carries the four digit code or the name. Emitted only when the
      // liner step is shown, so no other family gains a property.
      if (showLiner) {
        var linerKeyName = (sizeRule && sizeRule.edi_liner_key) || 'Liner';
        var linerOptEdi = currentLinerOpt && currentLinerOpt.edi;
        parentProps[linerKeyName] = (typeof linerOptEdi === 'string' && linerOptEdi)
                                    ? linerOptEdi
                                    : (state.linerLabel || 'None');
        if (state.linerColorValue) {
          var linerColorKeyName = (sizeRule && sizeRule.edi_liner_color_key) || 'Liner Color';
          parentProps[linerColorKeyName] = state.linerColorValue;
        }
      }
      // Edge banding, same config-driven key shape as the liner so the EDI
      // integrator can rename it without a theme deploy.
      if (showEdgeBand) {
        var edgeKeyName = (pricingData && pricingData.edi_edge_banding_key) || 'Edge Banding';
        var edgeOptEdi = currentEdgeBandOpt && currentEdgeBandOpt.edi;
        parentProps[edgeKeyName] = (typeof edgeOptEdi === 'string' && edgeOptEdi)
                                   ? edgeOptEdi
                                   : (state.edgeBandLabel || 'No Edge Banding');
        if (state.edgeBandColorValue) {
          var edgeColorKeyName = (pricingData && pricingData.edi_edge_banding_color_key) || 'Edge Banding Color';
          parentProps[edgeColorKeyName] = state.edgeBandColorValue;
        }
      }
      // Valance selection. The human label goes out first, then the factory
      // fields from the option data, so an explicit EDI key always wins.
      if (showValanceSel) {
        var vsKeyName = (pricingData && pricingData.edi_valance_selection_key) || 'Valance';
        if (state.valanceSelLabel) parentProps[vsKeyName] = state.valanceSelLabel;
        var vsFields = valanceSelEdiFields(currentValanceSelOpt, state.mount);
        if (vsFields) {
          for (var vsK in vsFields) {
            if (Object.prototype.hasOwnProperty.call(vsFields, vsK)) {
              // Underscore keeps raw factory codes out of the cart and checkout.
              // Every other property here is a human label the mapper translates.
              parentProps[vsK.charAt(0) === '_' ? vsK : '_' + vsK] = vsFields[vsK];
            }
          }
        }
      }
      // SC19 takes the sky pole as a quantity field (SKY.POLE6 = 2), so the code stays hidden.
      if (showSkyPole && currentSkyPoleOpt && state.skyPoleValue) {
        var spQty = state.skyPoleQty || 1;
        parentProps['Sky Pole'] = (currentSkyPoleOpt.cart_label || currentSkyPoleOpt.label || currentSkyPoleOpt.value) + ' x ' + spQty;
        var spKey = currentSkyPoleOpt.edi_key;
        if (typeof spKey === 'string' && spKey) parentProps[spKey.charAt(0) === '_' ? spKey : '_' + spKey] = String(spQty);
      }
      // Two on One headrail, per the SNS24 EDI code sheet. Panel widths use the
      // customer's split, self-corrected to half and half if a later width
      // change left it stale, the same rule buildHeadrailDetails applies.
      var mbCfg = pricingData && pricingData.edi_multi_blind;
      if (mbCfg && state.headrailOption) {
        parentProps['Headrail Options'] = state.headrailOption;
        if (state.headrailOption === 'Two on One Headrail') {
          var mbOverall = fractions.combine(state.widthInt, state.widthFrac);
          var mbP1 = mbOverall / 2;
          var mbP2 = mbOverall / 2;
          if (state.blind1WidthInt != null && state.blind2WidthInt != null) {
            var mbA = fractions.combine(state.blind1WidthInt, state.blind1WidthFrac || 0);
            var mbB = fractions.combine(state.blind2WidthInt, state.blind2WidthFrac || 0);
            if (Math.abs((mbA + mbB) - mbOverall) < 0.0625) { mbP1 = mbA; mbP2 = mbB; }
          }
          // Arun 2026-09-12: panels must EXCLUDE the gap, so panel1 + gap +
          // panel2 equals the opening. 108in even split sends 53.75/0.5/53.75.
          var mbGap = (typeof mbCfg.gap1 === 'number') ? mbCfg.gap1 : 0;
          // SWF sets a different gap per mechanism (cordless 3/8, loop 1/2).
          var mbGapByCtl = mbCfg.gap1_by_control;
          if (state.control && mbGapByCtl && typeof mbGapByCtl[state.control] === 'number') mbGap = mbGapByCtl[state.control];
          parentProps['_MULTI.BLIND'] = 'Y';
          parentProps['_BLINDS.PER.HDRL'] = '2';
          parentProps['_PANEL1.WIDTH'] = ediNum(mbP1 - mbGap / 2);
          parentProps['_PANEL2.WIDTH'] = ediNum(mbP2 - mbGap / 2);
          if (mbGap) parentProps['_GAP1'] = ediNum(mbGap);
        }
      }
      // Phase II shade mappings (9037/9041/9063 + 9035 Solar) read the
      // chain / motorwand location from a separate `Lift Side` property.
      // Mariak's controlType/liftPosition both read from `Control Style`
      // via .includes, so the legacy combined label there already encodes
      // L/R and we skip the separate field to avoid noise in the Mariak
      // cart UI.
      if (!isMariakVendor && ediEntry && ediEntry.side) {
        parentProps['Lift Side'] = ediEntry.side;
      }
      // Roman fold style + lining (EDI 9000). Emit the readable LABELS (e.g.
      // 'Soft Fold', 'Thermal Sateen - White') so the cart shows real names and
      // the 9000 LogicBroker mapper maps them to codes (Fold Style -> Model
      // SF/PL/FF via modelType(); Liner Options -> A/B/C/D/F via linerCode()).
      // Only set when the fold/lining steps are shown (Roman), so every other
      // family emits neither.
      if (state.foldLabel) { parentProps['Fold Style'] = state.foldLabel; }
      if (state.liningLabel) { parentProps['Liner Options'] = state.liningLabel; }
      // Zebra (9040/9085) LogicBroker maps `Lift Cord` to Cord_Placement and
      // derives the Cordless / Motorization flags from it, via a fixed lookup
      // table keyed on the exact strings the old builder sent for years. It
      // does not fuzzy-match, so an unknown string falls through to a default.
      // Recognised values: "Left/Right-Continuous Loop System" (standard chain
      // L/R), "Cordless" (sets the Cordless Y/N field to Y), "Motorized",
      // "Motorwand (Left|Right)". Roller (9037/9041/9063) and Solar (9035) read
      // Lift Side instead, so they are unchanged.
      // NOTE: the two metal-chain strings below are NOT yet keys in the 9040
      // table (the old builder never offered metal chain on Zebra), so they
      // fall through until Phase II adds a 9040 entry. Confirm the exact key
      // with Phase II before relying on them for Cord_Placement M / N.
      if (isZebra && state.control) {
        var ZEBRA_LIFT_CORD = {
          'plastic-chain-left':    'Left-Continuous Loop System',
          'plastic-chain-right':   'Right-Continuous Loop System',
          'stainless-chain-left':  'Left-Metal Beaded Chain',
          'stainless-chain-right': 'Right-Metal Beaded Chain',
          'cordless':              'Cordless',
          'motorized':             'Motorized',
          'motorwand-left':        'Motorwand (Left)',
          'motorwand-right':       'Motorwand (Right)'
        };
        if (ZEBRA_LIFT_CORD[state.control]) {
          parentProps['Lift Cord'] = ZEBRA_LIFT_CORD[state.control];
        }
        // Phase II (9040/9085) maps PID*F*ZZ***Cordless=Y/N. Cordless omits
        // Lift Cord (no cord placement); all other control types emit both.
        // Customer-hidden only, as the comment below always intended. The
        // visible copy was sitting in the shopper's own list of choices as
        // "Cordless: N", which reads like a mistake and was raising service
        // tickets (Warwick, 11 Aug). The underscore keeps it off the cart and
        // every order email while staying on the order for us.
        // Safe to hide: the Phase II feed never read this property. It derives
        // Cordless from the Lift Cord line instead
        // (shopify-logicbroker-integration 9040-zebra-roller-shade.js getCordless).
        parentProps['_Cordless'] = state.control === 'cordless' ? 'Y' : 'N';
      }
      if (state.roomName) {
        parentProps['Window Name'] = state.roomName;
      }
      if (state.remoteLabel) {
        parentProps['Remote Control Options (Optional)'] = state.remoteLabel;
      }
      if (state.shippingUpgrade && atcShipCents != null) {
        parentProps['_ShippingUpgrade'] = '2 Day Air';
        parentProps['Shipping'] = '2-Day Air (+' + Core.formatMoney(atcShipCents / 100) + ')';
      }
      // Phase II Zebra (9040/9085): Ship_Via records the shipping lane.
      // 'S' = Standard, '2' = 2-Day Air upgrade.
      // Customer-hidden for the same reason as _Cordless above (Warwick,
      // 11 Aug): "Ship_Via: S" meant nothing to a shopper, and with 2-Day Air
      // switched off it was always 'S' anyway.
      // Safe to hide: the Phase II feed never read this property either. It
      // derives Ship_Via from _ShippingUpgrade
      // (shopify-logicbroker-integration vendors/phase-ii.js shipVia).
      if (isZebra) {
        parentProps['_Ship_Via'] = state.shippingUpgrade ? '2' : 'S';
      }
      // Smart Hub / Motorwand Charger props mirror legacy v1 EDI keys
      // so LogicBroker mapping does not change. Visible to customer in cart.
      if (state.smartHub) {
        parentProps['Smart Hub'] = 'Smart Hub';
      }
      if (state.motorwandCharger) {
        parentProps['Motorwand Charger'] = 'Motorwand Charger';
      }

      // Horizontal-blind EDI props (Mariak label passthrough). Keys + values
      // mirror the exact legacy Builder 1.0 cart properties confirmed against
      // live orders, so LogicBroker fuzzy mapping is unchanged. Each is gated
      // on its own state value, so a family lacking a given step emits nothing.
      if (isHorizontal) {
        if (state.wandControl)     { parentProps['Wand Control']    = state.wandControl; }
        if (state.valanceStyle)    { parentProps['Valance Style']   = state.valanceStyle; }
        if (state.valancePosition) { parentProps['Valance Options'] = state.valancePosition; }
        if (state.headrailOption) {
          parentProps['Headrail Options'] = state.headrailOption;
          parentProps['Headrail Details'] = buildHeadrailDetails(state, widthDisplay);
        }
        if (state.privacyOption)    { parentProps['Privacy Options']   = state.privacyOption; }
      }
      // Outside the horizontal block because cellulars offer hold downs too.
      // Horizontal parents still set it last in their group, so their order is unchanged.
      if (state.optionalHardware) { parentProps['Optional Hardware'] = state.optionalHardware; }
      // Factory field per selected option, underscored like the valance selection fields.
      currentHardwareOpts.forEach(function(hwOpt) {
        if (!hwOpt || typeof hwOpt.edi_key !== 'string' || !hwOpt.edi_key) return;
        var hwKey = hwOpt.edi_key.charAt(0) === '_' ? hwOpt.edi_key : '_' + hwOpt.edi_key;
        parentProps[hwKey] = (typeof hwOpt.edi_value === 'string' && hwOpt.edi_value) ? hwOpt.edi_value : 'Y';
      });

      // Mariak vertical EDI (label passthrough; mariak.js maps each to a code).
      // Gated on isMariakVendor + isVertical + per-state, so non-vertical Mariak
      // families emit nothing new. 'Your Stack' -> STACK, 'Valance Style' ->
      // VALANCE.TYPE, 'Extra Vane' -> ADDL.LVRS, 'Channel Panel' -> CHANNEL.PANEL
      // (only when White is chosen), 'Headrail' -> VAL.BASE.COLOR (white locked).
      if (isMariakVendor && isVertical) {
        if (state.stackValue)           { parentProps['Your Stack'] = state.stackValue; }
        if (state.verticalValanceLabel) { parentProps['Valance Style'] = state.verticalValanceLabel; }
        if (state.extraVaneValue && state.extraVaneValue !== 'None') {
          parentProps['Extra Vane'] = state.extraVaneValue;
        }
        // Emit Channel Panel ONLY for White. The "none" label is non-empty and
        // mariak.pvcBacking() treats any value as 'W', so emitting it on the
        // free-hang choice would wrongly ship a channel panel.
        if (state.channelPanelCode === 'W') {
          parentProps['Channel Panel'] = state.channelPanelLabel;
        }
        // Vertical cellulars take a fabric-matched headrail: a parent relabels it,
        // or drops the property with null / ''. Absent keeps White.
        var verticalHeadrail = (pricingData && Object.prototype.hasOwnProperty.call(pricingData, 'vertical_headrail_label'))
          ? pricingData.vertical_headrail_label : 'White';
        if (typeof verticalHeadrail === 'string' && verticalHeadrail) {
          parentProps['Headrail'] = verticalHeadrail;
        }
      }

      var parentItem = {
        variantId: sizeVariantId,
        quantity: state.quantity,
        properties: parentProps
      };

      // Set loading state
      atcBtn.classList.add('builder-v2__atc-btn--loading');
      var atcText = atcBtn.querySelector('[data-atc-text]'); if (atcText) atcText.textContent = 'Adding to Cart...';
      atcBtn.disabled = true;

      // MeasureSafe: queue as standalone cart line AFTER the bundle,
      // matching old builder pattern (product-builder.js:4031-4054).
      // NOT part of _BundleIds — separate add-on.
      var msItem = null;
      if (state.measuresafe) {
        msItem = {
          variantId: measureSafeVariantId(),
          quantity: state.quantity,
          properties: {
            'Protected Product': parentData.title,
            'Protected Size': widthDisplay + ' x ' + heightDisplay
          }
        };
      }

      Core.Cart.addBundle(parentItem, childItems, { redirect: true, addonItem: msItem })
        .catch(function(err) {
          atcBtn.classList.remove('builder-v2__atc-btn--loading');
          var atcText = atcBtn.querySelector('[data-atc-text]'); if (atcText) atcText.textContent = 'Add to Cart';
          atcBtn.disabled = false;
          showError('Error adding to cart. Please try again.');
        });
    });
  }


  /* ============================================================
     QUANTITY CONTROLS
     ============================================================ */
  var qtyMinus = dom.qs('[data-qty-minus]');
  var qtyPlus = dom.qs('[data-qty-plus]');
  var qtyInput = dom.qs('[data-qty-input]');

  if (qtyMinus && qtyPlus && qtyInput) {
    dom.on(qtyMinus, 'click', function() {
      var val = parseInt(qtyInput.value, 10) || 1;
      if (val > 1) {
        qtyInput.value = val - 1;
        store.set('quantity', val - 1);
        recalculatePrice();
      }
    });

    dom.on(qtyPlus, 'click', function() {
      var val = parseInt(qtyInput.value, 10) || 1;
      qtyInput.value = val + 1;
      store.set('quantity', val + 1);
      recalculatePrice();
    });

    dom.on(qtyInput, 'change', function() {
      var val = parseInt(this.value, 10);
      if (!val || val < 1) val = 1;
      this.value = val;
      store.set('quantity', val);
      recalculatePrice();
    });
  }


  /* ============================================================
     SWATCH ZOOM LIGHTBOX (desktop only)
     ============================================================ */
  function injectSwatchZoomModal() {
    if (document.getElementById('builder-v2-swatch-zoom')) return;
    var modal = document.createElement('div');
    modal.id = 'builder-v2-swatch-zoom';
    modal.className = 'builder-v2__zoom-modal';
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-label', 'Color swatch zoom');
    modal.innerHTML =
      '<div class="builder-v2__zoom-backdrop"></div>' +
      '<div class="builder-v2__zoom-content">' +
        '<button class="builder-v2__zoom-close" type="button" aria-label="Close">&times;</button>' +
        '<img class="builder-v2__zoom-img" src="" alt="" />' +
        '<p class="builder-v2__zoom-name"></p>' +
      '</div>';
    document.body.appendChild(modal);

    modal.querySelector('.builder-v2__zoom-close').addEventListener('click', closeSwatchZoom);
    modal.querySelector('.builder-v2__zoom-backdrop').addEventListener('click', closeSwatchZoom);
  }

  function openSwatchZoom(imageUrl, colorName) {
    var modal = document.getElementById('builder-v2-swatch-zoom');
    if (!modal) return;
    modal.querySelector('.builder-v2__zoom-img').src = imageUrl;
    modal.querySelector('.builder-v2__zoom-img').alt = colorName || '';
    modal.querySelector('.builder-v2__zoom-name').textContent = colorName || '';
    modal.classList.add('builder-v2__zoom-modal--active');
    modal.querySelector('.builder-v2__zoom-close').focus();

    document.addEventListener('keydown', swatchZoomEscHandler);
  }

  function closeSwatchZoom() {
    var modal = document.getElementById('builder-v2-swatch-zoom');
    if (!modal) return;
    modal.classList.remove('builder-v2__zoom-modal--active');
    modal.querySelector('.builder-v2__zoom-img').src = '';
    document.removeEventListener('keydown', swatchZoomEscHandler);
  }

  function swatchZoomEscHandler(e) {
    if (e.key === 'Escape' || e.keyCode === 27) closeSwatchZoom();
  }

  /* ============================================================
     PRE-LOAD COLOR IMAGES
     Deferred to after page load to avoid hurting LCP.
     Only pre-loads product featured images, not every variant.
     ============================================================ */
  (function preloadColorImages() {
    var colorBlock = findColorBlock();
    if (!colorBlock || !colorBlock.products) return;

    function doPreload() {
      colorBlock.products.forEach(function(p) {
        if (p.image) {
          var img = new Image();
          img.src = p.image;
        }
      });
    }

    // Defer until after initial paint
    if ('requestIdleCallback' in window) {
      requestIdleCallback(doPreload);
    } else {
      setTimeout(doPreload, 1000);
    }
  })();


  /* ============================================================
     GALLERY — Thumbnail clicks + Color swap
     ============================================================ */
  var galleryMain = dom.qs('[data-gallery-main]');
  var galleryThumbs = dom.qs('[data-gallery-thumbs]');
  var galleryDots = dom.qs('[data-gallery-dots]');

  if (galleryThumbs && galleryMain) {
    dom.on(galleryThumbs, 'click', '.builder-v2__thumb', function() {
      var idx = parseInt(this.getAttribute('data-thumb-index'), 10);
      goToSlide(idx);
    });
  }

  // Dot clicks → navigate to slide
  if (galleryDots) {
    dom.on(galleryDots, 'click', '.builder-v2__gallery-dot', function() {
      var idx = parseInt(this.getAttribute('data-dot-index'), 10);
      goToSlide(idx);
    });
  }

  // Prev/next arrow clicks - mobile + desktop. Wrap around at the ends so
  // users can keep cycling through the gallery without hitting a dead button.
  function getCurrentSlideIndex() {
    if (!galleryMain) return 0;
    var slides = dom.qsa('.builder-v2__gallery-slide', galleryMain);
    for (var i = 0; i < slides.length; i++) {
      if (slides[i].classList.contains('builder-v2__gallery-slide--active')) {
        return i;
      }
    }
    return 0;
  }

  var prevBtn = dom.qs('[data-gallery-prev]');
  var nextBtn = dom.qs('[data-gallery-next]');
  if (prevBtn && nextBtn && galleryMain) {
    var totalSlides = dom.qsa('.builder-v2__gallery-slide', galleryMain).length;
    dom.on(prevBtn, 'click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      var current = getCurrentSlideIndex();
      var next = current === 0 ? totalSlides - 1 : current - 1;
      goToSlide(next);
    });
    dom.on(nextBtn, 'click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      var current = getCurrentSlideIndex();
      var next = current === totalSlides - 1 ? 0 : current + 1;
      goToSlide(next);
    });
  }

  // Mobile scroll tracking for dots
  if (galleryMain && galleryDots) {
    var scrollTimeout;
    dom.on(galleryMain, 'scroll', function() {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(function() {
        var slides = dom.qsa('.builder-v2__gallery-slide', galleryMain);
        var scrollLeft = galleryMain.scrollLeft;
        var width = galleryMain.offsetWidth;
        var idx = Math.round(scrollLeft / width);
        updateActiveDot(idx);
        updateActiveThumb(idx);
        updateCounter(idx);
      }, 50);
    });
  }

  // Gallery color swap — swaps the hero image (first slide) and first
  // thumbnail to match the selected color's hero image. ONLY fires
  // when the component product has a second image (hero_image) uploaded.
  // If only the swatch image exists, the gallery stays untouched.
  // This prevents swatch-quality thumbnails from being upscaled into
  // the main gallery. As Rai uploads proper hero images per color,
  // the swap automatically activates for those products.
  events.on('color:change', function(data) {
    if (!data.heroImage || !galleryMain) return;

    // Swap first slide to the hero image (already at 1200px from bridge)
    var slides = dom.qsa('.builder-v2__gallery-slide', galleryMain);
    if (slides.length > 0) {
      var firstImg = slides[0].querySelector('img');
      if (firstImg) {
        firstImg.src = data.heroImage;
        firstImg.alt = data.colorName || '';
      }
      goToSlide(0);
    }

    // Sync first thumbnail
    if (galleryThumbs) {
      var firstThumb = galleryThumbs.querySelector('.builder-v2__thumb img');
      if (firstThumb) {
        firstThumb.src = data.heroImage.replace(/width=\d+/, 'width=160');
        firstThumb.alt = data.colorName || '';
      }
    }
  });

  function goToSlide(idx) {
    var slides = dom.qsa('.builder-v2__gallery-slide', galleryMain);
    if (!slides[idx]) return;

    // Use CSS class for active slide (avoids inline style vs media query conflicts on resize)
    slides.forEach(function(s) { s.classList.remove('builder-v2__gallery-slide--active'); });
    slides[idx].classList.add('builder-v2__gallery-slide--active');

    // Mobile: also scroll to the slide position
    if (window.innerWidth < 769) {
      var slideWidth = galleryMain.offsetWidth;
      var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      galleryMain.scrollTo({ left: slideWidth * idx, behavior: reduceMotion ? 'auto' : 'smooth' });
    }

    updateActiveThumb(idx);
    updateActiveDot(idx);
    updateCounter(idx);
  }

  function updateCounter(idx) {
    var counter = document.querySelector('[data-counter-current]');
    if (counter) counter.textContent = (idx + 1);
  }

  function updateActiveThumb(idx) {
    if (!galleryThumbs) return;
    var thumbs = dom.qsa('.builder-v2__thumb', galleryThumbs);
    thumbs.forEach(function(t) { t.classList.remove('builder-v2__thumb--active'); });
    if (thumbs[idx]) thumbs[idx].classList.add('builder-v2__thumb--active');
  }

  // Old info tabs (Description / Shipping / Measurement) removed.
  // Replaced by native HTML <details>/<summary> accordions that need
  // no JS for open/close behavior.

  // Desktop lightbox zoom
  // CRITICAL: theme's .page-container has transform:translate3d on desktop,
  // which creates a containing block for position:fixed descendants. This
  // means a lightbox inside .page-container is NOT relative to the viewport
  // it's relative to .page-container, causing it to be clipped/misaligned.
  // Fix: move the lightbox to <body> so it escapes the transformed ancestor.
  var lightbox = dom.qs('[data-lightbox]');
  var lightboxImg = dom.qs('[data-lightbox-img]');
  var lightboxClose = dom.qs('[data-lightbox-close]');

  if (lightbox && document.body) {
    document.body.appendChild(lightbox);
  }

  if (galleryMain && lightbox && lightboxImg) {
    galleryMain.addEventListener('click', function(e) {
      if (window.innerWidth < 769) return;
      var img = e.target.tagName === 'IMG' ? e.target : null;
      if (!img) return;
      var fullSrc = img.src.replace(/width=\d+/, 'width=1600');
      if (fullSrc === img.src) {
        fullSrc = img.src + (img.src.indexOf('?') >= 0 ? '&' : '?') + 'width=1600';
      }
      lightboxImg.src = fullSrc;
      lightboxImg.alt = img.alt || '';
      lightbox.classList.add('builder-v2__lightbox--open');
      lightbox.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    });

    function closeLightbox() {
      lightbox.classList.remove('builder-v2__lightbox--open');
      lightbox.setAttribute('aria-hidden', 'true');
      lightboxImg.src = '';
      document.body.style.overflow = '';
    }

    if (lightboxClose) {
      lightboxClose.addEventListener('click', closeLightbox);
    }

    lightbox.addEventListener('click', function(e) {
      if (e.target === lightbox) closeLightbox();
    });

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && lightbox.classList.contains('builder-v2__lightbox--open')) {
        closeLightbox();
      }
    });
  }

  function updateActiveDot(idx) {
    if (!galleryDots) return;
    var dots = dom.qsa('.builder-v2__gallery-dot', galleryDots);
    dots.forEach(function(d) { d.classList.remove('builder-v2__gallery-dot--active'); });
    if (dots[idx]) dots[idx].classList.add('builder-v2__gallery-dot--active');
  }


  /* ============================================================
     UTILITY: POPULATE SELECT
     ============================================================ */
  function populateSelect(select, values, placeholder, selectedValue) {
    select.innerHTML = '<option value="">' + placeholder + '</option>';
    values.forEach(function(val) {
      var opt = document.createElement('option');
      opt.value = val;
      opt.textContent = val + '"';
      if (selectedValue !== null && selectedValue !== undefined && val === selectedValue) {
        opt.selected = true;
      }
      select.appendChild(opt);
    });
  }

  function populateFractionSelect(select) {
    select.innerHTML = '';
    for (var i = 0; i < fractions.VALUES.length; i++) {
      var opt = document.createElement('option');
      opt.value = fractions.VALUES[i];
      opt.textContent = fractions.LABELS[i] || '0"';
      select.appendChild(opt);
    }
  }


  /* ============================================================
     UTILITY: ERROR DISPLAY
     ============================================================ */
  function showError(msg) {
    var el = dom.qs('[data-builder-error]');
    if (!el) return;
    el.textContent = msg;
    el.classList.add('builder-v2__error--visible');
    // Auto-dismiss after 8 seconds (enough time to read + act)
    if (showError._timer) clearTimeout(showError._timer);
    showError._timer = setTimeout(function() {
      el.classList.remove('builder-v2__error--visible');
    }, 8000);
  }


  /* ============================================================
     UTILITY: HTML ESCAPE
     ============================================================ */
  function escapeHtml(str) {
    if (!str) return '';
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }


  /* ============================================================
     ESTIMATED SHIP DATE BADGE (top of builder)
     Fills in the "Estimated Ship Date: May 4th" badge between the
     reviews snippet and the price block. Reads the same production_days
     metafield as the shipping timeline so there is one source of truth.
     Single date = today + production_days business days.
     ============================================================ */
  (function renderShipDateBadge() {
    var badge = document.querySelector('[data-ship-date-badge]');
    if (!badge) return;
    var rangeEl = badge.querySelector('[data-ship-date-range]');
    if (!rangeEl) return;

    var prodDays = parseInt(badge.getAttribute('data-production-days'), 10) || 0;
    if (prodDays === 0) {
      badge.style.display = 'none';
      return;
    }

    var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

    function addBusinessDays(date, days) {
      var result = new Date(date);
      var added = 0;
      while (added < days) {
        result.setDate(result.getDate() + 1);
        var dow = result.getDay();
        if (dow !== 0 && dow !== 6) added++;
      }
      return result;
    }

    function ordinal(n) {
      var s = ['th', 'st', 'nd', 'rd'];
      var v = n % 100;
      return n + (s[(v - 20) % 10] || s[v] || s[0]);
    }

    function formatDate(d) {
      return MONTHS[d.getMonth()] + ' ' + ordinal(d.getDate());
    }

    var today = new Date();
    var shipDate = addBusinessDays(today, prodDays);

    rangeEl.textContent = ' ' + formatDate(shipDate);
  })();


  /* ============================================================
     INFO BOX  READ MORE smooth scroll
     The default browser jump-to-anchor would land the description
     under the fixed theme header. Use scrollIntoView with a small
     offset adjustment so the heading lands cleanly below the header.
     ============================================================ */
  (function bindInfoBoxReadMore() {
    var link = document.querySelector('[data-info-box-readmore]');
    if (!link) return;
    var target = document.getElementById('builder-v2-description');
    if (!target) return;

    link.addEventListener('click', function(e) {
      e.preventDefault();
      var headerOffset = 120; // matches v2 page-container padding-top + breathing room
      var rect = target.getBoundingClientRect();
      var top = rect.top + window.pageYOffset - headerOffset;
      var reduceMotion = window.matchMedia &&
        window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({
        top: top,
        behavior: reduceMotion ? 'auto' : 'smooth'
      });
      // Update the URL hash without triggering the default jump
      if (history.replaceState) {
        history.replaceState(null, '', '#builder-v2-description');
      }
    });
  })();


  /* ============================================================
     STEP 2 "Measurement information" LINK
     Delegated handler — the link is rendered dynamically inside
     renderSizeStep, so we listen on document and resolve at click time.
     Behaviour mirrors bindInfoBoxReadMore but also force-opens the
     <details> accordion (anchor-click alone won't open it).
     ============================================================ */
  document.addEventListener('click', function(e) {
    var link = e.target.closest && e.target.closest('[data-measure-info-link]');
    if (!link) return;
    var target = document.getElementById('builder-v2-measure-install');
    if (!target) return;
    e.preventDefault();
    if (target.tagName === 'DETAILS' && !target.open) target.open = true;
    var headerOffset = 120;
    var rect = target.getBoundingClientRect();
    var top = rect.top + window.pageYOffset - headerOffset;
    var reduceMotion = window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: top, behavior: reduceMotion ? 'auto' : 'smooth' });
    if (history.replaceState) {
      history.replaceState(null, '', '#builder-v2-measure-install');
    }
  });


  /* ============================================================
     SHIPPING TIMELINE
     Renders a 3-step Order Arrival Estimate from product metafields.
     Single dates, no range:
       Ordered   = today
       Order Ready = today + production_days business days
       Delivered = Order Ready + shipping_days business days
     Both production_days and shipping_days are merchant-editable
     metafields so the date logic updates without a code change.
     ============================================================ */
  (function renderShippingTimeline() {
    // Target the dedicated metafield bridge (has BOTH data-production-days
    // and data-shipping-days). Querying just [data-production-days] would
    // match the ship-date badge first, which only carries production_days,
    // so shipDays would silently fall back to its default and the
    // shipping_days metafield would appear to have no effect.
    var prodEl = dom.qs('[data-shipping-days]');
    var estEl = dom.qs('[data-shipping-estimate]');
    if (!prodEl || !estEl) return;

    var prodDays = parseInt(prodEl.getAttribute('data-production-days'), 10) || 0;
    var shipDays = parseInt(prodEl.getAttribute('data-shipping-days'), 10) || 7;
    if (prodDays === 0) return;

    var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

    function addBusinessDays(date, days) {
      var result = new Date(date);
      var added = 0;
      while (added < days) {
        result.setDate(result.getDate() + 1);
        var dow = result.getDay();
        if (dow !== 0 && dow !== 6) added++;
      }
      return result;
    }

    function ordinal(n) {
      var s = ['th', 'st', 'nd', 'rd'];
      var v = n % 100;
      return n + (s[(v - 20) % 10] || s[v] || s[0]);
    }

    function formatDate(d) {
      return MONTHS[d.getMonth()] + ' ' + ordinal(d.getDate());
    }

    var today = new Date();
    var readyDate = addBusinessDays(today, prodDays);
    var deliverDate = addBusinessDays(readyDate, Math.max(1, shipDays));

    // Callout box with truck icon header, matching MeasureSafe visual language
    var iconOrder = '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg>';
    var iconTruck = '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="1" y="3" width="15" height="13"/><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg>';
    var iconDelivered = '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="7" width="20" height="14" rx="2"/><path d="M16 7V5a4 4 0 0 0-8 0v2"/><path d="M9 14l2 2 4-4"/></svg>';

    // Layout: arrival-box (compact callout with just the timeline) on the
    // LEFT, and arrival-info (note + bullets) on the RIGHT on desktop.
    // Stacks vertically on mobile. Per Warwick PDP review v2: "Make the
    // box just a small section. If they could sit to the right of the
    // Order Arrival Estimate infographic on Desktop, and underneath on
    // Mobile, that would be great."
    estEl.innerHTML =
      '<div class="builder-v2__arrival-layout">' +
        // LEFT: compact callout box (header + 3 timeline steps only)
        '<div class="builder-v2__arrival-box">' +
          '<div class="builder-v2__arrival-header">' +
            '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
              '<rect x="1" y="3" width="15" height="13"/>' +
              '<polygon points="16 8 20 8 23 11 23 16 16 16 16 8"/>' +
              '<circle cx="5.5" cy="18.5" r="2.5"/>' +
              '<circle cx="18.5" cy="18.5" r="2.5"/>' +
            '</svg>' +
            '<span>Order Arrival Estimate</span>' +
          '</div>' +
          '<div class="builder-v2__shipping-timeline">' +
            '<div class="builder-v2__timeline-step">' +
              '<span class="builder-v2__timeline-dot">' + iconOrder + '</span>' +
              '<div>' +
                '<span class="builder-v2__timeline-date"><strong>' + formatDate(today) + '</strong></span>' +
                '<span class="builder-v2__timeline-label">Ordered</span>' +
              '</div>' +
            '</div>' +
            '<div class="builder-v2__timeline-step">' +
              '<span class="builder-v2__timeline-dot">' + iconTruck + '</span>' +
              '<div>' +
                '<span class="builder-v2__timeline-date"><strong>' + formatDate(readyDate) + '</strong></span>' +
                '<span class="builder-v2__timeline-label">Order Ready</span>' +
              '</div>' +
            '</div>' +
            '<div class="builder-v2__timeline-step">' +
              '<span class="builder-v2__timeline-dot">' + iconDelivered + '</span>' +
              '<div>' +
                '<span class="builder-v2__timeline-date"><strong>' + formatDate(deliverDate) + '</strong></span>' +
                '<span class="builder-v2__timeline-label">Delivered</span>' +
              '</div>' +
            '</div>' +
          '</div>' +
        '</div>' +
        // RIGHT: bullet points from section setting (editable in Theme Editor)
        '<div class="builder-v2__arrival-info">' +
          (function() {
            var bulletsRaw = Core.parseJSON('builder-timeline-bullets');
            if (bulletsRaw && bulletsRaw.trim()) {
              var lines = bulletsRaw.split('\n').filter(function(l) { return l.trim(); });
              var html = '<ul class="builder-v2__arrival-bullets">' +
                lines.map(function(l) {
                  return '<li>' + l.trim()
                    .replace(/\[production_days\]/g, prodDays)
                    .replace(/\[production_days_plus_2\]/g, (prodDays + 2)) + '</li>';
                }).join('') + '</ul>';
              return html;
            }
            return '<ul class="builder-v2__arrival-bullets">' +
              '<li>Free shipping on all orders inside the contiguous United States.</li>' +
              '<li>On average, customers receive their custom measured and cut blinds in 2 weeks from placing an order.</li>' +
              '<li>All blinds and shades are custom made to your specifications and typically ship ' + prodDays + ' to ' + (prodDays + 2) + ' business days after ordering.</li>' +
              '<li>Shipping times depend on your location and are usually 2-5 business days.</li>' +
              '<li>Our customer service team is always happy to check on the status and whereabouts of your order.</li>' +
            '</ul>';
          })() +
        '</div>' +
      '</div>' +
      // Note moved BELOW the layout per Warwick: "Move Note underneath
      // the Order Arrival Estimate infographic"
      '<p class="builder-v2__arrival-note">Note: Delivery times begin AFTER production. Oversize blinds must be shipped ground and may take longer to arrive. Estimated arrival time does not include holidays.</p>';
  })();


  /* ============================================================
     GOOGLE SHOPPING DEEP-LINK — auto-select color from URL
     If the URL contains ?color=Ivory (from a Google Shopping listing
     submitted by Feedoptimize), find the matching swatch and click it
     programmatically. This pre-selects the color, swaps the gallery
     image, updates the URL, and advances to step 2.
     Runs after all steps have rendered so swatches are in the DOM.
     ============================================================ */
  (function autoSelectFromURL() {
    var params;
    try { params = new URLSearchParams(window.location.search); }
    catch (e) { return; } // IE11 fallback: skip URL-driven preselect

    // Size deep-link: parse ?w/?h now; it is applied once the shopper picks
    // a mount (rebuildSizeDropdowns -> applyDeepLinkSize). Mount is never
    // taken from the URL, so nudge the shopper to choose one to see a price.
    deepLinkSize = parseSizeParams(params);
    if (deepLinkSize && stepElements[1] && stepElements[1].content &&
        !document.querySelector('[data-deeplink-hint]')) {
      var _hint = document.createElement('div');
      _hint.setAttribute('data-deeplink-hint', '');
      _hint.style.cssText = 'margin:0 0 14px;padding:10px 14px;border:1px solid #13548d;border-radius:8px;background:#eef4fb;color:#13548d;font-size:14px;line-height:1.4';
      _hint.textContent = 'Choose your mount type to see your price for this size.';
      stepElements[1].content.insertBefore(_hint, stepElements[1].content.firstChild);
    }

    var colorParam = params.get('color');
    if (!colorParam) return;

    colorParam = decodeURIComponent(colorParam).trim();
    if (!colorParam) return;

    var colorLower = colorParam.toLowerCase();

    // Find matching swatch across all color groups (case-insensitive)
    var swatches = dom.qsa('.builder-v2__swatch');
    var match = null;
    for (var i = 0; i < swatches.length; i++) {
      var swatchColor = swatches[i].getAttribute('data-color');
      if (swatchColor && swatchColor.trim().toLowerCase() === colorLower) {
        match = swatches[i];
        break;
      }
    }

    if (match) {
      // Small delay ensures the DOM is fully painted and event
      // delegation is bound before the programmatic click fires
      setTimeout(function() {
        match.click();
        // After the colour is selected (pricing group now active), seed the
        // URL's width/height into the store so the price reflects the linked
        // size on landing, before the shopper picks a mount (Google / the
        // shopper see the price for the size in the feed link, not the parent
        // base). The width/height dropdowns still populate after mount via
        // applyDeepLinkSize; this only seeds the engine so recalc is
        // size-accurate immediately. Out-of-range sizes resolve to no base
        // price and are skipped by applyDeepLinkSize, so they stay graceful.
        if (deepLinkSize && (deepLinkSize.wInt != null || deepLinkSize.hInt != null)) {
          if (deepLinkSize.wInt != null) {
            store.set('widthFrac', deepLinkSize.wFrac || 0);
            store.set('widthInt', deepLinkSize.wInt);
          }
          if (deepLinkSize.hInt != null) {
            store.set('heightFrac', deepLinkSize.hFrac || 0);
            store.set('heightInt', deepLinkSize.hInt);
          }
          // A seeded size has to clear the same gates a typed one does.
          if (showLiner) refreshLinerUi();
          applySizeRule();
          recalculatePrice();
        }
      }, 50);
    }
  })();


  // Rewrite static add-on price labels from the pricingData.addon_prices
  // metafield so the visible UI never disagrees with the cart math. Looks
  // for any element carrying data-addon-price-key + data-addon-price-default
  // and replaces its text content with the resolved price. If a sibling
  // input carries data-addon-price-attr, that attribute is also rewritten
  // (decimal dollars, used by legacy measuresafe handler).
  (function initAddonPriceLabels() {
    var labels = dom.qsa('[data-addon-price-key]');
    for (var i = 0; i < labels.length; i++) {
      var el = labels[i];
      var key = el.getAttribute('data-addon-price-key');
      var fallback = parseInt(el.getAttribute('data-addon-price-default'), 10);
      if (!key || isNaN(fallback)) continue;
      var cents = getAddonCents(key, fallback);
      if (cents == null) continue; // null metafield = leave label alone (card should be hidden by JS)
      var dollars = cents / 100;
      var suffix = el.getAttribute('data-addon-price-suffix') || '';
      // If the element is an <input>, rewrite the named data attribute instead.
      var attrName = el.getAttribute('data-addon-price-attr');
      if (attrName) {
        el.setAttribute(attrName, dollars.toFixed(2));
      } else {
        el.textContent = '+' + Core.formatMoney(dollars) + suffix;
      }
    }
  })();


  // Expose for debugging
  window.BuilderRoller = {
    store: store,
    pricing: pricing,
    recalculatePrice: recalculatePrice
  };

})();

